/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * NexusERP API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AbcAnalysisReport,
  Account,
  AccountGroup,
  AccountGroupInput,
  AccountInput,
  ActivityItem,
  AddOpsTicketCommentBody,
  AdminAsset,
  AdminAssetDetail,
  AdminAssetHistory,
  AdminAssetInput,
  AdminAssetLifecycleInput,
  AdminDashboard,
  AdminDepreciationSchedule,
  AdminFacilityRequest,
  AdminFacilityRequestInput,
  AdminHelpdeskTicket,
  AdminHelpdeskTicketInput,
  AdminLicenseAllocation,
  AdminRoom,
  AdminRoomBooking,
  AdminRoomBookingInput,
  AdminRoomInput,
  AdminSoftwareLicense,
  AdminSoftwareLicenseDetail,
  AdminSoftwareLicenseInput,
  AdminVendorContract,
  AdminVendorContractInput,
  AdminVisitor,
  AdminVisitorInput,
  AgingReport,
  AllocateLicenseSeatBody,
  ApprovalWorkflow,
  ApprovalWorkflowInput,
  ApprovalWorkflowUpdate,
  ApprovePerfKraBody,
  ApproveTravelAdvanceBody,
  ApproveTravelRequestBody,
  AttendancePolicy,
  AttendancePolicyInput,
  AttendanceRecord,
  AttendanceRegularization,
  AuditLogPage,
  AwardRfq200,
  BalanceSheetResponse,
  BankAccount,
  BankAccountInput,
  BankCashBook,
  BankStatementLine,
  Batch,
  BatchInput,
  BillActionInput,
  Bin,
  BinInput,
  Branch,
  BranchInput,
  BranchUpdate,
  Budget,
  BudgetDetail,
  BudgetInput,
  BudgetLine,
  BudgetLineInput,
  BudgetVsActuals,
  BulkGenerateIrnBody,
  BulkIrnResult,
  BulkQueueTallySync200,
  BulkQueueTallySyncBody,
  CancelEwbBody,
  CancelIrn200,
  CancelIrnBody,
  CancelOpsDispatchBody,
  CancelTravelRequestBody,
  CancelVoucherBody,
  CapexItem,
  CapexItemInput,
  CashFlowResponse,
  ComputeFullFinalSettlement200,
  ComputeFullFinalSettlementBody,
  ComputePayrollRun200,
  ComputePerfRatings200,
  ConfirmOpsDeliveryBody,
  ConvertCrmLead200,
  ConvertCrmLeadBody,
  CostCentre,
  CostCentreInput,
  CreateMisSavedReportBody,
  CreateMisScheduledReportBody,
  CreateOpsMilestoneBody,
  CreateOpsTimeLogBody,
  CrmAccount,
  CrmAccountDetail,
  CrmAccountInput,
  CrmActivity,
  CrmActivityInput,
  CrmContact,
  CrmContactInput,
  CrmLead,
  CrmLeadInput,
  CrmOpportunity,
  CrmOpportunityDetail,
  CrmOpportunityInput,
  CrmQuote,
  CrmQuoteDetail,
  CrmQuoteInput,
  CrmSalesOrder,
  CrmSalesOrderDetail,
  CrmSalesOrderInput,
  CsvImportResult,
  Currency,
  CurrencyInput,
  CurrencyUpdate,
  CustomDomain,
  CustomDomainInput,
  Customer,
  CustomerInput,
  CustomerProductPricing,
  CustomerProductPricingInput,
  CustomerReceipt,
  CustomerReceiptInput,
  DashboardStats,
  Department,
  DepartmentInput,
  DepartmentUpdate,
  Designation,
  DesignationInput,
  DesignationUpdate,
  DisburseTravelAdvanceBody,
  DiscountRule,
  DiscountRuleInput,
  DiscountRuleUpdate,
  DownloadForm16Bulk200Item,
  DownloadForm16BulkParams,
  DownloadForm24QParams,
  EinvoiceDashboard,
  EinvoiceLog,
  EmailCampaign,
  EmailCampaignDetail,
  EmailCampaignInput,
  Employee,
  EmployeeDocument,
  EmployeeDocumentInput,
  EmployeeInput,
  EmployeeLifecycleAction,
  EmployeeLoan,
  EmployeeLoanInput,
  EmployeeLoanUpdate,
  EmployeeSalaryAssignment,
  EmployeeSalaryAssignmentInput,
  EmployeeSalaryAssignmentUpdate,
  EmployeeSelfUpdate,
  EmployeeUpdate,
  EwbExtendInput,
  EwbPartBInput,
  EwbRecord,
  ExpenseClaim,
  ExpenseClaimDetail,
  ExpenseClaimInput,
  ExpenseClaimItem,
  ExpenseClaimItemInput,
  ExportOpsTimesheets200,
  FinanceApproveExpenseClaimBody,
  FiscalYear,
  FiscalYearInput,
  FiscalYearUpdate,
  Form16AResponse,
  Form26QResponse,
  GenerateEwbInput,
  GenerateIrn200,
  GetAbcAnalysisParams,
  GetAccountLedgerParams,
  GetApAgingParams,
  GetArAgingParams,
  GetBalanceSheetParams,
  GetBankCashBookParams,
  GetBankStatementParams,
  GetCashFlowParams,
  GetEmployeePerformanceHistory200Item,
  GetGstr1DataParams,
  GetGstr3bSummaryParams,
  GetInventoryLowStockReportParams,
  GetInventoryValuationReportParams,
  GetItcRegisterParams,
  GetMisHrAttendanceParams,
  GetMisHrHeadcountParams,
  GetMisPayrollSalaryRegisterParams,
  GetMyAttendanceParams,
  GetMyForm16200One,
  GetMyForm16Params,
  GetMyLeaveBalancesParams,
  GetMyPayrollSummary200,
  GetMyRegimeComparison200,
  GetMyRegimeComparisonParams,
  GetMyTaxSummary200,
  GetMyTaxSummaryParams,
  GetPerfBellCurve200Item,
  GetPerfPayrollHandoff200Item,
  GetProfitCentreReportParams,
  GetProfitLossParams,
  GetStockLedgerParams,
  GetTallyReconciliationParams,
  GetTdsForm16AParams,
  GetTdsForm26QParams,
  GetTeamAttendanceParams,
  GetTravelSpendSummaryParams,
  GetTrialBalanceParams,
  GoodsReceiptNote,
  GrnInput,
  GstConfig,
  GstConfigInput,
  GstinValidationResult,
  Gstr1Response,
  Gstr3bResponse,
  GstrFilingPeriod,
  GstrFilingPeriodInput,
  HealthStatus,
  HolidayCalendar,
  HolidayCalendarEntry,
  HolidayCalendarEntryInput,
  HolidayCalendarInput,
  HsnSac,
  HsnSacInput,
  IntermoduleJournalInput,
  InventoryConfig,
  InventoryConfigInput,
  InvoiceActionInput,
  InvoiceCrmSalesOrderBody,
  ItcEntry,
  LaunchEmailCampaign200,
  LdCertification,
  LdCertificationInput,
  LdCertificationRow,
  LdEmployeeSkill,
  LdEmployeeSkillInput,
  LdEmployeeSkillRow,
  LdReportSummary,
  LdRoleSkill,
  LdRoleSkillInput,
  LdRoleSkillRow,
  LdSkill,
  LdSkillInput,
  LdTrainingCostRow,
  LdTrainingHoursRow,
  LeaveActionInput,
  LeaveApplication,
  LeaveApplicationInput,
  LeaveBalance,
  LeaveBalanceAdjustment,
  LeaveType,
  LeaveTypeInput,
  LeaveTypeUpdate,
  LedgerResponse,
  ListAccountsParams,
  ListAdminAssetsParams,
  ListAllRoomBookingsParams,
  ListAttendanceRecordsParams,
  ListAuditLogParams,
  ListBatchesParams,
  ListBudgetsParams,
  ListCapexItemsParams,
  ListCrmAccountsParams,
  ListCrmActivitiesParams,
  ListCrmContactsParams,
  ListCrmLeadsParams,
  ListCrmOpportunitiesParams,
  ListCrmQuotesParams,
  ListCrmSalesOrdersParams,
  ListCustomerProductPricingParams,
  ListCustomerReceiptsParams,
  ListCustomersParams,
  ListEinvoiceLogsParams,
  ListEmailCampaignsParams,
  ListEmployeesParams,
  ListEwbParams,
  ListExpenseClaimsParams,
  ListFacilityRequestsParams,
  ListGrnParams,
  ListHolidayCalendarsParams,
  ListHsnSacParams,
  ListItHelpdeskTicketsParams,
  ListLdCertificationsParams,
  ListLdEmployeeSkillsParams,
  ListLeaveApplicationsParams,
  ListLeaveBalancesParams,
  ListMySalaryRevisions200Item,
  ListOnboardingInvitesParams,
  ListOpsDispatchParams,
  ListOpsProjectTasksParams,
  ListOpsProjectsParams,
  ListOpsTicketsParams,
  ListOpsTimesheetsParams,
  ListOpsWorkOrdersParams,
  ListPayrollRunEntries200,
  ListPayrollRunEntriesParams,
  ListPerfAssessmentsParams,
  ListPerfFeedbackRequestsParams,
  ListPerfKrasParams,
  ListPeriodLocksParams,
  ListProductAttributesParams,
  ListProductCategoriesParams,
  ListProductsParams,
  ListPurchaseIndentsParams,
  ListPurchaseOrdersParams,
  ListPurchaseRequisitionsParams,
  ListRegularizationsParams,
  ListReimbursementsParams,
  ListRfqsParams,
  ListRoomBookingsParams,
  ListSalesInvoicesParams,
  ListSalesTargetsParams,
  ListSoftwareLicensesParams,
  ListStockLevelsParams,
  ListStockMovementsParams,
  ListStockTakesParams,
  ListTallySyncQueueParams,
  ListTdsChallansParams,
  ListTdsDeclarationsParams,
  ListTdsDeductionsParams,
  ListTravelAdvancesParams,
  ListTravelBookingsParams,
  ListTravelRequestsParams,
  ListVendorBillsParams,
  ListVendorContractsParams,
  ListVendorPaymentsParams,
  ListVendorPortalTdsCertificatesParams,
  ListVendorsParams,
  ListVisitorsParams,
  ListVouchersParams,
  ListWarehousesParams,
  LowStockItem,
  ManagerApproveExpenseClaimBody,
  MapTallyInboundLedgerBody,
  MarketingSegment,
  MarketingSegmentInput,
  Me,
  MeUpdate,
  Notification,
  OnboardingInvite,
  OnboardingInviteInput,
  OnboardingRejectInput,
  OpsDashboard,
  OpsDispatchInput,
  OpsProject,
  OpsProjectInput,
  OpsSlaPolicyInput,
  OpsTaskInput,
  OpsTicket,
  OpsTicketInput,
  OpsTimesheetInput,
  OpsWorkOrderInput,
  OrgChartNode,
  POActionInput,
  PRActionInput,
  PayrollConfig,
  PayrollConfigUpdate,
  PayrollRun,
  PayrollRunEntry,
  PayrollRunEntryUpdate,
  PayrollRunInput,
  PerDiemPolicy,
  PerDiemPolicyInput,
  PerfAssessment,
  PerfAssessmentInput,
  PerfCycle,
  PerfCycleInput,
  PerfFeedbackRequest,
  PerfFeedbackRequestsInput,
  PerfFeedbackResponse,
  PerfFeedbackResponseInput,
  PerfKra,
  PerfKraInput,
  PerfRating,
  PerfRatingUpdate,
  PeriodLock,
  PeriodLockInput,
  PostDepreciationToFinance200,
  PostDepreciationToFinanceBody,
  PriceList,
  PriceListInput,
  PriceListItem,
  PriceListItemInput,
  PriceListItemUpdate,
  PriceListUpdate,
  PriceTier,
  PriceTierInput,
  Product,
  ProductAttribute,
  ProductAttributeInput,
  ProductAttributeUpdate,
  ProductBarcode,
  ProductBarcodeInput,
  ProductCategory,
  ProductCategoryInput,
  ProductCategoryUpdate,
  ProductDetail,
  ProductImage,
  ProductImageInput,
  ProductInput,
  ProductUpdate,
  ProductVariant,
  ProductVariantInput,
  ProductVariantUpdate,
  ProfitCentreReport,
  ProfitLossResponse,
  PtStateSlab,
  PtStateSlabInput,
  PullTallyLedgers200,
  PurchaseIndent,
  PurchaseIndentDetail,
  PurchaseIndentInput,
  PurchaseOrder,
  PurchaseOrderDetail,
  PurchaseOrderInput,
  PurchaseRequisition,
  PurchaseRequisitionInput,
  PurchaseRfq,
  PurchaseRfqDetail,
  PurchaseRfqInput,
  ReconcileBankStatement200,
  ReconcileInput,
  ReconcileTravelAdvanceBody,
  RecordAssetLifecycleEvent201,
  RegularizationActionInput,
  RegularizationInput,
  ReimbursementClaim,
  ReimbursementClaimInput,
  RejectExpenseClaimBody,
  RejectOpsTimesheetBody,
  RejectPerfKraBody,
  RejectReimbursementBody,
  RejectTravelRequestBody,
  Role,
  RoleDetail,
  RoleInput,
  RoleUpdate,
  RunMisAdhocReportBody,
  SalaryComponent,
  SalaryComponentInput,
  SalaryComponentUpdate,
  SalaryStructure,
  SalaryStructureInput,
  SalaryStructureItem,
  SalaryStructureItemInput,
  SalaryStructureUpdate,
  SalesInvoice,
  SalesInvoiceDetail,
  SalesInvoiceInput,
  SalesTarget,
  SalesTargetInput,
  SaveTallyVoucherTypeMappings200,
  SaveTallyVoucherTypeMappingsBodyItem,
  SeedIndiaCoa201,
  SeedPayrollConfigDefaults200,
  SendCrmQuote200,
  SendCrmQuoteBody,
  Shift,
  ShiftInput,
  StockLedgerReport,
  StockLevel,
  StockMovement,
  StockMovementDetail,
  StockMovementInput,
  StockTake,
  StockTakeDetail,
  StockTakeInput,
  SubmitOpsTicketFeedbackBody,
  SubmitVendorOnboarding200,
  SuccessResponse,
  TallyConfig,
  TallyConfigInput,
  TallyInboundLedger,
  TallyLedgerMapping,
  TallyLedgerMappingInput,
  TallyReconciliationReport,
  TallySyncQueueItem,
  TallyVoucherTypeMapping,
  TaxRate,
  TaxRateInput,
  TdsChallan,
  TdsChallanInput,
  TdsDeclaration,
  TdsDeclarationInput,
  TdsDeduction,
  TdsRateMaster,
  TdsRateMasterInput,
  Tenant,
  TenantSummary,
  TenantUpdate,
  TenantUser,
  TestTallyConnection200,
  TestTallyConnectionBody,
  TrackCampaignEngagementParams,
  TrainingNomination,
  TrainingNominationInput,
  TrainingNominationRow,
  TrainingNominationUpdate,
  TrainingProgramme,
  TrainingProgrammeInput,
  TravelAdvance,
  TravelAdvanceInput,
  TravelBooking,
  TravelBookingInput,
  TravelRequest,
  TravelRequestInput,
  TravelSpendSummary,
  TrialBalanceResponse,
  Uom,
  UomConversion,
  UomConversionInput,
  UomInput,
  UomUpdate,
  UpdateMisScheduledReportBody,
  UpdateOpsMilestoneBody,
  UpdatePayrollRunEntry409,
  UploadUrlRequest,
  UploadUrlResponse,
  UserInvite,
  UserUpdate,
  ValuationReport,
  Vendor,
  VendorBankAccount,
  VendorBankAccountInput,
  VendorBill,
  VendorBillDetail,
  VendorBillInput,
  VendorDetail,
  VendorDocument,
  VendorDocumentInput,
  VendorInput,
  VendorInvite,
  VendorInviteInput,
  VendorInviteReviewInput,
  VendorOnboardingFormData,
  VendorOnboardingSubmission,
  VendorPayment,
  VendorPaymentInput,
  VendorPortalProfile,
  ViewCustomerPortalParams,
  ViewCustomerPortalQuoteParams,
  Voucher,
  VoucherDetail,
  VoucherInput,
  Warehouse,
  WarehouseDetail,
  WarehouseInput
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMeUrl = () => {




  return `/api/me`
}

/**
 * @summary Get current user profile with tenant context
 */
export const getMe = async ( options?: RequestInit): Promise<Me> => {

  return customFetch<Me>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<unknown>


/**
 * @summary Get current user profile with tenant context
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateMeUrl = () => {




  return `/api/me`
}

/**
 * @summary Update current user profile
 */
export const updateMe = async (meUpdate: MeUpdate, options?: RequestInit): Promise<Me> => {

  return customFetch<Me>(getUpdateMeUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      meUpdate,)
  }
);}




export const getUpdateMeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: BodyType<MeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: BodyType<MeUpdate>}, TContext> => {

const mutationKey = ['updateMe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMe>>, {data: BodyType<MeUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateMe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof updateMe>>>
    export type UpdateMeMutationBody = BodyType<MeUpdate>
    export type UpdateMeMutationError = ErrorType<unknown>

    /**
 * @summary Update current user profile
 */
export const useUpdateMe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: BodyType<MeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMe>>,
        TError,
        {data: BodyType<MeUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMeMutationOptions(options));
    }

export const getGetTenantUrl = () => {




  return `/api/tenant`
}

/**
 * @summary Get current tenant settings
 */
export const getTenant = async ( options?: RequestInit): Promise<Tenant> => {

  return customFetch<Tenant>(getGetTenantUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTenantQueryKey = () => {
    return [
    `/api/tenant`
    ] as const;
    }


export const getGetTenantQueryOptions = <TData = Awaited<ReturnType<typeof getTenant>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenant>>> = ({ signal }) => getTenant({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getTenant>>>
export type GetTenantQueryError = ErrorType<unknown>


/**
 * @summary Get current tenant settings
 */

export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTenantQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateTenantUrl = () => {




  return `/api/tenant`
}

/**
 * @summary Update tenant settings
 */
export const updateTenant = async (tenantUpdate: TenantUpdate, options?: RequestInit): Promise<Tenant> => {

  return customFetch<Tenant>(getUpdateTenantUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantUpdate,)
  }
);}




export const getUpdateTenantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{data: BodyType<TenantUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{data: BodyType<TenantUpdate>}, TContext> => {

const mutationKey = ['updateTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTenant>>, {data: BodyType<TenantUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateTenant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTenantMutationResult = NonNullable<Awaited<ReturnType<typeof updateTenant>>>
    export type UpdateTenantMutationBody = BodyType<TenantUpdate>
    export type UpdateTenantMutationError = ErrorType<unknown>

    /**
 * @summary Update tenant settings
 */
export const useUpdateTenant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{data: BodyType<TenantUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTenant>>,
        TError,
        {data: BodyType<TenantUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTenantMutationOptions(options));
    }

export const getListBranchesUrl = () => {




  return `/api/branches`
}

/**
 * @summary List all branches
 */
export const listBranches = async ( options?: RequestInit): Promise<Branch[]> => {

  return customFetch<Branch[]>(getListBranchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBranchesQueryKey = () => {
    return [
    `/api/branches`
    ] as const;
    }


export const getListBranchesQueryOptions = <TData = Awaited<ReturnType<typeof listBranches>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBranches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBranchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBranches>>> = ({ signal }) => listBranches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBranches>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBranchesQueryResult = NonNullable<Awaited<ReturnType<typeof listBranches>>>
export type ListBranchesQueryError = ErrorType<unknown>


/**
 * @summary List all branches
 */

export function useListBranches<TData = Awaited<ReturnType<typeof listBranches>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBranches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBranchesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBranchUrl = () => {




  return `/api/branches`
}

/**
 * @summary Create a branch
 */
export const createBranch = async (branchInput: BranchInput, options?: RequestInit): Promise<Branch> => {

  return customFetch<Branch>(getCreateBranchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      branchInput,)
  }
);}




export const getCreateBranchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBranch>>, TError,{data: BodyType<BranchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBranch>>, TError,{data: BodyType<BranchInput>}, TContext> => {

const mutationKey = ['createBranch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBranch>>, {data: BodyType<BranchInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBranch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBranchMutationResult = NonNullable<Awaited<ReturnType<typeof createBranch>>>
    export type CreateBranchMutationBody = BodyType<BranchInput>
    export type CreateBranchMutationError = ErrorType<unknown>

    /**
 * @summary Create a branch
 */
export const useCreateBranch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBranch>>, TError,{data: BodyType<BranchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBranch>>,
        TError,
        {data: BodyType<BranchInput>},
        TContext
      > => {
      return useMutation(getCreateBranchMutationOptions(options));
    }

export const getGetBranchUrl = (id: number,) => {




  return `/api/branches/${id}`
}

/**
 * @summary Get a branch
 */
export const getBranch = async (id: number, options?: RequestInit): Promise<Branch> => {

  return customFetch<Branch>(getGetBranchUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBranchQueryKey = (id: number,) => {
    return [
    `/api/branches/${id}`
    ] as const;
    }


export const getGetBranchQueryOptions = <TData = Awaited<ReturnType<typeof getBranch>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBranch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBranchQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBranch>>> = ({ signal }) => getBranch(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBranch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBranchQueryResult = NonNullable<Awaited<ReturnType<typeof getBranch>>>
export type GetBranchQueryError = ErrorType<unknown>


/**
 * @summary Get a branch
 */

export function useGetBranch<TData = Awaited<ReturnType<typeof getBranch>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBranch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBranchQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateBranchUrl = (id: number,) => {




  return `/api/branches/${id}`
}

/**
 * @summary Update a branch
 */
export const updateBranch = async (id: number,
    branchUpdate: BranchUpdate, options?: RequestInit): Promise<Branch> => {

  return customFetch<Branch>(getUpdateBranchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      branchUpdate,)
  }
);}




export const getUpdateBranchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBranch>>, TError,{id: number;data: BodyType<BranchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBranch>>, TError,{id: number;data: BodyType<BranchUpdate>}, TContext> => {

const mutationKey = ['updateBranch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBranch>>, {id: number;data: BodyType<BranchUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBranch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBranchMutationResult = NonNullable<Awaited<ReturnType<typeof updateBranch>>>
    export type UpdateBranchMutationBody = BodyType<BranchUpdate>
    export type UpdateBranchMutationError = ErrorType<unknown>

    /**
 * @summary Update a branch
 */
export const useUpdateBranch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBranch>>, TError,{id: number;data: BodyType<BranchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBranch>>,
        TError,
        {id: number;data: BodyType<BranchUpdate>},
        TContext
      > => {
      return useMutation(getUpdateBranchMutationOptions(options));
    }

export const getDeleteBranchUrl = (id: number,) => {




  return `/api/branches/${id}`
}

/**
 * @summary Delete a branch
 */
export const deleteBranch = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteBranchUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteBranchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBranch>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBranch>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteBranch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBranch>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteBranch(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBranchMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBranch>>>

    export type DeleteBranchMutationError = ErrorType<unknown>

    /**
 * @summary Delete a branch
 */
export const useDeleteBranch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBranch>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteBranch>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteBranchMutationOptions(options));
    }

export const getImportBranchesUrl = () => {




  return `/api/branches/import`
}

/**
 * @summary Bulk import branches from CSV (header row: name,code,city,state,country)
 */
export const importBranches = async (importBranchesBody: string, options?: RequestInit): Promise<CsvImportResult> => {

  return customFetch<CsvImportResult>(getImportBranchesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/csv', ...options?.headers },
    body: JSON.stringify(
      importBranchesBody,)
  }
);}




export const getImportBranchesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importBranches>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importBranches>>, TError,{data: BodyType<string>}, TContext> => {

const mutationKey = ['importBranches'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importBranches>>, {data: BodyType<string>}> = (props) => {
          const {data} = props ?? {};

          return  importBranches(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportBranchesMutationResult = NonNullable<Awaited<ReturnType<typeof importBranches>>>
    export type ImportBranchesMutationBody = BodyType<string>
    export type ImportBranchesMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import branches from CSV (header row: name,code,city,state,country)
 */
export const useImportBranches = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importBranches>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importBranches>>,
        TError,
        {data: BodyType<string>},
        TContext
      > => {
      return useMutation(getImportBranchesMutationOptions(options));
    }

export const getListDepartmentsUrl = () => {




  return `/api/departments`
}

/**
 * @summary List all departments
 */
export const listDepartments = async ( options?: RequestInit): Promise<Department[]> => {

  return customFetch<Department[]>(getListDepartmentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDepartmentsQueryKey = () => {
    return [
    `/api/departments`
    ] as const;
    }


export const getListDepartmentsQueryOptions = <TData = Awaited<ReturnType<typeof listDepartments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDepartmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDepartments>>> = ({ signal }) => listDepartments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listDepartments>>>
export type ListDepartmentsQueryError = ErrorType<unknown>


/**
 * @summary List all departments
 */

export function useListDepartments<TData = Awaited<ReturnType<typeof listDepartments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDepartmentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateDepartmentUrl = () => {




  return `/api/departments`
}

/**
 * @summary Create a department
 */
export const createDepartment = async (departmentInput: DepartmentInput, options?: RequestInit): Promise<Department> => {

  return customFetch<Department>(getCreateDepartmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      departmentInput,)
  }
);}




export const getCreateDepartmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: BodyType<DepartmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: BodyType<DepartmentInput>}, TContext> => {

const mutationKey = ['createDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDepartment>>, {data: BodyType<DepartmentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createDepartment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof createDepartment>>>
    export type CreateDepartmentMutationBody = BodyType<DepartmentInput>
    export type CreateDepartmentMutationError = ErrorType<unknown>

    /**
 * @summary Create a department
 */
export const useCreateDepartment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: BodyType<DepartmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDepartment>>,
        TError,
        {data: BodyType<DepartmentInput>},
        TContext
      > => {
      return useMutation(getCreateDepartmentMutationOptions(options));
    }

export const getUpdateDepartmentUrl = (id: number,) => {




  return `/api/departments/${id}`
}

/**
 * @summary Update a department
 */
export const updateDepartment = async (id: number,
    departmentUpdate: DepartmentUpdate, options?: RequestInit): Promise<Department> => {

  return customFetch<Department>(getUpdateDepartmentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      departmentUpdate,)
  }
);}




export const getUpdateDepartmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{id: number;data: BodyType<DepartmentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{id: number;data: BodyType<DepartmentUpdate>}, TContext> => {

const mutationKey = ['updateDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDepartment>>, {id: number;data: BodyType<DepartmentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDepartment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateDepartment>>>
    export type UpdateDepartmentMutationBody = BodyType<DepartmentUpdate>
    export type UpdateDepartmentMutationError = ErrorType<unknown>

    /**
 * @summary Update a department
 */
export const useUpdateDepartment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{id: number;data: BodyType<DepartmentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDepartment>>,
        TError,
        {id: number;data: BodyType<DepartmentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDepartmentMutationOptions(options));
    }

export const getDeleteDepartmentUrl = (id: number,) => {




  return `/api/departments/${id}`
}

/**
 * @summary Delete a department
 */
export const deleteDepartment = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteDepartmentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDepartmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDepartment>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDepartment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDepartment>>>

    export type DeleteDepartmentMutationError = ErrorType<unknown>

    /**
 * @summary Delete a department
 */
export const useDeleteDepartment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDepartment>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteDepartmentMutationOptions(options));
    }

export const getImportDepartmentsUrl = () => {




  return `/api/departments/import`
}

/**
 * @summary Bulk import departments from CSV (header row: name,code,description)
 */
export const importDepartments = async (importDepartmentsBody: string, options?: RequestInit): Promise<CsvImportResult> => {

  return customFetch<CsvImportResult>(getImportDepartmentsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/csv', ...options?.headers },
    body: JSON.stringify(
      importDepartmentsBody,)
  }
);}




export const getImportDepartmentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importDepartments>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importDepartments>>, TError,{data: BodyType<string>}, TContext> => {

const mutationKey = ['importDepartments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importDepartments>>, {data: BodyType<string>}> = (props) => {
          const {data} = props ?? {};

          return  importDepartments(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportDepartmentsMutationResult = NonNullable<Awaited<ReturnType<typeof importDepartments>>>
    export type ImportDepartmentsMutationBody = BodyType<string>
    export type ImportDepartmentsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import departments from CSV (header row: name,code,description)
 */
export const useImportDepartments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importDepartments>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importDepartments>>,
        TError,
        {data: BodyType<string>},
        TContext
      > => {
      return useMutation(getImportDepartmentsMutationOptions(options));
    }

export const getListDesignationsUrl = () => {




  return `/api/designations`
}

/**
 * @summary List all designations
 */
export const listDesignations = async ( options?: RequestInit): Promise<Designation[]> => {

  return customFetch<Designation[]>(getListDesignationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDesignationsQueryKey = () => {
    return [
    `/api/designations`
    ] as const;
    }


export const getListDesignationsQueryOptions = <TData = Awaited<ReturnType<typeof listDesignations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDesignations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDesignationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDesignations>>> = ({ signal }) => listDesignations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDesignations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDesignationsQueryResult = NonNullable<Awaited<ReturnType<typeof listDesignations>>>
export type ListDesignationsQueryError = ErrorType<unknown>


/**
 * @summary List all designations
 */

export function useListDesignations<TData = Awaited<ReturnType<typeof listDesignations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDesignations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDesignationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateDesignationUrl = () => {




  return `/api/designations`
}

/**
 * @summary Create a designation
 */
export const createDesignation = async (designationInput: DesignationInput, options?: RequestInit): Promise<Designation> => {

  return customFetch<Designation>(getCreateDesignationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      designationInput,)
  }
);}




export const getCreateDesignationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDesignation>>, TError,{data: BodyType<DesignationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDesignation>>, TError,{data: BodyType<DesignationInput>}, TContext> => {

const mutationKey = ['createDesignation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDesignation>>, {data: BodyType<DesignationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createDesignation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDesignationMutationResult = NonNullable<Awaited<ReturnType<typeof createDesignation>>>
    export type CreateDesignationMutationBody = BodyType<DesignationInput>
    export type CreateDesignationMutationError = ErrorType<unknown>

    /**
 * @summary Create a designation
 */
export const useCreateDesignation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDesignation>>, TError,{data: BodyType<DesignationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDesignation>>,
        TError,
        {data: BodyType<DesignationInput>},
        TContext
      > => {
      return useMutation(getCreateDesignationMutationOptions(options));
    }

export const getUpdateDesignationUrl = (id: number,) => {




  return `/api/designations/${id}`
}

/**
 * @summary Update a designation
 */
export const updateDesignation = async (id: number,
    designationUpdate: DesignationUpdate, options?: RequestInit): Promise<Designation> => {

  return customFetch<Designation>(getUpdateDesignationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      designationUpdate,)
  }
);}




export const getUpdateDesignationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDesignation>>, TError,{id: number;data: BodyType<DesignationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDesignation>>, TError,{id: number;data: BodyType<DesignationUpdate>}, TContext> => {

const mutationKey = ['updateDesignation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDesignation>>, {id: number;data: BodyType<DesignationUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDesignation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDesignationMutationResult = NonNullable<Awaited<ReturnType<typeof updateDesignation>>>
    export type UpdateDesignationMutationBody = BodyType<DesignationUpdate>
    export type UpdateDesignationMutationError = ErrorType<unknown>

    /**
 * @summary Update a designation
 */
export const useUpdateDesignation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDesignation>>, TError,{id: number;data: BodyType<DesignationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDesignation>>,
        TError,
        {id: number;data: BodyType<DesignationUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDesignationMutationOptions(options));
    }

export const getDeleteDesignationUrl = (id: number,) => {




  return `/api/designations/${id}`
}

/**
 * @summary Delete a designation
 */
export const deleteDesignation = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteDesignationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDesignationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDesignation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDesignation>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDesignation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDesignation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDesignation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDesignationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDesignation>>>

    export type DeleteDesignationMutationError = ErrorType<unknown>

    /**
 * @summary Delete a designation
 */
export const useDeleteDesignation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDesignation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDesignation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteDesignationMutationOptions(options));
    }

export const getImportDesignationsUrl = () => {




  return `/api/designations/import`
}

/**
 * @summary Bulk import designations from CSV (header row: name,code,description,level)
 */
export const importDesignations = async (importDesignationsBody: string, options?: RequestInit): Promise<CsvImportResult> => {

  return customFetch<CsvImportResult>(getImportDesignationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/csv', ...options?.headers },
    body: JSON.stringify(
      importDesignationsBody,)
  }
);}




export const getImportDesignationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importDesignations>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importDesignations>>, TError,{data: BodyType<string>}, TContext> => {

const mutationKey = ['importDesignations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importDesignations>>, {data: BodyType<string>}> = (props) => {
          const {data} = props ?? {};

          return  importDesignations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportDesignationsMutationResult = NonNullable<Awaited<ReturnType<typeof importDesignations>>>
    export type ImportDesignationsMutationBody = BodyType<string>
    export type ImportDesignationsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import designations from CSV (header row: name,code,description,level)
 */
export const useImportDesignations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importDesignations>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importDesignations>>,
        TError,
        {data: BodyType<string>},
        TContext
      > => {
      return useMutation(getImportDesignationsMutationOptions(options));
    }

export const getListFiscalYearsUrl = () => {




  return `/api/fiscal-years`
}

/**
 * @summary List all fiscal years
 */
export const listFiscalYears = async ( options?: RequestInit): Promise<FiscalYear[]> => {

  return customFetch<FiscalYear[]>(getListFiscalYearsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFiscalYearsQueryKey = () => {
    return [
    `/api/fiscal-years`
    ] as const;
    }


export const getListFiscalYearsQueryOptions = <TData = Awaited<ReturnType<typeof listFiscalYears>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFiscalYears>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFiscalYearsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFiscalYears>>> = ({ signal }) => listFiscalYears({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFiscalYears>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFiscalYearsQueryResult = NonNullable<Awaited<ReturnType<typeof listFiscalYears>>>
export type ListFiscalYearsQueryError = ErrorType<unknown>


/**
 * @summary List all fiscal years
 */

export function useListFiscalYears<TData = Awaited<ReturnType<typeof listFiscalYears>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFiscalYears>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFiscalYearsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateFiscalYearUrl = () => {




  return `/api/fiscal-years`
}

/**
 * @summary Create a fiscal year
 */
export const createFiscalYear = async (fiscalYearInput: FiscalYearInput, options?: RequestInit): Promise<FiscalYear> => {

  return customFetch<FiscalYear>(getCreateFiscalYearUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      fiscalYearInput,)
  }
);}




export const getCreateFiscalYearMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFiscalYear>>, TError,{data: BodyType<FiscalYearInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFiscalYear>>, TError,{data: BodyType<FiscalYearInput>}, TContext> => {

const mutationKey = ['createFiscalYear'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFiscalYear>>, {data: BodyType<FiscalYearInput>}> = (props) => {
          const {data} = props ?? {};

          return  createFiscalYear(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFiscalYearMutationResult = NonNullable<Awaited<ReturnType<typeof createFiscalYear>>>
    export type CreateFiscalYearMutationBody = BodyType<FiscalYearInput>
    export type CreateFiscalYearMutationError = ErrorType<unknown>

    /**
 * @summary Create a fiscal year
 */
export const useCreateFiscalYear = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFiscalYear>>, TError,{data: BodyType<FiscalYearInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFiscalYear>>,
        TError,
        {data: BodyType<FiscalYearInput>},
        TContext
      > => {
      return useMutation(getCreateFiscalYearMutationOptions(options));
    }

export const getUpdateFiscalYearUrl = (id: number,) => {




  return `/api/fiscal-years/${id}`
}

/**
 * @summary Update a fiscal year
 */
export const updateFiscalYear = async (id: number,
    fiscalYearUpdate: FiscalYearUpdate, options?: RequestInit): Promise<FiscalYear> => {

  return customFetch<FiscalYear>(getUpdateFiscalYearUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      fiscalYearUpdate,)
  }
);}




export const getUpdateFiscalYearMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFiscalYear>>, TError,{id: number;data: BodyType<FiscalYearUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFiscalYear>>, TError,{id: number;data: BodyType<FiscalYearUpdate>}, TContext> => {

const mutationKey = ['updateFiscalYear'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFiscalYear>>, {id: number;data: BodyType<FiscalYearUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFiscalYear(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFiscalYearMutationResult = NonNullable<Awaited<ReturnType<typeof updateFiscalYear>>>
    export type UpdateFiscalYearMutationBody = BodyType<FiscalYearUpdate>
    export type UpdateFiscalYearMutationError = ErrorType<unknown>

    /**
 * @summary Update a fiscal year
 */
export const useUpdateFiscalYear = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFiscalYear>>, TError,{id: number;data: BodyType<FiscalYearUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateFiscalYear>>,
        TError,
        {id: number;data: BodyType<FiscalYearUpdate>},
        TContext
      > => {
      return useMutation(getUpdateFiscalYearMutationOptions(options));
    }

export const getListCurrenciesUrl = () => {




  return `/api/currencies`
}

/**
 * @summary List all currencies
 */
export const listCurrencies = async ( options?: RequestInit): Promise<Currency[]> => {

  return customFetch<Currency[]>(getListCurrenciesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCurrenciesQueryKey = () => {
    return [
    `/api/currencies`
    ] as const;
    }


export const getListCurrenciesQueryOptions = <TData = Awaited<ReturnType<typeof listCurrencies>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCurrencies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCurrenciesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurrencies>>> = ({ signal }) => listCurrencies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurrencies>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCurrenciesQueryResult = NonNullable<Awaited<ReturnType<typeof listCurrencies>>>
export type ListCurrenciesQueryError = ErrorType<unknown>


/**
 * @summary List all currencies
 */

export function useListCurrencies<TData = Awaited<ReturnType<typeof listCurrencies>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCurrencies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCurrenciesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCurrencyUrl = () => {




  return `/api/currencies`
}

/**
 * @summary Add a currency
 */
export const createCurrency = async (currencyInput: CurrencyInput, options?: RequestInit): Promise<Currency> => {

  return customFetch<Currency>(getCreateCurrencyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      currencyInput,)
  }
);}




export const getCreateCurrencyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCurrency>>, TError,{data: BodyType<CurrencyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCurrency>>, TError,{data: BodyType<CurrencyInput>}, TContext> => {

const mutationKey = ['createCurrency'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCurrency>>, {data: BodyType<CurrencyInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCurrency(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCurrencyMutationResult = NonNullable<Awaited<ReturnType<typeof createCurrency>>>
    export type CreateCurrencyMutationBody = BodyType<CurrencyInput>
    export type CreateCurrencyMutationError = ErrorType<unknown>

    /**
 * @summary Add a currency
 */
export const useCreateCurrency = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCurrency>>, TError,{data: BodyType<CurrencyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCurrency>>,
        TError,
        {data: BodyType<CurrencyInput>},
        TContext
      > => {
      return useMutation(getCreateCurrencyMutationOptions(options));
    }

export const getUpdateCurrencyUrl = (id: number,) => {




  return `/api/currencies/${id}`
}

/**
 * @summary Update a currency
 */
export const updateCurrency = async (id: number,
    currencyUpdate: CurrencyUpdate, options?: RequestInit): Promise<Currency> => {

  return customFetch<Currency>(getUpdateCurrencyUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      currencyUpdate,)
  }
);}




export const getUpdateCurrencyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrency>>, TError,{id: number;data: BodyType<CurrencyUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCurrency>>, TError,{id: number;data: BodyType<CurrencyUpdate>}, TContext> => {

const mutationKey = ['updateCurrency'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCurrency>>, {id: number;data: BodyType<CurrencyUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCurrency(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCurrencyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCurrency>>>
    export type UpdateCurrencyMutationBody = BodyType<CurrencyUpdate>
    export type UpdateCurrencyMutationError = ErrorType<unknown>

    /**
 * @summary Update a currency
 */
export const useUpdateCurrency = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrency>>, TError,{id: number;data: BodyType<CurrencyUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCurrency>>,
        TError,
        {id: number;data: BodyType<CurrencyUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCurrencyMutationOptions(options));
    }

export const getListRolesUrl = () => {




  return `/api/roles`
}

/**
 * @summary List all roles
 */
export const listRoles = async ( options?: RequestInit): Promise<Role[]> => {

  return customFetch<Role[]>(getListRolesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRolesQueryKey = () => {
    return [
    `/api/roles`
    ] as const;
    }


export const getListRolesQueryOptions = <TData = Awaited<ReturnType<typeof listRoles>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoles>>> = ({ signal }) => listRoles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listRoles>>>
export type ListRolesQueryError = ErrorType<unknown>


/**
 * @summary List all roles
 */

export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRolesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateRoleUrl = () => {




  return `/api/roles`
}

/**
 * @summary Create a role
 */
export const createRole = async (roleInput: RoleInput, options?: RequestInit): Promise<Role> => {

  return customFetch<Role>(getCreateRoleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleInput,)
  }
);}




export const getCreateRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: BodyType<RoleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: BodyType<RoleInput>}, TContext> => {

const mutationKey = ['createRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRole>>, {data: BodyType<RoleInput>}> = (props) => {
          const {data} = props ?? {};

          return  createRole(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof createRole>>>
    export type CreateRoleMutationBody = BodyType<RoleInput>
    export type CreateRoleMutationError = ErrorType<unknown>

    /**
 * @summary Create a role
 */
export const useCreateRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: BodyType<RoleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRole>>,
        TError,
        {data: BodyType<RoleInput>},
        TContext
      > => {
      return useMutation(getCreateRoleMutationOptions(options));
    }

export const getGetRoleUrl = (id: number,) => {




  return `/api/roles/${id}`
}

/**
 * @summary Get a role with full permission matrix
 */
export const getRole = async (id: number, options?: RequestInit): Promise<RoleDetail> => {

  return customFetch<RoleDetail>(getGetRoleUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoleQueryKey = (id: number,) => {
    return [
    `/api/roles/${id}`
    ] as const;
    }


export const getGetRoleQueryOptions = <TData = Awaited<ReturnType<typeof getRole>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRole>>> = ({ signal }) => getRole(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getRole>>>
export type GetRoleQueryError = ErrorType<unknown>


/**
 * @summary Get a role with full permission matrix
 */

export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRoleQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateRoleUrl = (id: number,) => {




  return `/api/roles/${id}`
}

/**
 * @summary Update role name/description and permissions
 */
export const updateRole = async (id: number,
    roleUpdate: RoleUpdate, options?: RequestInit): Promise<RoleDetail> => {

  return customFetch<RoleDetail>(getUpdateRoleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleUpdate,)
  }
);}




export const getUpdateRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: number;data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: number;data: BodyType<RoleUpdate>}, TContext> => {

const mutationKey = ['updateRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRole>>, {id: number;data: BodyType<RoleUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRole>>>
    export type UpdateRoleMutationBody = BodyType<RoleUpdate>
    export type UpdateRoleMutationError = ErrorType<unknown>

    /**
 * @summary Update role name/description and permissions
 */
export const useUpdateRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: number;data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRole>>,
        TError,
        {id: number;data: BodyType<RoleUpdate>},
        TContext
      > => {
      return useMutation(getUpdateRoleMutationOptions(options));
    }

export const getDeleteRoleUrl = (id: number,) => {




  return `/api/roles/${id}`
}

/**
 * @summary Delete a role
 */
export const deleteRole = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteRoleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRole>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRole(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRole>>>

    export type DeleteRoleMutationError = ErrorType<unknown>

    /**
 * @summary Delete a role
 */
export const useDeleteRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteRole>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteRoleMutationOptions(options));
    }

export const getListUsersUrl = () => {




  return `/api/users`
}

/**
 * @summary List all users in the tenant
 */
export const listUsers = async ( options?: RequestInit): Promise<TenantUser[]> => {

  return customFetch<TenantUser[]>(getListUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = () => {
    return [
    `/api/users`
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<unknown>


/**
 * @summary List all users in the tenant
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getInviteUserUrl = () => {




  return `/api/users/invite`
}

/**
 * @summary Invite a new user to the tenant
 */
export const inviteUser = async (userInvite: UserInvite, options?: RequestInit): Promise<TenantUser> => {

  return customFetch<TenantUser>(getInviteUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userInvite,)
  }
);}




export const getInviteUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: BodyType<UserInvite>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: BodyType<UserInvite>}, TContext> => {

const mutationKey = ['inviteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteUser>>, {data: BodyType<UserInvite>}> = (props) => {
          const {data} = props ?? {};

          return  inviteUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteUserMutationResult = NonNullable<Awaited<ReturnType<typeof inviteUser>>>
    export type InviteUserMutationBody = BodyType<UserInvite>
    export type InviteUserMutationError = ErrorType<unknown>

    /**
 * @summary Invite a new user to the tenant
 */
export const useInviteUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: BodyType<UserInvite>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof inviteUser>>,
        TError,
        {data: BodyType<UserInvite>},
        TContext
      > => {
      return useMutation(getInviteUserMutationOptions(options));
    }

export const getUpdateUserUrl = (id: string,) => {




  return `/api/users/${id}`
}

/**
 * @summary Update a user (role, status)
 */
export const updateUser = async (id: string,
    userUpdate: UserUpdate, options?: RequestInit): Promise<TenantUser> => {

  return customFetch<TenantUser>(getUpdateUserUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userUpdate,)
  }
);}




export const getUpdateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: BodyType<UserUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: BodyType<UserUpdate>}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {id: string;data: BodyType<UserUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = BodyType<UserUpdate>
    export type UpdateUserMutationError = ErrorType<unknown>

    /**
 * @summary Update a user (role, status)
 */
export const useUpdateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: BodyType<UserUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {id: string;data: BodyType<UserUpdate>},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options));
    }

export const getRemoveUserUrl = (id: string,) => {




  return `/api/users/${id}`
}

/**
 * @summary Remove a user from the tenant
 */
export const removeUser = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRemoveUserUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['removeUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  removeUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveUserMutationResult = NonNullable<Awaited<ReturnType<typeof removeUser>>>

    export type RemoveUserMutationError = ErrorType<unknown>

    /**
 * @summary Remove a user from the tenant
 */
export const useRemoveUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRemoveUserMutationOptions(options));
    }

export const getListAuditLogUrl = (params?: ListAuditLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit-log?${stringifiedParams}` : `/api/audit-log`
}

/**
 * @summary List audit log entries
 */
export const listAuditLog = async (params?: ListAuditLogParams, options?: RequestInit): Promise<AuditLogPage> => {

  return customFetch<AuditLogPage>(getListAuditLogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditLogQueryKey = (params?: ListAuditLogParams,) => {
    return [
    `/api/audit-log`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLog>>, TError = ErrorType<unknown>>(params?: ListAuditLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLog>>> = ({ signal }) => listAuditLog(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLog>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLog>>>
export type ListAuditLogQueryError = ErrorType<unknown>


/**
 * @summary List audit log entries
 */

export function useListAuditLog<TData = Awaited<ReturnType<typeof listAuditLog>>, TError = ErrorType<unknown>>(
 params?: ListAuditLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAuditLogQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListNotificationsUrl = () => {




  return `/api/notifications`
}

/**
 * @summary List notifications for current user
 */
export const listNotifications = async ( options?: RequestInit): Promise<Notification[]> => {

  return customFetch<Notification[]>(getListNotificationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = () => {
    return [
    `/api/notifications`
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = ErrorType<unknown>


/**
 * @summary List notifications for current user
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getMarkNotificationReadUrl = (id: number,) => {




  return `/api/notifications/${id}/read`
}

/**
 * @summary Mark a notification as read
 */
export const markNotificationRead = async (id: number, options?: RequestInit): Promise<Notification> => {

  return customFetch<Notification>(getMarkNotificationReadUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getMarkNotificationReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext> => {

const mutationKey = ['markNotificationRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationRead>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markNotificationRead(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>

    export type MarkNotificationReadMutationError = ErrorType<unknown>

    /**
 * @summary Mark a notification as read
 */
export const useMarkNotificationRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationRead>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkNotificationReadMutationOptions(options));
    }

export const getMarkAllNotificationsReadUrl = () => {




  return `/api/notifications/read-all`
}

/**
 * @summary Mark all notifications as read
 */
export const markAllNotificationsRead = async ( options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getMarkAllNotificationsReadUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getMarkAllNotificationsReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,void, TContext> => {

const mutationKey = ['markAllNotificationsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllNotificationsRead>>, void> = () => {


          return  markAllNotificationsRead(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAllNotificationsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllNotificationsRead>>>

    export type MarkAllNotificationsReadMutationError = ErrorType<unknown>

    /**
 * @summary Mark all notifications as read
 */
export const useMarkAllNotificationsRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markAllNotificationsRead>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkAllNotificationsReadMutationOptions(options));
    }

export const getListCustomDomainsUrl = () => {




  return `/api/custom-domains`
}

/**
 * @summary List custom domains for the tenant
 */
export const listCustomDomains = async ( options?: RequestInit): Promise<CustomDomain[]> => {

  return customFetch<CustomDomain[]>(getListCustomDomainsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomDomainsQueryKey = () => {
    return [
    `/api/custom-domains`
    ] as const;
    }


export const getListCustomDomainsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomDomains>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomDomains>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomDomainsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomDomains>>> = ({ signal }) => listCustomDomains({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomDomains>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomDomains>>>
export type ListCustomDomainsQueryError = ErrorType<unknown>


/**
 * @summary List custom domains for the tenant
 */

export function useListCustomDomains<TData = Awaited<ReturnType<typeof listCustomDomains>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomDomains>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomDomainsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAddCustomDomainUrl = () => {




  return `/api/custom-domains`
}

/**
 * @summary Add a custom domain (generates TXT verification token)
 */
export const addCustomDomain = async (customDomainInput: CustomDomainInput, options?: RequestInit): Promise<CustomDomain> => {

  return customFetch<CustomDomain>(getAddCustomDomainUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customDomainInput,)
  }
);}




export const getAddCustomDomainMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomDomain>>, TError,{data: BodyType<CustomDomainInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addCustomDomain>>, TError,{data: BodyType<CustomDomainInput>}, TContext> => {

const mutationKey = ['addCustomDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCustomDomain>>, {data: BodyType<CustomDomainInput>}> = (props) => {
          const {data} = props ?? {};

          return  addCustomDomain(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof addCustomDomain>>>
    export type AddCustomDomainMutationBody = BodyType<CustomDomainInput>
    export type AddCustomDomainMutationError = ErrorType<unknown>

    /**
 * @summary Add a custom domain (generates TXT verification token)
 */
export const useAddCustomDomain = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomDomain>>, TError,{data: BodyType<CustomDomainInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addCustomDomain>>,
        TError,
        {data: BodyType<CustomDomainInput>},
        TContext
      > => {
      return useMutation(getAddCustomDomainMutationOptions(options));
    }

export const getVerifyCustomDomainUrl = (id: number,) => {




  return `/api/custom-domains/${id}/verify`
}

/**
 * @summary Trigger DNS verification for a custom domain
 */
export const verifyCustomDomain = async (id: number, options?: RequestInit): Promise<CustomDomain> => {

  return customFetch<CustomDomain>(getVerifyCustomDomainUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getVerifyCustomDomainMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCustomDomain>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyCustomDomain>>, TError,{id: number}, TContext> => {

const mutationKey = ['verifyCustomDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCustomDomain>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  verifyCustomDomain(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCustomDomain>>>

    export type VerifyCustomDomainMutationError = ErrorType<unknown>

    /**
 * @summary Trigger DNS verification for a custom domain
 */
export const useVerifyCustomDomain = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCustomDomain>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyCustomDomain>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getVerifyCustomDomainMutationOptions(options));
    }

export const getRenewCertUrl = (id: number,) => {




  return `/api/custom-domains/${id}/renew-cert`
}

/**
 * @summary Manually trigger TLS certificate renewal for a verified domain
 */
export const renewCert = async (id: number, options?: RequestInit): Promise<CustomDomain> => {

  return customFetch<CustomDomain>(getRenewCertUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRenewCertMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewCert>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renewCert>>, TError,{id: number}, TContext> => {

const mutationKey = ['renewCert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renewCert>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  renewCert(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenewCertMutationResult = NonNullable<Awaited<ReturnType<typeof renewCert>>>

    export type RenewCertMutationError = ErrorType<void>

    /**
 * @summary Manually trigger TLS certificate renewal for a verified domain
 */
export const useRenewCert = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewCert>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof renewCert>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRenewCertMutationOptions(options));
    }

export const getDeleteCustomDomainUrl = (id: number,) => {




  return `/api/custom-domains/${id}`
}

/**
 * @summary Remove a custom domain
 */
export const deleteCustomDomain = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomDomainUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCustomDomainMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomDomain>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomDomain>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCustomDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomDomain>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomDomain(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomDomain>>>

    export type DeleteCustomDomainMutationError = ErrorType<unknown>

    /**
 * @summary Remove a custom domain
 */
export const useDeleteCustomDomain = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomDomain>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomDomain>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCustomDomainMutationOptions(options));
    }

export const getGetDashboardStatsUrl = () => {




  return `/api/dashboard/stats`
}

/**
 * @summary Get dashboard summary stats (headcount, modules, pending approvals, recent activity)
 */
export const getDashboardStats = async ( options?: RequestInit): Promise<DashboardStats> => {

  return customFetch<DashboardStats>(getGetDashboardStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardStatsQueryKey = () => {
    return [
    `/api/dashboard/stats`
    ] as const;
    }


export const getGetDashboardStatsQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardStats>>> = ({ signal }) => getDashboardStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardStats>>>
export type GetDashboardStatsQueryError = ErrorType<unknown>


/**
 * @summary Get dashboard summary stats (headcount, modules, pending approvals, recent activity)
 */

export function useGetDashboardStats<TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDashboardActivityUrl = () => {




  return `/api/dashboard/activity`
}

/**
 * @summary Get recent activity feed
 */
export const getDashboardActivity = async ( options?: RequestInit): Promise<ActivityItem[]> => {

  return customFetch<ActivityItem[]>(getGetDashboardActivityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardActivityQueryKey = () => {
    return [
    `/api/dashboard/activity`
    ] as const;
    }


export const getGetDashboardActivityQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardActivity>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardActivityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardActivity>>> = ({ signal }) => getDashboardActivity({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardActivity>>>
export type GetDashboardActivityQueryError = ErrorType<unknown>


/**
 * @summary Get recent activity feed
 */

export function useGetDashboardActivity<TData = Awaited<ReturnType<typeof getDashboardActivity>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardActivityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListApprovalWorkflowsUrl = () => {




  return `/api/approval-workflows`
}

/**
 * @summary List all approval workflows for the current tenant
 */
export const listApprovalWorkflows = async ( options?: RequestInit): Promise<ApprovalWorkflow[]> => {

  return customFetch<ApprovalWorkflow[]>(getListApprovalWorkflowsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListApprovalWorkflowsQueryKey = () => {
    return [
    `/api/approval-workflows`
    ] as const;
    }


export const getListApprovalWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof listApprovalWorkflows>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApprovalWorkflows>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApprovalWorkflowsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApprovalWorkflows>>> = ({ signal }) => listApprovalWorkflows({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApprovalWorkflows>>, TError, TData> & { queryKey: QueryKey }
}

export type ListApprovalWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof listApprovalWorkflows>>>
export type ListApprovalWorkflowsQueryError = ErrorType<unknown>


/**
 * @summary List all approval workflows for the current tenant
 */

export function useListApprovalWorkflows<TData = Awaited<ReturnType<typeof listApprovalWorkflows>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApprovalWorkflows>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListApprovalWorkflowsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateApprovalWorkflowUrl = () => {




  return `/api/approval-workflows`
}

/**
 * @summary Create an approval workflow
 */
export const createApprovalWorkflow = async (approvalWorkflowInput: ApprovalWorkflowInput, options?: RequestInit): Promise<ApprovalWorkflow> => {

  return customFetch<ApprovalWorkflow>(getCreateApprovalWorkflowUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approvalWorkflowInput,)
  }
);}




export const getCreateApprovalWorkflowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApprovalWorkflow>>, TError,{data: BodyType<ApprovalWorkflowInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createApprovalWorkflow>>, TError,{data: BodyType<ApprovalWorkflowInput>}, TContext> => {

const mutationKey = ['createApprovalWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApprovalWorkflow>>, {data: BodyType<ApprovalWorkflowInput>}> = (props) => {
          const {data} = props ?? {};

          return  createApprovalWorkflow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateApprovalWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof createApprovalWorkflow>>>
    export type CreateApprovalWorkflowMutationBody = BodyType<ApprovalWorkflowInput>
    export type CreateApprovalWorkflowMutationError = ErrorType<unknown>

    /**
 * @summary Create an approval workflow
 */
export const useCreateApprovalWorkflow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApprovalWorkflow>>, TError,{data: BodyType<ApprovalWorkflowInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createApprovalWorkflow>>,
        TError,
        {data: BodyType<ApprovalWorkflowInput>},
        TContext
      > => {
      return useMutation(getCreateApprovalWorkflowMutationOptions(options));
    }

export const getGetApprovalWorkflowUrl = (id: number,) => {




  return `/api/approval-workflows/${id}`
}

/**
 * @summary Get a single approval workflow
 */
export const getApprovalWorkflow = async (id: number, options?: RequestInit): Promise<ApprovalWorkflow> => {

  return customFetch<ApprovalWorkflow>(getGetApprovalWorkflowUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApprovalWorkflowQueryKey = (id: number,) => {
    return [
    `/api/approval-workflows/${id}`
    ] as const;
    }


export const getGetApprovalWorkflowQueryOptions = <TData = Awaited<ReturnType<typeof getApprovalWorkflow>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApprovalWorkflow>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalWorkflowQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalWorkflow>>> = ({ signal }) => getApprovalWorkflow(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApprovalWorkflow>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApprovalWorkflowQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalWorkflow>>>
export type GetApprovalWorkflowQueryError = ErrorType<unknown>


/**
 * @summary Get a single approval workflow
 */

export function useGetApprovalWorkflow<TData = Awaited<ReturnType<typeof getApprovalWorkflow>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApprovalWorkflow>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApprovalWorkflowQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateApprovalWorkflowUrl = (id: number,) => {




  return `/api/approval-workflows/${id}`
}

/**
 * @summary Update an approval workflow
 */
export const updateApprovalWorkflow = async (id: number,
    approvalWorkflowUpdate: ApprovalWorkflowUpdate, options?: RequestInit): Promise<ApprovalWorkflow> => {

  return customFetch<ApprovalWorkflow>(getUpdateApprovalWorkflowUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approvalWorkflowUpdate,)
  }
);}




export const getUpdateApprovalWorkflowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApprovalWorkflow>>, TError,{id: number;data: BodyType<ApprovalWorkflowUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateApprovalWorkflow>>, TError,{id: number;data: BodyType<ApprovalWorkflowUpdate>}, TContext> => {

const mutationKey = ['updateApprovalWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateApprovalWorkflow>>, {id: number;data: BodyType<ApprovalWorkflowUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateApprovalWorkflow(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateApprovalWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof updateApprovalWorkflow>>>
    export type UpdateApprovalWorkflowMutationBody = BodyType<ApprovalWorkflowUpdate>
    export type UpdateApprovalWorkflowMutationError = ErrorType<unknown>

    /**
 * @summary Update an approval workflow
 */
export const useUpdateApprovalWorkflow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApprovalWorkflow>>, TError,{id: number;data: BodyType<ApprovalWorkflowUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateApprovalWorkflow>>,
        TError,
        {id: number;data: BodyType<ApprovalWorkflowUpdate>},
        TContext
      > => {
      return useMutation(getUpdateApprovalWorkflowMutationOptions(options));
    }

export const getDeleteApprovalWorkflowUrl = (id: number,) => {




  return `/api/approval-workflows/${id}`
}

/**
 * @summary Delete an approval workflow
 */
export const deleteApprovalWorkflow = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteApprovalWorkflowUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApprovalWorkflowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApprovalWorkflow>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApprovalWorkflow>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteApprovalWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApprovalWorkflow>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteApprovalWorkflow(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApprovalWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApprovalWorkflow>>>

    export type DeleteApprovalWorkflowMutationError = ErrorType<unknown>

    /**
 * @summary Delete an approval workflow
 */
export const useDeleteApprovalWorkflow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApprovalWorkflow>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApprovalWorkflow>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteApprovalWorkflowMutationOptions(options));
    }

export const getListTenantsUrl = () => {




  return `/api/admin/tenants`
}

/**
 * @summary Super-admin — list all tenants with domain and cert status
 */
export const listTenants = async ( options?: RequestInit): Promise<TenantSummary[]> => {

  return customFetch<TenantSummary[]>(getListTenantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTenantsQueryKey = () => {
    return [
    `/api/admin/tenants`
    ] as const;
    }


export const getListTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listTenants>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenants>>> = ({ signal }) => listTenants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listTenants>>>
export type ListTenantsQueryError = ErrorType<unknown>


/**
 * @summary Super-admin — list all tenants with domain and cert status
 */

export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTenantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListEmployeesUrl = (params?: ListEmployeesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/employees?${stringifiedParams}` : `/api/hr/employees`
}

/**
 * @summary List all employees
 */
export const listEmployees = async (params?: ListEmployeesParams, options?: RequestInit): Promise<Employee[]> => {

  return customFetch<Employee[]>(getListEmployeesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmployeesQueryKey = (params?: ListEmployeesParams,) => {
    return [
    `/api/hr/employees`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof listEmployees>>, TError = ErrorType<unknown>>(params?: ListEmployeesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmployeesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployees>>> = ({ signal }) => listEmployees(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployees>>>
export type ListEmployeesQueryError = ErrorType<unknown>


/**
 * @summary List all employees
 */

export function useListEmployees<TData = Awaited<ReturnType<typeof listEmployees>>, TError = ErrorType<unknown>>(
 params?: ListEmployeesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEmployeesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateEmployeeUrl = () => {




  return `/api/hr/employees`
}

/**
 * @summary Create an employee record
 */
export const createEmployee = async (employeeInput: EmployeeInput, options?: RequestInit): Promise<Employee> => {

  return customFetch<Employee>(getCreateEmployeeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeInput,)
  }
);}




export const getCreateEmployeeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: BodyType<EmployeeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: BodyType<EmployeeInput>}, TContext> => {

const mutationKey = ['createEmployee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployee>>, {data: BodyType<EmployeeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createEmployee(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployee>>>
    export type CreateEmployeeMutationBody = BodyType<EmployeeInput>
    export type CreateEmployeeMutationError = ErrorType<unknown>

    /**
 * @summary Create an employee record
 */
export const useCreateEmployee = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: BodyType<EmployeeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEmployee>>,
        TError,
        {data: BodyType<EmployeeInput>},
        TContext
      > => {
      return useMutation(getCreateEmployeeMutationOptions(options));
    }

export const getImportEmployeesUrl = () => {




  return `/api/hr/employees/import`
}

/**
 * @summary Bulk import employees from CSV
 */
export const importEmployees = async (importEmployeesBody: string, options?: RequestInit): Promise<CsvImportResult> => {

  return customFetch<CsvImportResult>(getImportEmployeesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/csv', ...options?.headers },
    body: JSON.stringify(
      importEmployeesBody,)
  }
);}




export const getImportEmployeesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importEmployees>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importEmployees>>, TError,{data: BodyType<string>}, TContext> => {

const mutationKey = ['importEmployees'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importEmployees>>, {data: BodyType<string>}> = (props) => {
          const {data} = props ?? {};

          return  importEmployees(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportEmployeesMutationResult = NonNullable<Awaited<ReturnType<typeof importEmployees>>>
    export type ImportEmployeesMutationBody = BodyType<string>
    export type ImportEmployeesMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import employees from CSV
 */
export const useImportEmployees = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importEmployees>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importEmployees>>,
        TError,
        {data: BodyType<string>},
        TContext
      > => {
      return useMutation(getImportEmployeesMutationOptions(options));
    }

export const getGetEmployeeUrl = (id: number,) => {




  return `/api/hr/employees/${id}`
}

/**
 * @summary Get employee details
 */
export const getEmployee = async (id: number, options?: RequestInit): Promise<Employee> => {

  return customFetch<Employee>(getGetEmployeeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmployeeQueryKey = (id: number,) => {
    return [
    `/api/hr/employees/${id}`
    ] as const;
    }


export const getGetEmployeeQueryOptions = <TData = Awaited<ReturnType<typeof getEmployee>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployee>>> = ({ signal }) => getEmployee(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeeQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployee>>>
export type GetEmployeeQueryError = ErrorType<unknown>


/**
 * @summary Get employee details
 */

export function useGetEmployee<TData = Awaited<ReturnType<typeof getEmployee>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployeeQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateEmployeeUrl = (id: number,) => {




  return `/api/hr/employees/${id}`
}

/**
 * @summary Update employee details
 */
export const updateEmployee = async (id: number,
    employeeUpdate: EmployeeUpdate, options?: RequestInit): Promise<Employee> => {

  return customFetch<Employee>(getUpdateEmployeeUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeUpdate,)
  }
);}




export const getUpdateEmployeeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployee>>, TError,{id: number;data: BodyType<EmployeeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployee>>, TError,{id: number;data: BodyType<EmployeeUpdate>}, TContext> => {

const mutationKey = ['updateEmployee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployee>>, {id: number;data: BodyType<EmployeeUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployee(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployee>>>
    export type UpdateEmployeeMutationBody = BodyType<EmployeeUpdate>
    export type UpdateEmployeeMutationError = ErrorType<unknown>

    /**
 * @summary Update employee details
 */
export const useUpdateEmployee = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployee>>, TError,{id: number;data: BodyType<EmployeeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployee>>,
        TError,
        {id: number;data: BodyType<EmployeeUpdate>},
        TContext
      > => {
      return useMutation(getUpdateEmployeeMutationOptions(options));
    }

export const getDeleteEmployeeUrl = (id: number,) => {




  return `/api/hr/employees/${id}`
}

/**
 * @summary Delete an employee record
 */
export const deleteEmployee = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteEmployeeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEmployeeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployee>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployee>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteEmployee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployee>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployee(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployee>>>

    export type DeleteEmployeeMutationError = ErrorType<unknown>

    /**
 * @summary Delete an employee record
 */
export const useDeleteEmployee = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployee>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployee>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteEmployeeMutationOptions(options));
    }

export const getEmployeeLifecycleActionUrl = (id: number,) => {




  return `/api/hr/employees/${id}/lifecycle`
}

/**
 * @summary Perform a lifecycle action: confirm, transfer, promote, resign, terminate
 */
export const employeeLifecycleAction = async (id: number,
    employeeLifecycleAction: EmployeeLifecycleAction, options?: RequestInit): Promise<Employee> => {

  return customFetch<Employee>(getEmployeeLifecycleActionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeLifecycleAction,)
  }
);}




export const getEmployeeLifecycleActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeeLifecycleAction>>, TError,{id: number;data: BodyType<EmployeeLifecycleAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof employeeLifecycleAction>>, TError,{id: number;data: BodyType<EmployeeLifecycleAction>}, TContext> => {

const mutationKey = ['employeeLifecycleAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeeLifecycleAction>>, {id: number;data: BodyType<EmployeeLifecycleAction>}> = (props) => {
          const {id,data} = props ?? {};

          return  employeeLifecycleAction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmployeeLifecycleActionMutationResult = NonNullable<Awaited<ReturnType<typeof employeeLifecycleAction>>>
    export type EmployeeLifecycleActionMutationBody = BodyType<EmployeeLifecycleAction>
    export type EmployeeLifecycleActionMutationError = ErrorType<unknown>

    /**
 * @summary Perform a lifecycle action: confirm, transfer, promote, resign, terminate
 */
export const useEmployeeLifecycleAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeeLifecycleAction>>, TError,{id: number;data: BodyType<EmployeeLifecycleAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof employeeLifecycleAction>>,
        TError,
        {id: number;data: BodyType<EmployeeLifecycleAction>},
        TContext
      > => {
      return useMutation(getEmployeeLifecycleActionMutationOptions(options));
    }

export const getListEmployeeDocumentsUrl = (id: number,) => {




  return `/api/hr/employees/${id}/documents`
}

/**
 * @summary List documents for an employee
 */
export const listEmployeeDocuments = async (id: number, options?: RequestInit): Promise<EmployeeDocument[]> => {

  return customFetch<EmployeeDocument[]>(getListEmployeeDocumentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmployeeDocumentsQueryKey = (id: number,) => {
    return [
    `/api/hr/employees/${id}/documents`
    ] as const;
    }


export const getListEmployeeDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listEmployeeDocuments>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployeeDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmployeeDocumentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployeeDocuments>>> = ({ signal }) => listEmployeeDocuments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmployeeDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEmployeeDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployeeDocuments>>>
export type ListEmployeeDocumentsQueryError = ErrorType<unknown>


/**
 * @summary List documents for an employee
 */

export function useListEmployeeDocuments<TData = Awaited<ReturnType<typeof listEmployeeDocuments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployeeDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEmployeeDocumentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateEmployeeDocumentUrl = (id: number,) => {




  return `/api/hr/employees/${id}/documents`
}

/**
 * @summary Add a document to an employee's vault
 */
export const createEmployeeDocument = async (id: number,
    employeeDocumentInput: EmployeeDocumentInput, options?: RequestInit): Promise<EmployeeDocument> => {

  return customFetch<EmployeeDocument>(getCreateEmployeeDocumentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeDocumentInput,)
  }
);}




export const getCreateEmployeeDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeDocument>>, TError,{id: number;data: BodyType<EmployeeDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployeeDocument>>, TError,{id: number;data: BodyType<EmployeeDocumentInput>}, TContext> => {

const mutationKey = ['createEmployeeDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployeeDocument>>, {id: number;data: BodyType<EmployeeDocumentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createEmployeeDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployeeDocument>>>
    export type CreateEmployeeDocumentMutationBody = BodyType<EmployeeDocumentInput>
    export type CreateEmployeeDocumentMutationError = ErrorType<unknown>

    /**
 * @summary Add a document to an employee's vault
 */
export const useCreateEmployeeDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeDocument>>, TError,{id: number;data: BodyType<EmployeeDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEmployeeDocument>>,
        TError,
        {id: number;data: BodyType<EmployeeDocumentInput>},
        TContext
      > => {
      return useMutation(getCreateEmployeeDocumentMutationOptions(options));
    }

export const getDeleteEmployeeDocumentUrl = (id: number,
    docId: number,) => {




  return `/api/hr/employees/${id}/documents/${docId}`
}

/**
 * @summary Delete an employee document
 */
export const deleteEmployeeDocument = async (id: number,
    docId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteEmployeeDocumentUrl(id,docId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEmployeeDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeDocument>>, TError,{id: number;docId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeDocument>>, TError,{id: number;docId: number}, TContext> => {

const mutationKey = ['deleteEmployeeDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeDocument>>, {id: number;docId: number}> = (props) => {
          const {id,docId} = props ?? {};

          return  deleteEmployeeDocument(id,docId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeDocument>>>

    export type DeleteEmployeeDocumentMutationError = ErrorType<unknown>

    /**
 * @summary Delete an employee document
 */
export const useDeleteEmployeeDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeDocument>>, TError,{id: number;docId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployeeDocument>>,
        TError,
        {id: number;docId: number},
        TContext
      > => {
      return useMutation(getDeleteEmployeeDocumentMutationOptions(options));
    }

export const getGetOrgChartUrl = () => {




  return `/api/hr/org-chart`
}

/**
 * @summary Get org chart data (reporting lines)
 */
export const getOrgChart = async ( options?: RequestInit): Promise<OrgChartNode[]> => {

  return customFetch<OrgChartNode[]>(getGetOrgChartUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgChartQueryKey = () => {
    return [
    `/api/hr/org-chart`
    ] as const;
    }


export const getGetOrgChartQueryOptions = <TData = Awaited<ReturnType<typeof getOrgChart>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgChart>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgChartQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgChart>>> = ({ signal }) => getOrgChart({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgChart>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgChartQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgChart>>>
export type GetOrgChartQueryError = ErrorType<unknown>


/**
 * @summary Get org chart data (reporting lines)
 */

export function useGetOrgChart<TData = Awaited<ReturnType<typeof getOrgChart>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgChart>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgChartQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListLeaveTypesUrl = () => {




  return `/api/hr/leave-types`
}

/**
 * @summary List all leave types
 */
export const listLeaveTypes = async ( options?: RequestInit): Promise<LeaveType[]> => {

  return customFetch<LeaveType[]>(getListLeaveTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLeaveTypesQueryKey = () => {
    return [
    `/api/hr/leave-types`
    ] as const;
    }


export const getListLeaveTypesQueryOptions = <TData = Awaited<ReturnType<typeof listLeaveTypes>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeaveTypes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLeaveTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeaveTypes>>> = ({ signal }) => listLeaveTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeaveTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLeaveTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listLeaveTypes>>>
export type ListLeaveTypesQueryError = ErrorType<unknown>


/**
 * @summary List all leave types
 */

export function useListLeaveTypes<TData = Awaited<ReturnType<typeof listLeaveTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeaveTypes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLeaveTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateLeaveTypeUrl = () => {




  return `/api/hr/leave-types`
}

/**
 * @summary Create a leave type
 */
export const createLeaveType = async (leaveTypeInput: LeaveTypeInput, options?: RequestInit): Promise<LeaveType> => {

  return customFetch<LeaveType>(getCreateLeaveTypeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveTypeInput,)
  }
);}




export const getCreateLeaveTypeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeaveType>>, TError,{data: BodyType<LeaveTypeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLeaveType>>, TError,{data: BodyType<LeaveTypeInput>}, TContext> => {

const mutationKey = ['createLeaveType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLeaveType>>, {data: BodyType<LeaveTypeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createLeaveType(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLeaveTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createLeaveType>>>
    export type CreateLeaveTypeMutationBody = BodyType<LeaveTypeInput>
    export type CreateLeaveTypeMutationError = ErrorType<unknown>

    /**
 * @summary Create a leave type
 */
export const useCreateLeaveType = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeaveType>>, TError,{data: BodyType<LeaveTypeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLeaveType>>,
        TError,
        {data: BodyType<LeaveTypeInput>},
        TContext
      > => {
      return useMutation(getCreateLeaveTypeMutationOptions(options));
    }

export const getUpdateLeaveTypeUrl = (id: number,) => {




  return `/api/hr/leave-types/${id}`
}

/**
 * @summary Update a leave type
 */
export const updateLeaveType = async (id: number,
    leaveTypeUpdate: LeaveTypeUpdate, options?: RequestInit): Promise<LeaveType> => {

  return customFetch<LeaveType>(getUpdateLeaveTypeUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveTypeUpdate,)
  }
);}




export const getUpdateLeaveTypeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeaveType>>, TError,{id: number;data: BodyType<LeaveTypeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLeaveType>>, TError,{id: number;data: BodyType<LeaveTypeUpdate>}, TContext> => {

const mutationKey = ['updateLeaveType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLeaveType>>, {id: number;data: BodyType<LeaveTypeUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLeaveType(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeaveTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateLeaveType>>>
    export type UpdateLeaveTypeMutationBody = BodyType<LeaveTypeUpdate>
    export type UpdateLeaveTypeMutationError = ErrorType<unknown>

    /**
 * @summary Update a leave type
 */
export const useUpdateLeaveType = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeaveType>>, TError,{id: number;data: BodyType<LeaveTypeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLeaveType>>,
        TError,
        {id: number;data: BodyType<LeaveTypeUpdate>},
        TContext
      > => {
      return useMutation(getUpdateLeaveTypeMutationOptions(options));
    }

export const getDeleteLeaveTypeUrl = (id: number,) => {




  return `/api/hr/leave-types/${id}`
}

/**
 * @summary Delete a leave type
 */
export const deleteLeaveType = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLeaveTypeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLeaveTypeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeaveType>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLeaveType>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteLeaveType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLeaveType>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteLeaveType(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLeaveTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLeaveType>>>

    export type DeleteLeaveTypeMutationError = ErrorType<unknown>

    /**
 * @summary Delete a leave type
 */
export const useDeleteLeaveType = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeaveType>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLeaveType>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteLeaveTypeMutationOptions(options));
    }

export const getListLeaveBalancesUrl = (params?: ListLeaveBalancesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/leave-balances?${stringifiedParams}` : `/api/hr/leave-balances`
}

/**
 * @summary List leave balances (optionally filter by employee or fiscal year)
 */
export const listLeaveBalances = async (params?: ListLeaveBalancesParams, options?: RequestInit): Promise<LeaveBalance[]> => {

  return customFetch<LeaveBalance[]>(getListLeaveBalancesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLeaveBalancesQueryKey = (params?: ListLeaveBalancesParams,) => {
    return [
    `/api/hr/leave-balances`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLeaveBalancesQueryOptions = <TData = Awaited<ReturnType<typeof listLeaveBalances>>, TError = ErrorType<unknown>>(params?: ListLeaveBalancesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeaveBalances>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLeaveBalancesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeaveBalances>>> = ({ signal }) => listLeaveBalances(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeaveBalances>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLeaveBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof listLeaveBalances>>>
export type ListLeaveBalancesQueryError = ErrorType<unknown>


/**
 * @summary List leave balances (optionally filter by employee or fiscal year)
 */

export function useListLeaveBalances<TData = Awaited<ReturnType<typeof listLeaveBalances>>, TError = ErrorType<unknown>>(
 params?: ListLeaveBalancesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeaveBalances>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLeaveBalancesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAdjustLeaveBalanceUrl = () => {




  return `/api/hr/leave-balances/adjust`
}

/**
 * @summary Manually adjust a leave balance
 */
export const adjustLeaveBalance = async (leaveBalanceAdjustment: LeaveBalanceAdjustment, options?: RequestInit): Promise<LeaveBalance> => {

  return customFetch<LeaveBalance>(getAdjustLeaveBalanceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveBalanceAdjustment,)
  }
);}




export const getAdjustLeaveBalanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustLeaveBalance>>, TError,{data: BodyType<LeaveBalanceAdjustment>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adjustLeaveBalance>>, TError,{data: BodyType<LeaveBalanceAdjustment>}, TContext> => {

const mutationKey = ['adjustLeaveBalance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adjustLeaveBalance>>, {data: BodyType<LeaveBalanceAdjustment>}> = (props) => {
          const {data} = props ?? {};

          return  adjustLeaveBalance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdjustLeaveBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof adjustLeaveBalance>>>
    export type AdjustLeaveBalanceMutationBody = BodyType<LeaveBalanceAdjustment>
    export type AdjustLeaveBalanceMutationError = ErrorType<unknown>

    /**
 * @summary Manually adjust a leave balance
 */
export const useAdjustLeaveBalance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustLeaveBalance>>, TError,{data: BodyType<LeaveBalanceAdjustment>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adjustLeaveBalance>>,
        TError,
        {data: BodyType<LeaveBalanceAdjustment>},
        TContext
      > => {
      return useMutation(getAdjustLeaveBalanceMutationOptions(options));
    }

export const getImportLeaveBalancesUrl = () => {




  return `/api/hr/leave-balances/import`
}

/**
 * @summary Bulk import opening leave balances from CSV
 */
export const importLeaveBalances = async (importLeaveBalancesBody: string, options?: RequestInit): Promise<CsvImportResult> => {

  return customFetch<CsvImportResult>(getImportLeaveBalancesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/csv', ...options?.headers },
    body: JSON.stringify(
      importLeaveBalancesBody,)
  }
);}




export const getImportLeaveBalancesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importLeaveBalances>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importLeaveBalances>>, TError,{data: BodyType<string>}, TContext> => {

const mutationKey = ['importLeaveBalances'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importLeaveBalances>>, {data: BodyType<string>}> = (props) => {
          const {data} = props ?? {};

          return  importLeaveBalances(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportLeaveBalancesMutationResult = NonNullable<Awaited<ReturnType<typeof importLeaveBalances>>>
    export type ImportLeaveBalancesMutationBody = BodyType<string>
    export type ImportLeaveBalancesMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import opening leave balances from CSV
 */
export const useImportLeaveBalances = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importLeaveBalances>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importLeaveBalances>>,
        TError,
        {data: BodyType<string>},
        TContext
      > => {
      return useMutation(getImportLeaveBalancesMutationOptions(options));
    }

export const getListLeaveApplicationsUrl = (params?: ListLeaveApplicationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/leave-applications?${stringifiedParams}` : `/api/hr/leave-applications`
}

/**
 * @summary List leave applications (admin view — all employees)
 */
export const listLeaveApplications = async (params?: ListLeaveApplicationsParams, options?: RequestInit): Promise<LeaveApplication[]> => {

  return customFetch<LeaveApplication[]>(getListLeaveApplicationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLeaveApplicationsQueryKey = (params?: ListLeaveApplicationsParams,) => {
    return [
    `/api/hr/leave-applications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLeaveApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof listLeaveApplications>>, TError = ErrorType<unknown>>(params?: ListLeaveApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeaveApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLeaveApplicationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeaveApplications>>> = ({ signal }) => listLeaveApplications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeaveApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLeaveApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listLeaveApplications>>>
export type ListLeaveApplicationsQueryError = ErrorType<unknown>


/**
 * @summary List leave applications (admin view — all employees)
 */

export function useListLeaveApplications<TData = Awaited<ReturnType<typeof listLeaveApplications>>, TError = ErrorType<unknown>>(
 params?: ListLeaveApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeaveApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLeaveApplicationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getApplyLeaveUrl = () => {




  return `/api/hr/leave-applications`
}

/**
 * @summary Submit a leave application
 */
export const applyLeave = async (leaveApplicationInput: LeaveApplicationInput, options?: RequestInit): Promise<LeaveApplication> => {

  return customFetch<LeaveApplication>(getApplyLeaveUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveApplicationInput,)
  }
);}




export const getApplyLeaveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyLeave>>, TError,{data: BodyType<LeaveApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyLeave>>, TError,{data: BodyType<LeaveApplicationInput>}, TContext> => {

const mutationKey = ['applyLeave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyLeave>>, {data: BodyType<LeaveApplicationInput>}> = (props) => {
          const {data} = props ?? {};

          return  applyLeave(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof applyLeave>>>
    export type ApplyLeaveMutationBody = BodyType<LeaveApplicationInput>
    export type ApplyLeaveMutationError = ErrorType<unknown>

    /**
 * @summary Submit a leave application
 */
export const useApplyLeave = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyLeave>>, TError,{data: BodyType<LeaveApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyLeave>>,
        TError,
        {data: BodyType<LeaveApplicationInput>},
        TContext
      > => {
      return useMutation(getApplyLeaveMutationOptions(options));
    }

export const getGetLeaveApplicationUrl = (id: number,) => {




  return `/api/hr/leave-applications/${id}`
}

/**
 * @summary Get a leave application
 */
export const getLeaveApplication = async (id: number, options?: RequestInit): Promise<LeaveApplication> => {

  return customFetch<LeaveApplication>(getGetLeaveApplicationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeaveApplicationQueryKey = (id: number,) => {
    return [
    `/api/hr/leave-applications/${id}`
    ] as const;
    }


export const getGetLeaveApplicationQueryOptions = <TData = Awaited<ReturnType<typeof getLeaveApplication>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLeaveApplication>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeaveApplicationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeaveApplication>>> = ({ signal }) => getLeaveApplication(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeaveApplication>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLeaveApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof getLeaveApplication>>>
export type GetLeaveApplicationQueryError = ErrorType<unknown>


/**
 * @summary Get a leave application
 */

export function useGetLeaveApplication<TData = Awaited<ReturnType<typeof getLeaveApplication>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLeaveApplication>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLeaveApplicationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getApproveLeaveUrl = (id: number,) => {




  return `/api/hr/leave-applications/${id}/approve`
}

/**
 * @summary Approve a leave application
 */
export const approveLeave = async (id: number,
    leaveActionInput: LeaveActionInput, options?: RequestInit): Promise<LeaveApplication> => {

  return customFetch<LeaveApplication>(getApproveLeaveUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveActionInput,)
  }
);}




export const getApproveLeaveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveLeave>>, TError,{id: number;data: BodyType<LeaveActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveLeave>>, TError,{id: number;data: BodyType<LeaveActionInput>}, TContext> => {

const mutationKey = ['approveLeave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveLeave>>, {id: number;data: BodyType<LeaveActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveLeave(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof approveLeave>>>
    export type ApproveLeaveMutationBody = BodyType<LeaveActionInput>
    export type ApproveLeaveMutationError = ErrorType<unknown>

    /**
 * @summary Approve a leave application
 */
export const useApproveLeave = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveLeave>>, TError,{id: number;data: BodyType<LeaveActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveLeave>>,
        TError,
        {id: number;data: BodyType<LeaveActionInput>},
        TContext
      > => {
      return useMutation(getApproveLeaveMutationOptions(options));
    }

export const getRejectLeaveUrl = (id: number,) => {




  return `/api/hr/leave-applications/${id}/reject`
}

/**
 * @summary Reject a leave application
 */
export const rejectLeave = async (id: number,
    leaveActionInput: LeaveActionInput, options?: RequestInit): Promise<LeaveApplication> => {

  return customFetch<LeaveApplication>(getRejectLeaveUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveActionInput,)
  }
);}




export const getRejectLeaveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectLeave>>, TError,{id: number;data: BodyType<LeaveActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectLeave>>, TError,{id: number;data: BodyType<LeaveActionInput>}, TContext> => {

const mutationKey = ['rejectLeave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectLeave>>, {id: number;data: BodyType<LeaveActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectLeave(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof rejectLeave>>>
    export type RejectLeaveMutationBody = BodyType<LeaveActionInput>
    export type RejectLeaveMutationError = ErrorType<unknown>

    /**
 * @summary Reject a leave application
 */
export const useRejectLeave = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectLeave>>, TError,{id: number;data: BodyType<LeaveActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectLeave>>,
        TError,
        {id: number;data: BodyType<LeaveActionInput>},
        TContext
      > => {
      return useMutation(getRejectLeaveMutationOptions(options));
    }

export const getCancelLeaveUrl = (id: number,) => {




  return `/api/hr/leave-applications/${id}/cancel`
}

/**
 * @summary Cancel a leave application
 */
export const cancelLeave = async (id: number,
    leaveActionInput: LeaveActionInput, options?: RequestInit): Promise<LeaveApplication> => {

  return customFetch<LeaveApplication>(getCancelLeaveUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveActionInput,)
  }
);}




export const getCancelLeaveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLeave>>, TError,{id: number;data: BodyType<LeaveActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelLeave>>, TError,{id: number;data: BodyType<LeaveActionInput>}, TContext> => {

const mutationKey = ['cancelLeave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelLeave>>, {id: number;data: BodyType<LeaveActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelLeave(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof cancelLeave>>>
    export type CancelLeaveMutationBody = BodyType<LeaveActionInput>
    export type CancelLeaveMutationError = ErrorType<unknown>

    /**
 * @summary Cancel a leave application
 */
export const useCancelLeave = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLeave>>, TError,{id: number;data: BodyType<LeaveActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelLeave>>,
        TError,
        {id: number;data: BodyType<LeaveActionInput>},
        TContext
      > => {
      return useMutation(getCancelLeaveMutationOptions(options));
    }

export const getListHolidayCalendarsUrl = (params?: ListHolidayCalendarsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/holiday-calendars?${stringifiedParams}` : `/api/hr/holiday-calendars`
}

/**
 * @summary List holiday calendars
 */
export const listHolidayCalendars = async (params?: ListHolidayCalendarsParams, options?: RequestInit): Promise<HolidayCalendar[]> => {

  return customFetch<HolidayCalendar[]>(getListHolidayCalendarsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHolidayCalendarsQueryKey = (params?: ListHolidayCalendarsParams,) => {
    return [
    `/api/hr/holiday-calendars`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHolidayCalendarsQueryOptions = <TData = Awaited<ReturnType<typeof listHolidayCalendars>>, TError = ErrorType<unknown>>(params?: ListHolidayCalendarsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHolidayCalendars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHolidayCalendarsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHolidayCalendars>>> = ({ signal }) => listHolidayCalendars(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHolidayCalendars>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHolidayCalendarsQueryResult = NonNullable<Awaited<ReturnType<typeof listHolidayCalendars>>>
export type ListHolidayCalendarsQueryError = ErrorType<unknown>


/**
 * @summary List holiday calendars
 */

export function useListHolidayCalendars<TData = Awaited<ReturnType<typeof listHolidayCalendars>>, TError = ErrorType<unknown>>(
 params?: ListHolidayCalendarsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHolidayCalendars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHolidayCalendarsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateHolidayCalendarUrl = () => {




  return `/api/hr/holiday-calendars`
}

/**
 * @summary Create a holiday calendar
 */
export const createHolidayCalendar = async (holidayCalendarInput: HolidayCalendarInput, options?: RequestInit): Promise<HolidayCalendar> => {

  return customFetch<HolidayCalendar>(getCreateHolidayCalendarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      holidayCalendarInput,)
  }
);}




export const getCreateHolidayCalendarMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHolidayCalendar>>, TError,{data: BodyType<HolidayCalendarInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHolidayCalendar>>, TError,{data: BodyType<HolidayCalendarInput>}, TContext> => {

const mutationKey = ['createHolidayCalendar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHolidayCalendar>>, {data: BodyType<HolidayCalendarInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHolidayCalendar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHolidayCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof createHolidayCalendar>>>
    export type CreateHolidayCalendarMutationBody = BodyType<HolidayCalendarInput>
    export type CreateHolidayCalendarMutationError = ErrorType<unknown>

    /**
 * @summary Create a holiday calendar
 */
export const useCreateHolidayCalendar = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHolidayCalendar>>, TError,{data: BodyType<HolidayCalendarInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHolidayCalendar>>,
        TError,
        {data: BodyType<HolidayCalendarInput>},
        TContext
      > => {
      return useMutation(getCreateHolidayCalendarMutationOptions(options));
    }

export const getUpdateHolidayCalendarUrl = (id: number,) => {




  return `/api/hr/holiday-calendars/${id}`
}

/**
 * @summary Update a holiday calendar
 */
export const updateHolidayCalendar = async (id: number,
    holidayCalendarInput: HolidayCalendarInput, options?: RequestInit): Promise<HolidayCalendar> => {

  return customFetch<HolidayCalendar>(getUpdateHolidayCalendarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      holidayCalendarInput,)
  }
);}




export const getUpdateHolidayCalendarMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHolidayCalendar>>, TError,{id: number;data: BodyType<HolidayCalendarInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHolidayCalendar>>, TError,{id: number;data: BodyType<HolidayCalendarInput>}, TContext> => {

const mutationKey = ['updateHolidayCalendar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHolidayCalendar>>, {id: number;data: BodyType<HolidayCalendarInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHolidayCalendar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHolidayCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof updateHolidayCalendar>>>
    export type UpdateHolidayCalendarMutationBody = BodyType<HolidayCalendarInput>
    export type UpdateHolidayCalendarMutationError = ErrorType<unknown>

    /**
 * @summary Update a holiday calendar
 */
export const useUpdateHolidayCalendar = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHolidayCalendar>>, TError,{id: number;data: BodyType<HolidayCalendarInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHolidayCalendar>>,
        TError,
        {id: number;data: BodyType<HolidayCalendarInput>},
        TContext
      > => {
      return useMutation(getUpdateHolidayCalendarMutationOptions(options));
    }

export const getDeleteHolidayCalendarUrl = (id: number,) => {




  return `/api/hr/holiday-calendars/${id}`
}

/**
 * @summary Delete a holiday calendar
 */
export const deleteHolidayCalendar = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHolidayCalendarUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteHolidayCalendarMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHolidayCalendar>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHolidayCalendar>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteHolidayCalendar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHolidayCalendar>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteHolidayCalendar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHolidayCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHolidayCalendar>>>

    export type DeleteHolidayCalendarMutationError = ErrorType<unknown>

    /**
 * @summary Delete a holiday calendar
 */
export const useDeleteHolidayCalendar = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHolidayCalendar>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHolidayCalendar>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteHolidayCalendarMutationOptions(options));
    }

export const getListHolidayCalendarEntriesUrl = (id: number,) => {




  return `/api/hr/holiday-calendars/${id}/entries`
}

/**
 * @summary List entries for a holiday calendar
 */
export const listHolidayCalendarEntries = async (id: number, options?: RequestInit): Promise<HolidayCalendarEntry[]> => {

  return customFetch<HolidayCalendarEntry[]>(getListHolidayCalendarEntriesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHolidayCalendarEntriesQueryKey = (id: number,) => {
    return [
    `/api/hr/holiday-calendars/${id}/entries`
    ] as const;
    }


export const getListHolidayCalendarEntriesQueryOptions = <TData = Awaited<ReturnType<typeof listHolidayCalendarEntries>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHolidayCalendarEntries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHolidayCalendarEntriesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHolidayCalendarEntries>>> = ({ signal }) => listHolidayCalendarEntries(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHolidayCalendarEntries>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHolidayCalendarEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof listHolidayCalendarEntries>>>
export type ListHolidayCalendarEntriesQueryError = ErrorType<unknown>


/**
 * @summary List entries for a holiday calendar
 */

export function useListHolidayCalendarEntries<TData = Awaited<ReturnType<typeof listHolidayCalendarEntries>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHolidayCalendarEntries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHolidayCalendarEntriesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateHolidayCalendarEntryUrl = (id: number,) => {




  return `/api/hr/holiday-calendars/${id}/entries`
}

/**
 * @summary Add a holiday to a calendar
 */
export const createHolidayCalendarEntry = async (id: number,
    holidayCalendarEntryInput: HolidayCalendarEntryInput, options?: RequestInit): Promise<HolidayCalendarEntry> => {

  return customFetch<HolidayCalendarEntry>(getCreateHolidayCalendarEntryUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      holidayCalendarEntryInput,)
  }
);}




export const getCreateHolidayCalendarEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHolidayCalendarEntry>>, TError,{id: number;data: BodyType<HolidayCalendarEntryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHolidayCalendarEntry>>, TError,{id: number;data: BodyType<HolidayCalendarEntryInput>}, TContext> => {

const mutationKey = ['createHolidayCalendarEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHolidayCalendarEntry>>, {id: number;data: BodyType<HolidayCalendarEntryInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createHolidayCalendarEntry(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHolidayCalendarEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createHolidayCalendarEntry>>>
    export type CreateHolidayCalendarEntryMutationBody = BodyType<HolidayCalendarEntryInput>
    export type CreateHolidayCalendarEntryMutationError = ErrorType<unknown>

    /**
 * @summary Add a holiday to a calendar
 */
export const useCreateHolidayCalendarEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHolidayCalendarEntry>>, TError,{id: number;data: BodyType<HolidayCalendarEntryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHolidayCalendarEntry>>,
        TError,
        {id: number;data: BodyType<HolidayCalendarEntryInput>},
        TContext
      > => {
      return useMutation(getCreateHolidayCalendarEntryMutationOptions(options));
    }

export const getDeleteHolidayCalendarEntryUrl = (id: number,
    entryId: number,) => {




  return `/api/hr/holiday-calendars/${id}/entries/${entryId}`
}

/**
 * @summary Delete a holiday calendar entry
 */
export const deleteHolidayCalendarEntry = async (id: number,
    entryId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHolidayCalendarEntryUrl(id,entryId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteHolidayCalendarEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHolidayCalendarEntry>>, TError,{id: number;entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHolidayCalendarEntry>>, TError,{id: number;entryId: number}, TContext> => {

const mutationKey = ['deleteHolidayCalendarEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHolidayCalendarEntry>>, {id: number;entryId: number}> = (props) => {
          const {id,entryId} = props ?? {};

          return  deleteHolidayCalendarEntry(id,entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHolidayCalendarEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHolidayCalendarEntry>>>

    export type DeleteHolidayCalendarEntryMutationError = ErrorType<unknown>

    /**
 * @summary Delete a holiday calendar entry
 */
export const useDeleteHolidayCalendarEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHolidayCalendarEntry>>, TError,{id: number;entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHolidayCalendarEntry>>,
        TError,
        {id: number;entryId: number},
        TContext
      > => {
      return useMutation(getDeleteHolidayCalendarEntryMutationOptions(options));
    }

export const getListShiftsUrl = () => {




  return `/api/hr/shifts`
}

/**
 * @summary List all shifts
 */
export const listShifts = async ( options?: RequestInit): Promise<Shift[]> => {

  return customFetch<Shift[]>(getListShiftsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShiftsQueryKey = () => {
    return [
    `/api/hr/shifts`
    ] as const;
    }


export const getListShiftsQueryOptions = <TData = Awaited<ReturnType<typeof listShifts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShifts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShiftsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShifts>>> = ({ signal }) => listShifts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShifts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShiftsQueryResult = NonNullable<Awaited<ReturnType<typeof listShifts>>>
export type ListShiftsQueryError = ErrorType<unknown>


/**
 * @summary List all shifts
 */

export function useListShifts<TData = Awaited<ReturnType<typeof listShifts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShifts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShiftsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateShiftUrl = () => {




  return `/api/hr/shifts`
}

/**
 * @summary Create a shift
 */
export const createShift = async (shiftInput: ShiftInput, options?: RequestInit): Promise<Shift> => {

  return customFetch<Shift>(getCreateShiftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      shiftInput,)
  }
);}




export const getCreateShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShift>>, TError,{data: BodyType<ShiftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createShift>>, TError,{data: BodyType<ShiftInput>}, TContext> => {

const mutationKey = ['createShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createShift>>, {data: BodyType<ShiftInput>}> = (props) => {
          const {data} = props ?? {};

          return  createShift(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateShiftMutationResult = NonNullable<Awaited<ReturnType<typeof createShift>>>
    export type CreateShiftMutationBody = BodyType<ShiftInput>
    export type CreateShiftMutationError = ErrorType<unknown>

    /**
 * @summary Create a shift
 */
export const useCreateShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShift>>, TError,{data: BodyType<ShiftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createShift>>,
        TError,
        {data: BodyType<ShiftInput>},
        TContext
      > => {
      return useMutation(getCreateShiftMutationOptions(options));
    }

export const getUpdateShiftUrl = (id: number,) => {




  return `/api/hr/shifts/${id}`
}

/**
 * @summary Update a shift
 */
export const updateShift = async (id: number,
    shiftInput: ShiftInput, options?: RequestInit): Promise<Shift> => {

  return customFetch<Shift>(getUpdateShiftUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      shiftInput,)
  }
);}




export const getUpdateShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShift>>, TError,{id: number;data: BodyType<ShiftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateShift>>, TError,{id: number;data: BodyType<ShiftInput>}, TContext> => {

const mutationKey = ['updateShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateShift>>, {id: number;data: BodyType<ShiftInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateShift(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateShiftMutationResult = NonNullable<Awaited<ReturnType<typeof updateShift>>>
    export type UpdateShiftMutationBody = BodyType<ShiftInput>
    export type UpdateShiftMutationError = ErrorType<unknown>

    /**
 * @summary Update a shift
 */
export const useUpdateShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShift>>, TError,{id: number;data: BodyType<ShiftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateShift>>,
        TError,
        {id: number;data: BodyType<ShiftInput>},
        TContext
      > => {
      return useMutation(getUpdateShiftMutationOptions(options));
    }

export const getDeleteShiftUrl = (id: number,) => {




  return `/api/hr/shifts/${id}`
}

/**
 * @summary Delete a shift
 */
export const deleteShift = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteShiftUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShift>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShift>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShift>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteShift(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteShiftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShift>>>

    export type DeleteShiftMutationError = ErrorType<unknown>

    /**
 * @summary Delete a shift
 */
export const useDeleteShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShift>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteShift>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteShiftMutationOptions(options));
    }

export const getGetAttendancePolicyUrl = () => {




  return `/api/hr/attendance-policy`
}

/**
 * @summary Get tenant attendance policy
 */
export const getAttendancePolicy = async ( options?: RequestInit): Promise<AttendancePolicy> => {

  return customFetch<AttendancePolicy>(getGetAttendancePolicyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAttendancePolicyQueryKey = () => {
    return [
    `/api/hr/attendance-policy`
    ] as const;
    }


export const getGetAttendancePolicyQueryOptions = <TData = Awaited<ReturnType<typeof getAttendancePolicy>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAttendancePolicy>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttendancePolicyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttendancePolicy>>> = ({ signal }) => getAttendancePolicy({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttendancePolicy>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAttendancePolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getAttendancePolicy>>>
export type GetAttendancePolicyQueryError = ErrorType<unknown>


/**
 * @summary Get tenant attendance policy
 */

export function useGetAttendancePolicy<TData = Awaited<ReturnType<typeof getAttendancePolicy>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAttendancePolicy>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAttendancePolicyQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpsertAttendancePolicyUrl = () => {




  return `/api/hr/attendance-policy`
}

/**
 * @summary Create or update attendance policy
 */
export const upsertAttendancePolicy = async (attendancePolicyInput: AttendancePolicyInput, options?: RequestInit): Promise<AttendancePolicy> => {

  return customFetch<AttendancePolicy>(getUpsertAttendancePolicyUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      attendancePolicyInput,)
  }
);}




export const getUpsertAttendancePolicyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAttendancePolicy>>, TError,{data: BodyType<AttendancePolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertAttendancePolicy>>, TError,{data: BodyType<AttendancePolicyInput>}, TContext> => {

const mutationKey = ['upsertAttendancePolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertAttendancePolicy>>, {data: BodyType<AttendancePolicyInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertAttendancePolicy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertAttendancePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof upsertAttendancePolicy>>>
    export type UpsertAttendancePolicyMutationBody = BodyType<AttendancePolicyInput>
    export type UpsertAttendancePolicyMutationError = ErrorType<unknown>

    /**
 * @summary Create or update attendance policy
 */
export const useUpsertAttendancePolicy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAttendancePolicy>>, TError,{data: BodyType<AttendancePolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertAttendancePolicy>>,
        TError,
        {data: BodyType<AttendancePolicyInput>},
        TContext
      > => {
      return useMutation(getUpsertAttendancePolicyMutationOptions(options));
    }

export const getListAttendanceRecordsUrl = (params?: ListAttendanceRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/attendance?${stringifiedParams}` : `/api/hr/attendance`
}

/**
 * @summary List attendance records
 */
export const listAttendanceRecords = async (params?: ListAttendanceRecordsParams, options?: RequestInit): Promise<AttendanceRecord[]> => {

  return customFetch<AttendanceRecord[]>(getListAttendanceRecordsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAttendanceRecordsQueryKey = (params?: ListAttendanceRecordsParams,) => {
    return [
    `/api/hr/attendance`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAttendanceRecordsQueryOptions = <TData = Awaited<ReturnType<typeof listAttendanceRecords>>, TError = ErrorType<unknown>>(params?: ListAttendanceRecordsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAttendanceRecords>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAttendanceRecordsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAttendanceRecords>>> = ({ signal }) => listAttendanceRecords(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAttendanceRecords>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAttendanceRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof listAttendanceRecords>>>
export type ListAttendanceRecordsQueryError = ErrorType<unknown>


/**
 * @summary List attendance records
 */

export function useListAttendanceRecords<TData = Awaited<ReturnType<typeof listAttendanceRecords>>, TError = ErrorType<unknown>>(
 params?: ListAttendanceRecordsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAttendanceRecords>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAttendanceRecordsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getImportAttendanceUrl = () => {




  return `/api/hr/attendance/import`
}

/**
 * @summary Import attendance from biometric CSV
 */
export const importAttendance = async (importAttendanceBody: string, options?: RequestInit): Promise<CsvImportResult> => {

  return customFetch<CsvImportResult>(getImportAttendanceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/csv', ...options?.headers },
    body: JSON.stringify(
      importAttendanceBody,)
  }
);}




export const getImportAttendanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAttendance>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importAttendance>>, TError,{data: BodyType<string>}, TContext> => {

const mutationKey = ['importAttendance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importAttendance>>, {data: BodyType<string>}> = (props) => {
          const {data} = props ?? {};

          return  importAttendance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportAttendanceMutationResult = NonNullable<Awaited<ReturnType<typeof importAttendance>>>
    export type ImportAttendanceMutationBody = BodyType<string>
    export type ImportAttendanceMutationError = ErrorType<unknown>

    /**
 * @summary Import attendance from biometric CSV
 */
export const useImportAttendance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAttendance>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importAttendance>>,
        TError,
        {data: BodyType<string>},
        TContext
      > => {
      return useMutation(getImportAttendanceMutationOptions(options));
    }

export const getListRegularizationsUrl = (params?: ListRegularizationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/attendance/regularizations?${stringifiedParams}` : `/api/hr/attendance/regularizations`
}

/**
 * @summary List regularization requests
 */
export const listRegularizations = async (params?: ListRegularizationsParams, options?: RequestInit): Promise<AttendanceRegularization[]> => {

  return customFetch<AttendanceRegularization[]>(getListRegularizationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRegularizationsQueryKey = (params?: ListRegularizationsParams,) => {
    return [
    `/api/hr/attendance/regularizations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRegularizationsQueryOptions = <TData = Awaited<ReturnType<typeof listRegularizations>>, TError = ErrorType<unknown>>(params?: ListRegularizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRegularizations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRegularizationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRegularizations>>> = ({ signal }) => listRegularizations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRegularizations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRegularizationsQueryResult = NonNullable<Awaited<ReturnType<typeof listRegularizations>>>
export type ListRegularizationsQueryError = ErrorType<unknown>


/**
 * @summary List regularization requests
 */

export function useListRegularizations<TData = Awaited<ReturnType<typeof listRegularizations>>, TError = ErrorType<unknown>>(
 params?: ListRegularizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRegularizations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRegularizationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSubmitRegularizationUrl = () => {




  return `/api/hr/attendance/regularizations`
}

/**
 * @summary Submit an attendance regularization request
 */
export const submitRegularization = async (regularizationInput: RegularizationInput, options?: RequestInit): Promise<AttendanceRegularization> => {

  return customFetch<AttendanceRegularization>(getSubmitRegularizationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      regularizationInput,)
  }
);}




export const getSubmitRegularizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitRegularization>>, TError,{data: BodyType<RegularizationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitRegularization>>, TError,{data: BodyType<RegularizationInput>}, TContext> => {

const mutationKey = ['submitRegularization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitRegularization>>, {data: BodyType<RegularizationInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitRegularization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitRegularizationMutationResult = NonNullable<Awaited<ReturnType<typeof submitRegularization>>>
    export type SubmitRegularizationMutationBody = BodyType<RegularizationInput>
    export type SubmitRegularizationMutationError = ErrorType<unknown>

    /**
 * @summary Submit an attendance regularization request
 */
export const useSubmitRegularization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitRegularization>>, TError,{data: BodyType<RegularizationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitRegularization>>,
        TError,
        {data: BodyType<RegularizationInput>},
        TContext
      > => {
      return useMutation(getSubmitRegularizationMutationOptions(options));
    }

export const getApproveRegularizationUrl = (id: number,) => {




  return `/api/hr/attendance/regularizations/${id}/approve`
}

/**
 * @summary Approve a regularization request
 */
export const approveRegularization = async (id: number,
    regularizationActionInput: RegularizationActionInput, options?: RequestInit): Promise<AttendanceRegularization> => {

  return customFetch<AttendanceRegularization>(getApproveRegularizationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      regularizationActionInput,)
  }
);}




export const getApproveRegularizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRegularization>>, TError,{id: number;data: BodyType<RegularizationActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveRegularization>>, TError,{id: number;data: BodyType<RegularizationActionInput>}, TContext> => {

const mutationKey = ['approveRegularization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveRegularization>>, {id: number;data: BodyType<RegularizationActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveRegularization(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveRegularizationMutationResult = NonNullable<Awaited<ReturnType<typeof approveRegularization>>>
    export type ApproveRegularizationMutationBody = BodyType<RegularizationActionInput>
    export type ApproveRegularizationMutationError = ErrorType<unknown>

    /**
 * @summary Approve a regularization request
 */
export const useApproveRegularization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRegularization>>, TError,{id: number;data: BodyType<RegularizationActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveRegularization>>,
        TError,
        {id: number;data: BodyType<RegularizationActionInput>},
        TContext
      > => {
      return useMutation(getApproveRegularizationMutationOptions(options));
    }

export const getRejectRegularizationUrl = (id: number,) => {




  return `/api/hr/attendance/regularizations/${id}/reject`
}

/**
 * @summary Reject a regularization request
 */
export const rejectRegularization = async (id: number,
    regularizationActionInput: RegularizationActionInput, options?: RequestInit): Promise<AttendanceRegularization> => {

  return customFetch<AttendanceRegularization>(getRejectRegularizationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      regularizationActionInput,)
  }
);}




export const getRejectRegularizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRegularization>>, TError,{id: number;data: BodyType<RegularizationActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectRegularization>>, TError,{id: number;data: BodyType<RegularizationActionInput>}, TContext> => {

const mutationKey = ['rejectRegularization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectRegularization>>, {id: number;data: BodyType<RegularizationActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectRegularization(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectRegularizationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectRegularization>>>
    export type RejectRegularizationMutationBody = BodyType<RegularizationActionInput>
    export type RejectRegularizationMutationError = ErrorType<unknown>

    /**
 * @summary Reject a regularization request
 */
export const useRejectRegularization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRegularization>>, TError,{id: number;data: BodyType<RegularizationActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectRegularization>>,
        TError,
        {id: number;data: BodyType<RegularizationActionInput>},
        TContext
      > => {
      return useMutation(getRejectRegularizationMutationOptions(options));
    }

export const getListOnboardingInvitesUrl = (params?: ListOnboardingInvitesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/onboarding?${stringifiedParams}` : `/api/hr/onboarding`
}

/**
 * @summary List onboarding invites
 */
export const listOnboardingInvites = async (params?: ListOnboardingInvitesParams, options?: RequestInit): Promise<OnboardingInvite[]> => {

  return customFetch<OnboardingInvite[]>(getListOnboardingInvitesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOnboardingInvitesQueryKey = (params?: ListOnboardingInvitesParams,) => {
    return [
    `/api/hr/onboarding`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOnboardingInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listOnboardingInvites>>, TError = ErrorType<unknown>>(params?: ListOnboardingInvitesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOnboardingInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOnboardingInvitesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOnboardingInvites>>> = ({ signal }) => listOnboardingInvites(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOnboardingInvites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOnboardingInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listOnboardingInvites>>>
export type ListOnboardingInvitesQueryError = ErrorType<unknown>


/**
 * @summary List onboarding invites
 */

export function useListOnboardingInvites<TData = Awaited<ReturnType<typeof listOnboardingInvites>>, TError = ErrorType<unknown>>(
 params?: ListOnboardingInvitesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOnboardingInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOnboardingInvitesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOnboardingInviteUrl = () => {




  return `/api/hr/onboarding`
}

/**
 * @summary Send a digital onboarding invite to a candidate
 */
export const createOnboardingInvite = async (onboardingInviteInput: OnboardingInviteInput, options?: RequestInit): Promise<OnboardingInvite> => {

  return customFetch<OnboardingInvite>(getCreateOnboardingInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      onboardingInviteInput,)
  }
);}




export const getCreateOnboardingInviteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOnboardingInvite>>, TError,{data: BodyType<OnboardingInviteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOnboardingInvite>>, TError,{data: BodyType<OnboardingInviteInput>}, TContext> => {

const mutationKey = ['createOnboardingInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOnboardingInvite>>, {data: BodyType<OnboardingInviteInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOnboardingInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOnboardingInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createOnboardingInvite>>>
    export type CreateOnboardingInviteMutationBody = BodyType<OnboardingInviteInput>
    export type CreateOnboardingInviteMutationError = ErrorType<unknown>

    /**
 * @summary Send a digital onboarding invite to a candidate
 */
export const useCreateOnboardingInvite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOnboardingInvite>>, TError,{data: BodyType<OnboardingInviteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOnboardingInvite>>,
        TError,
        {data: BodyType<OnboardingInviteInput>},
        TContext
      > => {
      return useMutation(getCreateOnboardingInviteMutationOptions(options));
    }

export const getApproveOnboardingUrl = (id: number,) => {




  return `/api/hr/onboarding/${id}/approve`
}

/**
 * @summary Approve onboarding and convert to employee
 */
export const approveOnboarding = async (id: number, options?: RequestInit): Promise<OnboardingInvite> => {

  return customFetch<OnboardingInvite>(getApproveOnboardingUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApproveOnboardingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOnboarding>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveOnboarding>>, TError,{id: number}, TContext> => {

const mutationKey = ['approveOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveOnboarding>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  approveOnboarding(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof approveOnboarding>>>

    export type ApproveOnboardingMutationError = ErrorType<unknown>

    /**
 * @summary Approve onboarding and convert to employee
 */
export const useApproveOnboarding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOnboarding>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveOnboarding>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApproveOnboardingMutationOptions(options));
    }

export const getRejectOnboardingUrl = (id: number,) => {




  return `/api/hr/onboarding/${id}/reject`
}

/**
 * @summary Reject an onboarding application
 */
export const rejectOnboarding = async (id: number,
    onboardingRejectInput: OnboardingRejectInput, options?: RequestInit): Promise<OnboardingInvite> => {

  return customFetch<OnboardingInvite>(getRejectOnboardingUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      onboardingRejectInput,)
  }
);}




export const getRejectOnboardingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOnboarding>>, TError,{id: number;data: BodyType<OnboardingRejectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectOnboarding>>, TError,{id: number;data: BodyType<OnboardingRejectInput>}, TContext> => {

const mutationKey = ['rejectOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectOnboarding>>, {id: number;data: BodyType<OnboardingRejectInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectOnboarding(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof rejectOnboarding>>>
    export type RejectOnboardingMutationBody = BodyType<OnboardingRejectInput>
    export type RejectOnboardingMutationError = ErrorType<unknown>

    /**
 * @summary Reject an onboarding application
 */
export const useRejectOnboarding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOnboarding>>, TError,{id: number;data: BodyType<OnboardingRejectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectOnboarding>>,
        TError,
        {id: number;data: BodyType<OnboardingRejectInput>},
        TContext
      > => {
      return useMutation(getRejectOnboardingMutationOptions(options));
    }

export const getGetMyEmployeeUrl = () => {




  return `/api/hr/me/employee`
}

/**
 * @summary Get the current user's employee record
 */
export const getMyEmployee = async ( options?: RequestInit): Promise<Employee> => {

  return customFetch<Employee>(getGetMyEmployeeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyEmployeeQueryKey = () => {
    return [
    `/api/hr/me/employee`
    ] as const;
    }


export const getGetMyEmployeeQueryOptions = <TData = Awaited<ReturnType<typeof getMyEmployee>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyEmployee>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyEmployeeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyEmployee>>> = ({ signal }) => getMyEmployee({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyEmployee>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyEmployeeQueryResult = NonNullable<Awaited<ReturnType<typeof getMyEmployee>>>
export type GetMyEmployeeQueryError = ErrorType<unknown>


/**
 * @summary Get the current user's employee record
 */

export function useGetMyEmployee<TData = Awaited<ReturnType<typeof getMyEmployee>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyEmployee>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyEmployeeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateMyEmployeeUrl = () => {




  return `/api/hr/me/employee`
}

/**
 * @summary Employee self-update (personal details, bank, emergency contact)
 */
export const updateMyEmployee = async (employeeSelfUpdate: EmployeeSelfUpdate, options?: RequestInit): Promise<Employee> => {

  return customFetch<Employee>(getUpdateMyEmployeeUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeSelfUpdate,)
  }
);}




export const getUpdateMyEmployeeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyEmployee>>, TError,{data: BodyType<EmployeeSelfUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyEmployee>>, TError,{data: BodyType<EmployeeSelfUpdate>}, TContext> => {

const mutationKey = ['updateMyEmployee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyEmployee>>, {data: BodyType<EmployeeSelfUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateMyEmployee(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyEmployee>>>
    export type UpdateMyEmployeeMutationBody = BodyType<EmployeeSelfUpdate>
    export type UpdateMyEmployeeMutationError = ErrorType<unknown>

    /**
 * @summary Employee self-update (personal details, bank, emergency contact)
 */
export const useUpdateMyEmployee = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyEmployee>>, TError,{data: BodyType<EmployeeSelfUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMyEmployee>>,
        TError,
        {data: BodyType<EmployeeSelfUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMyEmployeeMutationOptions(options));
    }

export const getGetMyLeaveBalancesUrl = (params?: GetMyLeaveBalancesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/me/leave-balances?${stringifiedParams}` : `/api/hr/me/leave-balances`
}

/**
 * @summary Get current employee's leave balances
 */
export const getMyLeaveBalances = async (params?: GetMyLeaveBalancesParams, options?: RequestInit): Promise<LeaveBalance[]> => {

  return customFetch<LeaveBalance[]>(getGetMyLeaveBalancesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyLeaveBalancesQueryKey = (params?: GetMyLeaveBalancesParams,) => {
    return [
    `/api/hr/me/leave-balances`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyLeaveBalancesQueryOptions = <TData = Awaited<ReturnType<typeof getMyLeaveBalances>>, TError = ErrorType<unknown>>(params?: GetMyLeaveBalancesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyLeaveBalances>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyLeaveBalancesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyLeaveBalances>>> = ({ signal }) => getMyLeaveBalances(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyLeaveBalances>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyLeaveBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyLeaveBalances>>>
export type GetMyLeaveBalancesQueryError = ErrorType<unknown>


/**
 * @summary Get current employee's leave balances
 */

export function useGetMyLeaveBalances<TData = Awaited<ReturnType<typeof getMyLeaveBalances>>, TError = ErrorType<unknown>>(
 params?: GetMyLeaveBalancesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyLeaveBalances>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyLeaveBalancesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMyLeaveApplicationsUrl = () => {




  return `/api/hr/me/leave-applications`
}

/**
 * @summary Get current employee's leave applications
 */
export const getMyLeaveApplications = async ( options?: RequestInit): Promise<LeaveApplication[]> => {

  return customFetch<LeaveApplication[]>(getGetMyLeaveApplicationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyLeaveApplicationsQueryKey = () => {
    return [
    `/api/hr/me/leave-applications`
    ] as const;
    }


export const getGetMyLeaveApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof getMyLeaveApplications>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyLeaveApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyLeaveApplicationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyLeaveApplications>>> = ({ signal }) => getMyLeaveApplications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyLeaveApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyLeaveApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyLeaveApplications>>>
export type GetMyLeaveApplicationsQueryError = ErrorType<unknown>


/**
 * @summary Get current employee's leave applications
 */

export function useGetMyLeaveApplications<TData = Awaited<ReturnType<typeof getMyLeaveApplications>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyLeaveApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyLeaveApplicationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getApplyMyLeaveUrl = () => {




  return `/api/hr/me/leave-applications`
}

/**
 * @summary Apply for leave (employee self-service)
 */
export const applyMyLeave = async (leaveApplicationInput: LeaveApplicationInput, options?: RequestInit): Promise<LeaveApplication> => {

  return customFetch<LeaveApplication>(getApplyMyLeaveUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveApplicationInput,)
  }
);}




export const getApplyMyLeaveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyMyLeave>>, TError,{data: BodyType<LeaveApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyMyLeave>>, TError,{data: BodyType<LeaveApplicationInput>}, TContext> => {

const mutationKey = ['applyMyLeave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyMyLeave>>, {data: BodyType<LeaveApplicationInput>}> = (props) => {
          const {data} = props ?? {};

          return  applyMyLeave(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyMyLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof applyMyLeave>>>
    export type ApplyMyLeaveMutationBody = BodyType<LeaveApplicationInput>
    export type ApplyMyLeaveMutationError = ErrorType<unknown>

    /**
 * @summary Apply for leave (employee self-service)
 */
export const useApplyMyLeave = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyMyLeave>>, TError,{data: BodyType<LeaveApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyMyLeave>>,
        TError,
        {data: BodyType<LeaveApplicationInput>},
        TContext
      > => {
      return useMutation(getApplyMyLeaveMutationOptions(options));
    }

export const getGetMyAttendanceUrl = (params?: GetMyAttendanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/me/attendance?${stringifiedParams}` : `/api/hr/me/attendance`
}

/**
 * @summary Get current employee's attendance records
 */
export const getMyAttendance = async (params?: GetMyAttendanceParams, options?: RequestInit): Promise<AttendanceRecord[]> => {

  return customFetch<AttendanceRecord[]>(getGetMyAttendanceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyAttendanceQueryKey = (params?: GetMyAttendanceParams,) => {
    return [
    `/api/hr/me/attendance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyAttendanceQueryOptions = <TData = Awaited<ReturnType<typeof getMyAttendance>>, TError = ErrorType<unknown>>(params?: GetMyAttendanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyAttendance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyAttendanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAttendance>>> = ({ signal }) => getMyAttendance(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyAttendance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyAttendanceQueryResult = NonNullable<Awaited<ReturnType<typeof getMyAttendance>>>
export type GetMyAttendanceQueryError = ErrorType<unknown>


/**
 * @summary Get current employee's attendance records
 */

export function useGetMyAttendance<TData = Awaited<ReturnType<typeof getMyAttendance>>, TError = ErrorType<unknown>>(
 params?: GetMyAttendanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyAttendance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyAttendanceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMyRegularizationsUrl = () => {




  return `/api/hr/me/regularizations`
}

/**
 * @summary Get current employee's regularization requests
 */
export const getMyRegularizations = async ( options?: RequestInit): Promise<AttendanceRegularization[]> => {

  return customFetch<AttendanceRegularization[]>(getGetMyRegularizationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyRegularizationsQueryKey = () => {
    return [
    `/api/hr/me/regularizations`
    ] as const;
    }


export const getGetMyRegularizationsQueryOptions = <TData = Awaited<ReturnType<typeof getMyRegularizations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyRegularizations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyRegularizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyRegularizations>>> = ({ signal }) => getMyRegularizations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyRegularizations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyRegularizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyRegularizations>>>
export type GetMyRegularizationsQueryError = ErrorType<unknown>


/**
 * @summary Get current employee's regularization requests
 */

export function useGetMyRegularizations<TData = Awaited<ReturnType<typeof getMyRegularizations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyRegularizations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyRegularizationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSubmitMyRegularizationUrl = () => {




  return `/api/hr/me/regularizations`
}

/**
 * @summary Submit regularization request (self-service)
 */
export const submitMyRegularization = async (regularizationInput: RegularizationInput, options?: RequestInit): Promise<AttendanceRegularization> => {

  return customFetch<AttendanceRegularization>(getSubmitMyRegularizationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      regularizationInput,)
  }
);}




export const getSubmitMyRegularizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitMyRegularization>>, TError,{data: BodyType<RegularizationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitMyRegularization>>, TError,{data: BodyType<RegularizationInput>}, TContext> => {

const mutationKey = ['submitMyRegularization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitMyRegularization>>, {data: BodyType<RegularizationInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitMyRegularization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitMyRegularizationMutationResult = NonNullable<Awaited<ReturnType<typeof submitMyRegularization>>>
    export type SubmitMyRegularizationMutationBody = BodyType<RegularizationInput>
    export type SubmitMyRegularizationMutationError = ErrorType<unknown>

    /**
 * @summary Submit regularization request (self-service)
 */
export const useSubmitMyRegularization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitMyRegularization>>, TError,{data: BodyType<RegularizationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitMyRegularization>>,
        TError,
        {data: BodyType<RegularizationInput>},
        TContext
      > => {
      return useMutation(getSubmitMyRegularizationMutationOptions(options));
    }

export const getGetMyDocumentsUrl = () => {




  return `/api/hr/me/documents`
}

/**
 * @summary Get current employee's documents
 */
export const getMyDocuments = async ( options?: RequestInit): Promise<EmployeeDocument[]> => {

  return customFetch<EmployeeDocument[]>(getGetMyDocumentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyDocumentsQueryKey = () => {
    return [
    `/api/hr/me/documents`
    ] as const;
    }


export const getGetMyDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getMyDocuments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyDocumentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyDocuments>>> = ({ signal }) => getMyDocuments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyDocuments>>>
export type GetMyDocumentsQueryError = ErrorType<unknown>


/**
 * @summary Get current employee's documents
 */

export function useGetMyDocuments<TData = Awaited<ReturnType<typeof getMyDocuments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyDocumentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUploadMyDocumentUrl = () => {




  return `/api/hr/me/documents`
}

/**
 * @summary Upload a document (self-service)
 */
export const uploadMyDocument = async (employeeDocumentInput: EmployeeDocumentInput, options?: RequestInit): Promise<EmployeeDocument> => {

  return customFetch<EmployeeDocument>(getUploadMyDocumentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeDocumentInput,)
  }
);}




export const getUploadMyDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMyDocument>>, TError,{data: BodyType<EmployeeDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadMyDocument>>, TError,{data: BodyType<EmployeeDocumentInput>}, TContext> => {

const mutationKey = ['uploadMyDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadMyDocument>>, {data: BodyType<EmployeeDocumentInput>}> = (props) => {
          const {data} = props ?? {};

          return  uploadMyDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadMyDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadMyDocument>>>
    export type UploadMyDocumentMutationBody = BodyType<EmployeeDocumentInput>
    export type UploadMyDocumentMutationError = ErrorType<unknown>

    /**
 * @summary Upload a document (self-service)
 */
export const useUploadMyDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMyDocument>>, TError,{data: BodyType<EmployeeDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadMyDocument>>,
        TError,
        {data: BodyType<EmployeeDocumentInput>},
        TContext
      > => {
      return useMutation(getUploadMyDocumentMutationOptions(options));
    }

export const getGetTeamAttendanceUrl = (params?: GetTeamAttendanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/me/team-attendance?${stringifiedParams}` : `/api/hr/me/team-attendance`
}

/**
 * @summary Manager view — get team attendance
 */
export const getTeamAttendance = async (params?: GetTeamAttendanceParams, options?: RequestInit): Promise<AttendanceRecord[]> => {

  return customFetch<AttendanceRecord[]>(getGetTeamAttendanceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamAttendanceQueryKey = (params?: GetTeamAttendanceParams,) => {
    return [
    `/api/hr/me/team-attendance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamAttendanceQueryOptions = <TData = Awaited<ReturnType<typeof getTeamAttendance>>, TError = ErrorType<unknown>>(params?: GetTeamAttendanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamAttendance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamAttendanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamAttendance>>> = ({ signal }) => getTeamAttendance(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamAttendance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamAttendanceQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamAttendance>>>
export type GetTeamAttendanceQueryError = ErrorType<unknown>


/**
 * @summary Manager view — get team attendance
 */

export function useGetTeamAttendance<TData = Awaited<ReturnType<typeof getTeamAttendance>>, TError = ErrorType<unknown>>(
 params?: GetTeamAttendanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamAttendance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamAttendanceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetTeamLeaveApplicationsUrl = () => {




  return `/api/hr/me/team-leave-applications`
}

/**
 * @summary Manager view — get pending team leave applications
 */
export const getTeamLeaveApplications = async ( options?: RequestInit): Promise<LeaveApplication[]> => {

  return customFetch<LeaveApplication[]>(getGetTeamLeaveApplicationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamLeaveApplicationsQueryKey = () => {
    return [
    `/api/hr/me/team-leave-applications`
    ] as const;
    }


export const getGetTeamLeaveApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeaveApplications>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamLeaveApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeaveApplicationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeaveApplications>>> = ({ signal }) => getTeamLeaveApplications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeaveApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamLeaveApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeaveApplications>>>
export type GetTeamLeaveApplicationsQueryError = ErrorType<unknown>


/**
 * @summary Manager view — get pending team leave applications
 */

export function useGetTeamLeaveApplications<TData = Awaited<ReturnType<typeof getTeamLeaveApplications>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamLeaveApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamLeaveApplicationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * @summary Request a presigned URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      uploadUrlRequest,)
  }
);}




export const getRequestUploadUrlMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<void>

    /**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * @summary Serve an object entity
 */
export const getStorageObject = async (objectPath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<void>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(objectPath), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<void>


/**
 * @summary Serve an object entity
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<void>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAccountGroupsUrl = () => {




  return `/api/finance/account-groups`
}

/**
 * @summary List account groups (COA hierarchy)
 */
export const listAccountGroups = async ( options?: RequestInit): Promise<AccountGroup[]> => {

  return customFetch<AccountGroup[]>(getListAccountGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountGroupsQueryKey = () => {
    return [
    `/api/finance/account-groups`
    ] as const;
    }


export const getListAccountGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listAccountGroups>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountGroups>>> = ({ signal }) => listAccountGroups({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountGroups>>>
export type ListAccountGroupsQueryError = ErrorType<unknown>


/**
 * @summary List account groups (COA hierarchy)
 */

export function useListAccountGroups<TData = Awaited<ReturnType<typeof listAccountGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountGroupsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAccountGroupUrl = () => {




  return `/api/finance/account-groups`
}

/**
 * @summary Create an account group
 */
export const createAccountGroup = async (accountGroupInput: AccountGroupInput, options?: RequestInit): Promise<AccountGroup> => {

  return customFetch<AccountGroup>(getCreateAccountGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountGroupInput,)
  }
);}




export const getCreateAccountGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountGroup>>, TError,{data: BodyType<AccountGroupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccountGroup>>, TError,{data: BodyType<AccountGroupInput>}, TContext> => {

const mutationKey = ['createAccountGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccountGroup>>, {data: BodyType<AccountGroupInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAccountGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createAccountGroup>>>
    export type CreateAccountGroupMutationBody = BodyType<AccountGroupInput>
    export type CreateAccountGroupMutationError = ErrorType<unknown>

    /**
 * @summary Create an account group
 */
export const useCreateAccountGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountGroup>>, TError,{data: BodyType<AccountGroupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAccountGroup>>,
        TError,
        {data: BodyType<AccountGroupInput>},
        TContext
      > => {
      return useMutation(getCreateAccountGroupMutationOptions(options));
    }

export const getUpdateAccountGroupUrl = (id: number,) => {




  return `/api/finance/account-groups/${id}`
}

/**
 * @summary Update an account group
 */
export const updateAccountGroup = async (id: number,
    accountGroupInput: AccountGroupInput, options?: RequestInit): Promise<AccountGroup> => {

  return customFetch<AccountGroup>(getUpdateAccountGroupUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountGroupInput,)
  }
);}




export const getUpdateAccountGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountGroup>>, TError,{id: number;data: BodyType<AccountGroupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccountGroup>>, TError,{id: number;data: BodyType<AccountGroupInput>}, TContext> => {

const mutationKey = ['updateAccountGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountGroup>>, {id: number;data: BodyType<AccountGroupInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAccountGroup(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountGroup>>>
    export type UpdateAccountGroupMutationBody = BodyType<AccountGroupInput>
    export type UpdateAccountGroupMutationError = ErrorType<unknown>

    /**
 * @summary Update an account group
 */
export const useUpdateAccountGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountGroup>>, TError,{id: number;data: BodyType<AccountGroupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAccountGroup>>,
        TError,
        {id: number;data: BodyType<AccountGroupInput>},
        TContext
      > => {
      return useMutation(getUpdateAccountGroupMutationOptions(options));
    }

export const getDeleteAccountGroupUrl = (id: number,) => {




  return `/api/finance/account-groups/${id}`
}

/**
 * @summary Delete an account group
 */
export const deleteAccountGroup = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAccountGroupUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAccountGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountGroup>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccountGroup>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAccountGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccountGroup>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccountGroup(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccountGroup>>>

    export type DeleteAccountGroupMutationError = ErrorType<unknown>

    /**
 * @summary Delete an account group
 */
export const useDeleteAccountGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountGroup>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccountGroup>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAccountGroupMutationOptions(options));
    }

export const getListAccountsUrl = (params?: ListAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/accounts?${stringifiedParams}` : `/api/finance/accounts`
}

/**
 * @summary List all ledger accounts
 */
export const listAccounts = async (params?: ListAccountsParams, options?: RequestInit): Promise<Account[]> => {

  return customFetch<Account[]>(getListAccountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountsQueryKey = (params?: ListAccountsParams,) => {
    return [
    `/api/finance/accounts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listAccounts>>, TError = ErrorType<unknown>>(params?: ListAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccounts>>> = ({ signal }) => listAccounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccounts>>>
export type ListAccountsQueryError = ErrorType<unknown>


/**
 * @summary List all ledger accounts
 */

export function useListAccounts<TData = Awaited<ReturnType<typeof listAccounts>>, TError = ErrorType<unknown>>(
 params?: ListAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAccountUrl = () => {




  return `/api/finance/accounts`
}

/**
 * @summary Create a ledger account
 */
export const createAccount = async (accountInput: AccountInput, options?: RequestInit): Promise<Account> => {

  return customFetch<Account>(getCreateAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountInput,)
  }
);}




export const getCreateAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: BodyType<AccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: BodyType<AccountInput>}, TContext> => {

const mutationKey = ['createAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccount>>, {data: BodyType<AccountInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createAccount>>>
    export type CreateAccountMutationBody = BodyType<AccountInput>
    export type CreateAccountMutationError = ErrorType<unknown>

    /**
 * @summary Create a ledger account
 */
export const useCreateAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: BodyType<AccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAccount>>,
        TError,
        {data: BodyType<AccountInput>},
        TContext
      > => {
      return useMutation(getCreateAccountMutationOptions(options));
    }

export const getGetAccountUrl = (id: number,) => {




  return `/api/finance/accounts/${id}`
}

/**
 * @summary Get a ledger account with running balance
 */
export const getAccount = async (id: number, options?: RequestInit): Promise<Account> => {

  return customFetch<Account>(getGetAccountUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountQueryKey = (id: number,) => {
    return [
    `/api/finance/accounts/${id}`
    ] as const;
    }


export const getGetAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({ signal }) => getAccount(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccount>>>
export type GetAccountQueryError = ErrorType<unknown>


/**
 * @summary Get a ledger account with running balance
 */

export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAccountUrl = (id: number,) => {




  return `/api/finance/accounts/${id}`
}

/**
 * @summary Update a ledger account
 */
export const updateAccount = async (id: number,
    accountInput: AccountInput, options?: RequestInit): Promise<Account> => {

  return customFetch<Account>(getUpdateAccountUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountInput,)
  }
);}




export const getUpdateAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{id: number;data: BodyType<AccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{id: number;data: BodyType<AccountInput>}, TContext> => {

const mutationKey = ['updateAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccount>>, {id: number;data: BodyType<AccountInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccount>>>
    export type UpdateAccountMutationBody = BodyType<AccountInput>
    export type UpdateAccountMutationError = ErrorType<unknown>

    /**
 * @summary Update a ledger account
 */
export const useUpdateAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{id: number;data: BodyType<AccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAccount>>,
        TError,
        {id: number;data: BodyType<AccountInput>},
        TContext
      > => {
      return useMutation(getUpdateAccountMutationOptions(options));
    }

export const getDeleteAccountUrl = (id: number,) => {




  return `/api/finance/accounts/${id}`
}

/**
 * @summary Delete a ledger account
 */
export const deleteAccount = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAccountUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>

    export type DeleteAccountMutationError = ErrorType<unknown>

    /**
 * @summary Delete a ledger account
 */
export const useDeleteAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAccountMutationOptions(options));
    }

export const getGetAccountLedgerUrl = (id: number,
    params?: GetAccountLedgerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/accounts/${id}/ledger?${stringifiedParams}` : `/api/finance/accounts/${id}/ledger`
}

/**
 * @summary Get ledger entries for an account with running balance
 */
export const getAccountLedger = async (id: number,
    params?: GetAccountLedgerParams, options?: RequestInit): Promise<LedgerResponse> => {

  return customFetch<LedgerResponse>(getGetAccountLedgerUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountLedgerQueryKey = (id: number,
    params?: GetAccountLedgerParams,) => {
    return [
    `/api/finance/accounts/${id}/ledger`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAccountLedgerQueryOptions = <TData = Awaited<ReturnType<typeof getAccountLedger>>, TError = ErrorType<unknown>>(id: number,
    params?: GetAccountLedgerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountLedger>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountLedgerQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountLedger>>> = ({ signal }) => getAccountLedger(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountLedger>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountLedger>>>
export type GetAccountLedgerQueryError = ErrorType<unknown>


/**
 * @summary Get ledger entries for an account with running balance
 */

export function useGetAccountLedger<TData = Awaited<ReturnType<typeof getAccountLedger>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetAccountLedgerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountLedger>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountLedgerQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSeedIndiaCoaUrl = () => {




  return `/api/finance/accounts/seed-india-coa`
}

/**
 * @summary Seed India-standard Chart of Accounts for the tenant
 */
export const seedIndiaCoa = async ( options?: RequestInit): Promise<SeedIndiaCoa201> => {

  return customFetch<SeedIndiaCoa201>(getSeedIndiaCoaUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSeedIndiaCoaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seedIndiaCoa>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof seedIndiaCoa>>, TError,void, TContext> => {

const mutationKey = ['seedIndiaCoa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof seedIndiaCoa>>, void> = () => {


          return  seedIndiaCoa(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SeedIndiaCoaMutationResult = NonNullable<Awaited<ReturnType<typeof seedIndiaCoa>>>

    export type SeedIndiaCoaMutationError = ErrorType<unknown>

    /**
 * @summary Seed India-standard Chart of Accounts for the tenant
 */
export const useSeedIndiaCoa = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seedIndiaCoa>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof seedIndiaCoa>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSeedIndiaCoaMutationOptions(options));
    }

export const getListBudgetsUrl = (params?: ListBudgetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/budgets?${stringifiedParams}` : `/api/finance/budgets`
}

/**
 * @summary List budgets
 */
export const listBudgets = async (params?: ListBudgetsParams, options?: RequestInit): Promise<Budget[]> => {

  return customFetch<Budget[]>(getListBudgetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBudgetsQueryKey = (params?: ListBudgetsParams,) => {
    return [
    `/api/finance/budgets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBudgetsQueryOptions = <TData = Awaited<ReturnType<typeof listBudgets>>, TError = ErrorType<unknown>>(params?: ListBudgetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBudgets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBudgetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBudgets>>> = ({ signal }) => listBudgets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBudgets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBudgetsQueryResult = NonNullable<Awaited<ReturnType<typeof listBudgets>>>
export type ListBudgetsQueryError = ErrorType<unknown>


/**
 * @summary List budgets
 */

export function useListBudgets<TData = Awaited<ReturnType<typeof listBudgets>>, TError = ErrorType<unknown>>(
 params?: ListBudgetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBudgets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBudgetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBudgetUrl = () => {




  return `/api/finance/budgets`
}

/**
 * @summary Create a budget
 */
export const createBudget = async (budgetInput: BudgetInput, options?: RequestInit): Promise<Budget> => {

  return customFetch<Budget>(getCreateBudgetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      budgetInput,)
  }
);}




export const getCreateBudgetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBudget>>, TError,{data: BodyType<BudgetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBudget>>, TError,{data: BodyType<BudgetInput>}, TContext> => {

const mutationKey = ['createBudget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBudget>>, {data: BodyType<BudgetInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBudget(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBudgetMutationResult = NonNullable<Awaited<ReturnType<typeof createBudget>>>
    export type CreateBudgetMutationBody = BodyType<BudgetInput>
    export type CreateBudgetMutationError = ErrorType<unknown>

    /**
 * @summary Create a budget
 */
export const useCreateBudget = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBudget>>, TError,{data: BodyType<BudgetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBudget>>,
        TError,
        {data: BodyType<BudgetInput>},
        TContext
      > => {
      return useMutation(getCreateBudgetMutationOptions(options));
    }

export const getGetBudgetUrl = (id: number,) => {




  return `/api/finance/budgets/${id}`
}

/**
 * @summary Get a budget with its lines
 */
export const getBudget = async (id: number, options?: RequestInit): Promise<BudgetDetail> => {

  return customFetch<BudgetDetail>(getGetBudgetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBudgetQueryKey = (id: number,) => {
    return [
    `/api/finance/budgets/${id}`
    ] as const;
    }


export const getGetBudgetQueryOptions = <TData = Awaited<ReturnType<typeof getBudget>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBudget>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBudgetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBudget>>> = ({ signal }) => getBudget(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBudget>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBudgetQueryResult = NonNullable<Awaited<ReturnType<typeof getBudget>>>
export type GetBudgetQueryError = ErrorType<unknown>


/**
 * @summary Get a budget with its lines
 */

export function useGetBudget<TData = Awaited<ReturnType<typeof getBudget>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBudget>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBudgetQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateBudgetUrl = (id: number,) => {




  return `/api/finance/budgets/${id}`
}

/**
 * @summary Update a budget
 */
export const updateBudget = async (id: number,
    budgetInput: BudgetInput, options?: RequestInit): Promise<Budget> => {

  return customFetch<Budget>(getUpdateBudgetUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      budgetInput,)
  }
);}




export const getUpdateBudgetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBudget>>, TError,{id: number;data: BodyType<BudgetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBudget>>, TError,{id: number;data: BodyType<BudgetInput>}, TContext> => {

const mutationKey = ['updateBudget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBudget>>, {id: number;data: BodyType<BudgetInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBudget(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBudgetMutationResult = NonNullable<Awaited<ReturnType<typeof updateBudget>>>
    export type UpdateBudgetMutationBody = BodyType<BudgetInput>
    export type UpdateBudgetMutationError = ErrorType<unknown>

    /**
 * @summary Update a budget
 */
export const useUpdateBudget = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBudget>>, TError,{id: number;data: BodyType<BudgetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBudget>>,
        TError,
        {id: number;data: BodyType<BudgetInput>},
        TContext
      > => {
      return useMutation(getUpdateBudgetMutationOptions(options));
    }

export const getDeleteBudgetUrl = (id: number,) => {




  return `/api/finance/budgets/${id}`
}

/**
 * @summary Delete a draft budget
 */
export const deleteBudget = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteBudgetUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteBudgetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBudget>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBudget>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteBudget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBudget>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteBudget(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBudgetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBudget>>>

    export type DeleteBudgetMutationError = ErrorType<unknown>

    /**
 * @summary Delete a draft budget
 */
export const useDeleteBudget = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBudget>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteBudget>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteBudgetMutationOptions(options));
    }

export const getReviseBudgetUrl = (id: number,) => {




  return `/api/finance/budgets/${id}/revise`
}

/**
 * @summary Create a revised copy of a budget (new version)
 */
export const reviseBudget = async (id: number, options?: RequestInit): Promise<Budget> => {

  return customFetch<Budget>(getReviseBudgetUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReviseBudgetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviseBudget>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviseBudget>>, TError,{id: number}, TContext> => {

const mutationKey = ['reviseBudget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviseBudget>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  reviseBudget(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviseBudgetMutationResult = NonNullable<Awaited<ReturnType<typeof reviseBudget>>>

    export type ReviseBudgetMutationError = ErrorType<unknown>

    /**
 * @summary Create a revised copy of a budget (new version)
 */
export const useReviseBudget = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviseBudget>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviseBudget>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getReviseBudgetMutationOptions(options));
    }

export const getSaveBudgetLinesUrl = (id: number,) => {




  return `/api/finance/budgets/${id}/lines`
}

/**
 * @summary Replace all lines for a budget
 */
export const saveBudgetLines = async (id: number,
    budgetLineInput: BudgetLineInput[], options?: RequestInit): Promise<BudgetLine[]> => {

  return customFetch<BudgetLine[]>(getSaveBudgetLinesUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      budgetLineInput,)
  }
);}




export const getSaveBudgetLinesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveBudgetLines>>, TError,{id: number;data: BodyType<BudgetLineInput[]>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveBudgetLines>>, TError,{id: number;data: BodyType<BudgetLineInput[]>}, TContext> => {

const mutationKey = ['saveBudgetLines'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveBudgetLines>>, {id: number;data: BodyType<BudgetLineInput[]>}> = (props) => {
          const {id,data} = props ?? {};

          return  saveBudgetLines(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveBudgetLinesMutationResult = NonNullable<Awaited<ReturnType<typeof saveBudgetLines>>>
    export type SaveBudgetLinesMutationBody = BodyType<BudgetLineInput[]>
    export type SaveBudgetLinesMutationError = ErrorType<unknown>

    /**
 * @summary Replace all lines for a budget
 */
export const useSaveBudgetLines = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveBudgetLines>>, TError,{id: number;data: BodyType<BudgetLineInput[]>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveBudgetLines>>,
        TError,
        {id: number;data: BodyType<BudgetLineInput[]>},
        TContext
      > => {
      return useMutation(getSaveBudgetLinesMutationOptions(options));
    }

export const getGetBudgetVsActualsUrl = (id: number,) => {




  return `/api/finance/budgets/${id}/vs-actuals`
}

/**
 * @summary Get budget vs actuals comparison
 */
export const getBudgetVsActuals = async (id: number, options?: RequestInit): Promise<BudgetVsActuals> => {

  return customFetch<BudgetVsActuals>(getGetBudgetVsActualsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBudgetVsActualsQueryKey = (id: number,) => {
    return [
    `/api/finance/budgets/${id}/vs-actuals`
    ] as const;
    }


export const getGetBudgetVsActualsQueryOptions = <TData = Awaited<ReturnType<typeof getBudgetVsActuals>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBudgetVsActuals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBudgetVsActualsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBudgetVsActuals>>> = ({ signal }) => getBudgetVsActuals(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBudgetVsActuals>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBudgetVsActualsQueryResult = NonNullable<Awaited<ReturnType<typeof getBudgetVsActuals>>>
export type GetBudgetVsActualsQueryError = ErrorType<unknown>


/**
 * @summary Get budget vs actuals comparison
 */

export function useGetBudgetVsActuals<TData = Awaited<ReturnType<typeof getBudgetVsActuals>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBudgetVsActuals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBudgetVsActualsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getExportBudgetExcelUrl = (id: number,) => {




  return `/api/finance/budgets/${id}/export`
}

/**
 * @summary Download budget vs actuals as Excel (XLSX)
 */
export const exportBudgetExcel = async (id: number, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getExportBudgetExcelUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportBudgetExcelQueryKey = (id: number,) => {
    return [
    `/api/finance/budgets/${id}/export`
    ] as const;
    }


export const getExportBudgetExcelQueryOptions = <TData = Awaited<ReturnType<typeof exportBudgetExcel>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportBudgetExcel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportBudgetExcelQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportBudgetExcel>>> = ({ signal }) => exportBudgetExcel(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportBudgetExcel>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportBudgetExcelQueryResult = NonNullable<Awaited<ReturnType<typeof exportBudgetExcel>>>
export type ExportBudgetExcelQueryError = ErrorType<unknown>


/**
 * @summary Download budget vs actuals as Excel (XLSX)
 */

export function useExportBudgetExcel<TData = Awaited<ReturnType<typeof exportBudgetExcel>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportBudgetExcel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportBudgetExcelQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetProfitCentreReportUrl = (params?: GetProfitCentreReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/profit-centre?${stringifiedParams}` : `/api/finance/reports/profit-centre`
}

/**
 * @summary Profit centre P&L report (revenue and cost by cost/profit centre)
 */
export const getProfitCentreReport = async (params?: GetProfitCentreReportParams, options?: RequestInit): Promise<ProfitCentreReport> => {

  return customFetch<ProfitCentreReport>(getGetProfitCentreReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfitCentreReportQueryKey = (params?: GetProfitCentreReportParams,) => {
    return [
    `/api/finance/reports/profit-centre`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProfitCentreReportQueryOptions = <TData = Awaited<ReturnType<typeof getProfitCentreReport>>, TError = ErrorType<unknown>>(params?: GetProfitCentreReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitCentreReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfitCentreReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfitCentreReport>>> = ({ signal }) => getProfitCentreReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfitCentreReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProfitCentreReportQueryResult = NonNullable<Awaited<ReturnType<typeof getProfitCentreReport>>>
export type GetProfitCentreReportQueryError = ErrorType<unknown>


/**
 * @summary Profit centre P&L report (revenue and cost by cost/profit centre)
 */

export function useGetProfitCentreReport<TData = Awaited<ReturnType<typeof getProfitCentreReport>>, TError = ErrorType<unknown>>(
 params?: GetProfitCentreReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitCentreReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProfitCentreReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCapexItemsUrl = (params?: ListCapexItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/capex?${stringifiedParams}` : `/api/finance/capex`
}

/**
 * @summary List CAPEX items
 */
export const listCapexItems = async (params?: ListCapexItemsParams, options?: RequestInit): Promise<CapexItem[]> => {

  return customFetch<CapexItem[]>(getListCapexItemsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCapexItemsQueryKey = (params?: ListCapexItemsParams,) => {
    return [
    `/api/finance/capex`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCapexItemsQueryOptions = <TData = Awaited<ReturnType<typeof listCapexItems>>, TError = ErrorType<unknown>>(params?: ListCapexItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCapexItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCapexItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCapexItems>>> = ({ signal }) => listCapexItems(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCapexItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCapexItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listCapexItems>>>
export type ListCapexItemsQueryError = ErrorType<unknown>


/**
 * @summary List CAPEX items
 */

export function useListCapexItems<TData = Awaited<ReturnType<typeof listCapexItems>>, TError = ErrorType<unknown>>(
 params?: ListCapexItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCapexItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCapexItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCapexItemUrl = () => {




  return `/api/finance/capex`
}

/**
 * @summary Create a CAPEX item
 */
export const createCapexItem = async (capexItemInput: CapexItemInput, options?: RequestInit): Promise<CapexItem> => {

  return customFetch<CapexItem>(getCreateCapexItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      capexItemInput,)
  }
);}




export const getCreateCapexItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCapexItem>>, TError,{data: BodyType<CapexItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCapexItem>>, TError,{data: BodyType<CapexItemInput>}, TContext> => {

const mutationKey = ['createCapexItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCapexItem>>, {data: BodyType<CapexItemInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCapexItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCapexItemMutationResult = NonNullable<Awaited<ReturnType<typeof createCapexItem>>>
    export type CreateCapexItemMutationBody = BodyType<CapexItemInput>
    export type CreateCapexItemMutationError = ErrorType<unknown>

    /**
 * @summary Create a CAPEX item
 */
export const useCreateCapexItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCapexItem>>, TError,{data: BodyType<CapexItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCapexItem>>,
        TError,
        {data: BodyType<CapexItemInput>},
        TContext
      > => {
      return useMutation(getCreateCapexItemMutationOptions(options));
    }

export const getUpdateCapexItemUrl = (id: number,) => {




  return `/api/finance/capex/${id}`
}

/**
 * @summary Update / action a CAPEX item (approve, reject, capitalize)
 */
export const updateCapexItem = async (id: number,
    capexItemInput: CapexItemInput, options?: RequestInit): Promise<CapexItem> => {

  return customFetch<CapexItem>(getUpdateCapexItemUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      capexItemInput,)
  }
);}




export const getUpdateCapexItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCapexItem>>, TError,{id: number;data: BodyType<CapexItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCapexItem>>, TError,{id: number;data: BodyType<CapexItemInput>}, TContext> => {

const mutationKey = ['updateCapexItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCapexItem>>, {id: number;data: BodyType<CapexItemInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCapexItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCapexItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateCapexItem>>>
    export type UpdateCapexItemMutationBody = BodyType<CapexItemInput>
    export type UpdateCapexItemMutationError = ErrorType<unknown>

    /**
 * @summary Update / action a CAPEX item (approve, reject, capitalize)
 */
export const useUpdateCapexItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCapexItem>>, TError,{id: number;data: BodyType<CapexItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCapexItem>>,
        TError,
        {id: number;data: BodyType<CapexItemInput>},
        TContext
      > => {
      return useMutation(getUpdateCapexItemMutationOptions(options));
    }

export const getDeleteCapexItemUrl = (id: number,) => {




  return `/api/finance/capex/${id}`
}

/**
 * @summary Delete a draft CAPEX item
 */
export const deleteCapexItem = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCapexItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCapexItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCapexItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCapexItem>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCapexItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCapexItem>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCapexItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCapexItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCapexItem>>>

    export type DeleteCapexItemMutationError = ErrorType<unknown>

    /**
 * @summary Delete a draft CAPEX item
 */
export const useDeleteCapexItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCapexItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCapexItem>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCapexItemMutationOptions(options));
    }

export const getListCostCentresUrl = () => {




  return `/api/finance/cost-centres`
}

/**
 * @summary List cost/profit centres
 */
export const listCostCentres = async ( options?: RequestInit): Promise<CostCentre[]> => {

  return customFetch<CostCentre[]>(getListCostCentresUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCostCentresQueryKey = () => {
    return [
    `/api/finance/cost-centres`
    ] as const;
    }


export const getListCostCentresQueryOptions = <TData = Awaited<ReturnType<typeof listCostCentres>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCostCentres>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCostCentresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCostCentres>>> = ({ signal }) => listCostCentres({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCostCentres>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCostCentresQueryResult = NonNullable<Awaited<ReturnType<typeof listCostCentres>>>
export type ListCostCentresQueryError = ErrorType<unknown>


/**
 * @summary List cost/profit centres
 */

export function useListCostCentres<TData = Awaited<ReturnType<typeof listCostCentres>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCostCentres>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCostCentresQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCostCentreUrl = () => {




  return `/api/finance/cost-centres`
}

/**
 * @summary Create a cost/profit centre
 */
export const createCostCentre = async (costCentreInput: CostCentreInput, options?: RequestInit): Promise<CostCentre> => {

  return customFetch<CostCentre>(getCreateCostCentreUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      costCentreInput,)
  }
);}




export const getCreateCostCentreMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCostCentre>>, TError,{data: BodyType<CostCentreInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCostCentre>>, TError,{data: BodyType<CostCentreInput>}, TContext> => {

const mutationKey = ['createCostCentre'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCostCentre>>, {data: BodyType<CostCentreInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCostCentre(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCostCentreMutationResult = NonNullable<Awaited<ReturnType<typeof createCostCentre>>>
    export type CreateCostCentreMutationBody = BodyType<CostCentreInput>
    export type CreateCostCentreMutationError = ErrorType<unknown>

    /**
 * @summary Create a cost/profit centre
 */
export const useCreateCostCentre = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCostCentre>>, TError,{data: BodyType<CostCentreInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCostCentre>>,
        TError,
        {data: BodyType<CostCentreInput>},
        TContext
      > => {
      return useMutation(getCreateCostCentreMutationOptions(options));
    }

export const getUpdateCostCentreUrl = (id: number,) => {




  return `/api/finance/cost-centres/${id}`
}

export const updateCostCentre = async (id: number,
    costCentreInput: CostCentreInput, options?: RequestInit): Promise<CostCentre> => {

  return customFetch<CostCentre>(getUpdateCostCentreUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      costCentreInput,)
  }
);}




export const getUpdateCostCentreMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCostCentre>>, TError,{id: number;data: BodyType<CostCentreInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCostCentre>>, TError,{id: number;data: BodyType<CostCentreInput>}, TContext> => {

const mutationKey = ['updateCostCentre'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCostCentre>>, {id: number;data: BodyType<CostCentreInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCostCentre(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCostCentreMutationResult = NonNullable<Awaited<ReturnType<typeof updateCostCentre>>>
    export type UpdateCostCentreMutationBody = BodyType<CostCentreInput>
    export type UpdateCostCentreMutationError = ErrorType<unknown>

    export const useUpdateCostCentre = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCostCentre>>, TError,{id: number;data: BodyType<CostCentreInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCostCentre>>,
        TError,
        {id: number;data: BodyType<CostCentreInput>},
        TContext
      > => {
      return useMutation(getUpdateCostCentreMutationOptions(options));
    }

export const getDeleteCostCentreUrl = (id: number,) => {




  return `/api/finance/cost-centres/${id}`
}

export const deleteCostCentre = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCostCentreUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCostCentreMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCostCentre>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCostCentre>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCostCentre'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCostCentre>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCostCentre(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCostCentreMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCostCentre>>>

    export type DeleteCostCentreMutationError = ErrorType<unknown>

    export const useDeleteCostCentre = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCostCentre>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCostCentre>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCostCentreMutationOptions(options));
    }

export const getListVouchersUrl = (params?: ListVouchersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/vouchers?${stringifiedParams}` : `/api/finance/vouchers`
}

/**
 * @summary List vouchers
 */
export const listVouchers = async (params?: ListVouchersParams, options?: RequestInit): Promise<Voucher[]> => {

  return customFetch<Voucher[]>(getListVouchersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVouchersQueryKey = (params?: ListVouchersParams,) => {
    return [
    `/api/finance/vouchers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVouchersQueryOptions = <TData = Awaited<ReturnType<typeof listVouchers>>, TError = ErrorType<unknown>>(params?: ListVouchersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVouchers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVouchersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVouchers>>> = ({ signal }) => listVouchers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVouchers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVouchersQueryResult = NonNullable<Awaited<ReturnType<typeof listVouchers>>>
export type ListVouchersQueryError = ErrorType<unknown>


/**
 * @summary List vouchers
 */

export function useListVouchers<TData = Awaited<ReturnType<typeof listVouchers>>, TError = ErrorType<unknown>>(
 params?: ListVouchersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVouchers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVouchersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateVoucherUrl = () => {




  return `/api/finance/vouchers`
}

/**
 * @summary Create and post a voucher (enforces double-entry)
 */
export const createVoucher = async (voucherInput: VoucherInput, options?: RequestInit): Promise<Voucher> => {

  return customFetch<Voucher>(getCreateVoucherUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voucherInput,)
  }
);}




export const getCreateVoucherMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVoucher>>, TError,{data: BodyType<VoucherInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVoucher>>, TError,{data: BodyType<VoucherInput>}, TContext> => {

const mutationKey = ['createVoucher'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVoucher>>, {data: BodyType<VoucherInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVoucher(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVoucherMutationResult = NonNullable<Awaited<ReturnType<typeof createVoucher>>>
    export type CreateVoucherMutationBody = BodyType<VoucherInput>
    export type CreateVoucherMutationError = ErrorType<unknown>

    /**
 * @summary Create and post a voucher (enforces double-entry)
 */
export const useCreateVoucher = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVoucher>>, TError,{data: BodyType<VoucherInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVoucher>>,
        TError,
        {data: BodyType<VoucherInput>},
        TContext
      > => {
      return useMutation(getCreateVoucherMutationOptions(options));
    }

export const getGetVoucherUrl = (id: number,) => {




  return `/api/finance/vouchers/${id}`
}

/**
 * @summary Get a voucher with lines
 */
export const getVoucher = async (id: number, options?: RequestInit): Promise<VoucherDetail> => {

  return customFetch<VoucherDetail>(getGetVoucherUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVoucherQueryKey = (id: number,) => {
    return [
    `/api/finance/vouchers/${id}`
    ] as const;
    }


export const getGetVoucherQueryOptions = <TData = Awaited<ReturnType<typeof getVoucher>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVoucher>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVoucherQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVoucher>>> = ({ signal }) => getVoucher(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVoucher>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVoucherQueryResult = NonNullable<Awaited<ReturnType<typeof getVoucher>>>
export type GetVoucherQueryError = ErrorType<unknown>


/**
 * @summary Get a voucher with lines
 */

export function useGetVoucher<TData = Awaited<ReturnType<typeof getVoucher>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVoucher>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVoucherQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateVoucherUrl = (id: number,) => {




  return `/api/finance/vouchers/${id}`
}

/**
 * @summary Update a draft voucher
 */
export const updateVoucher = async (id: number,
    voucherInput: VoucherInput, options?: RequestInit): Promise<Voucher> => {

  return customFetch<Voucher>(getUpdateVoucherUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voucherInput,)
  }
);}




export const getUpdateVoucherMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVoucher>>, TError,{id: number;data: BodyType<VoucherInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVoucher>>, TError,{id: number;data: BodyType<VoucherInput>}, TContext> => {

const mutationKey = ['updateVoucher'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVoucher>>, {id: number;data: BodyType<VoucherInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVoucher(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVoucherMutationResult = NonNullable<Awaited<ReturnType<typeof updateVoucher>>>
    export type UpdateVoucherMutationBody = BodyType<VoucherInput>
    export type UpdateVoucherMutationError = ErrorType<unknown>

    /**
 * @summary Update a draft voucher
 */
export const useUpdateVoucher = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVoucher>>, TError,{id: number;data: BodyType<VoucherInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVoucher>>,
        TError,
        {id: number;data: BodyType<VoucherInput>},
        TContext
      > => {
      return useMutation(getUpdateVoucherMutationOptions(options));
    }

export const getPostVoucherUrl = (id: number,) => {




  return `/api/finance/vouchers/${id}/post`
}

/**
 * @summary Post a draft voucher (irreversible unless cancelled)
 */
export const postVoucher = async (id: number, options?: RequestInit): Promise<Voucher> => {

  return customFetch<Voucher>(getPostVoucherUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostVoucherMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVoucher>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postVoucher>>, TError,{id: number}, TContext> => {

const mutationKey = ['postVoucher'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVoucher>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postVoucher(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostVoucherMutationResult = NonNullable<Awaited<ReturnType<typeof postVoucher>>>

    export type PostVoucherMutationError = ErrorType<unknown>

    /**
 * @summary Post a draft voucher (irreversible unless cancelled)
 */
export const usePostVoucher = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVoucher>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postVoucher>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostVoucherMutationOptions(options));
    }

export const getCancelVoucherUrl = (id: number,) => {




  return `/api/finance/vouchers/${id}/cancel`
}

/**
 * @summary Cancel a posted voucher (creates reversal)
 */
export const cancelVoucher = async (id: number,
    cancelVoucherBody?: CancelVoucherBody, options?: RequestInit): Promise<Voucher> => {

  return customFetch<Voucher>(getCancelVoucherUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cancelVoucherBody,)
  }
);}




export const getCancelVoucherMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelVoucher>>, TError,{id: number;data?: BodyType<CancelVoucherBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelVoucher>>, TError,{id: number;data?: BodyType<CancelVoucherBody>}, TContext> => {

const mutationKey = ['cancelVoucher'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelVoucher>>, {id: number;data?: BodyType<CancelVoucherBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelVoucher(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelVoucherMutationResult = NonNullable<Awaited<ReturnType<typeof cancelVoucher>>>
    export type CancelVoucherMutationBody = BodyType<CancelVoucherBody> | undefined
    export type CancelVoucherMutationError = ErrorType<unknown>

    /**
 * @summary Cancel a posted voucher (creates reversal)
 */
export const useCancelVoucher = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelVoucher>>, TError,{id: number;data?: BodyType<CancelVoucherBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelVoucher>>,
        TError,
        {id: number;data?: BodyType<CancelVoucherBody>},
        TContext
      > => {
      return useMutation(getCancelVoucherMutationOptions(options));
    }

export const getListPeriodLocksUrl = (params?: ListPeriodLocksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/period-locks?${stringifiedParams}` : `/api/finance/period-locks`
}

/**
 * @summary List period locks
 */
export const listPeriodLocks = async (params?: ListPeriodLocksParams, options?: RequestInit): Promise<PeriodLock[]> => {

  return customFetch<PeriodLock[]>(getListPeriodLocksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPeriodLocksQueryKey = (params?: ListPeriodLocksParams,) => {
    return [
    `/api/finance/period-locks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPeriodLocksQueryOptions = <TData = Awaited<ReturnType<typeof listPeriodLocks>>, TError = ErrorType<unknown>>(params?: ListPeriodLocksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPeriodLocks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPeriodLocksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPeriodLocks>>> = ({ signal }) => listPeriodLocks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPeriodLocks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPeriodLocksQueryResult = NonNullable<Awaited<ReturnType<typeof listPeriodLocks>>>
export type ListPeriodLocksQueryError = ErrorType<unknown>


/**
 * @summary List period locks
 */

export function useListPeriodLocks<TData = Awaited<ReturnType<typeof listPeriodLocks>>, TError = ErrorType<unknown>>(
 params?: ListPeriodLocksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPeriodLocks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPeriodLocksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetPeriodLockUrl = () => {




  return `/api/finance/period-locks`
}

/**
 * @summary Lock or unlock a period
 */
export const setPeriodLock = async (periodLockInput: PeriodLockInput, options?: RequestInit): Promise<PeriodLock> => {

  return customFetch<PeriodLock>(getSetPeriodLockUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      periodLockInput,)
  }
);}




export const getSetPeriodLockMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPeriodLock>>, TError,{data: BodyType<PeriodLockInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPeriodLock>>, TError,{data: BodyType<PeriodLockInput>}, TContext> => {

const mutationKey = ['setPeriodLock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPeriodLock>>, {data: BodyType<PeriodLockInput>}> = (props) => {
          const {data} = props ?? {};

          return  setPeriodLock(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPeriodLockMutationResult = NonNullable<Awaited<ReturnType<typeof setPeriodLock>>>
    export type SetPeriodLockMutationBody = BodyType<PeriodLockInput>
    export type SetPeriodLockMutationError = ErrorType<unknown>

    /**
 * @summary Lock or unlock a period
 */
export const useSetPeriodLock = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPeriodLock>>, TError,{data: BodyType<PeriodLockInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPeriodLock>>,
        TError,
        {data: BodyType<PeriodLockInput>},
        TContext
      > => {
      return useMutation(getSetPeriodLockMutationOptions(options));
    }

export const getListVendorsUrl = (params?: ListVendorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/vendors?${stringifiedParams}` : `/api/finance/vendors`
}

/**
 * @summary List vendors
 */
export const listVendors = async (params?: ListVendorsParams, options?: RequestInit): Promise<Vendor[]> => {

  return customFetch<Vendor[]>(getListVendorsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorsQueryKey = (params?: ListVendorsParams,) => {
    return [
    `/api/finance/vendors`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVendorsQueryOptions = <TData = Awaited<ReturnType<typeof listVendors>>, TError = ErrorType<unknown>>(params?: ListVendorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendors>>> = ({ signal }) => listVendors(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendors>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendors>>>
export type ListVendorsQueryError = ErrorType<unknown>


/**
 * @summary List vendors
 */

export function useListVendors<TData = Awaited<ReturnType<typeof listVendors>>, TError = ErrorType<unknown>>(
 params?: ListVendorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateVendorUrl = () => {




  return `/api/finance/vendors`
}

/**
 * @summary Create a vendor
 */
export const createVendor = async (vendorInput: VendorInput, options?: RequestInit): Promise<Vendor> => {

  return customFetch<Vendor>(getCreateVendorUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorInput,)
  }
);}




export const getCreateVendorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendor>>, TError,{data: BodyType<VendorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVendor>>, TError,{data: BodyType<VendorInput>}, TContext> => {

const mutationKey = ['createVendor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVendor>>, {data: BodyType<VendorInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVendor(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVendorMutationResult = NonNullable<Awaited<ReturnType<typeof createVendor>>>
    export type CreateVendorMutationBody = BodyType<VendorInput>
    export type CreateVendorMutationError = ErrorType<unknown>

    /**
 * @summary Create a vendor
 */
export const useCreateVendor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendor>>, TError,{data: BodyType<VendorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVendor>>,
        TError,
        {data: BodyType<VendorInput>},
        TContext
      > => {
      return useMutation(getCreateVendorMutationOptions(options));
    }

export const getGetVendorUrl = (id: number,) => {




  return `/api/finance/vendors/${id}`
}

/**
 * @summary Get vendor detail with contacts and bank accounts
 */
export const getVendor = async (id: number, options?: RequestInit): Promise<VendorDetail> => {

  return customFetch<VendorDetail>(getGetVendorUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorQueryKey = (id: number,) => {
    return [
    `/api/finance/vendors/${id}`
    ] as const;
    }


export const getGetVendorQueryOptions = <TData = Awaited<ReturnType<typeof getVendor>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendor>>> = ({ signal }) => getVendor(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVendorQueryResult = NonNullable<Awaited<ReturnType<typeof getVendor>>>
export type GetVendorQueryError = ErrorType<unknown>


/**
 * @summary Get vendor detail with contacts and bank accounts
 */

export function useGetVendor<TData = Awaited<ReturnType<typeof getVendor>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVendorQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateVendorUrl = (id: number,) => {




  return `/api/finance/vendors/${id}`
}

/**
 * @summary Update a vendor
 */
export const updateVendor = async (id: number,
    vendorInput: VendorInput, options?: RequestInit): Promise<Vendor> => {

  return customFetch<Vendor>(getUpdateVendorUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorInput,)
  }
);}




export const getUpdateVendorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendor>>, TError,{id: number;data: BodyType<VendorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVendor>>, TError,{id: number;data: BodyType<VendorInput>}, TContext> => {

const mutationKey = ['updateVendor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVendor>>, {id: number;data: BodyType<VendorInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVendor(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVendorMutationResult = NonNullable<Awaited<ReturnType<typeof updateVendor>>>
    export type UpdateVendorMutationBody = BodyType<VendorInput>
    export type UpdateVendorMutationError = ErrorType<unknown>

    /**
 * @summary Update a vendor
 */
export const useUpdateVendor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendor>>, TError,{id: number;data: BodyType<VendorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVendor>>,
        TError,
        {id: number;data: BodyType<VendorInput>},
        TContext
      > => {
      return useMutation(getUpdateVendorMutationOptions(options));
    }

export const getDeleteVendorUrl = (id: number,) => {




  return `/api/finance/vendors/${id}`
}

/**
 * @summary Delete a vendor (soft-delete / blacklist)
 */
export const deleteVendor = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteVendorUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteVendorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVendor>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVendor>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteVendor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVendor>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteVendor(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVendorMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVendor>>>

    export type DeleteVendorMutationError = ErrorType<unknown>

    /**
 * @summary Delete a vendor (soft-delete / blacklist)
 */
export const useDeleteVendor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVendor>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVendor>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteVendorMutationOptions(options));
    }

export const getValidateVendorGstinUrl = (id: number,) => {




  return `/api/finance/vendors/${id}/validate-gstin`
}

/**
 * @summary Live GSTIN validation
 */
export const validateVendorGstin = async (id: number, options?: RequestInit): Promise<GstinValidationResult> => {

  return customFetch<GstinValidationResult>(getValidateVendorGstinUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getValidateVendorGstinMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateVendorGstin>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof validateVendorGstin>>, TError,{id: number}, TContext> => {

const mutationKey = ['validateVendorGstin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateVendorGstin>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  validateVendorGstin(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidateVendorGstinMutationResult = NonNullable<Awaited<ReturnType<typeof validateVendorGstin>>>

    export type ValidateVendorGstinMutationError = ErrorType<unknown>

    /**
 * @summary Live GSTIN validation
 */
export const useValidateVendorGstin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateVendorGstin>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof validateVendorGstin>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getValidateVendorGstinMutationOptions(options));
    }

export const getListVendorBankAccountsUrl = (id: number,) => {




  return `/api/finance/vendors/${id}/bank-accounts`
}

export const listVendorBankAccounts = async (id: number, options?: RequestInit): Promise<VendorBankAccount[]> => {

  return customFetch<VendorBankAccount[]>(getListVendorBankAccountsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorBankAccountsQueryKey = (id: number,) => {
    return [
    `/api/finance/vendors/${id}/bank-accounts`
    ] as const;
    }


export const getListVendorBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listVendorBankAccounts>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorBankAccountsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorBankAccounts>>> = ({ signal }) => listVendorBankAccounts(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorBankAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorBankAccounts>>>
export type ListVendorBankAccountsQueryError = ErrorType<unknown>



export function useListVendorBankAccounts<TData = Awaited<ReturnType<typeof listVendorBankAccounts>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorBankAccountsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAddVendorBankAccountUrl = (id: number,) => {




  return `/api/finance/vendors/${id}/bank-accounts`
}

export const addVendorBankAccount = async (id: number,
    vendorBankAccountInput: VendorBankAccountInput, options?: RequestInit): Promise<VendorBankAccount> => {

  return customFetch<VendorBankAccount>(getAddVendorBankAccountUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorBankAccountInput,)
  }
);}




export const getAddVendorBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addVendorBankAccount>>, TError,{id: number;data: BodyType<VendorBankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addVendorBankAccount>>, TError,{id: number;data: BodyType<VendorBankAccountInput>}, TContext> => {

const mutationKey = ['addVendorBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addVendorBankAccount>>, {id: number;data: BodyType<VendorBankAccountInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addVendorBankAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddVendorBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof addVendorBankAccount>>>
    export type AddVendorBankAccountMutationBody = BodyType<VendorBankAccountInput>
    export type AddVendorBankAccountMutationError = ErrorType<unknown>

    export const useAddVendorBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addVendorBankAccount>>, TError,{id: number;data: BodyType<VendorBankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addVendorBankAccount>>,
        TError,
        {id: number;data: BodyType<VendorBankAccountInput>},
        TContext
      > => {
      return useMutation(getAddVendorBankAccountMutationOptions(options));
    }

export const getUpdateVendorBankAccountUrl = (id: number,
    bankId: number,) => {




  return `/api/finance/vendors/${id}/bank-accounts/${bankId}`
}

export const updateVendorBankAccount = async (id: number,
    bankId: number,
    vendorBankAccountInput: VendorBankAccountInput, options?: RequestInit): Promise<VendorBankAccount> => {

  return customFetch<VendorBankAccount>(getUpdateVendorBankAccountUrl(id,bankId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorBankAccountInput,)
  }
);}




export const getUpdateVendorBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendorBankAccount>>, TError,{id: number;bankId: number;data: BodyType<VendorBankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVendorBankAccount>>, TError,{id: number;bankId: number;data: BodyType<VendorBankAccountInput>}, TContext> => {

const mutationKey = ['updateVendorBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVendorBankAccount>>, {id: number;bankId: number;data: BodyType<VendorBankAccountInput>}> = (props) => {
          const {id,bankId,data} = props ?? {};

          return  updateVendorBankAccount(id,bankId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVendorBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateVendorBankAccount>>>
    export type UpdateVendorBankAccountMutationBody = BodyType<VendorBankAccountInput>
    export type UpdateVendorBankAccountMutationError = ErrorType<unknown>

    export const useUpdateVendorBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendorBankAccount>>, TError,{id: number;bankId: number;data: BodyType<VendorBankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVendorBankAccount>>,
        TError,
        {id: number;bankId: number;data: BodyType<VendorBankAccountInput>},
        TContext
      > => {
      return useMutation(getUpdateVendorBankAccountMutationOptions(options));
    }

export const getDeleteVendorBankAccountUrl = (id: number,
    bankId: number,) => {




  return `/api/finance/vendors/${id}/bank-accounts/${bankId}`
}

export const deleteVendorBankAccount = async (id: number,
    bankId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteVendorBankAccountUrl(id,bankId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteVendorBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVendorBankAccount>>, TError,{id: number;bankId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVendorBankAccount>>, TError,{id: number;bankId: number}, TContext> => {

const mutationKey = ['deleteVendorBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVendorBankAccount>>, {id: number;bankId: number}> = (props) => {
          const {id,bankId} = props ?? {};

          return  deleteVendorBankAccount(id,bankId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVendorBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVendorBankAccount>>>

    export type DeleteVendorBankAccountMutationError = ErrorType<unknown>

    export const useDeleteVendorBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVendorBankAccount>>, TError,{id: number;bankId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVendorBankAccount>>,
        TError,
        {id: number;bankId: number},
        TContext
      > => {
      return useMutation(getDeleteVendorBankAccountMutationOptions(options));
    }

export const getListVendorInvitesUrl = () => {




  return `/api/finance/vendors/invites`
}

/**
 * @summary List vendor onboarding invites
 */
export const listVendorInvites = async ( options?: RequestInit): Promise<VendorInvite[]> => {

  return customFetch<VendorInvite[]>(getListVendorInvitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorInvitesQueryKey = () => {
    return [
    `/api/finance/vendors/invites`
    ] as const;
    }


export const getListVendorInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listVendorInvites>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorInvites>>> = ({ signal }) => listVendorInvites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorInvites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorInvites>>>
export type ListVendorInvitesQueryError = ErrorType<unknown>


/**
 * @summary List vendor onboarding invites
 */

export function useListVendorInvites<TData = Awaited<ReturnType<typeof listVendorInvites>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorInvitesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateVendorInviteUrl = () => {




  return `/api/finance/vendors/invites`
}

/**
 * @summary Send vendor self-onboarding invite
 */
export const createVendorInvite = async (vendorInviteInput: VendorInviteInput, options?: RequestInit): Promise<VendorInvite> => {

  return customFetch<VendorInvite>(getCreateVendorInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorInviteInput,)
  }
);}




export const getCreateVendorInviteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorInvite>>, TError,{data: BodyType<VendorInviteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVendorInvite>>, TError,{data: BodyType<VendorInviteInput>}, TContext> => {

const mutationKey = ['createVendorInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVendorInvite>>, {data: BodyType<VendorInviteInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVendorInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVendorInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createVendorInvite>>>
    export type CreateVendorInviteMutationBody = BodyType<VendorInviteInput>
    export type CreateVendorInviteMutationError = ErrorType<unknown>

    /**
 * @summary Send vendor self-onboarding invite
 */
export const useCreateVendorInvite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorInvite>>, TError,{data: BodyType<VendorInviteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVendorInvite>>,
        TError,
        {data: BodyType<VendorInviteInput>},
        TContext
      > => {
      return useMutation(getCreateVendorInviteMutationOptions(options));
    }

export const getReviewVendorInviteUrl = (id: number,) => {




  return `/api/finance/vendors/invites/${id}/review`
}

/**
 * @summary Approve or reject a vendor onboarding submission
 */
export const reviewVendorInvite = async (id: number,
    vendorInviteReviewInput: VendorInviteReviewInput, options?: RequestInit): Promise<VendorInvite> => {

  return customFetch<VendorInvite>(getReviewVendorInviteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorInviteReviewInput,)
  }
);}




export const getReviewVendorInviteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewVendorInvite>>, TError,{id: number;data: BodyType<VendorInviteReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewVendorInvite>>, TError,{id: number;data: BodyType<VendorInviteReviewInput>}, TContext> => {

const mutationKey = ['reviewVendorInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewVendorInvite>>, {id: number;data: BodyType<VendorInviteReviewInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  reviewVendorInvite(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewVendorInviteMutationResult = NonNullable<Awaited<ReturnType<typeof reviewVendorInvite>>>
    export type ReviewVendorInviteMutationBody = BodyType<VendorInviteReviewInput>
    export type ReviewVendorInviteMutationError = ErrorType<unknown>

    /**
 * @summary Approve or reject a vendor onboarding submission
 */
export const useReviewVendorInvite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewVendorInvite>>, TError,{id: number;data: BodyType<VendorInviteReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewVendorInvite>>,
        TError,
        {id: number;data: BodyType<VendorInviteReviewInput>},
        TContext
      > => {
      return useMutation(getReviewVendorInviteMutationOptions(options));
    }

export const getListPurchaseRequisitionsUrl = (params?: ListPurchaseRequisitionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/purchase-requisitions?${stringifiedParams}` : `/api/finance/purchase-requisitions`
}

/**
 * @summary List purchase requisitions
 */
export const listPurchaseRequisitions = async (params?: ListPurchaseRequisitionsParams, options?: RequestInit): Promise<PurchaseRequisition[]> => {

  return customFetch<PurchaseRequisition[]>(getListPurchaseRequisitionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseRequisitionsQueryKey = (params?: ListPurchaseRequisitionsParams,) => {
    return [
    `/api/finance/purchase-requisitions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseRequisitionsQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseRequisitions>>, TError = ErrorType<unknown>>(params?: ListPurchaseRequisitionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseRequisitions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseRequisitionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseRequisitions>>> = ({ signal }) => listPurchaseRequisitions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseRequisitions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseRequisitionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseRequisitions>>>
export type ListPurchaseRequisitionsQueryError = ErrorType<unknown>


/**
 * @summary List purchase requisitions
 */

export function useListPurchaseRequisitions<TData = Awaited<ReturnType<typeof listPurchaseRequisitions>>, TError = ErrorType<unknown>>(
 params?: ListPurchaseRequisitionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseRequisitions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseRequisitionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePurchaseRequisitionUrl = () => {




  return `/api/finance/purchase-requisitions`
}

/**
 * @summary Create a purchase requisition
 */
export const createPurchaseRequisition = async (purchaseRequisitionInput: PurchaseRequisitionInput, options?: RequestInit): Promise<PurchaseRequisition> => {

  return customFetch<PurchaseRequisition>(getCreatePurchaseRequisitionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      purchaseRequisitionInput,)
  }
);}




export const getCreatePurchaseRequisitionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseRequisition>>, TError,{data: BodyType<PurchaseRequisitionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPurchaseRequisition>>, TError,{data: BodyType<PurchaseRequisitionInput>}, TContext> => {

const mutationKey = ['createPurchaseRequisition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPurchaseRequisition>>, {data: BodyType<PurchaseRequisitionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPurchaseRequisition(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePurchaseRequisitionMutationResult = NonNullable<Awaited<ReturnType<typeof createPurchaseRequisition>>>
    export type CreatePurchaseRequisitionMutationBody = BodyType<PurchaseRequisitionInput>
    export type CreatePurchaseRequisitionMutationError = ErrorType<unknown>

    /**
 * @summary Create a purchase requisition
 */
export const useCreatePurchaseRequisition = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseRequisition>>, TError,{data: BodyType<PurchaseRequisitionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPurchaseRequisition>>,
        TError,
        {data: BodyType<PurchaseRequisitionInput>},
        TContext
      > => {
      return useMutation(getCreatePurchaseRequisitionMutationOptions(options));
    }

export const getGetPurchaseRequisitionUrl = (id: number,) => {




  return `/api/finance/purchase-requisitions/${id}`
}

export const getPurchaseRequisition = async (id: number, options?: RequestInit): Promise<PurchaseRequisition> => {

  return customFetch<PurchaseRequisition>(getGetPurchaseRequisitionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseRequisitionQueryKey = (id: number,) => {
    return [
    `/api/finance/purchase-requisitions/${id}`
    ] as const;
    }


export const getGetPurchaseRequisitionQueryOptions = <TData = Awaited<ReturnType<typeof getPurchaseRequisition>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseRequisition>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseRequisitionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchaseRequisition>>> = ({ signal }) => getPurchaseRequisition(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchaseRequisition>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseRequisitionQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchaseRequisition>>>
export type GetPurchaseRequisitionQueryError = ErrorType<unknown>



export function useGetPurchaseRequisition<TData = Awaited<ReturnType<typeof getPurchaseRequisition>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseRequisition>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseRequisitionQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePurchaseRequisitionUrl = (id: number,) => {




  return `/api/finance/purchase-requisitions/${id}`
}

export const updatePurchaseRequisition = async (id: number,
    purchaseRequisitionInput: PurchaseRequisitionInput, options?: RequestInit): Promise<PurchaseRequisition> => {

  return customFetch<PurchaseRequisition>(getUpdatePurchaseRequisitionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      purchaseRequisitionInput,)
  }
);}




export const getUpdatePurchaseRequisitionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseRequisition>>, TError,{id: number;data: BodyType<PurchaseRequisitionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseRequisition>>, TError,{id: number;data: BodyType<PurchaseRequisitionInput>}, TContext> => {

const mutationKey = ['updatePurchaseRequisition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePurchaseRequisition>>, {id: number;data: BodyType<PurchaseRequisitionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePurchaseRequisition(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePurchaseRequisitionMutationResult = NonNullable<Awaited<ReturnType<typeof updatePurchaseRequisition>>>
    export type UpdatePurchaseRequisitionMutationBody = BodyType<PurchaseRequisitionInput>
    export type UpdatePurchaseRequisitionMutationError = ErrorType<unknown>

    export const useUpdatePurchaseRequisition = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseRequisition>>, TError,{id: number;data: BodyType<PurchaseRequisitionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePurchaseRequisition>>,
        TError,
        {id: number;data: BodyType<PurchaseRequisitionInput>},
        TContext
      > => {
      return useMutation(getUpdatePurchaseRequisitionMutationOptions(options));
    }

export const getPurchaseRequisitionActionUrl = (id: number,) => {




  return `/api/finance/purchase-requisitions/${id}/action`
}

/**
 * @summary Submit, approve, or reject a PR
 */
export const purchaseRequisitionAction = async (id: number,
    pRActionInput: PRActionInput, options?: RequestInit): Promise<PurchaseRequisition> => {

  return customFetch<PurchaseRequisition>(getPurchaseRequisitionActionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pRActionInput,)
  }
);}




export const getPurchaseRequisitionActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseRequisitionAction>>, TError,{id: number;data: BodyType<PRActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof purchaseRequisitionAction>>, TError,{id: number;data: BodyType<PRActionInput>}, TContext> => {

const mutationKey = ['purchaseRequisitionAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchaseRequisitionAction>>, {id: number;data: BodyType<PRActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  purchaseRequisitionAction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PurchaseRequisitionActionMutationResult = NonNullable<Awaited<ReturnType<typeof purchaseRequisitionAction>>>
    export type PurchaseRequisitionActionMutationBody = BodyType<PRActionInput>
    export type PurchaseRequisitionActionMutationError = ErrorType<unknown>

    /**
 * @summary Submit, approve, or reject a PR
 */
export const usePurchaseRequisitionAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseRequisitionAction>>, TError,{id: number;data: BodyType<PRActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof purchaseRequisitionAction>>,
        TError,
        {id: number;data: BodyType<PRActionInput>},
        TContext
      > => {
      return useMutation(getPurchaseRequisitionActionMutationOptions(options));
    }

export const getListPurchaseOrdersUrl = (params?: ListPurchaseOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/purchase-orders?${stringifiedParams}` : `/api/finance/purchase-orders`
}

/**
 * @summary List purchase orders
 */
export const listPurchaseOrders = async (params?: ListPurchaseOrdersParams, options?: RequestInit): Promise<PurchaseOrder[]> => {

  return customFetch<PurchaseOrder[]>(getListPurchaseOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseOrdersQueryKey = (params?: ListPurchaseOrdersParams,) => {
    return [
    `/api/finance/purchase-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseOrders>>, TError = ErrorType<unknown>>(params?: ListPurchaseOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseOrders>>> = ({ signal }) => listPurchaseOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseOrders>>>
export type ListPurchaseOrdersQueryError = ErrorType<unknown>


/**
 * @summary List purchase orders
 */

export function useListPurchaseOrders<TData = Awaited<ReturnType<typeof listPurchaseOrders>>, TError = ErrorType<unknown>>(
 params?: ListPurchaseOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePurchaseOrderUrl = () => {




  return `/api/finance/purchase-orders`
}

/**
 * @summary Create a purchase order
 */
export const createPurchaseOrder = async (purchaseOrderInput: PurchaseOrderInput, options?: RequestInit): Promise<PurchaseOrder> => {

  return customFetch<PurchaseOrder>(getCreatePurchaseOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      purchaseOrderInput,)
  }
);}




export const getCreatePurchaseOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseOrder>>, TError,{data: BodyType<PurchaseOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPurchaseOrder>>, TError,{data: BodyType<PurchaseOrderInput>}, TContext> => {

const mutationKey = ['createPurchaseOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPurchaseOrder>>, {data: BodyType<PurchaseOrderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPurchaseOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePurchaseOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createPurchaseOrder>>>
    export type CreatePurchaseOrderMutationBody = BodyType<PurchaseOrderInput>
    export type CreatePurchaseOrderMutationError = ErrorType<unknown>

    /**
 * @summary Create a purchase order
 */
export const useCreatePurchaseOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseOrder>>, TError,{data: BodyType<PurchaseOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPurchaseOrder>>,
        TError,
        {data: BodyType<PurchaseOrderInput>},
        TContext
      > => {
      return useMutation(getCreatePurchaseOrderMutationOptions(options));
    }

export const getGetPurchaseOrderUrl = (id: number,) => {




  return `/api/finance/purchase-orders/${id}`
}

export const getPurchaseOrder = async (id: number, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getGetPurchaseOrderUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseOrderQueryKey = (id: number,) => {
    return [
    `/api/finance/purchase-orders/${id}`
    ] as const;
    }


export const getGetPurchaseOrderQueryOptions = <TData = Awaited<ReturnType<typeof getPurchaseOrder>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseOrderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchaseOrder>>> = ({ signal }) => getPurchaseOrder(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchaseOrder>>>
export type GetPurchaseOrderQueryError = ErrorType<unknown>



export function useGetPurchaseOrder<TData = Awaited<ReturnType<typeof getPurchaseOrder>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseOrderQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePurchaseOrderUrl = (id: number,) => {




  return `/api/finance/purchase-orders/${id}`
}

export const updatePurchaseOrder = async (id: number,
    purchaseOrderInput: PurchaseOrderInput, options?: RequestInit): Promise<PurchaseOrder> => {

  return customFetch<PurchaseOrder>(getUpdatePurchaseOrderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      purchaseOrderInput,)
  }
);}




export const getUpdatePurchaseOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrder>>, TError,{id: number;data: BodyType<PurchaseOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrder>>, TError,{id: number;data: BodyType<PurchaseOrderInput>}, TContext> => {

const mutationKey = ['updatePurchaseOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePurchaseOrder>>, {id: number;data: BodyType<PurchaseOrderInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePurchaseOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePurchaseOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updatePurchaseOrder>>>
    export type UpdatePurchaseOrderMutationBody = BodyType<PurchaseOrderInput>
    export type UpdatePurchaseOrderMutationError = ErrorType<unknown>

    export const useUpdatePurchaseOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrder>>, TError,{id: number;data: BodyType<PurchaseOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePurchaseOrder>>,
        TError,
        {id: number;data: BodyType<PurchaseOrderInput>},
        TContext
      > => {
      return useMutation(getUpdatePurchaseOrderMutationOptions(options));
    }

export const getPurchaseOrderActionUrl = (id: number,) => {




  return `/api/finance/purchase-orders/${id}/action`
}

/**
 * @summary Approve, reject, send, or close a PO
 */
export const purchaseOrderAction = async (id: number,
    pOActionInput: POActionInput, options?: RequestInit): Promise<PurchaseOrder> => {

  return customFetch<PurchaseOrder>(getPurchaseOrderActionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pOActionInput,)
  }
);}




export const getPurchaseOrderActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrderAction>>, TError,{id: number;data: BodyType<POActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof purchaseOrderAction>>, TError,{id: number;data: BodyType<POActionInput>}, TContext> => {

const mutationKey = ['purchaseOrderAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchaseOrderAction>>, {id: number;data: BodyType<POActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  purchaseOrderAction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PurchaseOrderActionMutationResult = NonNullable<Awaited<ReturnType<typeof purchaseOrderAction>>>
    export type PurchaseOrderActionMutationBody = BodyType<POActionInput>
    export type PurchaseOrderActionMutationError = ErrorType<unknown>

    /**
 * @summary Approve, reject, send, or close a PO
 */
export const usePurchaseOrderAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrderAction>>, TError,{id: number;data: BodyType<POActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof purchaseOrderAction>>,
        TError,
        {id: number;data: BodyType<POActionInput>},
        TContext
      > => {
      return useMutation(getPurchaseOrderActionMutationOptions(options));
    }

export const getListGrnUrl = (params?: ListGrnParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/grn?${stringifiedParams}` : `/api/finance/grn`
}

/**
 * @summary List goods receipt notes
 */
export const listGrn = async (params?: ListGrnParams, options?: RequestInit): Promise<GoodsReceiptNote[]> => {

  return customFetch<GoodsReceiptNote[]>(getListGrnUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGrnQueryKey = (params?: ListGrnParams,) => {
    return [
    `/api/finance/grn`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGrnQueryOptions = <TData = Awaited<ReturnType<typeof listGrn>>, TError = ErrorType<unknown>>(params?: ListGrnParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGrn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGrnQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGrn>>> = ({ signal }) => listGrn(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGrn>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGrnQueryResult = NonNullable<Awaited<ReturnType<typeof listGrn>>>
export type ListGrnQueryError = ErrorType<unknown>


/**
 * @summary List goods receipt notes
 */

export function useListGrn<TData = Awaited<ReturnType<typeof listGrn>>, TError = ErrorType<unknown>>(
 params?: ListGrnParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGrn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGrnQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateGrnUrl = () => {




  return `/api/finance/grn`
}

/**
 * @summary Create a goods receipt note
 */
export const createGrn = async (grnInput: GrnInput, options?: RequestInit): Promise<GoodsReceiptNote> => {

  return customFetch<GoodsReceiptNote>(getCreateGrnUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      grnInput,)
  }
);}




export const getCreateGrnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGrn>>, TError,{data: BodyType<GrnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createGrn>>, TError,{data: BodyType<GrnInput>}, TContext> => {

const mutationKey = ['createGrn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGrn>>, {data: BodyType<GrnInput>}> = (props) => {
          const {data} = props ?? {};

          return  createGrn(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGrnMutationResult = NonNullable<Awaited<ReturnType<typeof createGrn>>>
    export type CreateGrnMutationBody = BodyType<GrnInput>
    export type CreateGrnMutationError = ErrorType<unknown>

    /**
 * @summary Create a goods receipt note
 */
export const useCreateGrn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGrn>>, TError,{data: BodyType<GrnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createGrn>>,
        TError,
        {data: BodyType<GrnInput>},
        TContext
      > => {
      return useMutation(getCreateGrnMutationOptions(options));
    }

export const getGetGrnUrl = (id: number,) => {




  return `/api/finance/grn/${id}`
}

export const getGrn = async (id: number, options?: RequestInit): Promise<GoodsReceiptNote> => {

  return customFetch<GoodsReceiptNote>(getGetGrnUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGrnQueryKey = (id: number,) => {
    return [
    `/api/finance/grn/${id}`
    ] as const;
    }


export const getGetGrnQueryOptions = <TData = Awaited<ReturnType<typeof getGrn>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGrn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGrnQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGrn>>> = ({ signal }) => getGrn(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGrn>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGrnQueryResult = NonNullable<Awaited<ReturnType<typeof getGrn>>>
export type GetGrnQueryError = ErrorType<unknown>



export function useGetGrn<TData = Awaited<ReturnType<typeof getGrn>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGrn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGrnQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateGrnUrl = (id: number,) => {




  return `/api/finance/grn/${id}`
}

export const updateGrn = async (id: number,
    grnInput: GrnInput, options?: RequestInit): Promise<GoodsReceiptNote> => {

  return customFetch<GoodsReceiptNote>(getUpdateGrnUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      grnInput,)
  }
);}




export const getUpdateGrnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGrn>>, TError,{id: number;data: BodyType<GrnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGrn>>, TError,{id: number;data: BodyType<GrnInput>}, TContext> => {

const mutationKey = ['updateGrn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGrn>>, {id: number;data: BodyType<GrnInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateGrn(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGrnMutationResult = NonNullable<Awaited<ReturnType<typeof updateGrn>>>
    export type UpdateGrnMutationBody = BodyType<GrnInput>
    export type UpdateGrnMutationError = ErrorType<unknown>

    export const useUpdateGrn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGrn>>, TError,{id: number;data: BodyType<GrnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateGrn>>,
        TError,
        {id: number;data: BodyType<GrnInput>},
        TContext
      > => {
      return useMutation(getUpdateGrnMutationOptions(options));
    }

export const getListVendorBillsUrl = (params?: ListVendorBillsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/vendor-bills?${stringifiedParams}` : `/api/finance/vendor-bills`
}

/**
 * @summary List vendor bills (AP)
 */
export const listVendorBills = async (params?: ListVendorBillsParams, options?: RequestInit): Promise<VendorBill[]> => {

  return customFetch<VendorBill[]>(getListVendorBillsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorBillsQueryKey = (params?: ListVendorBillsParams,) => {
    return [
    `/api/finance/vendor-bills`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVendorBillsQueryOptions = <TData = Awaited<ReturnType<typeof listVendorBills>>, TError = ErrorType<unknown>>(params?: ListVendorBillsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorBills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorBillsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorBills>>> = ({ signal }) => listVendorBills(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorBills>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorBillsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorBills>>>
export type ListVendorBillsQueryError = ErrorType<unknown>


/**
 * @summary List vendor bills (AP)
 */

export function useListVendorBills<TData = Awaited<ReturnType<typeof listVendorBills>>, TError = ErrorType<unknown>>(
 params?: ListVendorBillsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorBills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorBillsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateVendorBillUrl = () => {




  return `/api/finance/vendor-bills`
}

/**
 * @summary Create a vendor bill
 */
export const createVendorBill = async (vendorBillInput: VendorBillInput, options?: RequestInit): Promise<VendorBill> => {

  return customFetch<VendorBill>(getCreateVendorBillUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorBillInput,)
  }
);}




export const getCreateVendorBillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorBill>>, TError,{data: BodyType<VendorBillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVendorBill>>, TError,{data: BodyType<VendorBillInput>}, TContext> => {

const mutationKey = ['createVendorBill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVendorBill>>, {data: BodyType<VendorBillInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVendorBill(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVendorBillMutationResult = NonNullable<Awaited<ReturnType<typeof createVendorBill>>>
    export type CreateVendorBillMutationBody = BodyType<VendorBillInput>
    export type CreateVendorBillMutationError = ErrorType<unknown>

    /**
 * @summary Create a vendor bill
 */
export const useCreateVendorBill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorBill>>, TError,{data: BodyType<VendorBillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVendorBill>>,
        TError,
        {data: BodyType<VendorBillInput>},
        TContext
      > => {
      return useMutation(getCreateVendorBillMutationOptions(options));
    }

export const getGetVendorBillUrl = (id: number,) => {




  return `/api/finance/vendor-bills/${id}`
}

export const getVendorBill = async (id: number, options?: RequestInit): Promise<VendorBillDetail> => {

  return customFetch<VendorBillDetail>(getGetVendorBillUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorBillQueryKey = (id: number,) => {
    return [
    `/api/finance/vendor-bills/${id}`
    ] as const;
    }


export const getGetVendorBillQueryOptions = <TData = Awaited<ReturnType<typeof getVendorBill>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorBill>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorBillQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendorBill>>> = ({ signal }) => getVendorBill(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendorBill>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVendorBillQueryResult = NonNullable<Awaited<ReturnType<typeof getVendorBill>>>
export type GetVendorBillQueryError = ErrorType<unknown>



export function useGetVendorBill<TData = Awaited<ReturnType<typeof getVendorBill>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorBill>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVendorBillQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateVendorBillUrl = (id: number,) => {




  return `/api/finance/vendor-bills/${id}`
}

export const updateVendorBill = async (id: number,
    vendorBillInput: VendorBillInput, options?: RequestInit): Promise<VendorBill> => {

  return customFetch<VendorBill>(getUpdateVendorBillUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorBillInput,)
  }
);}




export const getUpdateVendorBillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendorBill>>, TError,{id: number;data: BodyType<VendorBillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVendorBill>>, TError,{id: number;data: BodyType<VendorBillInput>}, TContext> => {

const mutationKey = ['updateVendorBill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVendorBill>>, {id: number;data: BodyType<VendorBillInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVendorBill(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVendorBillMutationResult = NonNullable<Awaited<ReturnType<typeof updateVendorBill>>>
    export type UpdateVendorBillMutationBody = BodyType<VendorBillInput>
    export type UpdateVendorBillMutationError = ErrorType<unknown>

    export const useUpdateVendorBill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendorBill>>, TError,{id: number;data: BodyType<VendorBillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVendorBill>>,
        TError,
        {id: number;data: BodyType<VendorBillInput>},
        TContext
      > => {
      return useMutation(getUpdateVendorBillMutationOptions(options));
    }

export const getVendorBillActionUrl = (id: number,) => {




  return `/api/finance/vendor-bills/${id}/action`
}

/**
 * @summary Approve, post, or cancel a bill
 */
export const vendorBillAction = async (id: number,
    billActionInput: BillActionInput, options?: RequestInit): Promise<VendorBill> => {

  return customFetch<VendorBill>(getVendorBillActionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      billActionInput,)
  }
);}




export const getVendorBillActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorBillAction>>, TError,{id: number;data: BodyType<BillActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorBillAction>>, TError,{id: number;data: BodyType<BillActionInput>}, TContext> => {

const mutationKey = ['vendorBillAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorBillAction>>, {id: number;data: BodyType<BillActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  vendorBillAction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorBillActionMutationResult = NonNullable<Awaited<ReturnType<typeof vendorBillAction>>>
    export type VendorBillActionMutationBody = BodyType<BillActionInput>
    export type VendorBillActionMutationError = ErrorType<unknown>

    /**
 * @summary Approve, post, or cancel a bill
 */
export const useVendorBillAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorBillAction>>, TError,{id: number;data: BodyType<BillActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof vendorBillAction>>,
        TError,
        {id: number;data: BodyType<BillActionInput>},
        TContext
      > => {
      return useMutation(getVendorBillActionMutationOptions(options));
    }

export const getListVendorPaymentsUrl = (params?: ListVendorPaymentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/vendor-payments?${stringifiedParams}` : `/api/finance/vendor-payments`
}

/**
 * @summary List vendor payments
 */
export const listVendorPayments = async (params?: ListVendorPaymentsParams, options?: RequestInit): Promise<VendorPayment[]> => {

  return customFetch<VendorPayment[]>(getListVendorPaymentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorPaymentsQueryKey = (params?: ListVendorPaymentsParams,) => {
    return [
    `/api/finance/vendor-payments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVendorPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listVendorPayments>>, TError = ErrorType<unknown>>(params?: ListVendorPaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorPaymentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorPayments>>> = ({ signal }) => listVendorPayments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorPayments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorPayments>>>
export type ListVendorPaymentsQueryError = ErrorType<unknown>


/**
 * @summary List vendor payments
 */

export function useListVendorPayments<TData = Awaited<ReturnType<typeof listVendorPayments>>, TError = ErrorType<unknown>>(
 params?: ListVendorPaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorPaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateVendorPaymentUrl = () => {




  return `/api/finance/vendor-payments`
}

/**
 * @summary Create a vendor payment (with bill allocation)
 */
export const createVendorPayment = async (vendorPaymentInput: VendorPaymentInput, options?: RequestInit): Promise<VendorPayment> => {

  return customFetch<VendorPayment>(getCreateVendorPaymentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorPaymentInput,)
  }
);}




export const getCreateVendorPaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorPayment>>, TError,{data: BodyType<VendorPaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVendorPayment>>, TError,{data: BodyType<VendorPaymentInput>}, TContext> => {

const mutationKey = ['createVendorPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVendorPayment>>, {data: BodyType<VendorPaymentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVendorPayment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVendorPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof createVendorPayment>>>
    export type CreateVendorPaymentMutationBody = BodyType<VendorPaymentInput>
    export type CreateVendorPaymentMutationError = ErrorType<unknown>

    /**
 * @summary Create a vendor payment (with bill allocation)
 */
export const useCreateVendorPayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorPayment>>, TError,{data: BodyType<VendorPaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVendorPayment>>,
        TError,
        {data: BodyType<VendorPaymentInput>},
        TContext
      > => {
      return useMutation(getCreateVendorPaymentMutationOptions(options));
    }

export const getGetVendorPaymentUrl = (id: number,) => {




  return `/api/finance/vendor-payments/${id}`
}

export const getVendorPayment = async (id: number, options?: RequestInit): Promise<VendorPayment> => {

  return customFetch<VendorPayment>(getGetVendorPaymentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorPaymentQueryKey = (id: number,) => {
    return [
    `/api/finance/vendor-payments/${id}`
    ] as const;
    }


export const getGetVendorPaymentQueryOptions = <TData = Awaited<ReturnType<typeof getVendorPayment>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorPayment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorPaymentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendorPayment>>> = ({ signal }) => getVendorPayment(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendorPayment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVendorPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof getVendorPayment>>>
export type GetVendorPaymentQueryError = ErrorType<unknown>



export function useGetVendorPayment<TData = Awaited<ReturnType<typeof getVendorPayment>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorPayment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVendorPaymentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetApAgingUrl = (params?: GetApAgingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/ap-aging?${stringifiedParams}` : `/api/finance/ap-aging`
}

/**
 * @summary AP aging report (0-30, 31-60, 61-90, 90+ days)
 */
export const getApAging = async (params?: GetApAgingParams, options?: RequestInit): Promise<AgingReport> => {

  return customFetch<AgingReport>(getGetApAgingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApAgingQueryKey = (params?: GetApAgingParams,) => {
    return [
    `/api/finance/ap-aging`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApAgingQueryOptions = <TData = Awaited<ReturnType<typeof getApAging>>, TError = ErrorType<unknown>>(params?: GetApAgingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApAging>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApAgingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApAging>>> = ({ signal }) => getApAging(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApAging>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApAgingQueryResult = NonNullable<Awaited<ReturnType<typeof getApAging>>>
export type GetApAgingQueryError = ErrorType<unknown>


/**
 * @summary AP aging report (0-30, 31-60, 61-90, 90+ days)
 */

export function useGetApAging<TData = Awaited<ReturnType<typeof getApAging>>, TError = ErrorType<unknown>>(
 params?: GetApAgingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApAging>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApAgingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCustomersUrl = (params?: ListCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/customers?${stringifiedParams}` : `/api/finance/customers`
}

/**
 * @summary List customers
 */
export const listCustomers = async (params?: ListCustomersParams, options?: RequestInit): Promise<Customer[]> => {

  return customFetch<Customer[]>(getListCustomersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomersQueryKey = (params?: ListCustomersParams,) => {
    return [
    `/api/finance/customers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomersQueryOptions = <TData = Awaited<ReturnType<typeof listCustomers>>, TError = ErrorType<unknown>>(params?: ListCustomersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomers>>> = ({ signal }) => listCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomers>>>
export type ListCustomersQueryError = ErrorType<unknown>


/**
 * @summary List customers
 */

export function useListCustomers<TData = Awaited<ReturnType<typeof listCustomers>>, TError = ErrorType<unknown>>(
 params?: ListCustomersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCustomerUrl = () => {




  return `/api/finance/customers`
}

export const createCustomer = async (customerInput: CustomerInput, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getCreateCustomerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerInput,)
  }
);}




export const getCreateCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CustomerInput>}, TContext> => {

const mutationKey = ['createCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomer>>, {data: BodyType<CustomerInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomer>>>
    export type CreateCustomerMutationBody = BodyType<CustomerInput>
    export type CreateCustomerMutationError = ErrorType<unknown>

    export const useCreateCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomer>>,
        TError,
        {data: BodyType<CustomerInput>},
        TContext
      > => {
      return useMutation(getCreateCustomerMutationOptions(options));
    }

export const getGetCustomerUrl = (id: number,) => {




  return `/api/finance/customers/${id}`
}

export const getCustomer = async (id: number, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getGetCustomerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerQueryKey = (id: number,) => {
    return [
    `/api/finance/customers/${id}`
    ] as const;
    }


export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = ErrorType<unknown>



export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCustomerUrl = (id: number,) => {




  return `/api/finance/customers/${id}`
}

export const updateCustomer = async (id: number,
    customerInput: CustomerInput, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getUpdateCustomerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerInput,)
  }
);}




export const getUpdateCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<CustomerInput>}, TContext> => {

const mutationKey = ['updateCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomer>>, {id: number;data: BodyType<CustomerInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCustomer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomer>>>
    export type UpdateCustomerMutationBody = BodyType<CustomerInput>
    export type UpdateCustomerMutationError = ErrorType<unknown>

    export const useUpdateCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomer>>,
        TError,
        {id: number;data: BodyType<CustomerInput>},
        TContext
      > => {
      return useMutation(getUpdateCustomerMutationOptions(options));
    }

export const getDeleteCustomerUrl = (id: number,) => {




  return `/api/finance/customers/${id}`
}

export const deleteCustomer = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomerUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomer>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomer>>>

    export type DeleteCustomerMutationError = ErrorType<unknown>

    export const useDeleteCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomer>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCustomerMutationOptions(options));
    }

export const getListSalesInvoicesUrl = (params?: ListSalesInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/sales-invoices?${stringifiedParams}` : `/api/finance/sales-invoices`
}

/**
 * @summary List sales invoices
 */
export const listSalesInvoices = async (params?: ListSalesInvoicesParams, options?: RequestInit): Promise<SalesInvoice[]> => {

  return customFetch<SalesInvoice[]>(getListSalesInvoicesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalesInvoicesQueryKey = (params?: ListSalesInvoicesParams,) => {
    return [
    `/api/finance/sales-invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSalesInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listSalesInvoices>>, TError = ErrorType<unknown>>(params?: ListSalesInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalesInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalesInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalesInvoices>>> = ({ signal }) => listSalesInvoices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalesInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalesInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listSalesInvoices>>>
export type ListSalesInvoicesQueryError = ErrorType<unknown>


/**
 * @summary List sales invoices
 */

export function useListSalesInvoices<TData = Awaited<ReturnType<typeof listSalesInvoices>>, TError = ErrorType<unknown>>(
 params?: ListSalesInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalesInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalesInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSalesInvoiceUrl = () => {




  return `/api/finance/sales-invoices`
}

/**
 * @summary Create a sales invoice or proforma
 */
export const createSalesInvoice = async (salesInvoiceInput: SalesInvoiceInput, options?: RequestInit): Promise<SalesInvoice> => {

  return customFetch<SalesInvoice>(getCreateSalesInvoiceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salesInvoiceInput,)
  }
);}




export const getCreateSalesInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesInvoice>>, TError,{data: BodyType<SalesInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSalesInvoice>>, TError,{data: BodyType<SalesInvoiceInput>}, TContext> => {

const mutationKey = ['createSalesInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSalesInvoice>>, {data: BodyType<SalesInvoiceInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSalesInvoice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSalesInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof createSalesInvoice>>>
    export type CreateSalesInvoiceMutationBody = BodyType<SalesInvoiceInput>
    export type CreateSalesInvoiceMutationError = ErrorType<unknown>

    /**
 * @summary Create a sales invoice or proforma
 */
export const useCreateSalesInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesInvoice>>, TError,{data: BodyType<SalesInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSalesInvoice>>,
        TError,
        {data: BodyType<SalesInvoiceInput>},
        TContext
      > => {
      return useMutation(getCreateSalesInvoiceMutationOptions(options));
    }

export const getGetSalesInvoiceUrl = (id: number,) => {




  return `/api/finance/sales-invoices/${id}`
}

export const getSalesInvoice = async (id: number, options?: RequestInit): Promise<SalesInvoiceDetail> => {

  return customFetch<SalesInvoiceDetail>(getGetSalesInvoiceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesInvoiceQueryKey = (id: number,) => {
    return [
    `/api/finance/sales-invoices/${id}`
    ] as const;
    }


export const getGetSalesInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getSalesInvoice>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesInvoiceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesInvoice>>> = ({ signal }) => getSalesInvoice(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesInvoice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesInvoice>>>
export type GetSalesInvoiceQueryError = ErrorType<unknown>



export function useGetSalesInvoice<TData = Awaited<ReturnType<typeof getSalesInvoice>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesInvoiceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSalesInvoiceUrl = (id: number,) => {




  return `/api/finance/sales-invoices/${id}`
}

export const updateSalesInvoice = async (id: number,
    salesInvoiceInput: SalesInvoiceInput, options?: RequestInit): Promise<SalesInvoice> => {

  return customFetch<SalesInvoice>(getUpdateSalesInvoiceUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salesInvoiceInput,)
  }
);}




export const getUpdateSalesInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesInvoice>>, TError,{id: number;data: BodyType<SalesInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSalesInvoice>>, TError,{id: number;data: BodyType<SalesInvoiceInput>}, TContext> => {

const mutationKey = ['updateSalesInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSalesInvoice>>, {id: number;data: BodyType<SalesInvoiceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSalesInvoice(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSalesInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof updateSalesInvoice>>>
    export type UpdateSalesInvoiceMutationBody = BodyType<SalesInvoiceInput>
    export type UpdateSalesInvoiceMutationError = ErrorType<unknown>

    export const useUpdateSalesInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesInvoice>>, TError,{id: number;data: BodyType<SalesInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSalesInvoice>>,
        TError,
        {id: number;data: BodyType<SalesInvoiceInput>},
        TContext
      > => {
      return useMutation(getUpdateSalesInvoiceMutationOptions(options));
    }

export const getSalesInvoiceActionUrl = (id: number,) => {




  return `/api/finance/sales-invoices/${id}/action`
}

/**
 * @summary Approve, post, send, cancel or convert proforma to tax invoice
 */
export const salesInvoiceAction = async (id: number,
    invoiceActionInput: InvoiceActionInput, options?: RequestInit): Promise<SalesInvoice> => {

  return customFetch<SalesInvoice>(getSalesInvoiceActionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      invoiceActionInput,)
  }
);}




export const getSalesInvoiceActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesInvoiceAction>>, TError,{id: number;data: BodyType<InvoiceActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof salesInvoiceAction>>, TError,{id: number;data: BodyType<InvoiceActionInput>}, TContext> => {

const mutationKey = ['salesInvoiceAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof salesInvoiceAction>>, {id: number;data: BodyType<InvoiceActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  salesInvoiceAction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SalesInvoiceActionMutationResult = NonNullable<Awaited<ReturnType<typeof salesInvoiceAction>>>
    export type SalesInvoiceActionMutationBody = BodyType<InvoiceActionInput>
    export type SalesInvoiceActionMutationError = ErrorType<unknown>

    /**
 * @summary Approve, post, send, cancel or convert proforma to tax invoice
 */
export const useSalesInvoiceAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof salesInvoiceAction>>, TError,{id: number;data: BodyType<InvoiceActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof salesInvoiceAction>>,
        TError,
        {id: number;data: BodyType<InvoiceActionInput>},
        TContext
      > => {
      return useMutation(getSalesInvoiceActionMutationOptions(options));
    }

export const getGenerateIrnUrl = (id: number,) => {




  return `/api/finance/sales-invoices/${id}/generate-irn`
}

/**
 * @summary Generate IRN (e-Invoice) for a tax invoice
 */
export const generateIrn = async (id: number, options?: RequestInit): Promise<GenerateIrn200> => {

  return customFetch<GenerateIrn200>(getGenerateIrnUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGenerateIrnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateIrn>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateIrn>>, TError,{id: number}, TContext> => {

const mutationKey = ['generateIrn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateIrn>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  generateIrn(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateIrnMutationResult = NonNullable<Awaited<ReturnType<typeof generateIrn>>>

    export type GenerateIrnMutationError = ErrorType<unknown>

    /**
 * @summary Generate IRN (e-Invoice) for a tax invoice
 */
export const useGenerateIrn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateIrn>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateIrn>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getGenerateIrnMutationOptions(options));
    }

export const getCancelIrnUrl = (id: number,) => {




  return `/api/finance/sales-invoices/${id}/cancel-irn`
}

/**
 * @summary Cancel IRN within 24-hour window
 */
export const cancelIrn = async (id: number,
    cancelIrnBody?: CancelIrnBody, options?: RequestInit): Promise<CancelIrn200> => {

  return customFetch<CancelIrn200>(getCancelIrnUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cancelIrnBody,)
  }
);}




export const getCancelIrnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelIrn>>, TError,{id: number;data?: BodyType<CancelIrnBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelIrn>>, TError,{id: number;data?: BodyType<CancelIrnBody>}, TContext> => {

const mutationKey = ['cancelIrn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelIrn>>, {id: number;data?: BodyType<CancelIrnBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelIrn(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelIrnMutationResult = NonNullable<Awaited<ReturnType<typeof cancelIrn>>>
    export type CancelIrnMutationBody = BodyType<CancelIrnBody> | undefined
    export type CancelIrnMutationError = ErrorType<unknown>

    /**
 * @summary Cancel IRN within 24-hour window
 */
export const useCancelIrn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelIrn>>, TError,{id: number;data?: BodyType<CancelIrnBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelIrn>>,
        TError,
        {id: number;data?: BodyType<CancelIrnBody>},
        TContext
      > => {
      return useMutation(getCancelIrnMutationOptions(options));
    }

export const getBulkGenerateIrnUrl = () => {




  return `/api/finance/sales-invoices/bulk-irn`
}

/**
 * @summary Bulk IRN generation for multiple invoices
 */
export const bulkGenerateIrn = async (bulkGenerateIrnBody: BulkGenerateIrnBody, options?: RequestInit): Promise<BulkIrnResult> => {

  return customFetch<BulkIrnResult>(getBulkGenerateIrnUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkGenerateIrnBody,)
  }
);}




export const getBulkGenerateIrnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkGenerateIrn>>, TError,{data: BodyType<BulkGenerateIrnBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkGenerateIrn>>, TError,{data: BodyType<BulkGenerateIrnBody>}, TContext> => {

const mutationKey = ['bulkGenerateIrn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkGenerateIrn>>, {data: BodyType<BulkGenerateIrnBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkGenerateIrn(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkGenerateIrnMutationResult = NonNullable<Awaited<ReturnType<typeof bulkGenerateIrn>>>
    export type BulkGenerateIrnMutationBody = BodyType<BulkGenerateIrnBody>
    export type BulkGenerateIrnMutationError = ErrorType<unknown>

    /**
 * @summary Bulk IRN generation for multiple invoices
 */
export const useBulkGenerateIrn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkGenerateIrn>>, TError,{data: BodyType<BulkGenerateIrnBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkGenerateIrn>>,
        TError,
        {data: BodyType<BulkGenerateIrnBody>},
        TContext
      > => {
      return useMutation(getBulkGenerateIrnMutationOptions(options));
    }

export const getGenerateEwbUrl = (id: number,) => {




  return `/api/finance/sales-invoices/${id}/generate-ewb`
}

/**
 * @summary Generate e-Way Bill for an invoice
 */
export const generateEwb = async (id: number,
    generateEwbInput?: GenerateEwbInput, options?: RequestInit): Promise<EwbRecord> => {

  return customFetch<EwbRecord>(getGenerateEwbUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      generateEwbInput,)
  }
);}




export const getGenerateEwbMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEwb>>, TError,{id: number;data?: BodyType<GenerateEwbInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateEwb>>, TError,{id: number;data?: BodyType<GenerateEwbInput>}, TContext> => {

const mutationKey = ['generateEwb'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateEwb>>, {id: number;data?: BodyType<GenerateEwbInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  generateEwb(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateEwbMutationResult = NonNullable<Awaited<ReturnType<typeof generateEwb>>>
    export type GenerateEwbMutationBody = BodyType<GenerateEwbInput> | undefined
    export type GenerateEwbMutationError = ErrorType<unknown>

    /**
 * @summary Generate e-Way Bill for an invoice
 */
export const useGenerateEwb = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEwb>>, TError,{id: number;data?: BodyType<GenerateEwbInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateEwb>>,
        TError,
        {id: number;data?: BodyType<GenerateEwbInput>},
        TContext
      > => {
      return useMutation(getGenerateEwbMutationOptions(options));
    }

export const getListEwbUrl = (params?: ListEwbParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/ewb?${stringifiedParams}` : `/api/finance/ewb`
}

/**
 * @summary List e-Way Bills
 */
export const listEwb = async (params?: ListEwbParams, options?: RequestInit): Promise<EwbRecord[]> => {

  return customFetch<EwbRecord[]>(getListEwbUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEwbQueryKey = (params?: ListEwbParams,) => {
    return [
    `/api/finance/ewb`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEwbQueryOptions = <TData = Awaited<ReturnType<typeof listEwb>>, TError = ErrorType<unknown>>(params?: ListEwbParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEwb>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEwbQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEwb>>> = ({ signal }) => listEwb(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEwb>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEwbQueryResult = NonNullable<Awaited<ReturnType<typeof listEwb>>>
export type ListEwbQueryError = ErrorType<unknown>


/**
 * @summary List e-Way Bills
 */

export function useListEwb<TData = Awaited<ReturnType<typeof listEwb>>, TError = ErrorType<unknown>>(
 params?: ListEwbParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEwb>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEwbQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateEwbVehicleUrl = (ewbId: number,) => {




  return `/api/finance/ewb/${ewbId}/update-vehicle`
}

/**
 * @summary Update vehicle number (Part-B) for an EWB
 */
export const updateEwbVehicle = async (ewbId: number,
    ewbPartBInput?: EwbPartBInput, options?: RequestInit): Promise<EwbRecord> => {

  return customFetch<EwbRecord>(getUpdateEwbVehicleUrl(ewbId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ewbPartBInput,)
  }
);}




export const getUpdateEwbVehicleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEwbVehicle>>, TError,{ewbId: number;data?: BodyType<EwbPartBInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEwbVehicle>>, TError,{ewbId: number;data?: BodyType<EwbPartBInput>}, TContext> => {

const mutationKey = ['updateEwbVehicle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEwbVehicle>>, {ewbId: number;data?: BodyType<EwbPartBInput>}> = (props) => {
          const {ewbId,data} = props ?? {};

          return  updateEwbVehicle(ewbId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEwbVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof updateEwbVehicle>>>
    export type UpdateEwbVehicleMutationBody = BodyType<EwbPartBInput> | undefined
    export type UpdateEwbVehicleMutationError = ErrorType<unknown>

    /**
 * @summary Update vehicle number (Part-B) for an EWB
 */
export const useUpdateEwbVehicle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEwbVehicle>>, TError,{ewbId: number;data?: BodyType<EwbPartBInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEwbVehicle>>,
        TError,
        {ewbId: number;data?: BodyType<EwbPartBInput>},
        TContext
      > => {
      return useMutation(getUpdateEwbVehicleMutationOptions(options));
    }

export const getExtendEwbUrl = (ewbId: number,) => {




  return `/api/finance/ewb/${ewbId}/extend`
}

/**
 * @summary Extend e-Way Bill validity
 */
export const extendEwb = async (ewbId: number,
    ewbExtendInput?: EwbExtendInput, options?: RequestInit): Promise<EwbRecord> => {

  return customFetch<EwbRecord>(getExtendEwbUrl(ewbId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ewbExtendInput,)
  }
);}




export const getExtendEwbMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendEwb>>, TError,{ewbId: number;data?: BodyType<EwbExtendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof extendEwb>>, TError,{ewbId: number;data?: BodyType<EwbExtendInput>}, TContext> => {

const mutationKey = ['extendEwb'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extendEwb>>, {ewbId: number;data?: BodyType<EwbExtendInput>}> = (props) => {
          const {ewbId,data} = props ?? {};

          return  extendEwb(ewbId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtendEwbMutationResult = NonNullable<Awaited<ReturnType<typeof extendEwb>>>
    export type ExtendEwbMutationBody = BodyType<EwbExtendInput> | undefined
    export type ExtendEwbMutationError = ErrorType<unknown>

    /**
 * @summary Extend e-Way Bill validity
 */
export const useExtendEwb = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendEwb>>, TError,{ewbId: number;data?: BodyType<EwbExtendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof extendEwb>>,
        TError,
        {ewbId: number;data?: BodyType<EwbExtendInput>},
        TContext
      > => {
      return useMutation(getExtendEwbMutationOptions(options));
    }

export const getCancelEwbUrl = (ewbId: number,) => {




  return `/api/finance/ewb/${ewbId}/cancel`
}

/**
 * @summary Cancel an e-Way Bill within 24-hour window
 */
export const cancelEwb = async (ewbId: number,
    cancelEwbBody?: CancelEwbBody, options?: RequestInit): Promise<EwbRecord> => {

  return customFetch<EwbRecord>(getCancelEwbUrl(ewbId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cancelEwbBody,)
  }
);}




export const getCancelEwbMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEwb>>, TError,{ewbId: number;data?: BodyType<CancelEwbBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelEwb>>, TError,{ewbId: number;data?: BodyType<CancelEwbBody>}, TContext> => {

const mutationKey = ['cancelEwb'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEwb>>, {ewbId: number;data?: BodyType<CancelEwbBody>}> = (props) => {
          const {ewbId,data} = props ?? {};

          return  cancelEwb(ewbId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelEwbMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEwb>>>
    export type CancelEwbMutationBody = BodyType<CancelEwbBody> | undefined
    export type CancelEwbMutationError = ErrorType<unknown>

    /**
 * @summary Cancel an e-Way Bill within 24-hour window
 */
export const useCancelEwb = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEwb>>, TError,{ewbId: number;data?: BodyType<CancelEwbBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelEwb>>,
        TError,
        {ewbId: number;data?: BodyType<CancelEwbBody>},
        TContext
      > => {
      return useMutation(getCancelEwbMutationOptions(options));
    }

export const getListEinvoiceLogsUrl = (params?: ListEinvoiceLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/einvoice-logs?${stringifiedParams}` : `/api/finance/einvoice-logs`
}

/**
 * @summary List IRN generation attempt logs
 */
export const listEinvoiceLogs = async (params?: ListEinvoiceLogsParams, options?: RequestInit): Promise<EinvoiceLog[]> => {

  return customFetch<EinvoiceLog[]>(getListEinvoiceLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEinvoiceLogsQueryKey = (params?: ListEinvoiceLogsParams,) => {
    return [
    `/api/finance/einvoice-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEinvoiceLogsQueryOptions = <TData = Awaited<ReturnType<typeof listEinvoiceLogs>>, TError = ErrorType<unknown>>(params?: ListEinvoiceLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEinvoiceLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEinvoiceLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEinvoiceLogs>>> = ({ signal }) => listEinvoiceLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEinvoiceLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEinvoiceLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listEinvoiceLogs>>>
export type ListEinvoiceLogsQueryError = ErrorType<unknown>


/**
 * @summary List IRN generation attempt logs
 */

export function useListEinvoiceLogs<TData = Awaited<ReturnType<typeof listEinvoiceLogs>>, TError = ErrorType<unknown>>(
 params?: ListEinvoiceLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEinvoiceLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEinvoiceLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetEinvoiceDashboardUrl = () => {




  return `/api/finance/compliance/einvoice-dashboard`
}

/**
 * @summary Compliance dashboard — IRN counts and EWB stats
 */
export const getEinvoiceDashboard = async ( options?: RequestInit): Promise<EinvoiceDashboard> => {

  return customFetch<EinvoiceDashboard>(getGetEinvoiceDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEinvoiceDashboardQueryKey = () => {
    return [
    `/api/finance/compliance/einvoice-dashboard`
    ] as const;
    }


export const getGetEinvoiceDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getEinvoiceDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEinvoiceDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEinvoiceDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEinvoiceDashboard>>> = ({ signal }) => getEinvoiceDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEinvoiceDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEinvoiceDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getEinvoiceDashboard>>>
export type GetEinvoiceDashboardQueryError = ErrorType<unknown>


/**
 * @summary Compliance dashboard — IRN counts and EWB stats
 */

export function useGetEinvoiceDashboard<TData = Awaited<ReturnType<typeof getEinvoiceDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEinvoiceDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEinvoiceDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCustomerReceiptsUrl = (params?: ListCustomerReceiptsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/customer-receipts?${stringifiedParams}` : `/api/finance/customer-receipts`
}

/**
 * @summary List customer receipts
 */
export const listCustomerReceipts = async (params?: ListCustomerReceiptsParams, options?: RequestInit): Promise<CustomerReceipt[]> => {

  return customFetch<CustomerReceipt[]>(getListCustomerReceiptsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerReceiptsQueryKey = (params?: ListCustomerReceiptsParams,) => {
    return [
    `/api/finance/customer-receipts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerReceiptsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerReceipts>>, TError = ErrorType<unknown>>(params?: ListCustomerReceiptsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerReceipts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerReceiptsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerReceipts>>> = ({ signal }) => listCustomerReceipts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerReceipts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerReceiptsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerReceipts>>>
export type ListCustomerReceiptsQueryError = ErrorType<unknown>


/**
 * @summary List customer receipts
 */

export function useListCustomerReceipts<TData = Awaited<ReturnType<typeof listCustomerReceipts>>, TError = ErrorType<unknown>>(
 params?: ListCustomerReceiptsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerReceipts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerReceiptsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCustomerReceiptUrl = () => {




  return `/api/finance/customer-receipts`
}

/**
 * @summary Record a customer receipt with invoice allocation
 */
export const createCustomerReceipt = async (customerReceiptInput: CustomerReceiptInput, options?: RequestInit): Promise<CustomerReceipt> => {

  return customFetch<CustomerReceipt>(getCreateCustomerReceiptUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerReceiptInput,)
  }
);}




export const getCreateCustomerReceiptMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerReceipt>>, TError,{data: BodyType<CustomerReceiptInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomerReceipt>>, TError,{data: BodyType<CustomerReceiptInput>}, TContext> => {

const mutationKey = ['createCustomerReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomerReceipt>>, {data: BodyType<CustomerReceiptInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomerReceipt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomerReceipt>>>
    export type CreateCustomerReceiptMutationBody = BodyType<CustomerReceiptInput>
    export type CreateCustomerReceiptMutationError = ErrorType<unknown>

    /**
 * @summary Record a customer receipt with invoice allocation
 */
export const useCreateCustomerReceipt = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerReceipt>>, TError,{data: BodyType<CustomerReceiptInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomerReceipt>>,
        TError,
        {data: BodyType<CustomerReceiptInput>},
        TContext
      > => {
      return useMutation(getCreateCustomerReceiptMutationOptions(options));
    }

export const getGetArAgingUrl = (params?: GetArAgingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/ar-aging?${stringifiedParams}` : `/api/finance/ar-aging`
}

/**
 * @summary AR aging report
 */
export const getArAging = async (params?: GetArAgingParams, options?: RequestInit): Promise<AgingReport> => {

  return customFetch<AgingReport>(getGetArAgingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetArAgingQueryKey = (params?: GetArAgingParams,) => {
    return [
    `/api/finance/ar-aging`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetArAgingQueryOptions = <TData = Awaited<ReturnType<typeof getArAging>>, TError = ErrorType<unknown>>(params?: GetArAgingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getArAging>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArAgingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArAging>>> = ({ signal }) => getArAging(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArAging>>, TError, TData> & { queryKey: QueryKey }
}

export type GetArAgingQueryResult = NonNullable<Awaited<ReturnType<typeof getArAging>>>
export type GetArAgingQueryError = ErrorType<unknown>


/**
 * @summary AR aging report
 */

export function useGetArAging<TData = Awaited<ReturnType<typeof getArAging>>, TError = ErrorType<unknown>>(
 params?: GetArAgingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getArAging>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetArAgingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetGstConfigUrl = () => {




  return `/api/finance/gst/config`
}

/**
 * @summary Get GST configuration for the tenant
 */
export const getGstConfig = async ( options?: RequestInit): Promise<GstConfig> => {

  return customFetch<GstConfig>(getGetGstConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGstConfigQueryKey = () => {
    return [
    `/api/finance/gst/config`
    ] as const;
    }


export const getGetGstConfigQueryOptions = <TData = Awaited<ReturnType<typeof getGstConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGstConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGstConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGstConfig>>> = ({ signal }) => getGstConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGstConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGstConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getGstConfig>>>
export type GetGstConfigQueryError = ErrorType<unknown>


/**
 * @summary Get GST configuration for the tenant
 */

export function useGetGstConfig<TData = Awaited<ReturnType<typeof getGstConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGstConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGstConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpsertGstConfigUrl = () => {




  return `/api/finance/gst/config`
}

/**
 * @summary Create or update GST config
 */
export const upsertGstConfig = async (gstConfigInput: GstConfigInput, options?: RequestInit): Promise<GstConfig> => {

  return customFetch<GstConfig>(getUpsertGstConfigUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      gstConfigInput,)
  }
);}




export const getUpsertGstConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertGstConfig>>, TError,{data: BodyType<GstConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertGstConfig>>, TError,{data: BodyType<GstConfigInput>}, TContext> => {

const mutationKey = ['upsertGstConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertGstConfig>>, {data: BodyType<GstConfigInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertGstConfig(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertGstConfigMutationResult = NonNullable<Awaited<ReturnType<typeof upsertGstConfig>>>
    export type UpsertGstConfigMutationBody = BodyType<GstConfigInput>
    export type UpsertGstConfigMutationError = ErrorType<unknown>

    /**
 * @summary Create or update GST config
 */
export const useUpsertGstConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertGstConfig>>, TError,{data: BodyType<GstConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertGstConfig>>,
        TError,
        {data: BodyType<GstConfigInput>},
        TContext
      > => {
      return useMutation(getUpsertGstConfigMutationOptions(options));
    }

export const getListHsnSacUrl = (params?: ListHsnSacParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/gst/hsn-sac?${stringifiedParams}` : `/api/finance/gst/hsn-sac`
}

/**
 * @summary List HSN/SAC codes
 */
export const listHsnSac = async (params?: ListHsnSacParams, options?: RequestInit): Promise<HsnSac[]> => {

  return customFetch<HsnSac[]>(getListHsnSacUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHsnSacQueryKey = (params?: ListHsnSacParams,) => {
    return [
    `/api/finance/gst/hsn-sac`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHsnSacQueryOptions = <TData = Awaited<ReturnType<typeof listHsnSac>>, TError = ErrorType<unknown>>(params?: ListHsnSacParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHsnSac>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHsnSacQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHsnSac>>> = ({ signal }) => listHsnSac(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHsnSac>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHsnSacQueryResult = NonNullable<Awaited<ReturnType<typeof listHsnSac>>>
export type ListHsnSacQueryError = ErrorType<unknown>


/**
 * @summary List HSN/SAC codes
 */

export function useListHsnSac<TData = Awaited<ReturnType<typeof listHsnSac>>, TError = ErrorType<unknown>>(
 params?: ListHsnSacParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHsnSac>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHsnSacQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateHsnSacUrl = () => {




  return `/api/finance/gst/hsn-sac`
}

export const createHsnSac = async (hsnSacInput: HsnSacInput, options?: RequestInit): Promise<HsnSac> => {

  return customFetch<HsnSac>(getCreateHsnSacUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      hsnSacInput,)
  }
);}




export const getCreateHsnSacMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHsnSac>>, TError,{data: BodyType<HsnSacInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHsnSac>>, TError,{data: BodyType<HsnSacInput>}, TContext> => {

const mutationKey = ['createHsnSac'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHsnSac>>, {data: BodyType<HsnSacInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHsnSac(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHsnSacMutationResult = NonNullable<Awaited<ReturnType<typeof createHsnSac>>>
    export type CreateHsnSacMutationBody = BodyType<HsnSacInput>
    export type CreateHsnSacMutationError = ErrorType<unknown>

    export const useCreateHsnSac = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHsnSac>>, TError,{data: BodyType<HsnSacInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHsnSac>>,
        TError,
        {data: BodyType<HsnSacInput>},
        TContext
      > => {
      return useMutation(getCreateHsnSacMutationOptions(options));
    }

export const getUpdateHsnSacUrl = (id: number,) => {




  return `/api/finance/gst/hsn-sac/${id}`
}

export const updateHsnSac = async (id: number,
    hsnSacInput: HsnSacInput, options?: RequestInit): Promise<HsnSac> => {

  return customFetch<HsnSac>(getUpdateHsnSacUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      hsnSacInput,)
  }
);}




export const getUpdateHsnSacMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHsnSac>>, TError,{id: number;data: BodyType<HsnSacInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHsnSac>>, TError,{id: number;data: BodyType<HsnSacInput>}, TContext> => {

const mutationKey = ['updateHsnSac'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHsnSac>>, {id: number;data: BodyType<HsnSacInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHsnSac(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHsnSacMutationResult = NonNullable<Awaited<ReturnType<typeof updateHsnSac>>>
    export type UpdateHsnSacMutationBody = BodyType<HsnSacInput>
    export type UpdateHsnSacMutationError = ErrorType<unknown>

    export const useUpdateHsnSac = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHsnSac>>, TError,{id: number;data: BodyType<HsnSacInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHsnSac>>,
        TError,
        {id: number;data: BodyType<HsnSacInput>},
        TContext
      > => {
      return useMutation(getUpdateHsnSacMutationOptions(options));
    }

export const getDeleteHsnSacUrl = (id: number,) => {




  return `/api/finance/gst/hsn-sac/${id}`
}

export const deleteHsnSac = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHsnSacUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteHsnSacMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHsnSac>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHsnSac>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteHsnSac'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHsnSac>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteHsnSac(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHsnSacMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHsnSac>>>

    export type DeleteHsnSacMutationError = ErrorType<unknown>

    export const useDeleteHsnSac = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHsnSac>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHsnSac>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteHsnSacMutationOptions(options));
    }

export const getListTaxRatesUrl = () => {




  return `/api/finance/gst/tax-rates`
}

/**
 * @summary List GST tax rates
 */
export const listTaxRates = async ( options?: RequestInit): Promise<TaxRate[]> => {

  return customFetch<TaxRate[]>(getListTaxRatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTaxRatesQueryKey = () => {
    return [
    `/api/finance/gst/tax-rates`
    ] as const;
    }


export const getListTaxRatesQueryOptions = <TData = Awaited<ReturnType<typeof listTaxRates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTaxRates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTaxRatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaxRates>>> = ({ signal }) => listTaxRates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTaxRates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTaxRatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTaxRates>>>
export type ListTaxRatesQueryError = ErrorType<unknown>


/**
 * @summary List GST tax rates
 */

export function useListTaxRates<TData = Awaited<ReturnType<typeof listTaxRates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTaxRates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTaxRatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTaxRateUrl = () => {




  return `/api/finance/gst/tax-rates`
}

export const createTaxRate = async (taxRateInput: TaxRateInput, options?: RequestInit): Promise<TaxRate> => {

  return customFetch<TaxRate>(getCreateTaxRateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taxRateInput,)
  }
);}




export const getCreateTaxRateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaxRate>>, TError,{data: BodyType<TaxRateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTaxRate>>, TError,{data: BodyType<TaxRateInput>}, TContext> => {

const mutationKey = ['createTaxRate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTaxRate>>, {data: BodyType<TaxRateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTaxRate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaxRateMutationResult = NonNullable<Awaited<ReturnType<typeof createTaxRate>>>
    export type CreateTaxRateMutationBody = BodyType<TaxRateInput>
    export type CreateTaxRateMutationError = ErrorType<unknown>

    export const useCreateTaxRate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaxRate>>, TError,{data: BodyType<TaxRateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTaxRate>>,
        TError,
        {data: BodyType<TaxRateInput>},
        TContext
      > => {
      return useMutation(getCreateTaxRateMutationOptions(options));
    }

export const getUpdateTaxRateUrl = (id: number,) => {




  return `/api/finance/gst/tax-rates/${id}`
}

export const updateTaxRate = async (id: number,
    taxRateInput: TaxRateInput, options?: RequestInit): Promise<TaxRate> => {

  return customFetch<TaxRate>(getUpdateTaxRateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taxRateInput,)
  }
);}




export const getUpdateTaxRateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaxRate>>, TError,{id: number;data: BodyType<TaxRateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTaxRate>>, TError,{id: number;data: BodyType<TaxRateInput>}, TContext> => {

const mutationKey = ['updateTaxRate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTaxRate>>, {id: number;data: BodyType<TaxRateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTaxRate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaxRateMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaxRate>>>
    export type UpdateTaxRateMutationBody = BodyType<TaxRateInput>
    export type UpdateTaxRateMutationError = ErrorType<unknown>

    export const useUpdateTaxRate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaxRate>>, TError,{id: number;data: BodyType<TaxRateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTaxRate>>,
        TError,
        {id: number;data: BodyType<TaxRateInput>},
        TContext
      > => {
      return useMutation(getUpdateTaxRateMutationOptions(options));
    }

export const getGetGstr1DataUrl = (params: GetGstr1DataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/gst/gstr1?${stringifiedParams}` : `/api/finance/gst/gstr1`
}

/**
 * @summary Get GSTR-1 data for a period (B2B, B2C, CDN, exports)
 */
export const getGstr1Data = async (params: GetGstr1DataParams, options?: RequestInit): Promise<Gstr1Response> => {

  return customFetch<Gstr1Response>(getGetGstr1DataUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGstr1DataQueryKey = (params?: GetGstr1DataParams,) => {
    return [
    `/api/finance/gst/gstr1`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGstr1DataQueryOptions = <TData = Awaited<ReturnType<typeof getGstr1Data>>, TError = ErrorType<unknown>>(params: GetGstr1DataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGstr1Data>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGstr1DataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGstr1Data>>> = ({ signal }) => getGstr1Data(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGstr1Data>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGstr1DataQueryResult = NonNullable<Awaited<ReturnType<typeof getGstr1Data>>>
export type GetGstr1DataQueryError = ErrorType<unknown>


/**
 * @summary Get GSTR-1 data for a period (B2B, B2C, CDN, exports)
 */

export function useGetGstr1Data<TData = Awaited<ReturnType<typeof getGstr1Data>>, TError = ErrorType<unknown>>(
 params: GetGstr1DataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGstr1Data>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGstr1DataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetGstr3bSummaryUrl = (params: GetGstr3bSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/gst/gstr3b?${stringifiedParams}` : `/api/finance/gst/gstr3b`
}

/**
 * @summary Get GSTR-3B summary for a period
 */
export const getGstr3bSummary = async (params: GetGstr3bSummaryParams, options?: RequestInit): Promise<Gstr3bResponse> => {

  return customFetch<Gstr3bResponse>(getGetGstr3bSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGstr3bSummaryQueryKey = (params?: GetGstr3bSummaryParams,) => {
    return [
    `/api/finance/gst/gstr3b`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGstr3bSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getGstr3bSummary>>, TError = ErrorType<unknown>>(params: GetGstr3bSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGstr3bSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGstr3bSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGstr3bSummary>>> = ({ signal }) => getGstr3bSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGstr3bSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGstr3bSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getGstr3bSummary>>>
export type GetGstr3bSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get GSTR-3B summary for a period
 */

export function useGetGstr3bSummary<TData = Awaited<ReturnType<typeof getGstr3bSummary>>, TError = ErrorType<unknown>>(
 params: GetGstr3bSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGstr3bSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGstr3bSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetItcRegisterUrl = (params?: GetItcRegisterParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/gst/itc-register?${stringifiedParams}` : `/api/finance/gst/itc-register`
}

/**
 * @summary Input Tax Credit register
 */
export const getItcRegister = async (params?: GetItcRegisterParams, options?: RequestInit): Promise<ItcEntry[]> => {

  return customFetch<ItcEntry[]>(getGetItcRegisterUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetItcRegisterQueryKey = (params?: GetItcRegisterParams,) => {
    return [
    `/api/finance/gst/itc-register`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetItcRegisterQueryOptions = <TData = Awaited<ReturnType<typeof getItcRegister>>, TError = ErrorType<unknown>>(params?: GetItcRegisterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItcRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetItcRegisterQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItcRegister>>> = ({ signal }) => getItcRegister(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItcRegister>>, TError, TData> & { queryKey: QueryKey }
}

export type GetItcRegisterQueryResult = NonNullable<Awaited<ReturnType<typeof getItcRegister>>>
export type GetItcRegisterQueryError = ErrorType<unknown>


/**
 * @summary Input Tax Credit register
 */

export function useGetItcRegister<TData = Awaited<ReturnType<typeof getItcRegister>>, TError = ErrorType<unknown>>(
 params?: GetItcRegisterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItcRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetItcRegisterQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListGstrFilingPeriodsUrl = () => {




  return `/api/finance/gst/filing-periods`
}

/**
 * @summary List GSTR filing period statuses
 */
export const listGstrFilingPeriods = async ( options?: RequestInit): Promise<GstrFilingPeriod[]> => {

  return customFetch<GstrFilingPeriod[]>(getListGstrFilingPeriodsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGstrFilingPeriodsQueryKey = () => {
    return [
    `/api/finance/gst/filing-periods`
    ] as const;
    }


export const getListGstrFilingPeriodsQueryOptions = <TData = Awaited<ReturnType<typeof listGstrFilingPeriods>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGstrFilingPeriods>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGstrFilingPeriodsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGstrFilingPeriods>>> = ({ signal }) => listGstrFilingPeriods({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGstrFilingPeriods>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGstrFilingPeriodsQueryResult = NonNullable<Awaited<ReturnType<typeof listGstrFilingPeriods>>>
export type ListGstrFilingPeriodsQueryError = ErrorType<unknown>


/**
 * @summary List GSTR filing period statuses
 */

export function useListGstrFilingPeriods<TData = Awaited<ReturnType<typeof listGstrFilingPeriods>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGstrFilingPeriods>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGstrFilingPeriodsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpsertGstrFilingPeriodUrl = () => {




  return `/api/finance/gst/filing-periods`
}

export const upsertGstrFilingPeriod = async (gstrFilingPeriodInput: GstrFilingPeriodInput, options?: RequestInit): Promise<GstrFilingPeriod> => {

  return customFetch<GstrFilingPeriod>(getUpsertGstrFilingPeriodUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      gstrFilingPeriodInput,)
  }
);}




export const getUpsertGstrFilingPeriodMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertGstrFilingPeriod>>, TError,{data: BodyType<GstrFilingPeriodInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertGstrFilingPeriod>>, TError,{data: BodyType<GstrFilingPeriodInput>}, TContext> => {

const mutationKey = ['upsertGstrFilingPeriod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertGstrFilingPeriod>>, {data: BodyType<GstrFilingPeriodInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertGstrFilingPeriod(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertGstrFilingPeriodMutationResult = NonNullable<Awaited<ReturnType<typeof upsertGstrFilingPeriod>>>
    export type UpsertGstrFilingPeriodMutationBody = BodyType<GstrFilingPeriodInput>
    export type UpsertGstrFilingPeriodMutationError = ErrorType<unknown>

    export const useUpsertGstrFilingPeriod = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertGstrFilingPeriod>>, TError,{data: BodyType<GstrFilingPeriodInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertGstrFilingPeriod>>,
        TError,
        {data: BodyType<GstrFilingPeriodInput>},
        TContext
      > => {
      return useMutation(getUpsertGstrFilingPeriodMutationOptions(options));
    }

export const getListTdsRatesUrl = () => {




  return `/api/finance/tds/rates`
}

/**
 * @summary List TDS rate master entries
 */
export const listTdsRates = async ( options?: RequestInit): Promise<TdsRateMaster[]> => {

  return customFetch<TdsRateMaster[]>(getListTdsRatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTdsRatesQueryKey = () => {
    return [
    `/api/finance/tds/rates`
    ] as const;
    }


export const getListTdsRatesQueryOptions = <TData = Awaited<ReturnType<typeof listTdsRates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTdsRates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTdsRatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTdsRates>>> = ({ signal }) => listTdsRates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTdsRates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTdsRatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTdsRates>>>
export type ListTdsRatesQueryError = ErrorType<unknown>


/**
 * @summary List TDS rate master entries
 */

export function useListTdsRates<TData = Awaited<ReturnType<typeof listTdsRates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTdsRates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTdsRatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTdsRateUrl = () => {




  return `/api/finance/tds/rates`
}

export const createTdsRate = async (tdsRateMasterInput: TdsRateMasterInput, options?: RequestInit): Promise<TdsRateMaster> => {

  return customFetch<TdsRateMaster>(getCreateTdsRateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tdsRateMasterInput,)
  }
);}




export const getCreateTdsRateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTdsRate>>, TError,{data: BodyType<TdsRateMasterInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTdsRate>>, TError,{data: BodyType<TdsRateMasterInput>}, TContext> => {

const mutationKey = ['createTdsRate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTdsRate>>, {data: BodyType<TdsRateMasterInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTdsRate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTdsRateMutationResult = NonNullable<Awaited<ReturnType<typeof createTdsRate>>>
    export type CreateTdsRateMutationBody = BodyType<TdsRateMasterInput>
    export type CreateTdsRateMutationError = ErrorType<unknown>

    export const useCreateTdsRate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTdsRate>>, TError,{data: BodyType<TdsRateMasterInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTdsRate>>,
        TError,
        {data: BodyType<TdsRateMasterInput>},
        TContext
      > => {
      return useMutation(getCreateTdsRateMutationOptions(options));
    }

export const getUpdateTdsRateUrl = (id: number,) => {




  return `/api/finance/tds/rates/${id}`
}

export const updateTdsRate = async (id: number,
    tdsRateMasterInput: TdsRateMasterInput, options?: RequestInit): Promise<TdsRateMaster> => {

  return customFetch<TdsRateMaster>(getUpdateTdsRateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tdsRateMasterInput,)
  }
);}




export const getUpdateTdsRateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTdsRate>>, TError,{id: number;data: BodyType<TdsRateMasterInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTdsRate>>, TError,{id: number;data: BodyType<TdsRateMasterInput>}, TContext> => {

const mutationKey = ['updateTdsRate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTdsRate>>, {id: number;data: BodyType<TdsRateMasterInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTdsRate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTdsRateMutationResult = NonNullable<Awaited<ReturnType<typeof updateTdsRate>>>
    export type UpdateTdsRateMutationBody = BodyType<TdsRateMasterInput>
    export type UpdateTdsRateMutationError = ErrorType<unknown>

    export const useUpdateTdsRate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTdsRate>>, TError,{id: number;data: BodyType<TdsRateMasterInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTdsRate>>,
        TError,
        {id: number;data: BodyType<TdsRateMasterInput>},
        TContext
      > => {
      return useMutation(getUpdateTdsRateMutationOptions(options));
    }

export const getDeleteTdsRateUrl = (id: number,) => {




  return `/api/finance/tds/rates/${id}`
}

export const deleteTdsRate = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTdsRateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTdsRateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTdsRate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTdsRate>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTdsRate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTdsRate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTdsRate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTdsRateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTdsRate>>>

    export type DeleteTdsRateMutationError = ErrorType<unknown>

    export const useDeleteTdsRate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTdsRate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTdsRate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTdsRateMutationOptions(options));
    }

export const getListTdsDeductionsUrl = (params?: ListTdsDeductionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/tds/deductions?${stringifiedParams}` : `/api/finance/tds/deductions`
}

/**
 * @summary List TDS deductions
 */
export const listTdsDeductions = async (params?: ListTdsDeductionsParams, options?: RequestInit): Promise<TdsDeduction[]> => {

  return customFetch<TdsDeduction[]>(getListTdsDeductionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTdsDeductionsQueryKey = (params?: ListTdsDeductionsParams,) => {
    return [
    `/api/finance/tds/deductions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTdsDeductionsQueryOptions = <TData = Awaited<ReturnType<typeof listTdsDeductions>>, TError = ErrorType<unknown>>(params?: ListTdsDeductionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTdsDeductions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTdsDeductionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTdsDeductions>>> = ({ signal }) => listTdsDeductions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTdsDeductions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTdsDeductionsQueryResult = NonNullable<Awaited<ReturnType<typeof listTdsDeductions>>>
export type ListTdsDeductionsQueryError = ErrorType<unknown>


/**
 * @summary List TDS deductions
 */

export function useListTdsDeductions<TData = Awaited<ReturnType<typeof listTdsDeductions>>, TError = ErrorType<unknown>>(
 params?: ListTdsDeductionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTdsDeductions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTdsDeductionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListTdsChallansUrl = (params?: ListTdsChallansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/tds/challans?${stringifiedParams}` : `/api/finance/tds/challans`
}

/**
 * @summary List TDS challans
 */
export const listTdsChallans = async (params?: ListTdsChallansParams, options?: RequestInit): Promise<TdsChallan[]> => {

  return customFetch<TdsChallan[]>(getListTdsChallansUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTdsChallansQueryKey = (params?: ListTdsChallansParams,) => {
    return [
    `/api/finance/tds/challans`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTdsChallansQueryOptions = <TData = Awaited<ReturnType<typeof listTdsChallans>>, TError = ErrorType<unknown>>(params?: ListTdsChallansParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTdsChallans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTdsChallansQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTdsChallans>>> = ({ signal }) => listTdsChallans(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTdsChallans>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTdsChallansQueryResult = NonNullable<Awaited<ReturnType<typeof listTdsChallans>>>
export type ListTdsChallansQueryError = ErrorType<unknown>


/**
 * @summary List TDS challans
 */

export function useListTdsChallans<TData = Awaited<ReturnType<typeof listTdsChallans>>, TError = ErrorType<unknown>>(
 params?: ListTdsChallansParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTdsChallans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTdsChallansQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTdsChallanUrl = () => {




  return `/api/finance/tds/challans`
}

export const createTdsChallan = async (tdsChallanInput: TdsChallanInput, options?: RequestInit): Promise<TdsChallan> => {

  return customFetch<TdsChallan>(getCreateTdsChallanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tdsChallanInput,)
  }
);}




export const getCreateTdsChallanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTdsChallan>>, TError,{data: BodyType<TdsChallanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTdsChallan>>, TError,{data: BodyType<TdsChallanInput>}, TContext> => {

const mutationKey = ['createTdsChallan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTdsChallan>>, {data: BodyType<TdsChallanInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTdsChallan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTdsChallanMutationResult = NonNullable<Awaited<ReturnType<typeof createTdsChallan>>>
    export type CreateTdsChallanMutationBody = BodyType<TdsChallanInput>
    export type CreateTdsChallanMutationError = ErrorType<unknown>

    export const useCreateTdsChallan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTdsChallan>>, TError,{data: BodyType<TdsChallanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTdsChallan>>,
        TError,
        {data: BodyType<TdsChallanInput>},
        TContext
      > => {
      return useMutation(getCreateTdsChallanMutationOptions(options));
    }

export const getUpdateTdsChallanUrl = (id: number,) => {




  return `/api/finance/tds/challans/${id}`
}

export const updateTdsChallan = async (id: number,
    tdsChallanInput: TdsChallanInput, options?: RequestInit): Promise<TdsChallan> => {

  return customFetch<TdsChallan>(getUpdateTdsChallanUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tdsChallanInput,)
  }
);}




export const getUpdateTdsChallanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTdsChallan>>, TError,{id: number;data: BodyType<TdsChallanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTdsChallan>>, TError,{id: number;data: BodyType<TdsChallanInput>}, TContext> => {

const mutationKey = ['updateTdsChallan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTdsChallan>>, {id: number;data: BodyType<TdsChallanInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTdsChallan(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTdsChallanMutationResult = NonNullable<Awaited<ReturnType<typeof updateTdsChallan>>>
    export type UpdateTdsChallanMutationBody = BodyType<TdsChallanInput>
    export type UpdateTdsChallanMutationError = ErrorType<unknown>

    export const useUpdateTdsChallan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTdsChallan>>, TError,{id: number;data: BodyType<TdsChallanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTdsChallan>>,
        TError,
        {id: number;data: BodyType<TdsChallanInput>},
        TContext
      > => {
      return useMutation(getUpdateTdsChallanMutationOptions(options));
    }

export const getGetTdsForm26QUrl = (params: GetTdsForm26QParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/tds/form26q?${stringifiedParams}` : `/api/finance/tds/form26q`
}

/**
 * @summary Get Form 26Q data for a quarter
 */
export const getTdsForm26Q = async (params: GetTdsForm26QParams, options?: RequestInit): Promise<Form26QResponse> => {

  return customFetch<Form26QResponse>(getGetTdsForm26QUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTdsForm26QQueryKey = (params?: GetTdsForm26QParams,) => {
    return [
    `/api/finance/tds/form26q`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTdsForm26QQueryOptions = <TData = Awaited<ReturnType<typeof getTdsForm26Q>>, TError = ErrorType<unknown>>(params: GetTdsForm26QParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTdsForm26Q>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTdsForm26QQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTdsForm26Q>>> = ({ signal }) => getTdsForm26Q(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTdsForm26Q>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTdsForm26QQueryResult = NonNullable<Awaited<ReturnType<typeof getTdsForm26Q>>>
export type GetTdsForm26QQueryError = ErrorType<unknown>


/**
 * @summary Get Form 26Q data for a quarter
 */

export function useGetTdsForm26Q<TData = Awaited<ReturnType<typeof getTdsForm26Q>>, TError = ErrorType<unknown>>(
 params: GetTdsForm26QParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTdsForm26Q>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTdsForm26QQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetTdsForm16AUrl = (vendorId: number,
    params: GetTdsForm16AParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/tds/form16a/${vendorId}?${stringifiedParams}` : `/api/finance/tds/form16a/${vendorId}`
}

/**
 * @summary Get Form 16A data for a vendor and quarter
 */
export const getTdsForm16A = async (vendorId: number,
    params: GetTdsForm16AParams, options?: RequestInit): Promise<Form16AResponse> => {

  return customFetch<Form16AResponse>(getGetTdsForm16AUrl(vendorId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTdsForm16AQueryKey = (vendorId: number,
    params?: GetTdsForm16AParams,) => {
    return [
    `/api/finance/tds/form16a/${vendorId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTdsForm16AQueryOptions = <TData = Awaited<ReturnType<typeof getTdsForm16A>>, TError = ErrorType<unknown>>(vendorId: number,
    params: GetTdsForm16AParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTdsForm16A>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTdsForm16AQueryKey(vendorId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTdsForm16A>>> = ({ signal }) => getTdsForm16A(vendorId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(vendorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTdsForm16A>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTdsForm16AQueryResult = NonNullable<Awaited<ReturnType<typeof getTdsForm16A>>>
export type GetTdsForm16AQueryError = ErrorType<unknown>


/**
 * @summary Get Form 16A data for a vendor and quarter
 */

export function useGetTdsForm16A<TData = Awaited<ReturnType<typeof getTdsForm16A>>, TError = ErrorType<unknown>>(
 vendorId: number,
    params: GetTdsForm16AParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTdsForm16A>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTdsForm16AQueryOptions(vendorId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListBankAccountsUrl = () => {




  return `/api/finance/bank-accounts`
}

/**
 * @summary List company bank accounts
 */
export const listBankAccounts = async ( options?: RequestInit): Promise<BankAccount[]> => {

  return customFetch<BankAccount[]>(getListBankAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankAccountsQueryKey = () => {
    return [
    `/api/finance/bank-accounts`
    ] as const;
    }


export const getListBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listBankAccounts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankAccounts>>> = ({ signal }) => listBankAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listBankAccounts>>>
export type ListBankAccountsQueryError = ErrorType<unknown>


/**
 * @summary List company bank accounts
 */

export function useListBankAccounts<TData = Awaited<ReturnType<typeof listBankAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBankAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBankAccountUrl = () => {




  return `/api/finance/bank-accounts`
}

export const createBankAccount = async (bankAccountInput: BankAccountInput, options?: RequestInit): Promise<BankAccount> => {

  return customFetch<BankAccount>(getCreateBankAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bankAccountInput,)
  }
);}




export const getCreateBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankAccount>>, TError,{data: BodyType<BankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBankAccount>>, TError,{data: BodyType<BankAccountInput>}, TContext> => {

const mutationKey = ['createBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBankAccount>>, {data: BodyType<BankAccountInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBankAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createBankAccount>>>
    export type CreateBankAccountMutationBody = BodyType<BankAccountInput>
    export type CreateBankAccountMutationError = ErrorType<unknown>

    export const useCreateBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankAccount>>, TError,{data: BodyType<BankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBankAccount>>,
        TError,
        {data: BodyType<BankAccountInput>},
        TContext
      > => {
      return useMutation(getCreateBankAccountMutationOptions(options));
    }

export const getUpdateBankAccountUrl = (id: number,) => {




  return `/api/finance/bank-accounts/${id}`
}

export const updateBankAccount = async (id: number,
    bankAccountInput: BankAccountInput, options?: RequestInit): Promise<BankAccount> => {

  return customFetch<BankAccount>(getUpdateBankAccountUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bankAccountInput,)
  }
);}




export const getUpdateBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankAccount>>, TError,{id: number;data: BodyType<BankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBankAccount>>, TError,{id: number;data: BodyType<BankAccountInput>}, TContext> => {

const mutationKey = ['updateBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBankAccount>>, {id: number;data: BodyType<BankAccountInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBankAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateBankAccount>>>
    export type UpdateBankAccountMutationBody = BodyType<BankAccountInput>
    export type UpdateBankAccountMutationError = ErrorType<unknown>

    export const useUpdateBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankAccount>>, TError,{id: number;data: BodyType<BankAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBankAccount>>,
        TError,
        {id: number;data: BodyType<BankAccountInput>},
        TContext
      > => {
      return useMutation(getUpdateBankAccountMutationOptions(options));
    }

export const getDeleteBankAccountUrl = (id: number,) => {




  return `/api/finance/bank-accounts/${id}`
}

export const deleteBankAccount = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteBankAccountUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBankAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteBankAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBankAccount>>>

    export type DeleteBankAccountMutationError = ErrorType<unknown>

    export const useDeleteBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteBankAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteBankAccountMutationOptions(options));
    }

export const getGetBankStatementUrl = (id: number,
    params?: GetBankStatementParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/bank-accounts/${id}/statement?${stringifiedParams}` : `/api/finance/bank-accounts/${id}/statement`
}

/**
 * @summary Get bank statement lines with reconciliation status
 */
export const getBankStatement = async (id: number,
    params?: GetBankStatementParams, options?: RequestInit): Promise<BankStatementLine[]> => {

  return customFetch<BankStatementLine[]>(getGetBankStatementUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBankStatementQueryKey = (id: number,
    params?: GetBankStatementParams,) => {
    return [
    `/api/finance/bank-accounts/${id}/statement`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBankStatementQueryOptions = <TData = Awaited<ReturnType<typeof getBankStatement>>, TError = ErrorType<unknown>>(id: number,
    params?: GetBankStatementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankStatement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankStatementQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankStatement>>> = ({ signal }) => getBankStatement(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankStatement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBankStatementQueryResult = NonNullable<Awaited<ReturnType<typeof getBankStatement>>>
export type GetBankStatementQueryError = ErrorType<unknown>


/**
 * @summary Get bank statement lines with reconciliation status
 */

export function useGetBankStatement<TData = Awaited<ReturnType<typeof getBankStatement>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetBankStatementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankStatement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBankStatementQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getImportBankStatementUrl = (id: number,) => {




  return `/api/finance/bank-accounts/${id}/statement`
}

/**
 * @summary Import bank statement CSV
 */
export const importBankStatement = async (id: number,
    importBankStatementBody: string, options?: RequestInit): Promise<CsvImportResult> => {

  return customFetch<CsvImportResult>(getImportBankStatementUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/csv', ...options?.headers },
    body: JSON.stringify(
      importBankStatementBody,)
  }
);}




export const getImportBankStatementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importBankStatement>>, TError,{id: number;data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importBankStatement>>, TError,{id: number;data: BodyType<string>}, TContext> => {

const mutationKey = ['importBankStatement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importBankStatement>>, {id: number;data: BodyType<string>}> = (props) => {
          const {id,data} = props ?? {};

          return  importBankStatement(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportBankStatementMutationResult = NonNullable<Awaited<ReturnType<typeof importBankStatement>>>
    export type ImportBankStatementMutationBody = BodyType<string>
    export type ImportBankStatementMutationError = ErrorType<unknown>

    /**
 * @summary Import bank statement CSV
 */
export const useImportBankStatement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importBankStatement>>, TError,{id: number;data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importBankStatement>>,
        TError,
        {id: number;data: BodyType<string>},
        TContext
      > => {
      return useMutation(getImportBankStatementMutationOptions(options));
    }

export const getReconcileBankStatementUrl = (id: number,) => {




  return `/api/finance/bank-accounts/${id}/reconcile`
}

/**
 * @summary Mark bank statement lines as reconciled against vouchers
 */
export const reconcileBankStatement = async (id: number,
    reconcileInput: ReconcileInput, options?: RequestInit): Promise<ReconcileBankStatement200> => {

  return customFetch<ReconcileBankStatement200>(getReconcileBankStatementUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reconcileInput,)
  }
);}




export const getReconcileBankStatementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileBankStatement>>, TError,{id: number;data: BodyType<ReconcileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reconcileBankStatement>>, TError,{id: number;data: BodyType<ReconcileInput>}, TContext> => {

const mutationKey = ['reconcileBankStatement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconcileBankStatement>>, {id: number;data: BodyType<ReconcileInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  reconcileBankStatement(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReconcileBankStatementMutationResult = NonNullable<Awaited<ReturnType<typeof reconcileBankStatement>>>
    export type ReconcileBankStatementMutationBody = BodyType<ReconcileInput>
    export type ReconcileBankStatementMutationError = ErrorType<unknown>

    /**
 * @summary Mark bank statement lines as reconciled against vouchers
 */
export const useReconcileBankStatement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileBankStatement>>, TError,{id: number;data: BodyType<ReconcileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reconcileBankStatement>>,
        TError,
        {id: number;data: BodyType<ReconcileInput>},
        TContext
      > => {
      return useMutation(getReconcileBankStatementMutationOptions(options));
    }

export const getGetBankCashBookUrl = (id: number,
    params?: GetBankCashBookParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/bank-accounts/${id}/book?${stringifiedParams}` : `/api/finance/bank-accounts/${id}/book`
}

/**
 * @summary Get bank/cash book with running balance
 */
export const getBankCashBook = async (id: number,
    params?: GetBankCashBookParams, options?: RequestInit): Promise<BankCashBook> => {

  return customFetch<BankCashBook>(getGetBankCashBookUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBankCashBookQueryKey = (id: number,
    params?: GetBankCashBookParams,) => {
    return [
    `/api/finance/bank-accounts/${id}/book`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBankCashBookQueryOptions = <TData = Awaited<ReturnType<typeof getBankCashBook>>, TError = ErrorType<unknown>>(id: number,
    params?: GetBankCashBookParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankCashBook>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankCashBookQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankCashBook>>> = ({ signal }) => getBankCashBook(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankCashBook>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBankCashBookQueryResult = NonNullable<Awaited<ReturnType<typeof getBankCashBook>>>
export type GetBankCashBookQueryError = ErrorType<unknown>


/**
 * @summary Get bank/cash book with running balance
 */

export function useGetBankCashBook<TData = Awaited<ReturnType<typeof getBankCashBook>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetBankCashBookParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankCashBook>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBankCashBookQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetTrialBalanceUrl = (params: GetTrialBalanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/trial-balance?${stringifiedParams}` : `/api/finance/reports/trial-balance`
}

/**
 * @summary Trial balance as of a date
 */
export const getTrialBalance = async (params: GetTrialBalanceParams, options?: RequestInit): Promise<TrialBalanceResponse> => {

  return customFetch<TrialBalanceResponse>(getGetTrialBalanceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrialBalanceQueryKey = (params?: GetTrialBalanceParams,) => {
    return [
    `/api/finance/reports/trial-balance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTrialBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getTrialBalance>>, TError = ErrorType<unknown>>(params: GetTrialBalanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrialBalance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrialBalanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrialBalance>>> = ({ signal }) => getTrialBalance(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrialBalance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTrialBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getTrialBalance>>>
export type GetTrialBalanceQueryError = ErrorType<unknown>


/**
 * @summary Trial balance as of a date
 */

export function useGetTrialBalance<TData = Awaited<ReturnType<typeof getTrialBalance>>, TError = ErrorType<unknown>>(
 params: GetTrialBalanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrialBalance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTrialBalanceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetProfitLossUrl = (params: GetProfitLossParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/profit-loss?${stringifiedParams}` : `/api/finance/reports/profit-loss`
}

/**
 * @summary Profit & Loss statement
 */
export const getProfitLoss = async (params: GetProfitLossParams, options?: RequestInit): Promise<ProfitLossResponse> => {

  return customFetch<ProfitLossResponse>(getGetProfitLossUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfitLossQueryKey = (params?: GetProfitLossParams,) => {
    return [
    `/api/finance/reports/profit-loss`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProfitLossQueryOptions = <TData = Awaited<ReturnType<typeof getProfitLoss>>, TError = ErrorType<unknown>>(params: GetProfitLossParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitLoss>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfitLossQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfitLoss>>> = ({ signal }) => getProfitLoss(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfitLoss>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProfitLossQueryResult = NonNullable<Awaited<ReturnType<typeof getProfitLoss>>>
export type GetProfitLossQueryError = ErrorType<unknown>


/**
 * @summary Profit & Loss statement
 */

export function useGetProfitLoss<TData = Awaited<ReturnType<typeof getProfitLoss>>, TError = ErrorType<unknown>>(
 params: GetProfitLossParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitLoss>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProfitLossQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetBalanceSheetUrl = (params: GetBalanceSheetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/balance-sheet?${stringifiedParams}` : `/api/finance/reports/balance-sheet`
}

/**
 * @summary Balance sheet as of a date
 */
export const getBalanceSheet = async (params: GetBalanceSheetParams, options?: RequestInit): Promise<BalanceSheetResponse> => {

  return customFetch<BalanceSheetResponse>(getGetBalanceSheetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBalanceSheetQueryKey = (params?: GetBalanceSheetParams,) => {
    return [
    `/api/finance/reports/balance-sheet`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBalanceSheetQueryOptions = <TData = Awaited<ReturnType<typeof getBalanceSheet>>, TError = ErrorType<unknown>>(params: GetBalanceSheetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBalanceSheet>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBalanceSheetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBalanceSheet>>> = ({ signal }) => getBalanceSheet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBalanceSheet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBalanceSheetQueryResult = NonNullable<Awaited<ReturnType<typeof getBalanceSheet>>>
export type GetBalanceSheetQueryError = ErrorType<unknown>


/**
 * @summary Balance sheet as of a date
 */

export function useGetBalanceSheet<TData = Awaited<ReturnType<typeof getBalanceSheet>>, TError = ErrorType<unknown>>(
 params: GetBalanceSheetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBalanceSheet>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBalanceSheetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetCashFlowUrl = (params: GetCashFlowParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/cash-flow?${stringifiedParams}` : `/api/finance/reports/cash-flow`
}

/**
 * @summary Cash flow statement
 */
export const getCashFlow = async (params: GetCashFlowParams, options?: RequestInit): Promise<CashFlowResponse> => {

  return customFetch<CashFlowResponse>(getGetCashFlowUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCashFlowQueryKey = (params?: GetCashFlowParams,) => {
    return [
    `/api/finance/reports/cash-flow`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCashFlowQueryOptions = <TData = Awaited<ReturnType<typeof getCashFlow>>, TError = ErrorType<unknown>>(params: GetCashFlowParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCashFlow>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCashFlowQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashFlow>>> = ({ signal }) => getCashFlow(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCashFlow>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCashFlowQueryResult = NonNullable<Awaited<ReturnType<typeof getCashFlow>>>
export type GetCashFlowQueryError = ErrorType<unknown>


/**
 * @summary Cash flow statement
 */

export function useGetCashFlow<TData = Awaited<ReturnType<typeof getCashFlow>>, TError = ErrorType<unknown>>(
 params: GetCashFlowParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCashFlow>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCashFlowQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetVendorPortalMeUrl = () => {




  return `/api/vendor-portal/me`
}

/**
 * @summary Get vendor portal profile (for logged-in vendor user)
 */
export const getVendorPortalMe = async ( options?: RequestInit): Promise<VendorPortalProfile> => {

  return customFetch<VendorPortalProfile>(getGetVendorPortalMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorPortalMeQueryKey = () => {
    return [
    `/api/vendor-portal/me`
    ] as const;
    }


export const getGetVendorPortalMeQueryOptions = <TData = Awaited<ReturnType<typeof getVendorPortalMe>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorPortalMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorPortalMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendorPortalMe>>> = ({ signal }) => getVendorPortalMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendorPortalMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVendorPortalMeQueryResult = NonNullable<Awaited<ReturnType<typeof getVendorPortalMe>>>
export type GetVendorPortalMeQueryError = ErrorType<unknown>


/**
 * @summary Get vendor portal profile (for logged-in vendor user)
 */

export function useGetVendorPortalMe<TData = Awaited<ReturnType<typeof getVendorPortalMe>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorPortalMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVendorPortalMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetVendorOnboardingFormUrl = (token: string,) => {




  return `/api/vendor-portal/onboarding/${token}`
}

/**
 * @summary Get onboarding invite details by token (unauthenticated)
 */
export const getVendorOnboardingForm = async (token: string, options?: RequestInit): Promise<VendorOnboardingFormData> => {

  return customFetch<VendorOnboardingFormData>(getGetVendorOnboardingFormUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorOnboardingFormQueryKey = (token: string,) => {
    return [
    `/api/vendor-portal/onboarding/${token}`
    ] as const;
    }


export const getGetVendorOnboardingFormQueryOptions = <TData = Awaited<ReturnType<typeof getVendorOnboardingForm>>, TError = ErrorType<unknown>>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorOnboardingForm>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorOnboardingFormQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendorOnboardingForm>>> = ({ signal }) => getVendorOnboardingForm(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendorOnboardingForm>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVendorOnboardingFormQueryResult = NonNullable<Awaited<ReturnType<typeof getVendorOnboardingForm>>>
export type GetVendorOnboardingFormQueryError = ErrorType<unknown>


/**
 * @summary Get onboarding invite details by token (unauthenticated)
 */

export function useGetVendorOnboardingForm<TData = Awaited<ReturnType<typeof getVendorOnboardingForm>>, TError = ErrorType<unknown>>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorOnboardingForm>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVendorOnboardingFormQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSubmitVendorOnboardingUrl = (token: string,) => {




  return `/api/vendor-portal/onboarding/${token}`
}

/**
 * @summary Submit vendor self-onboarding form
 */
export const submitVendorOnboarding = async (token: string,
    vendorOnboardingSubmission: VendorOnboardingSubmission, options?: RequestInit): Promise<SubmitVendorOnboarding200> => {

  return customFetch<SubmitVendorOnboarding200>(getSubmitVendorOnboardingUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorOnboardingSubmission,)
  }
);}




export const getSubmitVendorOnboardingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitVendorOnboarding>>, TError,{token: string;data: BodyType<VendorOnboardingSubmission>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitVendorOnboarding>>, TError,{token: string;data: BodyType<VendorOnboardingSubmission>}, TContext> => {

const mutationKey = ['submitVendorOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitVendorOnboarding>>, {token: string;data: BodyType<VendorOnboardingSubmission>}> = (props) => {
          const {token,data} = props ?? {};

          return  submitVendorOnboarding(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitVendorOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof submitVendorOnboarding>>>
    export type SubmitVendorOnboardingMutationBody = BodyType<VendorOnboardingSubmission>
    export type SubmitVendorOnboardingMutationError = ErrorType<unknown>

    /**
 * @summary Submit vendor self-onboarding form
 */
export const useSubmitVendorOnboarding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitVendorOnboarding>>, TError,{token: string;data: BodyType<VendorOnboardingSubmission>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitVendorOnboarding>>,
        TError,
        {token: string;data: BodyType<VendorOnboardingSubmission>},
        TContext
      > => {
      return useMutation(getSubmitVendorOnboardingMutationOptions(options));
    }

export const getListVendorPortalPOsUrl = () => {




  return `/api/vendor-portal/purchase-orders`
}

/**
 * @summary Vendor portal — view POs raised against this vendor
 */
export const listVendorPortalPOs = async ( options?: RequestInit): Promise<PurchaseOrder[]> => {

  return customFetch<PurchaseOrder[]>(getListVendorPortalPOsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorPortalPOsQueryKey = () => {
    return [
    `/api/vendor-portal/purchase-orders`
    ] as const;
    }


export const getListVendorPortalPOsQueryOptions = <TData = Awaited<ReturnType<typeof listVendorPortalPOs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalPOs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorPortalPOsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorPortalPOs>>> = ({ signal }) => listVendorPortalPOs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalPOs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorPortalPOsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorPortalPOs>>>
export type ListVendorPortalPOsQueryError = ErrorType<unknown>


/**
 * @summary Vendor portal — view POs raised against this vendor
 */

export function useListVendorPortalPOs<TData = Awaited<ReturnType<typeof listVendorPortalPOs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalPOs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorPortalPOsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListVendorPortalInvoicesUrl = () => {




  return `/api/vendor-portal/invoices`
}

/**
 * @summary Vendor portal — list submitted invoices with status
 */
export const listVendorPortalInvoices = async ( options?: RequestInit): Promise<VendorBill[]> => {

  return customFetch<VendorBill[]>(getListVendorPortalInvoicesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorPortalInvoicesQueryKey = () => {
    return [
    `/api/vendor-portal/invoices`
    ] as const;
    }


export const getListVendorPortalInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listVendorPortalInvoices>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorPortalInvoicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorPortalInvoices>>> = ({ signal }) => listVendorPortalInvoices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorPortalInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorPortalInvoices>>>
export type ListVendorPortalInvoicesQueryError = ErrorType<unknown>


/**
 * @summary Vendor portal — list submitted invoices with status
 */

export function useListVendorPortalInvoices<TData = Awaited<ReturnType<typeof listVendorPortalInvoices>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorPortalInvoicesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSubmitVendorPortalInvoiceUrl = () => {




  return `/api/vendor-portal/invoices`
}

/**
 * @summary Vendor portal — submit an invoice against a PO
 */
export const submitVendorPortalInvoice = async (vendorBillInput: VendorBillInput, options?: RequestInit): Promise<VendorBill> => {

  return customFetch<VendorBill>(getSubmitVendorPortalInvoiceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorBillInput,)
  }
);}




export const getSubmitVendorPortalInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitVendorPortalInvoice>>, TError,{data: BodyType<VendorBillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitVendorPortalInvoice>>, TError,{data: BodyType<VendorBillInput>}, TContext> => {

const mutationKey = ['submitVendorPortalInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitVendorPortalInvoice>>, {data: BodyType<VendorBillInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitVendorPortalInvoice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitVendorPortalInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof submitVendorPortalInvoice>>>
    export type SubmitVendorPortalInvoiceMutationBody = BodyType<VendorBillInput>
    export type SubmitVendorPortalInvoiceMutationError = ErrorType<unknown>

    /**
 * @summary Vendor portal — submit an invoice against a PO
 */
export const useSubmitVendorPortalInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitVendorPortalInvoice>>, TError,{data: BodyType<VendorBillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitVendorPortalInvoice>>,
        TError,
        {data: BodyType<VendorBillInput>},
        TContext
      > => {
      return useMutation(getSubmitVendorPortalInvoiceMutationOptions(options));
    }

export const getListVendorPortalPaymentsUrl = () => {




  return `/api/vendor-portal/payments`
}

/**
 * @summary Vendor portal — payment history with UTR
 */
export const listVendorPortalPayments = async ( options?: RequestInit): Promise<VendorPayment[]> => {

  return customFetch<VendorPayment[]>(getListVendorPortalPaymentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorPortalPaymentsQueryKey = () => {
    return [
    `/api/vendor-portal/payments`
    ] as const;
    }


export const getListVendorPortalPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listVendorPortalPayments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorPortalPaymentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorPortalPayments>>> = ({ signal }) => listVendorPortalPayments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalPayments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorPortalPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorPortalPayments>>>
export type ListVendorPortalPaymentsQueryError = ErrorType<unknown>


/**
 * @summary Vendor portal — payment history with UTR
 */

export function useListVendorPortalPayments<TData = Awaited<ReturnType<typeof listVendorPortalPayments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorPortalPaymentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListVendorPortalTdsCertificatesUrl = (params?: ListVendorPortalTdsCertificatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vendor-portal/tds-certificates?${stringifiedParams}` : `/api/vendor-portal/tds-certificates`
}

/**
 * @summary Vendor portal — Form 16A TDS certificates
 */
export const listVendorPortalTdsCertificates = async (params?: ListVendorPortalTdsCertificatesParams, options?: RequestInit): Promise<Form16AResponse[]> => {

  return customFetch<Form16AResponse[]>(getListVendorPortalTdsCertificatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorPortalTdsCertificatesQueryKey = (params?: ListVendorPortalTdsCertificatesParams,) => {
    return [
    `/api/vendor-portal/tds-certificates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVendorPortalTdsCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof listVendorPortalTdsCertificates>>, TError = ErrorType<unknown>>(params?: ListVendorPortalTdsCertificatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalTdsCertificates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorPortalTdsCertificatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorPortalTdsCertificates>>> = ({ signal }) => listVendorPortalTdsCertificates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalTdsCertificates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorPortalTdsCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorPortalTdsCertificates>>>
export type ListVendorPortalTdsCertificatesQueryError = ErrorType<unknown>


/**
 * @summary Vendor portal — Form 16A TDS certificates
 */

export function useListVendorPortalTdsCertificates<TData = Awaited<ReturnType<typeof listVendorPortalTdsCertificates>>, TError = ErrorType<unknown>>(
 params?: ListVendorPortalTdsCertificatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalTdsCertificates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorPortalTdsCertificatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListVendorPortalDocumentsUrl = () => {




  return `/api/vendor-portal/documents`
}

/**
 * @summary Vendor portal — compliance documents
 */
export const listVendorPortalDocuments = async ( options?: RequestInit): Promise<VendorDocument[]> => {

  return customFetch<VendorDocument[]>(getListVendorPortalDocumentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorPortalDocumentsQueryKey = () => {
    return [
    `/api/vendor-portal/documents`
    ] as const;
    }


export const getListVendorPortalDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listVendorPortalDocuments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorPortalDocumentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorPortalDocuments>>> = ({ signal }) => listVendorPortalDocuments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorPortalDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorPortalDocuments>>>
export type ListVendorPortalDocumentsQueryError = ErrorType<unknown>


/**
 * @summary Vendor portal — compliance documents
 */

export function useListVendorPortalDocuments<TData = Awaited<ReturnType<typeof listVendorPortalDocuments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorPortalDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorPortalDocumentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUploadVendorPortalDocumentUrl = () => {




  return `/api/vendor-portal/documents`
}

/**
 * @summary Vendor portal — upload/update compliance document
 */
export const uploadVendorPortalDocument = async (vendorDocumentInput: VendorDocumentInput, options?: RequestInit): Promise<VendorDocument> => {

  return customFetch<VendorDocument>(getUploadVendorPortalDocumentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorDocumentInput,)
  }
);}




export const getUploadVendorPortalDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadVendorPortalDocument>>, TError,{data: BodyType<VendorDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadVendorPortalDocument>>, TError,{data: BodyType<VendorDocumentInput>}, TContext> => {

const mutationKey = ['uploadVendorPortalDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadVendorPortalDocument>>, {data: BodyType<VendorDocumentInput>}> = (props) => {
          const {data} = props ?? {};

          return  uploadVendorPortalDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadVendorPortalDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadVendorPortalDocument>>>
    export type UploadVendorPortalDocumentMutationBody = BodyType<VendorDocumentInput>
    export type UploadVendorPortalDocumentMutationError = ErrorType<unknown>

    /**
 * @summary Vendor portal — upload/update compliance document
 */
export const useUploadVendorPortalDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadVendorPortalDocument>>, TError,{data: BodyType<VendorDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadVendorPortalDocument>>,
        TError,
        {data: BodyType<VendorDocumentInput>},
        TContext
      > => {
      return useMutation(getUploadVendorPortalDocumentMutationOptions(options));
    }

export const getPostIntermoduleJournalUrl = () => {




  return `/api/finance/intermodule/post-journal`
}

/**
 * @summary Post a journal entry from Payroll, CRM, or Stock
 */
export const postIntermoduleJournal = async (intermoduleJournalInput: IntermoduleJournalInput, options?: RequestInit): Promise<Voucher> => {

  return customFetch<Voucher>(getPostIntermoduleJournalUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      intermoduleJournalInput,)
  }
);}




export const getPostIntermoduleJournalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntermoduleJournal>>, TError,{data: BodyType<IntermoduleJournalInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntermoduleJournal>>, TError,{data: BodyType<IntermoduleJournalInput>}, TContext> => {

const mutationKey = ['postIntermoduleJournal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntermoduleJournal>>, {data: BodyType<IntermoduleJournalInput>}> = (props) => {
          const {data} = props ?? {};

          return  postIntermoduleJournal(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostIntermoduleJournalMutationResult = NonNullable<Awaited<ReturnType<typeof postIntermoduleJournal>>>
    export type PostIntermoduleJournalMutationBody = BodyType<IntermoduleJournalInput>
    export type PostIntermoduleJournalMutationError = ErrorType<unknown>

    /**
 * @summary Post a journal entry from Payroll, CRM, or Stock
 */
export const usePostIntermoduleJournal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntermoduleJournal>>, TError,{data: BodyType<IntermoduleJournalInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postIntermoduleJournal>>,
        TError,
        {data: BodyType<IntermoduleJournalInput>},
        TContext
      > => {
      return useMutation(getPostIntermoduleJournalMutationOptions(options));
    }

export const getListUomUrl = () => {




  return `/api/catalog/uom`
}

/**
 * @summary List units of measure
 */
export const listUom = async ( options?: RequestInit): Promise<Uom[]> => {

  return customFetch<Uom[]>(getListUomUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUomQueryKey = () => {
    return [
    `/api/catalog/uom`
    ] as const;
    }


export const getListUomQueryOptions = <TData = Awaited<ReturnType<typeof listUom>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUom>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUomQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUom>>> = ({ signal }) => listUom({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUom>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUomQueryResult = NonNullable<Awaited<ReturnType<typeof listUom>>>
export type ListUomQueryError = ErrorType<unknown>


/**
 * @summary List units of measure
 */

export function useListUom<TData = Awaited<ReturnType<typeof listUom>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUom>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUomQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateUomUrl = () => {




  return `/api/catalog/uom`
}

/**
 * @summary Create a unit of measure
 */
export const createUom = async (uomInput: UomInput, options?: RequestInit): Promise<Uom> => {

  return customFetch<Uom>(getCreateUomUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      uomInput,)
  }
);}




export const getCreateUomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUom>>, TError,{data: BodyType<UomInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUom>>, TError,{data: BodyType<UomInput>}, TContext> => {

const mutationKey = ['createUom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUom>>, {data: BodyType<UomInput>}> = (props) => {
          const {data} = props ?? {};

          return  createUom(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUomMutationResult = NonNullable<Awaited<ReturnType<typeof createUom>>>
    export type CreateUomMutationBody = BodyType<UomInput>
    export type CreateUomMutationError = ErrorType<unknown>

    /**
 * @summary Create a unit of measure
 */
export const useCreateUom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUom>>, TError,{data: BodyType<UomInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUom>>,
        TError,
        {data: BodyType<UomInput>},
        TContext
      > => {
      return useMutation(getCreateUomMutationOptions(options));
    }

export const getUpdateUomUrl = (id: number,) => {




  return `/api/catalog/uom/${id}`
}

/**
 * @summary Update a unit of measure
 */
export const updateUom = async (id: number,
    uomUpdate: UomUpdate, options?: RequestInit): Promise<Uom> => {

  return customFetch<Uom>(getUpdateUomUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      uomUpdate,)
  }
);}




export const getUpdateUomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUom>>, TError,{id: number;data: BodyType<UomUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUom>>, TError,{id: number;data: BodyType<UomUpdate>}, TContext> => {

const mutationKey = ['updateUom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUom>>, {id: number;data: BodyType<UomUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUom(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUomMutationResult = NonNullable<Awaited<ReturnType<typeof updateUom>>>
    export type UpdateUomMutationBody = BodyType<UomUpdate>
    export type UpdateUomMutationError = ErrorType<unknown>

    /**
 * @summary Update a unit of measure
 */
export const useUpdateUom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUom>>, TError,{id: number;data: BodyType<UomUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUom>>,
        TError,
        {id: number;data: BodyType<UomUpdate>},
        TContext
      > => {
      return useMutation(getUpdateUomMutationOptions(options));
    }

export const getDeleteUomUrl = (id: number,) => {




  return `/api/catalog/uom/${id}`
}

/**
 * @summary Delete a unit of measure
 */
export const deleteUom = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteUomUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteUomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUom>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteUom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUom>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteUom(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUomMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUom>>>

    export type DeleteUomMutationError = ErrorType<unknown>

    /**
 * @summary Delete a unit of measure
 */
export const useDeleteUom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUom>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteUomMutationOptions(options));
    }

export const getListUomConversionsUrl = (id: number,) => {




  return `/api/catalog/uom/${id}/conversions`
}

/**
 * @summary List conversion factors defined from a given unit
 */
export const listUomConversions = async (id: number, options?: RequestInit): Promise<UomConversion[]> => {

  return customFetch<UomConversion[]>(getListUomConversionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUomConversionsQueryKey = (id: number,) => {
    return [
    `/api/catalog/uom/${id}/conversions`
    ] as const;
    }


export const getListUomConversionsQueryOptions = <TData = Awaited<ReturnType<typeof listUomConversions>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUomConversions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUomConversionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUomConversions>>> = ({ signal }) => listUomConversions(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUomConversions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUomConversionsQueryResult = NonNullable<Awaited<ReturnType<typeof listUomConversions>>>
export type ListUomConversionsQueryError = ErrorType<unknown>


/**
 * @summary List conversion factors defined from a given unit
 */

export function useListUomConversions<TData = Awaited<ReturnType<typeof listUomConversions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUomConversions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUomConversionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateUomConversionUrl = (id: number,) => {




  return `/api/catalog/uom/${id}/conversions`
}

/**
 * @summary Add a conversion factor between two units
 */
export const createUomConversion = async (id: number,
    uomConversionInput: UomConversionInput, options?: RequestInit): Promise<UomConversion> => {

  return customFetch<UomConversion>(getCreateUomConversionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      uomConversionInput,)
  }
);}




export const getCreateUomConversionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUomConversion>>, TError,{id: number;data: BodyType<UomConversionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUomConversion>>, TError,{id: number;data: BodyType<UomConversionInput>}, TContext> => {

const mutationKey = ['createUomConversion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUomConversion>>, {id: number;data: BodyType<UomConversionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createUomConversion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUomConversionMutationResult = NonNullable<Awaited<ReturnType<typeof createUomConversion>>>
    export type CreateUomConversionMutationBody = BodyType<UomConversionInput>
    export type CreateUomConversionMutationError = ErrorType<unknown>

    /**
 * @summary Add a conversion factor between two units
 */
export const useCreateUomConversion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUomConversion>>, TError,{id: number;data: BodyType<UomConversionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUomConversion>>,
        TError,
        {id: number;data: BodyType<UomConversionInput>},
        TContext
      > => {
      return useMutation(getCreateUomConversionMutationOptions(options));
    }

export const getDeleteUomConversionUrl = (id: number,) => {




  return `/api/catalog/uom/conversions/${id}`
}

/**
 * @summary Delete a specific unit conversion
 */
export const deleteUomConversion = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteUomConversionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteUomConversionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUomConversion>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUomConversion>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteUomConversion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUomConversion>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteUomConversion(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUomConversionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUomConversion>>>

    export type DeleteUomConversionMutationError = ErrorType<unknown>

    /**
 * @summary Delete a specific unit conversion
 */
export const useDeleteUomConversion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUomConversion>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUomConversion>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteUomConversionMutationOptions(options));
    }

export const getListProductCategoriesUrl = (params?: ListProductCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalog/categories?${stringifiedParams}` : `/api/catalog/categories`
}

/**
 * @summary List product categories
 */
export const listProductCategories = async (params?: ListProductCategoriesParams, options?: RequestInit): Promise<ProductCategory[]> => {

  return customFetch<ProductCategory[]>(getListProductCategoriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductCategoriesQueryKey = (params?: ListProductCategoriesParams,) => {
    return [
    `/api/catalog/categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listProductCategories>>, TError = ErrorType<unknown>>(params?: ListProductCategoriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProductCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductCategories>>> = ({ signal }) => listProductCategories(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProductCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listProductCategories>>>
export type ListProductCategoriesQueryError = ErrorType<unknown>


/**
 * @summary List product categories
 */

export function useListProductCategories<TData = Awaited<ReturnType<typeof listProductCategories>>, TError = ErrorType<unknown>>(
 params?: ListProductCategoriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProductCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProductCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProductCategoryUrl = () => {




  return `/api/catalog/categories`
}

/**
 * @summary Create a product category
 */
export const createProductCategory = async (productCategoryInput: ProductCategoryInput, options?: RequestInit): Promise<ProductCategory> => {

  return customFetch<ProductCategory>(getCreateProductCategoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productCategoryInput,)
  }
);}




export const getCreateProductCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductCategory>>, TError,{data: BodyType<ProductCategoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductCategory>>, TError,{data: BodyType<ProductCategoryInput>}, TContext> => {

const mutationKey = ['createProductCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductCategory>>, {data: BodyType<ProductCategoryInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProductCategory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createProductCategory>>>
    export type CreateProductCategoryMutationBody = BodyType<ProductCategoryInput>
    export type CreateProductCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Create a product category
 */
export const useCreateProductCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductCategory>>, TError,{data: BodyType<ProductCategoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProductCategory>>,
        TError,
        {data: BodyType<ProductCategoryInput>},
        TContext
      > => {
      return useMutation(getCreateProductCategoryMutationOptions(options));
    }

export const getUpdateProductCategoryUrl = (id: number,) => {




  return `/api/catalog/categories/${id}`
}

/**
 * @summary Update a product category
 */
export const updateProductCategory = async (id: number,
    productCategoryUpdate: ProductCategoryUpdate, options?: RequestInit): Promise<ProductCategory> => {

  return customFetch<ProductCategory>(getUpdateProductCategoryUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productCategoryUpdate,)
  }
);}




export const getUpdateProductCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductCategory>>, TError,{id: number;data: BodyType<ProductCategoryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductCategory>>, TError,{id: number;data: BodyType<ProductCategoryUpdate>}, TContext> => {

const mutationKey = ['updateProductCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductCategory>>, {id: number;data: BodyType<ProductCategoryUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProductCategory(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductCategory>>>
    export type UpdateProductCategoryMutationBody = BodyType<ProductCategoryUpdate>
    export type UpdateProductCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Update a product category
 */
export const useUpdateProductCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductCategory>>, TError,{id: number;data: BodyType<ProductCategoryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProductCategory>>,
        TError,
        {id: number;data: BodyType<ProductCategoryUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProductCategoryMutationOptions(options));
    }

export const getDeleteProductCategoryUrl = (id: number,) => {




  return `/api/catalog/categories/${id}`
}

/**
 * @summary Delete a product category
 */
export const deleteProductCategory = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProductCategoryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductCategory>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteProductCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductCategory>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductCategory(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductCategory>>>

    export type DeleteProductCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Delete a product category
 */
export const useDeleteProductCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductCategory>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteProductCategoryMutationOptions(options));
    }

export const getListProductAttributesUrl = (params?: ListProductAttributesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalog/attributes?${stringifiedParams}` : `/api/catalog/attributes`
}

/**
 * @summary List product attributes
 */
export const listProductAttributes = async (params?: ListProductAttributesParams, options?: RequestInit): Promise<ProductAttribute[]> => {

  return customFetch<ProductAttribute[]>(getListProductAttributesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductAttributesQueryKey = (params?: ListProductAttributesParams,) => {
    return [
    `/api/catalog/attributes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductAttributesQueryOptions = <TData = Awaited<ReturnType<typeof listProductAttributes>>, TError = ErrorType<unknown>>(params?: ListProductAttributesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProductAttributes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductAttributesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductAttributes>>> = ({ signal }) => listProductAttributes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductAttributes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProductAttributesQueryResult = NonNullable<Awaited<ReturnType<typeof listProductAttributes>>>
export type ListProductAttributesQueryError = ErrorType<unknown>


/**
 * @summary List product attributes
 */

export function useListProductAttributes<TData = Awaited<ReturnType<typeof listProductAttributes>>, TError = ErrorType<unknown>>(
 params?: ListProductAttributesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProductAttributes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProductAttributesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProductAttributeUrl = () => {




  return `/api/catalog/attributes`
}

/**
 * @summary Create a product attribute
 */
export const createProductAttribute = async (productAttributeInput: ProductAttributeInput, options?: RequestInit): Promise<ProductAttribute> => {

  return customFetch<ProductAttribute>(getCreateProductAttributeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productAttributeInput,)
  }
);}




export const getCreateProductAttributeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductAttribute>>, TError,{data: BodyType<ProductAttributeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductAttribute>>, TError,{data: BodyType<ProductAttributeInput>}, TContext> => {

const mutationKey = ['createProductAttribute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductAttribute>>, {data: BodyType<ProductAttributeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProductAttribute(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof createProductAttribute>>>
    export type CreateProductAttributeMutationBody = BodyType<ProductAttributeInput>
    export type CreateProductAttributeMutationError = ErrorType<unknown>

    /**
 * @summary Create a product attribute
 */
export const useCreateProductAttribute = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductAttribute>>, TError,{data: BodyType<ProductAttributeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProductAttribute>>,
        TError,
        {data: BodyType<ProductAttributeInput>},
        TContext
      > => {
      return useMutation(getCreateProductAttributeMutationOptions(options));
    }

export const getUpdateProductAttributeUrl = (id: number,) => {




  return `/api/catalog/attributes/${id}`
}

/**
 * @summary Update a product attribute
 */
export const updateProductAttribute = async (id: number,
    productAttributeUpdate: ProductAttributeUpdate, options?: RequestInit): Promise<ProductAttribute> => {

  return customFetch<ProductAttribute>(getUpdateProductAttributeUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productAttributeUpdate,)
  }
);}




export const getUpdateProductAttributeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductAttribute>>, TError,{id: number;data: BodyType<ProductAttributeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductAttribute>>, TError,{id: number;data: BodyType<ProductAttributeUpdate>}, TContext> => {

const mutationKey = ['updateProductAttribute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductAttribute>>, {id: number;data: BodyType<ProductAttributeUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProductAttribute(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductAttribute>>>
    export type UpdateProductAttributeMutationBody = BodyType<ProductAttributeUpdate>
    export type UpdateProductAttributeMutationError = ErrorType<unknown>

    /**
 * @summary Update a product attribute
 */
export const useUpdateProductAttribute = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductAttribute>>, TError,{id: number;data: BodyType<ProductAttributeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProductAttribute>>,
        TError,
        {id: number;data: BodyType<ProductAttributeUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProductAttributeMutationOptions(options));
    }

export const getDeleteProductAttributeUrl = (id: number,) => {




  return `/api/catalog/attributes/${id}`
}

/**
 * @summary Delete a product attribute
 */
export const deleteProductAttribute = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProductAttributeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductAttributeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductAttribute>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductAttribute>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteProductAttribute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductAttribute>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductAttribute(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductAttribute>>>

    export type DeleteProductAttributeMutationError = ErrorType<unknown>

    /**
 * @summary Delete a product attribute
 */
export const useDeleteProductAttribute = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductAttribute>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductAttribute>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteProductAttributeMutationOptions(options));
    }

export const getListProductsUrl = (params?: ListProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalog/products?${stringifiedParams}` : `/api/catalog/products`
}

/**
 * @summary List products and services
 */
export const listProducts = async (params?: ListProductsParams, options?: RequestInit): Promise<Product[]> => {

  return customFetch<Product[]>(getListProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductsQueryKey = (params?: ListProductsParams,) => {
    return [
    `/api/catalog/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(params?: ListProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsQueryError = ErrorType<unknown>


/**
 * @summary List products and services
 */

export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(
 params?: ListProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProductUrl = () => {




  return `/api/catalog/products`
}

/**
 * @summary Create a product or service
 */
export const createProduct = async (productInput: ProductInput, options?: RequestInit): Promise<ProductDetail> => {

  return customFetch<ProductDetail>(getCreateProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productInput,)
  }
);}




export const getCreateProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext> => {

const mutationKey = ['createProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, {data: BodyType<ProductInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = BodyType<ProductInput>
    export type CreateProductMutationError = ErrorType<unknown>

    /**
 * @summary Create a product or service
 */
export const useCreateProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        {data: BodyType<ProductInput>},
        TContext
      > => {
      return useMutation(getCreateProductMutationOptions(options));
    }

export const getExportProductsUrl = () => {




  return `/api/catalog/products/export`
}

/**
 * @summary Export all products as CSV
 */
export const exportProducts = async ( options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportProductsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportProductsQueryKey = () => {
    return [
    `/api/catalog/products/export`
    ] as const;
    }


export const getExportProductsQueryOptions = <TData = Awaited<ReturnType<typeof exportProducts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportProductsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportProducts>>> = ({ signal }) => exportProducts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportProductsQueryResult = NonNullable<Awaited<ReturnType<typeof exportProducts>>>
export type ExportProductsQueryError = ErrorType<unknown>


/**
 * @summary Export all products as CSV
 */

export function useExportProducts<TData = Awaited<ReturnType<typeof exportProducts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportProductsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getImportProductsUrl = () => {




  return `/api/catalog/products/import`
}

/**
 * @summary Bulk import products from CSV (headers: sku,name,type,hsnCode,gstRate,basePrice,categoryCode,uomCode)
 */
export const importProducts = async (importProductsBody: string, options?: RequestInit): Promise<CsvImportResult> => {

  return customFetch<CsvImportResult>(getImportProductsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/csv', ...options?.headers },
    body: JSON.stringify(
      importProductsBody,)
  }
);}




export const getImportProductsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProducts>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importProducts>>, TError,{data: BodyType<string>}, TContext> => {

const mutationKey = ['importProducts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importProducts>>, {data: BodyType<string>}> = (props) => {
          const {data} = props ?? {};

          return  importProducts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportProductsMutationResult = NonNullable<Awaited<ReturnType<typeof importProducts>>>
    export type ImportProductsMutationBody = BodyType<string>
    export type ImportProductsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import products from CSV (headers: sku,name,type,hsnCode,gstRate,basePrice,categoryCode,uomCode)
 */
export const useImportProducts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProducts>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importProducts>>,
        TError,
        {data: BodyType<string>},
        TContext
      > => {
      return useMutation(getImportProductsMutationOptions(options));
    }

export const getGetProductUrl = (id: number,) => {




  return `/api/catalog/products/${id}`
}

/**
 * @summary Get a product with variants and images
 */
export const getProduct = async (id: number, options?: RequestInit): Promise<ProductDetail> => {

  return customFetch<ProductDetail>(getGetProductUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductQueryKey = (id: number,) => {
    return [
    `/api/catalog/products/${id}`
    ] as const;
    }


export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = ErrorType<unknown>


/**
 * @summary Get a product with variants and images
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateProductUrl = (id: number,) => {




  return `/api/catalog/products/${id}`
}

/**
 * @summary Update a product
 */
export const updateProduct = async (id: number,
    productUpdate: ProductUpdate, options?: RequestInit): Promise<ProductDetail> => {

  return customFetch<ProductDetail>(getUpdateProductUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productUpdate,)
  }
);}




export const getUpdateProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<ProductUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<ProductUpdate>}, TContext> => {

const mutationKey = ['updateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProduct>>, {id: number;data: BodyType<ProductUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProduct(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProduct>>>
    export type UpdateProductMutationBody = BodyType<ProductUpdate>
    export type UpdateProductMutationError = ErrorType<unknown>

    /**
 * @summary Update a product
 */
export const useUpdateProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<ProductUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProduct>>,
        TError,
        {id: number;data: BodyType<ProductUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProductMutationOptions(options));
    }

export const getDeleteProductUrl = (id: number,) => {




  return `/api/catalog/products/${id}`
}

/**
 * @summary Delete a product
 */
export const deleteProduct = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProductUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProduct>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteProduct(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProduct>>>

    export type DeleteProductMutationError = ErrorType<unknown>

    /**
 * @summary Delete a product
 */
export const useDeleteProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProduct>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteProductMutationOptions(options));
    }

export const getCreateProductVariantUrl = (id: number,) => {




  return `/api/catalog/products/${id}/variants`
}

/**
 * @summary Add a variant to a product
 */
export const createProductVariant = async (id: number,
    productVariantInput: ProductVariantInput, options?: RequestInit): Promise<ProductVariant> => {

  return customFetch<ProductVariant>(getCreateProductVariantUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productVariantInput,)
  }
);}




export const getCreateProductVariantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductVariant>>, TError,{id: number;data: BodyType<ProductVariantInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductVariant>>, TError,{id: number;data: BodyType<ProductVariantInput>}, TContext> => {

const mutationKey = ['createProductVariant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductVariant>>, {id: number;data: BodyType<ProductVariantInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createProductVariant(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductVariantMutationResult = NonNullable<Awaited<ReturnType<typeof createProductVariant>>>
    export type CreateProductVariantMutationBody = BodyType<ProductVariantInput>
    export type CreateProductVariantMutationError = ErrorType<unknown>

    /**
 * @summary Add a variant to a product
 */
export const useCreateProductVariant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductVariant>>, TError,{id: number;data: BodyType<ProductVariantInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProductVariant>>,
        TError,
        {id: number;data: BodyType<ProductVariantInput>},
        TContext
      > => {
      return useMutation(getCreateProductVariantMutationOptions(options));
    }

export const getUpdateProductVariantUrl = (id: number,
    variantId: number,) => {




  return `/api/catalog/products/${id}/variants/${variantId}`
}

/**
 * @summary Update a product variant
 */
export const updateProductVariant = async (id: number,
    variantId: number,
    productVariantUpdate: ProductVariantUpdate, options?: RequestInit): Promise<ProductVariant> => {

  return customFetch<ProductVariant>(getUpdateProductVariantUrl(id,variantId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productVariantUpdate,)
  }
);}




export const getUpdateProductVariantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductVariant>>, TError,{id: number;variantId: number;data: BodyType<ProductVariantUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductVariant>>, TError,{id: number;variantId: number;data: BodyType<ProductVariantUpdate>}, TContext> => {

const mutationKey = ['updateProductVariant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductVariant>>, {id: number;variantId: number;data: BodyType<ProductVariantUpdate>}> = (props) => {
          const {id,variantId,data} = props ?? {};

          return  updateProductVariant(id,variantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductVariantMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductVariant>>>
    export type UpdateProductVariantMutationBody = BodyType<ProductVariantUpdate>
    export type UpdateProductVariantMutationError = ErrorType<unknown>

    /**
 * @summary Update a product variant
 */
export const useUpdateProductVariant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductVariant>>, TError,{id: number;variantId: number;data: BodyType<ProductVariantUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProductVariant>>,
        TError,
        {id: number;variantId: number;data: BodyType<ProductVariantUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProductVariantMutationOptions(options));
    }

export const getDeleteProductVariantUrl = (id: number,
    variantId: number,) => {




  return `/api/catalog/products/${id}/variants/${variantId}`
}

/**
 * @summary Delete a product variant
 */
export const deleteProductVariant = async (id: number,
    variantId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProductVariantUrl(id,variantId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductVariantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductVariant>>, TError,{id: number;variantId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductVariant>>, TError,{id: number;variantId: number}, TContext> => {

const mutationKey = ['deleteProductVariant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductVariant>>, {id: number;variantId: number}> = (props) => {
          const {id,variantId} = props ?? {};

          return  deleteProductVariant(id,variantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductVariantMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductVariant>>>

    export type DeleteProductVariantMutationError = ErrorType<unknown>

    /**
 * @summary Delete a product variant
 */
export const useDeleteProductVariant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductVariant>>, TError,{id: number;variantId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductVariant>>,
        TError,
        {id: number;variantId: number},
        TContext
      > => {
      return useMutation(getDeleteProductVariantMutationOptions(options));
    }

export const getCreateProductImageUrl = (id: number,) => {




  return `/api/catalog/products/${id}/images`
}

/**
 * @summary Add an image to a product
 */
export const createProductImage = async (id: number,
    productImageInput: ProductImageInput, options?: RequestInit): Promise<ProductImage> => {

  return customFetch<ProductImage>(getCreateProductImageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productImageInput,)
  }
);}




export const getCreateProductImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductImage>>, TError,{id: number;data: BodyType<ProductImageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductImage>>, TError,{id: number;data: BodyType<ProductImageInput>}, TContext> => {

const mutationKey = ['createProductImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductImage>>, {id: number;data: BodyType<ProductImageInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createProductImage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductImageMutationResult = NonNullable<Awaited<ReturnType<typeof createProductImage>>>
    export type CreateProductImageMutationBody = BodyType<ProductImageInput>
    export type CreateProductImageMutationError = ErrorType<unknown>

    /**
 * @summary Add an image to a product
 */
export const useCreateProductImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductImage>>, TError,{id: number;data: BodyType<ProductImageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProductImage>>,
        TError,
        {id: number;data: BodyType<ProductImageInput>},
        TContext
      > => {
      return useMutation(getCreateProductImageMutationOptions(options));
    }

export const getDeleteProductImageUrl = (id: number,
    imageId: number,) => {




  return `/api/catalog/products/${id}/images/${imageId}`
}

/**
 * @summary Remove a product image
 */
export const deleteProductImage = async (id: number,
    imageId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProductImageUrl(id,imageId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductImage>>, TError,{id: number;imageId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductImage>>, TError,{id: number;imageId: number}, TContext> => {

const mutationKey = ['deleteProductImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductImage>>, {id: number;imageId: number}> = (props) => {
          const {id,imageId} = props ?? {};

          return  deleteProductImage(id,imageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductImage>>>

    export type DeleteProductImageMutationError = ErrorType<unknown>

    /**
 * @summary Remove a product image
 */
export const useDeleteProductImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductImage>>, TError,{id: number;imageId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductImage>>,
        TError,
        {id: number;imageId: number},
        TContext
      > => {
      return useMutation(getDeleteProductImageMutationOptions(options));
    }

export const getCreateProductBarcodeUrl = (id: number,) => {




  return `/api/catalog/products/${id}/barcodes`
}

/**
 * @summary Add a barcode to a product
 */
export const createProductBarcode = async (id: number,
    productBarcodeInput: ProductBarcodeInput, options?: RequestInit): Promise<ProductBarcode> => {

  return customFetch<ProductBarcode>(getCreateProductBarcodeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productBarcodeInput,)
  }
);}




export const getCreateProductBarcodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductBarcode>>, TError,{id: number;data: BodyType<ProductBarcodeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductBarcode>>, TError,{id: number;data: BodyType<ProductBarcodeInput>}, TContext> => {

const mutationKey = ['createProductBarcode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductBarcode>>, {id: number;data: BodyType<ProductBarcodeInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createProductBarcode(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductBarcodeMutationResult = NonNullable<Awaited<ReturnType<typeof createProductBarcode>>>
    export type CreateProductBarcodeMutationBody = BodyType<ProductBarcodeInput>
    export type CreateProductBarcodeMutationError = ErrorType<unknown>

    /**
 * @summary Add a barcode to a product
 */
export const useCreateProductBarcode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductBarcode>>, TError,{id: number;data: BodyType<ProductBarcodeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProductBarcode>>,
        TError,
        {id: number;data: BodyType<ProductBarcodeInput>},
        TContext
      > => {
      return useMutation(getCreateProductBarcodeMutationOptions(options));
    }

export const getDeleteProductBarcodeUrl = (id: number,
    barcodeId: number,) => {




  return `/api/catalog/products/${id}/barcodes/${barcodeId}`
}

/**
 * @summary Remove a product barcode
 */
export const deleteProductBarcode = async (id: number,
    barcodeId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProductBarcodeUrl(id,barcodeId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductBarcodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductBarcode>>, TError,{id: number;barcodeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductBarcode>>, TError,{id: number;barcodeId: number}, TContext> => {

const mutationKey = ['deleteProductBarcode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductBarcode>>, {id: number;barcodeId: number}> = (props) => {
          const {id,barcodeId} = props ?? {};

          return  deleteProductBarcode(id,barcodeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductBarcodeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductBarcode>>>

    export type DeleteProductBarcodeMutationError = ErrorType<unknown>

    /**
 * @summary Remove a product barcode
 */
export const useDeleteProductBarcode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductBarcode>>, TError,{id: number;barcodeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductBarcode>>,
        TError,
        {id: number;barcodeId: number},
        TContext
      > => {
      return useMutation(getDeleteProductBarcodeMutationOptions(options));
    }

export const getListPriceTiersUrl = (itemId: number,) => {




  return `/api/catalog/price-list-items/${itemId}/tiers`
}

/**
 * @summary List price tiers for a price list item
 */
export const listPriceTiers = async (itemId: number, options?: RequestInit): Promise<PriceTier[]> => {

  return customFetch<PriceTier[]>(getListPriceTiersUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPriceTiersQueryKey = (itemId: number,) => {
    return [
    `/api/catalog/price-list-items/${itemId}/tiers`
    ] as const;
    }


export const getListPriceTiersQueryOptions = <TData = Awaited<ReturnType<typeof listPriceTiers>>, TError = ErrorType<unknown>>(itemId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPriceTiers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPriceTiersQueryKey(itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPriceTiers>>> = ({ signal }) => listPriceTiers(itemId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPriceTiers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPriceTiersQueryResult = NonNullable<Awaited<ReturnType<typeof listPriceTiers>>>
export type ListPriceTiersQueryError = ErrorType<unknown>


/**
 * @summary List price tiers for a price list item
 */

export function useListPriceTiers<TData = Awaited<ReturnType<typeof listPriceTiers>>, TError = ErrorType<unknown>>(
 itemId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPriceTiers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPriceTiersQueryOptions(itemId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePriceTierUrl = (itemId: number,) => {




  return `/api/catalog/price-list-items/${itemId}/tiers`
}

/**
 * @summary Add a quantity-based price tier to a price list item
 */
export const createPriceTier = async (itemId: number,
    priceTierInput: PriceTierInput, options?: RequestInit): Promise<PriceTier> => {

  return customFetch<PriceTier>(getCreatePriceTierUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      priceTierInput,)
  }
);}




export const getCreatePriceTierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceTier>>, TError,{itemId: number;data: BodyType<PriceTierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPriceTier>>, TError,{itemId: number;data: BodyType<PriceTierInput>}, TContext> => {

const mutationKey = ['createPriceTier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPriceTier>>, {itemId: number;data: BodyType<PriceTierInput>}> = (props) => {
          const {itemId,data} = props ?? {};

          return  createPriceTier(itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePriceTierMutationResult = NonNullable<Awaited<ReturnType<typeof createPriceTier>>>
    export type CreatePriceTierMutationBody = BodyType<PriceTierInput>
    export type CreatePriceTierMutationError = ErrorType<unknown>

    /**
 * @summary Add a quantity-based price tier to a price list item
 */
export const useCreatePriceTier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceTier>>, TError,{itemId: number;data: BodyType<PriceTierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPriceTier>>,
        TError,
        {itemId: number;data: BodyType<PriceTierInput>},
        TContext
      > => {
      return useMutation(getCreatePriceTierMutationOptions(options));
    }

export const getDeletePriceTierUrl = (id: number,) => {




  return `/api/catalog/price-tiers/${id}`
}

/**
 * @summary Delete a price tier
 */
export const deletePriceTier = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePriceTierUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePriceTierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceTier>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePriceTier>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePriceTier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePriceTier>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePriceTier(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePriceTierMutationResult = NonNullable<Awaited<ReturnType<typeof deletePriceTier>>>

    export type DeletePriceTierMutationError = ErrorType<unknown>

    /**
 * @summary Delete a price tier
 */
export const useDeletePriceTier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceTier>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePriceTier>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePriceTierMutationOptions(options));
    }

export const getListPriceListsUrl = () => {




  return `/api/catalog/price-lists`
}

/**
 * @summary List price lists
 */
export const listPriceLists = async ( options?: RequestInit): Promise<PriceList[]> => {

  return customFetch<PriceList[]>(getListPriceListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPriceListsQueryKey = () => {
    return [
    `/api/catalog/price-lists`
    ] as const;
    }


export const getListPriceListsQueryOptions = <TData = Awaited<ReturnType<typeof listPriceLists>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPriceListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPriceLists>>> = ({ signal }) => listPriceLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPriceListsQueryResult = NonNullable<Awaited<ReturnType<typeof listPriceLists>>>
export type ListPriceListsQueryError = ErrorType<unknown>


/**
 * @summary List price lists
 */

export function useListPriceLists<TData = Awaited<ReturnType<typeof listPriceLists>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPriceListsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePriceListUrl = () => {




  return `/api/catalog/price-lists`
}

/**
 * @summary Create a price list
 */
export const createPriceList = async (priceListInput: PriceListInput, options?: RequestInit): Promise<PriceList> => {

  return customFetch<PriceList>(getCreatePriceListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      priceListInput,)
  }
);}




export const getCreatePriceListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceList>>, TError,{data: BodyType<PriceListInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPriceList>>, TError,{data: BodyType<PriceListInput>}, TContext> => {

const mutationKey = ['createPriceList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPriceList>>, {data: BodyType<PriceListInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPriceList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof createPriceList>>>
    export type CreatePriceListMutationBody = BodyType<PriceListInput>
    export type CreatePriceListMutationError = ErrorType<unknown>

    /**
 * @summary Create a price list
 */
export const useCreatePriceList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceList>>, TError,{data: BodyType<PriceListInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPriceList>>,
        TError,
        {data: BodyType<PriceListInput>},
        TContext
      > => {
      return useMutation(getCreatePriceListMutationOptions(options));
    }

export const getUpdatePriceListUrl = (id: number,) => {




  return `/api/catalog/price-lists/${id}`
}

/**
 * @summary Update a price list
 */
export const updatePriceList = async (id: number,
    priceListUpdate: PriceListUpdate, options?: RequestInit): Promise<PriceList> => {

  return customFetch<PriceList>(getUpdatePriceListUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      priceListUpdate,)
  }
);}




export const getUpdatePriceListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceList>>, TError,{id: number;data: BodyType<PriceListUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePriceList>>, TError,{id: number;data: BodyType<PriceListUpdate>}, TContext> => {

const mutationKey = ['updatePriceList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePriceList>>, {id: number;data: BodyType<PriceListUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePriceList(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof updatePriceList>>>
    export type UpdatePriceListMutationBody = BodyType<PriceListUpdate>
    export type UpdatePriceListMutationError = ErrorType<unknown>

    /**
 * @summary Update a price list
 */
export const useUpdatePriceList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceList>>, TError,{id: number;data: BodyType<PriceListUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePriceList>>,
        TError,
        {id: number;data: BodyType<PriceListUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePriceListMutationOptions(options));
    }

export const getDeletePriceListUrl = (id: number,) => {




  return `/api/catalog/price-lists/${id}`
}

/**
 * @summary Delete a price list
 */
export const deletePriceList = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePriceListUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePriceListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceList>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePriceList>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePriceList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePriceList>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePriceList(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof deletePriceList>>>

    export type DeletePriceListMutationError = ErrorType<unknown>

    /**
 * @summary Delete a price list
 */
export const useDeletePriceList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceList>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePriceList>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePriceListMutationOptions(options));
    }

export const getListPriceListItemsUrl = (id: number,) => {




  return `/api/catalog/price-lists/${id}/items`
}

/**
 * @summary List items in a price list
 */
export const listPriceListItems = async (id: number, options?: RequestInit): Promise<PriceListItem[]> => {

  return customFetch<PriceListItem[]>(getListPriceListItemsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPriceListItemsQueryKey = (id: number,) => {
    return [
    `/api/catalog/price-lists/${id}/items`
    ] as const;
    }


export const getListPriceListItemsQueryOptions = <TData = Awaited<ReturnType<typeof listPriceListItems>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPriceListItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPriceListItemsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPriceListItems>>> = ({ signal }) => listPriceListItems(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPriceListItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPriceListItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listPriceListItems>>>
export type ListPriceListItemsQueryError = ErrorType<unknown>


/**
 * @summary List items in a price list
 */

export function useListPriceListItems<TData = Awaited<ReturnType<typeof listPriceListItems>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPriceListItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPriceListItemsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePriceListItemUrl = (id: number,) => {




  return `/api/catalog/price-lists/${id}/items`
}

/**
 * @summary Set price for a product in a price list
 */
export const createPriceListItem = async (id: number,
    priceListItemInput: PriceListItemInput, options?: RequestInit): Promise<PriceListItem> => {

  return customFetch<PriceListItem>(getCreatePriceListItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      priceListItemInput,)
  }
);}




export const getCreatePriceListItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceListItem>>, TError,{id: number;data: BodyType<PriceListItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPriceListItem>>, TError,{id: number;data: BodyType<PriceListItemInput>}, TContext> => {

const mutationKey = ['createPriceListItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPriceListItem>>, {id: number;data: BodyType<PriceListItemInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createPriceListItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePriceListItemMutationResult = NonNullable<Awaited<ReturnType<typeof createPriceListItem>>>
    export type CreatePriceListItemMutationBody = BodyType<PriceListItemInput>
    export type CreatePriceListItemMutationError = ErrorType<unknown>

    /**
 * @summary Set price for a product in a price list
 */
export const useCreatePriceListItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceListItem>>, TError,{id: number;data: BodyType<PriceListItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPriceListItem>>,
        TError,
        {id: number;data: BodyType<PriceListItemInput>},
        TContext
      > => {
      return useMutation(getCreatePriceListItemMutationOptions(options));
    }

export const getUpdatePriceListItemUrl = (id: number,
    itemId: number,) => {




  return `/api/catalog/price-lists/${id}/items/${itemId}`
}

/**
 * @summary Update a price list item
 */
export const updatePriceListItem = async (id: number,
    itemId: number,
    priceListItemUpdate: PriceListItemUpdate, options?: RequestInit): Promise<PriceListItem> => {

  return customFetch<PriceListItem>(getUpdatePriceListItemUrl(id,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      priceListItemUpdate,)
  }
);}




export const getUpdatePriceListItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceListItem>>, TError,{id: number;itemId: number;data: BodyType<PriceListItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePriceListItem>>, TError,{id: number;itemId: number;data: BodyType<PriceListItemUpdate>}, TContext> => {

const mutationKey = ['updatePriceListItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePriceListItem>>, {id: number;itemId: number;data: BodyType<PriceListItemUpdate>}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  updatePriceListItem(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePriceListItemMutationResult = NonNullable<Awaited<ReturnType<typeof updatePriceListItem>>>
    export type UpdatePriceListItemMutationBody = BodyType<PriceListItemUpdate>
    export type UpdatePriceListItemMutationError = ErrorType<unknown>

    /**
 * @summary Update a price list item
 */
export const useUpdatePriceListItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceListItem>>, TError,{id: number;itemId: number;data: BodyType<PriceListItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePriceListItem>>,
        TError,
        {id: number;itemId: number;data: BodyType<PriceListItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePriceListItemMutationOptions(options));
    }

export const getDeletePriceListItemUrl = (id: number,
    itemId: number,) => {




  return `/api/catalog/price-lists/${id}/items/${itemId}`
}

/**
 * @summary Remove a product from a price list
 */
export const deletePriceListItem = async (id: number,
    itemId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePriceListItemUrl(id,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePriceListItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceListItem>>, TError,{id: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePriceListItem>>, TError,{id: number;itemId: number}, TContext> => {

const mutationKey = ['deletePriceListItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePriceListItem>>, {id: number;itemId: number}> = (props) => {
          const {id,itemId} = props ?? {};

          return  deletePriceListItem(id,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePriceListItemMutationResult = NonNullable<Awaited<ReturnType<typeof deletePriceListItem>>>

    export type DeletePriceListItemMutationError = ErrorType<unknown>

    /**
 * @summary Remove a product from a price list
 */
export const useDeletePriceListItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceListItem>>, TError,{id: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePriceListItem>>,
        TError,
        {id: number;itemId: number},
        TContext
      > => {
      return useMutation(getDeletePriceListItemMutationOptions(options));
    }

export const getListCustomerProductPricingUrl = (params?: ListCustomerProductPricingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalog/customer-pricing?${stringifiedParams}` : `/api/catalog/customer-pricing`
}

/**
 * @summary List customer-specific pricing
 */
export const listCustomerProductPricing = async (params?: ListCustomerProductPricingParams, options?: RequestInit): Promise<CustomerProductPricing[]> => {

  return customFetch<CustomerProductPricing[]>(getListCustomerProductPricingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerProductPricingQueryKey = (params?: ListCustomerProductPricingParams,) => {
    return [
    `/api/catalog/customer-pricing`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerProductPricingQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerProductPricing>>, TError = ErrorType<unknown>>(params?: ListCustomerProductPricingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerProductPricing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerProductPricingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerProductPricing>>> = ({ signal }) => listCustomerProductPricing(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerProductPricing>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerProductPricingQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerProductPricing>>>
export type ListCustomerProductPricingQueryError = ErrorType<unknown>


/**
 * @summary List customer-specific pricing
 */

export function useListCustomerProductPricing<TData = Awaited<ReturnType<typeof listCustomerProductPricing>>, TError = ErrorType<unknown>>(
 params?: ListCustomerProductPricingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerProductPricing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerProductPricingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCustomerProductPricingUrl = () => {




  return `/api/catalog/customer-pricing`
}

/**
 * @summary Set customer-specific price for a product
 */
export const createCustomerProductPricing = async (customerProductPricingInput: CustomerProductPricingInput, options?: RequestInit): Promise<CustomerProductPricing> => {

  return customFetch<CustomerProductPricing>(getCreateCustomerProductPricingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerProductPricingInput,)
  }
);}




export const getCreateCustomerProductPricingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerProductPricing>>, TError,{data: BodyType<CustomerProductPricingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomerProductPricing>>, TError,{data: BodyType<CustomerProductPricingInput>}, TContext> => {

const mutationKey = ['createCustomerProductPricing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomerProductPricing>>, {data: BodyType<CustomerProductPricingInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomerProductPricing(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerProductPricingMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomerProductPricing>>>
    export type CreateCustomerProductPricingMutationBody = BodyType<CustomerProductPricingInput>
    export type CreateCustomerProductPricingMutationError = ErrorType<unknown>

    /**
 * @summary Set customer-specific price for a product
 */
export const useCreateCustomerProductPricing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerProductPricing>>, TError,{data: BodyType<CustomerProductPricingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomerProductPricing>>,
        TError,
        {data: BodyType<CustomerProductPricingInput>},
        TContext
      > => {
      return useMutation(getCreateCustomerProductPricingMutationOptions(options));
    }

export const getDeleteCustomerProductPricingUrl = (id: number,) => {




  return `/api/catalog/customer-pricing/${id}`
}

/**
 * @summary Remove customer-specific pricing
 */
export const deleteCustomerProductPricing = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomerProductPricingUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCustomerProductPricingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerProductPricing>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerProductPricing>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCustomerProductPricing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerProductPricing>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomerProductPricing(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerProductPricingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerProductPricing>>>

    export type DeleteCustomerProductPricingMutationError = ErrorType<unknown>

    /**
 * @summary Remove customer-specific pricing
 */
export const useDeleteCustomerProductPricing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerProductPricing>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerProductPricing>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCustomerProductPricingMutationOptions(options));
    }

export const getListDiscountRulesUrl = () => {




  return `/api/catalog/discount-rules`
}

/**
 * @summary List discount rules
 */
export const listDiscountRules = async ( options?: RequestInit): Promise<DiscountRule[]> => {

  return customFetch<DiscountRule[]>(getListDiscountRulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDiscountRulesQueryKey = () => {
    return [
    `/api/catalog/discount-rules`
    ] as const;
    }


export const getListDiscountRulesQueryOptions = <TData = Awaited<ReturnType<typeof listDiscountRules>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDiscountRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDiscountRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDiscountRules>>> = ({ signal }) => listDiscountRules({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDiscountRules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDiscountRulesQueryResult = NonNullable<Awaited<ReturnType<typeof listDiscountRules>>>
export type ListDiscountRulesQueryError = ErrorType<unknown>


/**
 * @summary List discount rules
 */

export function useListDiscountRules<TData = Awaited<ReturnType<typeof listDiscountRules>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDiscountRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDiscountRulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateDiscountRuleUrl = () => {




  return `/api/catalog/discount-rules`
}

/**
 * @summary Create a discount rule
 */
export const createDiscountRule = async (discountRuleInput: DiscountRuleInput, options?: RequestInit): Promise<DiscountRule> => {

  return customFetch<DiscountRule>(getCreateDiscountRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      discountRuleInput,)
  }
);}




export const getCreateDiscountRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDiscountRule>>, TError,{data: BodyType<DiscountRuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDiscountRule>>, TError,{data: BodyType<DiscountRuleInput>}, TContext> => {

const mutationKey = ['createDiscountRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDiscountRule>>, {data: BodyType<DiscountRuleInput>}> = (props) => {
          const {data} = props ?? {};

          return  createDiscountRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDiscountRuleMutationResult = NonNullable<Awaited<ReturnType<typeof createDiscountRule>>>
    export type CreateDiscountRuleMutationBody = BodyType<DiscountRuleInput>
    export type CreateDiscountRuleMutationError = ErrorType<unknown>

    /**
 * @summary Create a discount rule
 */
export const useCreateDiscountRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDiscountRule>>, TError,{data: BodyType<DiscountRuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDiscountRule>>,
        TError,
        {data: BodyType<DiscountRuleInput>},
        TContext
      > => {
      return useMutation(getCreateDiscountRuleMutationOptions(options));
    }

export const getUpdateDiscountRuleUrl = (id: number,) => {




  return `/api/catalog/discount-rules/${id}`
}

/**
 * @summary Update a discount rule
 */
export const updateDiscountRule = async (id: number,
    discountRuleUpdate: DiscountRuleUpdate, options?: RequestInit): Promise<DiscountRule> => {

  return customFetch<DiscountRule>(getUpdateDiscountRuleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      discountRuleUpdate,)
  }
);}




export const getUpdateDiscountRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDiscountRule>>, TError,{id: number;data: BodyType<DiscountRuleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDiscountRule>>, TError,{id: number;data: BodyType<DiscountRuleUpdate>}, TContext> => {

const mutationKey = ['updateDiscountRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDiscountRule>>, {id: number;data: BodyType<DiscountRuleUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDiscountRule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDiscountRuleMutationResult = NonNullable<Awaited<ReturnType<typeof updateDiscountRule>>>
    export type UpdateDiscountRuleMutationBody = BodyType<DiscountRuleUpdate>
    export type UpdateDiscountRuleMutationError = ErrorType<unknown>

    /**
 * @summary Update a discount rule
 */
export const useUpdateDiscountRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDiscountRule>>, TError,{id: number;data: BodyType<DiscountRuleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDiscountRule>>,
        TError,
        {id: number;data: BodyType<DiscountRuleUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDiscountRuleMutationOptions(options));
    }

export const getDeleteDiscountRuleUrl = (id: number,) => {




  return `/api/catalog/discount-rules/${id}`
}

/**
 * @summary Delete a discount rule
 */
export const deleteDiscountRule = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteDiscountRuleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDiscountRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDiscountRule>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDiscountRule>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDiscountRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDiscountRule>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDiscountRule(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDiscountRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDiscountRule>>>

    export type DeleteDiscountRuleMutationError = ErrorType<unknown>

    /**
 * @summary Delete a discount rule
 */
export const useDeleteDiscountRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDiscountRule>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDiscountRule>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteDiscountRuleMutationOptions(options));
    }

export const getGetPayrollConfigUrl = () => {




  return `/api/payroll/config`
}

/**
 * @summary Get company payroll statutory config
 */
export const getPayrollConfig = async ( options?: RequestInit): Promise<PayrollConfig> => {

  return customFetch<PayrollConfig>(getGetPayrollConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPayrollConfigQueryKey = () => {
    return [
    `/api/payroll/config`
    ] as const;
    }


export const getGetPayrollConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPayrollConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollConfig>>> = ({ signal }) => getPayrollConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPayrollConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollConfig>>>
export type GetPayrollConfigQueryError = ErrorType<unknown>


/**
 * @summary Get company payroll statutory config
 */

export function useGetPayrollConfig<TData = Awaited<ReturnType<typeof getPayrollConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPayrollConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPayrollConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePayrollConfigUrl = () => {




  return `/api/payroll/config`
}

/**
 * @summary Upsert payroll statutory configuration
 */
export const updatePayrollConfig = async (payrollConfigUpdate: PayrollConfigUpdate, options?: RequestInit): Promise<PayrollConfig> => {

  return customFetch<PayrollConfig>(getUpdatePayrollConfigUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      payrollConfigUpdate,)
  }
);}




export const getUpdatePayrollConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayrollConfig>>, TError,{data: BodyType<PayrollConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePayrollConfig>>, TError,{data: BodyType<PayrollConfigUpdate>}, TContext> => {

const mutationKey = ['updatePayrollConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePayrollConfig>>, {data: BodyType<PayrollConfigUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updatePayrollConfig(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePayrollConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayrollConfig>>>
    export type UpdatePayrollConfigMutationBody = BodyType<PayrollConfigUpdate>
    export type UpdatePayrollConfigMutationError = ErrorType<unknown>

    /**
 * @summary Upsert payroll statutory configuration
 */
export const useUpdatePayrollConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayrollConfig>>, TError,{data: BodyType<PayrollConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePayrollConfig>>,
        TError,
        {data: BodyType<PayrollConfigUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePayrollConfigMutationOptions(options));
    }

export const getListPtStateSlabsUrl = () => {




  return `/api/payroll/config/pt-slabs`
}

/**
 * @summary List Professional Tax slabs
 */
export const listPtStateSlabs = async ( options?: RequestInit): Promise<PtStateSlab[]> => {

  return customFetch<PtStateSlab[]>(getListPtStateSlabsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPtStateSlabsQueryKey = () => {
    return [
    `/api/payroll/config/pt-slabs`
    ] as const;
    }


export const getListPtStateSlabsQueryOptions = <TData = Awaited<ReturnType<typeof listPtStateSlabs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPtStateSlabs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPtStateSlabsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPtStateSlabs>>> = ({ signal }) => listPtStateSlabs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPtStateSlabs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPtStateSlabsQueryResult = NonNullable<Awaited<ReturnType<typeof listPtStateSlabs>>>
export type ListPtStateSlabsQueryError = ErrorType<unknown>


/**
 * @summary List Professional Tax slabs
 */

export function useListPtStateSlabs<TData = Awaited<ReturnType<typeof listPtStateSlabs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPtStateSlabs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPtStateSlabsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePtStateSlabUrl = () => {




  return `/api/payroll/config/pt-slabs`
}

/**
 * @summary Create PT slab
 */
export const createPtStateSlab = async (ptStateSlabInput: PtStateSlabInput, options?: RequestInit): Promise<PtStateSlab> => {

  return customFetch<PtStateSlab>(getCreatePtStateSlabUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ptStateSlabInput,)
  }
);}




export const getCreatePtStateSlabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPtStateSlab>>, TError,{data: BodyType<PtStateSlabInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPtStateSlab>>, TError,{data: BodyType<PtStateSlabInput>}, TContext> => {

const mutationKey = ['createPtStateSlab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPtStateSlab>>, {data: BodyType<PtStateSlabInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPtStateSlab(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePtStateSlabMutationResult = NonNullable<Awaited<ReturnType<typeof createPtStateSlab>>>
    export type CreatePtStateSlabMutationBody = BodyType<PtStateSlabInput>
    export type CreatePtStateSlabMutationError = ErrorType<unknown>

    /**
 * @summary Create PT slab
 */
export const useCreatePtStateSlab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPtStateSlab>>, TError,{data: BodyType<PtStateSlabInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPtStateSlab>>,
        TError,
        {data: BodyType<PtStateSlabInput>},
        TContext
      > => {
      return useMutation(getCreatePtStateSlabMutationOptions(options));
    }

export const getUpdatePtStateSlabUrl = (id: number,) => {




  return `/api/payroll/config/pt-slabs/${id}`
}

/**
 * @summary Update PT slab
 */
export const updatePtStateSlab = async (id: number,
    ptStateSlabInput: PtStateSlabInput, options?: RequestInit): Promise<PtStateSlab> => {

  return customFetch<PtStateSlab>(getUpdatePtStateSlabUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ptStateSlabInput,)
  }
);}




export const getUpdatePtStateSlabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePtStateSlab>>, TError,{id: number;data: BodyType<PtStateSlabInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePtStateSlab>>, TError,{id: number;data: BodyType<PtStateSlabInput>}, TContext> => {

const mutationKey = ['updatePtStateSlab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePtStateSlab>>, {id: number;data: BodyType<PtStateSlabInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePtStateSlab(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePtStateSlabMutationResult = NonNullable<Awaited<ReturnType<typeof updatePtStateSlab>>>
    export type UpdatePtStateSlabMutationBody = BodyType<PtStateSlabInput>
    export type UpdatePtStateSlabMutationError = ErrorType<unknown>

    /**
 * @summary Update PT slab
 */
export const useUpdatePtStateSlab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePtStateSlab>>, TError,{id: number;data: BodyType<PtStateSlabInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePtStateSlab>>,
        TError,
        {id: number;data: BodyType<PtStateSlabInput>},
        TContext
      > => {
      return useMutation(getUpdatePtStateSlabMutationOptions(options));
    }

export const getDeletePtStateSlabUrl = (id: number,) => {




  return `/api/payroll/config/pt-slabs/${id}`
}

/**
 * @summary Delete PT slab
 */
export const deletePtStateSlab = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePtStateSlabUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePtStateSlabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePtStateSlab>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePtStateSlab>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePtStateSlab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePtStateSlab>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePtStateSlab(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePtStateSlabMutationResult = NonNullable<Awaited<ReturnType<typeof deletePtStateSlab>>>

    export type DeletePtStateSlabMutationError = ErrorType<unknown>

    /**
 * @summary Delete PT slab
 */
export const useDeletePtStateSlab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePtStateSlab>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePtStateSlab>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePtStateSlabMutationOptions(options));
    }

export const getListSalaryComponentsUrl = () => {




  return `/api/payroll/salary-components`
}

/**
 * @summary List salary components
 */
export const listSalaryComponents = async ( options?: RequestInit): Promise<SalaryComponent[]> => {

  return customFetch<SalaryComponent[]>(getListSalaryComponentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalaryComponentsQueryKey = () => {
    return [
    `/api/payroll/salary-components`
    ] as const;
    }


export const getListSalaryComponentsQueryOptions = <TData = Awaited<ReturnType<typeof listSalaryComponents>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalaryComponents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalaryComponentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalaryComponents>>> = ({ signal }) => listSalaryComponents({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalaryComponents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalaryComponentsQueryResult = NonNullable<Awaited<ReturnType<typeof listSalaryComponents>>>
export type ListSalaryComponentsQueryError = ErrorType<unknown>


/**
 * @summary List salary components
 */

export function useListSalaryComponents<TData = Awaited<ReturnType<typeof listSalaryComponents>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalaryComponents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalaryComponentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSalaryComponentUrl = () => {




  return `/api/payroll/salary-components`
}

/**
 * @summary Create salary component
 */
export const createSalaryComponent = async (salaryComponentInput: SalaryComponentInput, options?: RequestInit): Promise<SalaryComponent> => {

  return customFetch<SalaryComponent>(getCreateSalaryComponentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salaryComponentInput,)
  }
);}




export const getCreateSalaryComponentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalaryComponent>>, TError,{data: BodyType<SalaryComponentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSalaryComponent>>, TError,{data: BodyType<SalaryComponentInput>}, TContext> => {

const mutationKey = ['createSalaryComponent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSalaryComponent>>, {data: BodyType<SalaryComponentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSalaryComponent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSalaryComponentMutationResult = NonNullable<Awaited<ReturnType<typeof createSalaryComponent>>>
    export type CreateSalaryComponentMutationBody = BodyType<SalaryComponentInput>
    export type CreateSalaryComponentMutationError = ErrorType<unknown>

    /**
 * @summary Create salary component
 */
export const useCreateSalaryComponent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalaryComponent>>, TError,{data: BodyType<SalaryComponentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSalaryComponent>>,
        TError,
        {data: BodyType<SalaryComponentInput>},
        TContext
      > => {
      return useMutation(getCreateSalaryComponentMutationOptions(options));
    }

export const getUpdateSalaryComponentUrl = (id: number,) => {




  return `/api/payroll/salary-components/${id}`
}

/**
 * @summary Update salary component
 */
export const updateSalaryComponent = async (id: number,
    salaryComponentUpdate: SalaryComponentUpdate, options?: RequestInit): Promise<SalaryComponent> => {

  return customFetch<SalaryComponent>(getUpdateSalaryComponentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salaryComponentUpdate,)
  }
);}




export const getUpdateSalaryComponentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalaryComponent>>, TError,{id: number;data: BodyType<SalaryComponentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSalaryComponent>>, TError,{id: number;data: BodyType<SalaryComponentUpdate>}, TContext> => {

const mutationKey = ['updateSalaryComponent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSalaryComponent>>, {id: number;data: BodyType<SalaryComponentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSalaryComponent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSalaryComponentMutationResult = NonNullable<Awaited<ReturnType<typeof updateSalaryComponent>>>
    export type UpdateSalaryComponentMutationBody = BodyType<SalaryComponentUpdate>
    export type UpdateSalaryComponentMutationError = ErrorType<unknown>

    /**
 * @summary Update salary component
 */
export const useUpdateSalaryComponent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalaryComponent>>, TError,{id: number;data: BodyType<SalaryComponentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSalaryComponent>>,
        TError,
        {id: number;data: BodyType<SalaryComponentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSalaryComponentMutationOptions(options));
    }

export const getDeleteSalaryComponentUrl = (id: number,) => {




  return `/api/payroll/salary-components/${id}`
}

/**
 * @summary Delete salary component
 */
export const deleteSalaryComponent = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSalaryComponentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSalaryComponentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSalaryComponent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSalaryComponent>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSalaryComponent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSalaryComponent>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSalaryComponent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSalaryComponentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSalaryComponent>>>

    export type DeleteSalaryComponentMutationError = ErrorType<unknown>

    /**
 * @summary Delete salary component
 */
export const useDeleteSalaryComponent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSalaryComponent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSalaryComponent>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSalaryComponentMutationOptions(options));
    }

export const getListSalaryStructuresUrl = () => {




  return `/api/payroll/salary-structures`
}

/**
 * @summary List salary structures
 */
export const listSalaryStructures = async ( options?: RequestInit): Promise<SalaryStructure[]> => {

  return customFetch<SalaryStructure[]>(getListSalaryStructuresUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalaryStructuresQueryKey = () => {
    return [
    `/api/payroll/salary-structures`
    ] as const;
    }


export const getListSalaryStructuresQueryOptions = <TData = Awaited<ReturnType<typeof listSalaryStructures>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalaryStructures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalaryStructuresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalaryStructures>>> = ({ signal }) => listSalaryStructures({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalaryStructures>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalaryStructuresQueryResult = NonNullable<Awaited<ReturnType<typeof listSalaryStructures>>>
export type ListSalaryStructuresQueryError = ErrorType<unknown>


/**
 * @summary List salary structures
 */

export function useListSalaryStructures<TData = Awaited<ReturnType<typeof listSalaryStructures>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalaryStructures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalaryStructuresQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSalaryStructureUrl = () => {




  return `/api/payroll/salary-structures`
}

/**
 * @summary Create salary structure
 */
export const createSalaryStructure = async (salaryStructureInput: SalaryStructureInput, options?: RequestInit): Promise<SalaryStructure> => {

  return customFetch<SalaryStructure>(getCreateSalaryStructureUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salaryStructureInput,)
  }
);}




export const getCreateSalaryStructureMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalaryStructure>>, TError,{data: BodyType<SalaryStructureInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSalaryStructure>>, TError,{data: BodyType<SalaryStructureInput>}, TContext> => {

const mutationKey = ['createSalaryStructure'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSalaryStructure>>, {data: BodyType<SalaryStructureInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSalaryStructure(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSalaryStructureMutationResult = NonNullable<Awaited<ReturnType<typeof createSalaryStructure>>>
    export type CreateSalaryStructureMutationBody = BodyType<SalaryStructureInput>
    export type CreateSalaryStructureMutationError = ErrorType<unknown>

    /**
 * @summary Create salary structure
 */
export const useCreateSalaryStructure = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalaryStructure>>, TError,{data: BodyType<SalaryStructureInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSalaryStructure>>,
        TError,
        {data: BodyType<SalaryStructureInput>},
        TContext
      > => {
      return useMutation(getCreateSalaryStructureMutationOptions(options));
    }

export const getUpdateSalaryStructureUrl = (id: number,) => {




  return `/api/payroll/salary-structures/${id}`
}

/**
 * @summary Update salary structure
 */
export const updateSalaryStructure = async (id: number,
    salaryStructureUpdate: SalaryStructureUpdate, options?: RequestInit): Promise<SalaryStructure> => {

  return customFetch<SalaryStructure>(getUpdateSalaryStructureUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salaryStructureUpdate,)
  }
);}




export const getUpdateSalaryStructureMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalaryStructure>>, TError,{id: number;data: BodyType<SalaryStructureUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSalaryStructure>>, TError,{id: number;data: BodyType<SalaryStructureUpdate>}, TContext> => {

const mutationKey = ['updateSalaryStructure'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSalaryStructure>>, {id: number;data: BodyType<SalaryStructureUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSalaryStructure(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSalaryStructureMutationResult = NonNullable<Awaited<ReturnType<typeof updateSalaryStructure>>>
    export type UpdateSalaryStructureMutationBody = BodyType<SalaryStructureUpdate>
    export type UpdateSalaryStructureMutationError = ErrorType<unknown>

    /**
 * @summary Update salary structure
 */
export const useUpdateSalaryStructure = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalaryStructure>>, TError,{id: number;data: BodyType<SalaryStructureUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSalaryStructure>>,
        TError,
        {id: number;data: BodyType<SalaryStructureUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSalaryStructureMutationOptions(options));
    }

export const getDeleteSalaryStructureUrl = (id: number,) => {




  return `/api/payroll/salary-structures/${id}`
}

/**
 * @summary Delete salary structure
 */
export const deleteSalaryStructure = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSalaryStructureUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSalaryStructureMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSalaryStructure>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSalaryStructure>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSalaryStructure'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSalaryStructure>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSalaryStructure(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSalaryStructureMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSalaryStructure>>>

    export type DeleteSalaryStructureMutationError = ErrorType<unknown>

    /**
 * @summary Delete salary structure
 */
export const useDeleteSalaryStructure = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSalaryStructure>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSalaryStructure>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSalaryStructureMutationOptions(options));
    }

export const getListSalaryStructureItemsUrl = (id: number,) => {




  return `/api/payroll/salary-structures/${id}/items`
}

/**
 * @summary List components in a salary structure
 */
export const listSalaryStructureItems = async (id: number, options?: RequestInit): Promise<SalaryStructureItem[]> => {

  return customFetch<SalaryStructureItem[]>(getListSalaryStructureItemsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalaryStructureItemsQueryKey = (id: number,) => {
    return [
    `/api/payroll/salary-structures/${id}/items`
    ] as const;
    }


export const getListSalaryStructureItemsQueryOptions = <TData = Awaited<ReturnType<typeof listSalaryStructureItems>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalaryStructureItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalaryStructureItemsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalaryStructureItems>>> = ({ signal }) => listSalaryStructureItems(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalaryStructureItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalaryStructureItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listSalaryStructureItems>>>
export type ListSalaryStructureItemsQueryError = ErrorType<unknown>


/**
 * @summary List components in a salary structure
 */

export function useListSalaryStructureItems<TData = Awaited<ReturnType<typeof listSalaryStructureItems>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalaryStructureItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalaryStructureItemsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAddSalaryStructureItemUrl = (id: number,) => {




  return `/api/payroll/salary-structures/${id}/items`
}

/**
 * @summary Add component to salary structure
 */
export const addSalaryStructureItem = async (id: number,
    salaryStructureItemInput: SalaryStructureItemInput, options?: RequestInit): Promise<SalaryStructureItem> => {

  return customFetch<SalaryStructureItem>(getAddSalaryStructureItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salaryStructureItemInput,)
  }
);}




export const getAddSalaryStructureItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSalaryStructureItem>>, TError,{id: number;data: BodyType<SalaryStructureItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addSalaryStructureItem>>, TError,{id: number;data: BodyType<SalaryStructureItemInput>}, TContext> => {

const mutationKey = ['addSalaryStructureItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addSalaryStructureItem>>, {id: number;data: BodyType<SalaryStructureItemInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addSalaryStructureItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddSalaryStructureItemMutationResult = NonNullable<Awaited<ReturnType<typeof addSalaryStructureItem>>>
    export type AddSalaryStructureItemMutationBody = BodyType<SalaryStructureItemInput>
    export type AddSalaryStructureItemMutationError = ErrorType<unknown>

    /**
 * @summary Add component to salary structure
 */
export const useAddSalaryStructureItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSalaryStructureItem>>, TError,{id: number;data: BodyType<SalaryStructureItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addSalaryStructureItem>>,
        TError,
        {id: number;data: BodyType<SalaryStructureItemInput>},
        TContext
      > => {
      return useMutation(getAddSalaryStructureItemMutationOptions(options));
    }

export const getUpdateSalaryStructureItemUrl = (id: number,
    itemId: number,) => {




  return `/api/payroll/salary-structures/${id}/items/${itemId}`
}

/**
 * @summary Update structure item (formula / amount / order)
 */
export const updateSalaryStructureItem = async (id: number,
    itemId: number,
    salaryStructureItemInput: SalaryStructureItemInput, options?: RequestInit): Promise<SalaryStructureItem> => {

  return customFetch<SalaryStructureItem>(getUpdateSalaryStructureItemUrl(id,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salaryStructureItemInput,)
  }
);}




export const getUpdateSalaryStructureItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalaryStructureItem>>, TError,{id: number;itemId: number;data: BodyType<SalaryStructureItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSalaryStructureItem>>, TError,{id: number;itemId: number;data: BodyType<SalaryStructureItemInput>}, TContext> => {

const mutationKey = ['updateSalaryStructureItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSalaryStructureItem>>, {id: number;itemId: number;data: BodyType<SalaryStructureItemInput>}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  updateSalaryStructureItem(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSalaryStructureItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateSalaryStructureItem>>>
    export type UpdateSalaryStructureItemMutationBody = BodyType<SalaryStructureItemInput>
    export type UpdateSalaryStructureItemMutationError = ErrorType<unknown>

    /**
 * @summary Update structure item (formula / amount / order)
 */
export const useUpdateSalaryStructureItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalaryStructureItem>>, TError,{id: number;itemId: number;data: BodyType<SalaryStructureItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSalaryStructureItem>>,
        TError,
        {id: number;itemId: number;data: BodyType<SalaryStructureItemInput>},
        TContext
      > => {
      return useMutation(getUpdateSalaryStructureItemMutationOptions(options));
    }

export const getDeleteSalaryStructureItemUrl = (id: number,
    itemId: number,) => {




  return `/api/payroll/salary-structures/${id}/items/${itemId}`
}

/**
 * @summary Remove component from salary structure
 */
export const deleteSalaryStructureItem = async (id: number,
    itemId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSalaryStructureItemUrl(id,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSalaryStructureItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSalaryStructureItem>>, TError,{id: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSalaryStructureItem>>, TError,{id: number;itemId: number}, TContext> => {

const mutationKey = ['deleteSalaryStructureItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSalaryStructureItem>>, {id: number;itemId: number}> = (props) => {
          const {id,itemId} = props ?? {};

          return  deleteSalaryStructureItem(id,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSalaryStructureItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSalaryStructureItem>>>

    export type DeleteSalaryStructureItemMutationError = ErrorType<unknown>

    /**
 * @summary Remove component from salary structure
 */
export const useDeleteSalaryStructureItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSalaryStructureItem>>, TError,{id: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSalaryStructureItem>>,
        TError,
        {id: number;itemId: number},
        TContext
      > => {
      return useMutation(getDeleteSalaryStructureItemMutationOptions(options));
    }

export const getListEmployeeSalaryAssignmentsUrl = () => {




  return `/api/payroll/employee-assignments`
}

/**
 * @summary List all employee salary assignments
 */
export const listEmployeeSalaryAssignments = async ( options?: RequestInit): Promise<EmployeeSalaryAssignment[]> => {

  return customFetch<EmployeeSalaryAssignment[]>(getListEmployeeSalaryAssignmentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmployeeSalaryAssignmentsQueryKey = () => {
    return [
    `/api/payroll/employee-assignments`
    ] as const;
    }


export const getListEmployeeSalaryAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listEmployeeSalaryAssignments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployeeSalaryAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmployeeSalaryAssignmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployeeSalaryAssignments>>> = ({ signal }) => listEmployeeSalaryAssignments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmployeeSalaryAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEmployeeSalaryAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployeeSalaryAssignments>>>
export type ListEmployeeSalaryAssignmentsQueryError = ErrorType<unknown>


/**
 * @summary List all employee salary assignments
 */

export function useListEmployeeSalaryAssignments<TData = Awaited<ReturnType<typeof listEmployeeSalaryAssignments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployeeSalaryAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEmployeeSalaryAssignmentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateEmployeeSalaryAssignmentUrl = () => {




  return `/api/payroll/employee-assignments`
}

/**
 * @summary Assign salary structure to employee
 */
export const createEmployeeSalaryAssignment = async (employeeSalaryAssignmentInput: EmployeeSalaryAssignmentInput, options?: RequestInit): Promise<EmployeeSalaryAssignment> => {

  return customFetch<EmployeeSalaryAssignment>(getCreateEmployeeSalaryAssignmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeSalaryAssignmentInput,)
  }
);}




export const getCreateEmployeeSalaryAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeSalaryAssignment>>, TError,{data: BodyType<EmployeeSalaryAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployeeSalaryAssignment>>, TError,{data: BodyType<EmployeeSalaryAssignmentInput>}, TContext> => {

const mutationKey = ['createEmployeeSalaryAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployeeSalaryAssignment>>, {data: BodyType<EmployeeSalaryAssignmentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createEmployeeSalaryAssignment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeSalaryAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployeeSalaryAssignment>>>
    export type CreateEmployeeSalaryAssignmentMutationBody = BodyType<EmployeeSalaryAssignmentInput>
    export type CreateEmployeeSalaryAssignmentMutationError = ErrorType<unknown>

    /**
 * @summary Assign salary structure to employee
 */
export const useCreateEmployeeSalaryAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeSalaryAssignment>>, TError,{data: BodyType<EmployeeSalaryAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEmployeeSalaryAssignment>>,
        TError,
        {data: BodyType<EmployeeSalaryAssignmentInput>},
        TContext
      > => {
      return useMutation(getCreateEmployeeSalaryAssignmentMutationOptions(options));
    }

export const getGetEmployeeSalaryAssignmentHistoryUrl = (employeeId: number,) => {




  return `/api/payroll/employee-assignments/employee/${employeeId}`
}

/**
 * @summary Get salary assignment history for an employee
 */
export const getEmployeeSalaryAssignmentHistory = async (employeeId: number, options?: RequestInit): Promise<EmployeeSalaryAssignment[]> => {

  return customFetch<EmployeeSalaryAssignment[]>(getGetEmployeeSalaryAssignmentHistoryUrl(employeeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmployeeSalaryAssignmentHistoryQueryKey = (employeeId: number,) => {
    return [
    `/api/payroll/employee-assignments/employee/${employeeId}`
    ] as const;
    }


export const getGetEmployeeSalaryAssignmentHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeSalaryAssignmentHistory>>, TError = ErrorType<unknown>>(employeeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSalaryAssignmentHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeSalaryAssignmentHistoryQueryKey(employeeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeSalaryAssignmentHistory>>> = ({ signal }) => getEmployeeSalaryAssignmentHistory(employeeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(employeeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSalaryAssignmentHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeeSalaryAssignmentHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeSalaryAssignmentHistory>>>
export type GetEmployeeSalaryAssignmentHistoryQueryError = ErrorType<unknown>


/**
 * @summary Get salary assignment history for an employee
 */

export function useGetEmployeeSalaryAssignmentHistory<TData = Awaited<ReturnType<typeof getEmployeeSalaryAssignmentHistory>>, TError = ErrorType<unknown>>(
 employeeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSalaryAssignmentHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployeeSalaryAssignmentHistoryQueryOptions(employeeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateEmployeeSalaryAssignmentUrl = (id: number,) => {




  return `/api/payroll/employee-assignments/${id}`
}

/**
 * @summary Update employee salary assignment
 */
export const updateEmployeeSalaryAssignment = async (id: number,
    employeeSalaryAssignmentUpdate: EmployeeSalaryAssignmentUpdate, options?: RequestInit): Promise<EmployeeSalaryAssignment> => {

  return customFetch<EmployeeSalaryAssignment>(getUpdateEmployeeSalaryAssignmentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeSalaryAssignmentUpdate,)
  }
);}




export const getUpdateEmployeeSalaryAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeSalaryAssignment>>, TError,{id: number;data: BodyType<EmployeeSalaryAssignmentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeSalaryAssignment>>, TError,{id: number;data: BodyType<EmployeeSalaryAssignmentUpdate>}, TContext> => {

const mutationKey = ['updateEmployeeSalaryAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeSalaryAssignment>>, {id: number;data: BodyType<EmployeeSalaryAssignmentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployeeSalaryAssignment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeSalaryAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeSalaryAssignment>>>
    export type UpdateEmployeeSalaryAssignmentMutationBody = BodyType<EmployeeSalaryAssignmentUpdate>
    export type UpdateEmployeeSalaryAssignmentMutationError = ErrorType<unknown>

    /**
 * @summary Update employee salary assignment
 */
export const useUpdateEmployeeSalaryAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeSalaryAssignment>>, TError,{id: number;data: BodyType<EmployeeSalaryAssignmentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeSalaryAssignment>>,
        TError,
        {id: number;data: BodyType<EmployeeSalaryAssignmentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateEmployeeSalaryAssignmentMutationOptions(options));
    }

export const getListPayrollRunsUrl = () => {




  return `/api/payroll/runs`
}

/**
 * @summary List payroll runs
 */
export const listPayrollRuns = async ( options?: RequestInit): Promise<PayrollRun[]> => {

  return customFetch<PayrollRun[]>(getListPayrollRunsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPayrollRunsQueryKey = () => {
    return [
    `/api/payroll/runs`
    ] as const;
    }


export const getListPayrollRunsQueryOptions = <TData = Awaited<ReturnType<typeof listPayrollRuns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPayrollRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPayrollRunsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayrollRuns>>> = ({ signal }) => listPayrollRuns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayrollRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPayrollRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayrollRuns>>>
export type ListPayrollRunsQueryError = ErrorType<unknown>


/**
 * @summary List payroll runs
 */

export function useListPayrollRuns<TData = Awaited<ReturnType<typeof listPayrollRuns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPayrollRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPayrollRunsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePayrollRunUrl = () => {




  return `/api/payroll/runs`
}

/**
 * @summary Create a new payroll run for a month/year
 */
export const createPayrollRun = async (payrollRunInput: PayrollRunInput, options?: RequestInit): Promise<PayrollRun> => {

  return customFetch<PayrollRun>(getCreatePayrollRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      payrollRunInput,)
  }
);}




export const getCreatePayrollRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayrollRun>>, TError,{data: BodyType<PayrollRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPayrollRun>>, TError,{data: BodyType<PayrollRunInput>}, TContext> => {

const mutationKey = ['createPayrollRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPayrollRun>>, {data: BodyType<PayrollRunInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPayrollRun(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePayrollRunMutationResult = NonNullable<Awaited<ReturnType<typeof createPayrollRun>>>
    export type CreatePayrollRunMutationBody = BodyType<PayrollRunInput>
    export type CreatePayrollRunMutationError = ErrorType<void>

    /**
 * @summary Create a new payroll run for a month/year
 */
export const useCreatePayrollRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayrollRun>>, TError,{data: BodyType<PayrollRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPayrollRun>>,
        TError,
        {data: BodyType<PayrollRunInput>},
        TContext
      > => {
      return useMutation(getCreatePayrollRunMutationOptions(options));
    }

export const getGetPayrollRunUrl = (id: number,) => {




  return `/api/payroll/runs/${id}`
}

/**
 * @summary Get payroll run details
 */
export const getPayrollRun = async (id: number, options?: RequestInit): Promise<PayrollRun> => {

  return customFetch<PayrollRun>(getGetPayrollRunUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPayrollRunQueryKey = (id: number,) => {
    return [
    `/api/payroll/runs/${id}`
    ] as const;
    }


export const getGetPayrollRunQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollRun>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPayrollRun>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollRunQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollRun>>> = ({ signal }) => getPayrollRun(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollRun>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPayrollRunQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollRun>>>
export type GetPayrollRunQueryError = ErrorType<unknown>


/**
 * @summary Get payroll run details
 */

export function useGetPayrollRun<TData = Awaited<ReturnType<typeof getPayrollRun>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPayrollRun>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPayrollRunQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getComputePayrollRunUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/compute`
}

/**
 * @summary Run the India payroll engine (PF/ESI/PT/TDS) for all employees
 */
export const computePayrollRun = async (id: number, options?: RequestInit): Promise<ComputePayrollRun200> => {

  return customFetch<ComputePayrollRun200>(getComputePayrollRunUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getComputePayrollRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof computePayrollRun>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof computePayrollRun>>, TError,{id: number}, TContext> => {

const mutationKey = ['computePayrollRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof computePayrollRun>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  computePayrollRun(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ComputePayrollRunMutationResult = NonNullable<Awaited<ReturnType<typeof computePayrollRun>>>

    export type ComputePayrollRunMutationError = ErrorType<unknown>

    /**
 * @summary Run the India payroll engine (PF/ESI/PT/TDS) for all employees
 */
export const useComputePayrollRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof computePayrollRun>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof computePayrollRun>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getComputePayrollRunMutationOptions(options));
    }

export const getLockPayrollRunUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/lock`
}

/**
 * @summary Lock a payroll run (must be in preview status)
 */
export const lockPayrollRun = async (id: number, options?: RequestInit): Promise<PayrollRun> => {

  return customFetch<PayrollRun>(getLockPayrollRunUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getLockPayrollRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockPayrollRun>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof lockPayrollRun>>, TError,{id: number}, TContext> => {

const mutationKey = ['lockPayrollRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lockPayrollRun>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  lockPayrollRun(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LockPayrollRunMutationResult = NonNullable<Awaited<ReturnType<typeof lockPayrollRun>>>

    export type LockPayrollRunMutationError = ErrorType<unknown>

    /**
 * @summary Lock a payroll run (must be in preview status)
 */
export const useLockPayrollRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockPayrollRun>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof lockPayrollRun>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getLockPayrollRunMutationOptions(options));
    }

export const getUnlockPayrollRunUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/unlock`
}

/**
 * @summary Unlock a payroll run back to preview
 */
export const unlockPayrollRun = async (id: number, options?: RequestInit): Promise<PayrollRun> => {

  return customFetch<PayrollRun>(getUnlockPayrollRunUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnlockPayrollRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockPayrollRun>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlockPayrollRun>>, TError,{id: number}, TContext> => {

const mutationKey = ['unlockPayrollRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockPayrollRun>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  unlockPayrollRun(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlockPayrollRunMutationResult = NonNullable<Awaited<ReturnType<typeof unlockPayrollRun>>>

    export type UnlockPayrollRunMutationError = ErrorType<unknown>

    /**
 * @summary Unlock a payroll run back to preview
 */
export const useUnlockPayrollRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockPayrollRun>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlockPayrollRun>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getUnlockPayrollRunMutationOptions(options));
    }

export const getDownloadPayrollPfEcrUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/reports/pf-ecr`
}

/**
 * @summary Download EPFO ECR (Electronic Challan cum Return) text file for a locked payroll run
 */
export const downloadPayrollPfEcr = async (id: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadPayrollPfEcrUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPayrollPfEcrQueryKey = (id: number,) => {
    return [
    `/api/payroll/runs/${id}/reports/pf-ecr`
    ] as const;
    }


export const getDownloadPayrollPfEcrQueryOptions = <TData = Awaited<ReturnType<typeof downloadPayrollPfEcr>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollPfEcr>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPayrollPfEcrQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPayrollPfEcr>>> = ({ signal }) => downloadPayrollPfEcr(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollPfEcr>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPayrollPfEcrQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPayrollPfEcr>>>
export type DownloadPayrollPfEcrQueryError = ErrorType<unknown>


/**
 * @summary Download EPFO ECR (Electronic Challan cum Return) text file for a locked payroll run
 */

export function useDownloadPayrollPfEcr<TData = Awaited<ReturnType<typeof downloadPayrollPfEcr>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollPfEcr>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPayrollPfEcrQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadPayrollEsiChallanUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/reports/esi-challan`
}

/**
 * @summary Download ESI challan CSV for a payroll run
 */
export const downloadPayrollEsiChallan = async (id: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadPayrollEsiChallanUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPayrollEsiChallanQueryKey = (id: number,) => {
    return [
    `/api/payroll/runs/${id}/reports/esi-challan`
    ] as const;
    }


export const getDownloadPayrollEsiChallanQueryOptions = <TData = Awaited<ReturnType<typeof downloadPayrollEsiChallan>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollEsiChallan>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPayrollEsiChallanQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPayrollEsiChallan>>> = ({ signal }) => downloadPayrollEsiChallan(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollEsiChallan>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPayrollEsiChallanQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPayrollEsiChallan>>>
export type DownloadPayrollEsiChallanQueryError = ErrorType<unknown>


/**
 * @summary Download ESI challan CSV for a payroll run
 */

export function useDownloadPayrollEsiChallan<TData = Awaited<ReturnType<typeof downloadPayrollEsiChallan>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollEsiChallan>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPayrollEsiChallanQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadPayrollPtChallanUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/reports/pt-challan`
}

/**
 * @summary Download Professional Tax challan CSV for a payroll run
 */
export const downloadPayrollPtChallan = async (id: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadPayrollPtChallanUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPayrollPtChallanQueryKey = (id: number,) => {
    return [
    `/api/payroll/runs/${id}/reports/pt-challan`
    ] as const;
    }


export const getDownloadPayrollPtChallanQueryOptions = <TData = Awaited<ReturnType<typeof downloadPayrollPtChallan>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollPtChallan>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPayrollPtChallanQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPayrollPtChallan>>> = ({ signal }) => downloadPayrollPtChallan(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollPtChallan>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPayrollPtChallanQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPayrollPtChallan>>>
export type DownloadPayrollPtChallanQueryError = ErrorType<unknown>


/**
 * @summary Download Professional Tax challan CSV for a payroll run
 */

export function useDownloadPayrollPtChallan<TData = Awaited<ReturnType<typeof downloadPayrollPtChallan>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollPtChallan>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPayrollPtChallanQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadPayrollBankTransferUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/reports/bank-transfer`
}

/**
 * @summary Download bank transfer advice CSV for a locked payroll run
 */
export const downloadPayrollBankTransfer = async (id: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadPayrollBankTransferUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPayrollBankTransferQueryKey = (id: number,) => {
    return [
    `/api/payroll/runs/${id}/reports/bank-transfer`
    ] as const;
    }


export const getDownloadPayrollBankTransferQueryOptions = <TData = Awaited<ReturnType<typeof downloadPayrollBankTransfer>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollBankTransfer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPayrollBankTransferQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPayrollBankTransfer>>> = ({ signal }) => downloadPayrollBankTransfer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollBankTransfer>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPayrollBankTransferQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPayrollBankTransfer>>>
export type DownloadPayrollBankTransferQueryError = ErrorType<unknown>


/**
 * @summary Download bank transfer advice CSV for a locked payroll run
 */

export function useDownloadPayrollBankTransfer<TData = Awaited<ReturnType<typeof downloadPayrollBankTransfer>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollBankTransfer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPayrollBankTransferQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadPayrollRegisterUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/reports/payroll-register`
}

/**
 * @summary Download full payroll register CSV for a payroll run
 */
export const downloadPayrollRegister = async (id: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadPayrollRegisterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPayrollRegisterQueryKey = (id: number,) => {
    return [
    `/api/payroll/runs/${id}/reports/payroll-register`
    ] as const;
    }


export const getDownloadPayrollRegisterQueryOptions = <TData = Awaited<ReturnType<typeof downloadPayrollRegister>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPayrollRegisterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPayrollRegister>>> = ({ signal }) => downloadPayrollRegister(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollRegister>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPayrollRegisterQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPayrollRegister>>>
export type DownloadPayrollRegisterQueryError = ErrorType<unknown>


/**
 * @summary Download full payroll register CSV for a payroll run
 */

export function useDownloadPayrollRegister<TData = Awaited<ReturnType<typeof downloadPayrollRegister>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPayrollRegisterQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadPayrollTdsReportUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/reports/tds-report`
}

/**
 * @summary Download TDS deduction summary CSV for a payroll run
 */
export const downloadPayrollTdsReport = async (id: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadPayrollTdsReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPayrollTdsReportQueryKey = (id: number,) => {
    return [
    `/api/payroll/runs/${id}/reports/tds-report`
    ] as const;
    }


export const getDownloadPayrollTdsReportQueryOptions = <TData = Awaited<ReturnType<typeof downloadPayrollTdsReport>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollTdsReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPayrollTdsReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPayrollTdsReport>>> = ({ signal }) => downloadPayrollTdsReport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollTdsReport>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPayrollTdsReportQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPayrollTdsReport>>>
export type DownloadPayrollTdsReportQueryError = ErrorType<unknown>


/**
 * @summary Download TDS deduction summary CSV for a payroll run
 */

export function useDownloadPayrollTdsReport<TData = Awaited<ReturnType<typeof downloadPayrollTdsReport>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollTdsReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPayrollTdsReportQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadPayrollPfRegisterUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/reports/pf-register`
}

/**
 * @summary Download PF contribution register CSV for a payroll run
 */
export const downloadPayrollPfRegister = async (id: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadPayrollPfRegisterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPayrollPfRegisterQueryKey = (id: number,) => {
    return [
    `/api/payroll/runs/${id}/reports/pf-register`
    ] as const;
    }


export const getDownloadPayrollPfRegisterQueryOptions = <TData = Awaited<ReturnType<typeof downloadPayrollPfRegister>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollPfRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPayrollPfRegisterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPayrollPfRegister>>> = ({ signal }) => downloadPayrollPfRegister(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollPfRegister>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPayrollPfRegisterQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPayrollPfRegister>>>
export type DownloadPayrollPfRegisterQueryError = ErrorType<unknown>


/**
 * @summary Download PF contribution register CSV for a payroll run
 */

export function useDownloadPayrollPfRegister<TData = Awaited<ReturnType<typeof downloadPayrollPfRegister>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollPfRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPayrollPfRegisterQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadPayrollEsiReportUrl = (id: number,) => {




  return `/api/payroll/runs/${id}/reports/esi-report`
}

/**
 * @summary Download ESI contribution report CSV for a payroll run
 */
export const downloadPayrollEsiReport = async (id: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadPayrollEsiReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPayrollEsiReportQueryKey = (id: number,) => {
    return [
    `/api/payroll/runs/${id}/reports/esi-report`
    ] as const;
    }


export const getDownloadPayrollEsiReportQueryOptions = <TData = Awaited<ReturnType<typeof downloadPayrollEsiReport>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollEsiReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPayrollEsiReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPayrollEsiReport>>> = ({ signal }) => downloadPayrollEsiReport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollEsiReport>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPayrollEsiReportQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPayrollEsiReport>>>
export type DownloadPayrollEsiReportQueryError = ErrorType<unknown>


/**
 * @summary Download ESI contribution report CSV for a payroll run
 */

export function useDownloadPayrollEsiReport<TData = Awaited<ReturnType<typeof downloadPayrollEsiReport>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayrollEsiReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPayrollEsiReportQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListPayrollRunEntriesUrl = (id: number,
    params?: ListPayrollRunEntriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payroll/runs/${id}/entries?${stringifiedParams}` : `/api/payroll/runs/${id}/entries`
}

/**
 * Without `page`, returns a full array (legacy clients). With `page`, returns the ERP server-table envelope `{ data, total, page, pageSize, totalPages }`.

 * @summary List payslip entries for a payroll run
 */
export const listPayrollRunEntries = async (id: number,
    params?: ListPayrollRunEntriesParams, options?: RequestInit): Promise<ListPayrollRunEntries200> => {

  return customFetch<ListPayrollRunEntries200>(getListPayrollRunEntriesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPayrollRunEntriesQueryKey = (id: number,
    params?: ListPayrollRunEntriesParams,) => {
    return [
    `/api/payroll/runs/${id}/entries`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPayrollRunEntriesQueryOptions = <TData = Awaited<ReturnType<typeof listPayrollRunEntries>>, TError = ErrorType<unknown>>(id: number,
    params?: ListPayrollRunEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPayrollRunEntries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPayrollRunEntriesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayrollRunEntries>>> = ({ signal }) => listPayrollRunEntries(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayrollRunEntries>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPayrollRunEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof listPayrollRunEntries>>>
export type ListPayrollRunEntriesQueryError = ErrorType<unknown>


/**
 * @summary List payslip entries for a payroll run
 */

export function useListPayrollRunEntries<TData = Awaited<ReturnType<typeof listPayrollRunEntries>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListPayrollRunEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPayrollRunEntries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPayrollRunEntriesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePayrollRunEntryUrl = (id: number,
    entryId: number,) => {




  return `/api/payroll/runs/${id}/entries/${entryId}`
}

/**
 * @summary Override LOP days or flag an entry (before lock). Locked runs must be unlocked first.
 */
export const updatePayrollRunEntry = async (id: number,
    entryId: number,
    payrollRunEntryUpdate: PayrollRunEntryUpdate, options?: RequestInit): Promise<PayrollRunEntry> => {

  return customFetch<PayrollRunEntry>(getUpdatePayrollRunEntryUrl(id,entryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      payrollRunEntryUpdate,)
  }
);}




export const getUpdatePayrollRunEntryMutationOptions = <TError = ErrorType<UpdatePayrollRunEntry409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayrollRunEntry>>, TError,{id: number;entryId: number;data: BodyType<PayrollRunEntryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePayrollRunEntry>>, TError,{id: number;entryId: number;data: BodyType<PayrollRunEntryUpdate>}, TContext> => {

const mutationKey = ['updatePayrollRunEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePayrollRunEntry>>, {id: number;entryId: number;data: BodyType<PayrollRunEntryUpdate>}> = (props) => {
          const {id,entryId,data} = props ?? {};

          return  updatePayrollRunEntry(id,entryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePayrollRunEntryMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayrollRunEntry>>>
    export type UpdatePayrollRunEntryMutationBody = BodyType<PayrollRunEntryUpdate>
    export type UpdatePayrollRunEntryMutationError = ErrorType<UpdatePayrollRunEntry409>

    /**
 * @summary Override LOP days or flag an entry (before lock). Locked runs must be unlocked first.
 */
export const useUpdatePayrollRunEntry = <TError = ErrorType<UpdatePayrollRunEntry409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayrollRunEntry>>, TError,{id: number;entryId: number;data: BodyType<PayrollRunEntryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePayrollRunEntry>>,
        TError,
        {id: number;entryId: number;data: BodyType<PayrollRunEntryUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePayrollRunEntryMutationOptions(options));
    }

export const getDownloadPayslipHtmlUrl = (id: number,
    entryId: number,) => {




  return `/api/payroll/runs/${id}/entries/${entryId}/payslip`
}

/**
 * @summary Download HTML payslip for a payroll run entry (printable, browser-native PDF via Ctrl+P)
 */
export const downloadPayslipHtml = async (id: number,
    entryId: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadPayslipHtmlUrl(id,entryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPayslipHtmlQueryKey = (id: number,
    entryId: number,) => {
    return [
    `/api/payroll/runs/${id}/entries/${entryId}/payslip`
    ] as const;
    }


export const getDownloadPayslipHtmlQueryOptions = <TData = Awaited<ReturnType<typeof downloadPayslipHtml>>, TError = ErrorType<unknown>>(id: number,
    entryId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayslipHtml>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPayslipHtmlQueryKey(id,entryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPayslipHtml>>> = ({ signal }) => downloadPayslipHtml(id,entryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id && entryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPayslipHtml>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPayslipHtmlQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPayslipHtml>>>
export type DownloadPayslipHtmlQueryError = ErrorType<unknown>


/**
 * @summary Download HTML payslip for a payroll run entry (printable, browser-native PDF via Ctrl+P)
 */

export function useDownloadPayslipHtml<TData = Awaited<ReturnType<typeof downloadPayslipHtml>>, TError = ErrorType<unknown>>(
 id: number,
    entryId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPayslipHtml>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPayslipHtmlQueryOptions(id,entryId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListTdsDeclarationsUrl = (params?: ListTdsDeclarationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payroll/tds-declarations?${stringifiedParams}` : `/api/payroll/tds-declarations`
}

/**
 * @summary List TDS declarations (HR admin)
 */
export const listTdsDeclarations = async (params?: ListTdsDeclarationsParams, options?: RequestInit): Promise<TdsDeclaration[]> => {

  return customFetch<TdsDeclaration[]>(getListTdsDeclarationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTdsDeclarationsQueryKey = (params?: ListTdsDeclarationsParams,) => {
    return [
    `/api/payroll/tds-declarations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTdsDeclarationsQueryOptions = <TData = Awaited<ReturnType<typeof listTdsDeclarations>>, TError = ErrorType<unknown>>(params?: ListTdsDeclarationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTdsDeclarations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTdsDeclarationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTdsDeclarations>>> = ({ signal }) => listTdsDeclarations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTdsDeclarations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTdsDeclarationsQueryResult = NonNullable<Awaited<ReturnType<typeof listTdsDeclarations>>>
export type ListTdsDeclarationsQueryError = ErrorType<unknown>


/**
 * @summary List TDS declarations (HR admin)
 */

export function useListTdsDeclarations<TData = Awaited<ReturnType<typeof listTdsDeclarations>>, TError = ErrorType<unknown>>(
 params?: ListTdsDeclarationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTdsDeclarations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTdsDeclarationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getVerifyTdsDeclarationUrl = (id: number,) => {




  return `/api/payroll/tds-declarations/${id}/verify`
}

/**
 * @summary Verify a TDS declaration (HR marks proofs as verified)
 */
export const verifyTdsDeclaration = async (id: number, options?: RequestInit): Promise<TdsDeclaration> => {

  return customFetch<TdsDeclaration>(getVerifyTdsDeclarationUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getVerifyTdsDeclarationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTdsDeclaration>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyTdsDeclaration>>, TError,{id: number}, TContext> => {

const mutationKey = ['verifyTdsDeclaration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyTdsDeclaration>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  verifyTdsDeclaration(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyTdsDeclarationMutationResult = NonNullable<Awaited<ReturnType<typeof verifyTdsDeclaration>>>

    export type VerifyTdsDeclarationMutationError = ErrorType<unknown>

    /**
 * @summary Verify a TDS declaration (HR marks proofs as verified)
 */
export const useVerifyTdsDeclaration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTdsDeclaration>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyTdsDeclaration>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getVerifyTdsDeclarationMutationOptions(options));
    }

export const getListReimbursementsUrl = (params?: ListReimbursementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payroll/reimbursements?${stringifiedParams}` : `/api/payroll/reimbursements`
}

/**
 * @summary List reimbursement claims (HR admin)
 */
export const listReimbursements = async (params?: ListReimbursementsParams, options?: RequestInit): Promise<ReimbursementClaim[]> => {

  return customFetch<ReimbursementClaim[]>(getListReimbursementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReimbursementsQueryKey = (params?: ListReimbursementsParams,) => {
    return [
    `/api/payroll/reimbursements`, ...(params ? [params] : [])
    ] as const;
    }


export const getListReimbursementsQueryOptions = <TData = Awaited<ReturnType<typeof listReimbursements>>, TError = ErrorType<unknown>>(params?: ListReimbursementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReimbursements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReimbursementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReimbursements>>> = ({ signal }) => listReimbursements(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReimbursements>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReimbursementsQueryResult = NonNullable<Awaited<ReturnType<typeof listReimbursements>>>
export type ListReimbursementsQueryError = ErrorType<unknown>


/**
 * @summary List reimbursement claims (HR admin)
 */

export function useListReimbursements<TData = Awaited<ReturnType<typeof listReimbursements>>, TError = ErrorType<unknown>>(
 params?: ListReimbursementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReimbursements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReimbursementsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getApproveReimbursementUrl = (id: number,) => {




  return `/api/payroll/reimbursements/${id}/approve`
}

/**
 * @summary Approve a reimbursement claim
 */
export const approveReimbursement = async (id: number, options?: RequestInit): Promise<ReimbursementClaim> => {

  return customFetch<ReimbursementClaim>(getApproveReimbursementUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getApproveReimbursementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveReimbursement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveReimbursement>>, TError,{id: number}, TContext> => {

const mutationKey = ['approveReimbursement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveReimbursement>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  approveReimbursement(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveReimbursementMutationResult = NonNullable<Awaited<ReturnType<typeof approveReimbursement>>>

    export type ApproveReimbursementMutationError = ErrorType<unknown>

    /**
 * @summary Approve a reimbursement claim
 */
export const useApproveReimbursement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveReimbursement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveReimbursement>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApproveReimbursementMutationOptions(options));
    }

export const getRejectReimbursementUrl = (id: number,) => {




  return `/api/payroll/reimbursements/${id}/reject`
}

/**
 * @summary Reject a reimbursement claim
 */
export const rejectReimbursement = async (id: number,
    rejectReimbursementBody?: RejectReimbursementBody, options?: RequestInit): Promise<ReimbursementClaim> => {

  return customFetch<ReimbursementClaim>(getRejectReimbursementUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rejectReimbursementBody,)
  }
);}




export const getRejectReimbursementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectReimbursement>>, TError,{id: number;data?: BodyType<RejectReimbursementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectReimbursement>>, TError,{id: number;data?: BodyType<RejectReimbursementBody>}, TContext> => {

const mutationKey = ['rejectReimbursement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectReimbursement>>, {id: number;data?: BodyType<RejectReimbursementBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectReimbursement(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectReimbursementMutationResult = NonNullable<Awaited<ReturnType<typeof rejectReimbursement>>>
    export type RejectReimbursementMutationBody = BodyType<RejectReimbursementBody> | undefined
    export type RejectReimbursementMutationError = ErrorType<unknown>

    /**
 * @summary Reject a reimbursement claim
 */
export const useRejectReimbursement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectReimbursement>>, TError,{id: number;data?: BodyType<RejectReimbursementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectReimbursement>>,
        TError,
        {id: number;data?: BodyType<RejectReimbursementBody>},
        TContext
      > => {
      return useMutation(getRejectReimbursementMutationOptions(options));
    }

export const getListMyPayslipsUrl = () => {




  return `/api/payroll/me/payslips`
}

/**
 * @summary Get employee own payslips (locked runs only)
 */
export const listMyPayslips = async ( options?: RequestInit): Promise<PayrollRunEntry[]> => {

  return customFetch<PayrollRunEntry[]>(getListMyPayslipsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyPayslipsQueryKey = () => {
    return [
    `/api/payroll/me/payslips`
    ] as const;
    }


export const getListMyPayslipsQueryOptions = <TData = Awaited<ReturnType<typeof listMyPayslips>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyPayslips>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyPayslipsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyPayslips>>> = ({ signal }) => listMyPayslips({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyPayslips>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyPayslipsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyPayslips>>>
export type ListMyPayslipsQueryError = ErrorType<unknown>


/**
 * @summary Get employee own payslips (locked runs only)
 */

export function useListMyPayslips<TData = Awaited<ReturnType<typeof listMyPayslips>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyPayslips>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyPayslipsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMyPayrollSummaryUrl = () => {




  return `/api/payroll/me/summary`
}

/**
 * @summary Get employee YTD payroll summary
 */
export const getMyPayrollSummary = async ( options?: RequestInit): Promise<GetMyPayrollSummary200> => {

  return customFetch<GetMyPayrollSummary200>(getGetMyPayrollSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyPayrollSummaryQueryKey = () => {
    return [
    `/api/payroll/me/summary`
    ] as const;
    }


export const getGetMyPayrollSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMyPayrollSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPayrollSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyPayrollSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPayrollSummary>>> = ({ signal }) => getMyPayrollSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyPayrollSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyPayrollSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMyPayrollSummary>>>
export type GetMyPayrollSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get employee YTD payroll summary
 */

export function useGetMyPayrollSummary<TData = Awaited<ReturnType<typeof getMyPayrollSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPayrollSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyPayrollSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMyTdsDeclarationsUrl = () => {




  return `/api/payroll/me/declarations`
}

/**
 * @summary Get employee own TDS declarations
 */
export const listMyTdsDeclarations = async ( options?: RequestInit): Promise<TdsDeclaration[]> => {

  return customFetch<TdsDeclaration[]>(getListMyTdsDeclarationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyTdsDeclarationsQueryKey = () => {
    return [
    `/api/payroll/me/declarations`
    ] as const;
    }


export const getListMyTdsDeclarationsQueryOptions = <TData = Awaited<ReturnType<typeof listMyTdsDeclarations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyTdsDeclarations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyTdsDeclarationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyTdsDeclarations>>> = ({ signal }) => listMyTdsDeclarations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyTdsDeclarations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyTdsDeclarationsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyTdsDeclarations>>>
export type ListMyTdsDeclarationsQueryError = ErrorType<unknown>


/**
 * @summary Get employee own TDS declarations
 */

export function useListMyTdsDeclarations<TData = Awaited<ReturnType<typeof listMyTdsDeclarations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyTdsDeclarations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyTdsDeclarationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpsertMyTdsDeclarationUrl = () => {




  return `/api/payroll/me/declarations`
}

/**
 * @summary Submit or update TDS declaration for current FY
 */
export const upsertMyTdsDeclaration = async (tdsDeclarationInput: TdsDeclarationInput, options?: RequestInit): Promise<TdsDeclaration> => {

  return customFetch<TdsDeclaration>(getUpsertMyTdsDeclarationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tdsDeclarationInput,)
  }
);}




export const getUpsertMyTdsDeclarationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertMyTdsDeclaration>>, TError,{data: BodyType<TdsDeclarationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertMyTdsDeclaration>>, TError,{data: BodyType<TdsDeclarationInput>}, TContext> => {

const mutationKey = ['upsertMyTdsDeclaration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertMyTdsDeclaration>>, {data: BodyType<TdsDeclarationInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertMyTdsDeclaration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertMyTdsDeclarationMutationResult = NonNullable<Awaited<ReturnType<typeof upsertMyTdsDeclaration>>>
    export type UpsertMyTdsDeclarationMutationBody = BodyType<TdsDeclarationInput>
    export type UpsertMyTdsDeclarationMutationError = ErrorType<unknown>

    /**
 * @summary Submit or update TDS declaration for current FY
 */
export const useUpsertMyTdsDeclaration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertMyTdsDeclaration>>, TError,{data: BodyType<TdsDeclarationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertMyTdsDeclaration>>,
        TError,
        {data: BodyType<TdsDeclarationInput>},
        TContext
      > => {
      return useMutation(getUpsertMyTdsDeclarationMutationOptions(options));
    }

export const getListMyReimbursementsUrl = () => {




  return `/api/payroll/me/reimbursements`
}

/**
 * @summary Get employee own reimbursement claims
 */
export const listMyReimbursements = async ( options?: RequestInit): Promise<ReimbursementClaim[]> => {

  return customFetch<ReimbursementClaim[]>(getListMyReimbursementsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyReimbursementsQueryKey = () => {
    return [
    `/api/payroll/me/reimbursements`
    ] as const;
    }


export const getListMyReimbursementsQueryOptions = <TData = Awaited<ReturnType<typeof listMyReimbursements>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyReimbursements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyReimbursementsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyReimbursements>>> = ({ signal }) => listMyReimbursements({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyReimbursements>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyReimbursementsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyReimbursements>>>
export type ListMyReimbursementsQueryError = ErrorType<unknown>


/**
 * @summary Get employee own reimbursement claims
 */

export function useListMyReimbursements<TData = Awaited<ReturnType<typeof listMyReimbursements>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyReimbursements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyReimbursementsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSubmitReimbursementUrl = () => {




  return `/api/payroll/me/reimbursements`
}

/**
 * @summary Submit a reimbursement claim
 */
export const submitReimbursement = async (reimbursementClaimInput: ReimbursementClaimInput, options?: RequestInit): Promise<ReimbursementClaim> => {

  return customFetch<ReimbursementClaim>(getSubmitReimbursementUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reimbursementClaimInput,)
  }
);}




export const getSubmitReimbursementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReimbursement>>, TError,{data: BodyType<ReimbursementClaimInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitReimbursement>>, TError,{data: BodyType<ReimbursementClaimInput>}, TContext> => {

const mutationKey = ['submitReimbursement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitReimbursement>>, {data: BodyType<ReimbursementClaimInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitReimbursement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitReimbursementMutationResult = NonNullable<Awaited<ReturnType<typeof submitReimbursement>>>
    export type SubmitReimbursementMutationBody = BodyType<ReimbursementClaimInput>
    export type SubmitReimbursementMutationError = ErrorType<unknown>

    /**
 * @summary Submit a reimbursement claim
 */
export const useSubmitReimbursement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReimbursement>>, TError,{data: BodyType<ReimbursementClaimInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitReimbursement>>,
        TError,
        {data: BodyType<ReimbursementClaimInput>},
        TContext
      > => {
      return useMutation(getSubmitReimbursementMutationOptions(options));
    }

export const getListMySalaryRevisionsUrl = () => {




  return `/api/payroll/me/salary-revisions`
}

/**
 * @summary List employee own salary assignment history
 */
export const listMySalaryRevisions = async ( options?: RequestInit): Promise<ListMySalaryRevisions200Item[]> => {

  return customFetch<ListMySalaryRevisions200Item[]>(getListMySalaryRevisionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMySalaryRevisionsQueryKey = () => {
    return [
    `/api/payroll/me/salary-revisions`
    ] as const;
    }


export const getListMySalaryRevisionsQueryOptions = <TData = Awaited<ReturnType<typeof listMySalaryRevisions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMySalaryRevisions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMySalaryRevisionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMySalaryRevisions>>> = ({ signal }) => listMySalaryRevisions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMySalaryRevisions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMySalaryRevisionsQueryResult = NonNullable<Awaited<ReturnType<typeof listMySalaryRevisions>>>
export type ListMySalaryRevisionsQueryError = ErrorType<unknown>


/**
 * @summary List employee own salary assignment history
 */

export function useListMySalaryRevisions<TData = Awaited<ReturnType<typeof listMySalaryRevisions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMySalaryRevisions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMySalaryRevisionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMyLoansUrl = () => {




  return `/api/payroll/me/loans`
}

/**
 * @summary List employee own salary advance / loan records
 */
export const listMyLoans = async ( options?: RequestInit): Promise<EmployeeLoan[]> => {

  return customFetch<EmployeeLoan[]>(getListMyLoansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyLoansQueryKey = () => {
    return [
    `/api/payroll/me/loans`
    ] as const;
    }


export const getListMyLoansQueryOptions = <TData = Awaited<ReturnType<typeof listMyLoans>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyLoans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyLoansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyLoans>>> = ({ signal }) => listMyLoans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyLoans>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyLoansQueryResult = NonNullable<Awaited<ReturnType<typeof listMyLoans>>>
export type ListMyLoansQueryError = ErrorType<unknown>


/**
 * @summary List employee own salary advance / loan records
 */

export function useListMyLoans<TData = Awaited<ReturnType<typeof listMyLoans>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyLoans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyLoansQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMyForm16Url = (params: GetMyForm16Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payroll/me/form-16?${stringifiedParams}` : `/api/payroll/me/form-16`
}

/**
 * @summary Employee self-service Form 16 data for a financial year
 */
export const getMyForm16 = async (params: GetMyForm16Params, options?: RequestInit): Promise<GetMyForm16200One | string> => {

  return customFetch<GetMyForm16200One | string>(getGetMyForm16Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyForm16QueryKey = (params?: GetMyForm16Params,) => {
    return [
    `/api/payroll/me/form-16`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyForm16QueryOptions = <TData = Awaited<ReturnType<typeof getMyForm16>>, TError = ErrorType<unknown>>(params: GetMyForm16Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyForm16>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyForm16QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyForm16>>> = ({ signal }) => getMyForm16(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyForm16>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyForm16QueryResult = NonNullable<Awaited<ReturnType<typeof getMyForm16>>>
export type GetMyForm16QueryError = ErrorType<unknown>


/**
 * @summary Employee self-service Form 16 data for a financial year
 */

export function useGetMyForm16<TData = Awaited<ReturnType<typeof getMyForm16>>, TError = ErrorType<unknown>>(
 params: GetMyForm16Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyForm16>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyForm16QueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadMyPayslipHtmlUrl = (entryId: number,) => {




  return `/api/payroll/me/payslip/${entryId}`
}

/**
 * @summary Download HTML payslip for a locked payroll entry (employee self-service)
 */
export const downloadMyPayslipHtml = async (entryId: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadMyPayslipHtmlUrl(entryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadMyPayslipHtmlQueryKey = (entryId: number,) => {
    return [
    `/api/payroll/me/payslip/${entryId}`
    ] as const;
    }


export const getDownloadMyPayslipHtmlQueryOptions = <TData = Awaited<ReturnType<typeof downloadMyPayslipHtml>>, TError = ErrorType<unknown>>(entryId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadMyPayslipHtml>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadMyPayslipHtmlQueryKey(entryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadMyPayslipHtml>>> = ({ signal }) => downloadMyPayslipHtml(entryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(entryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadMyPayslipHtml>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadMyPayslipHtmlQueryResult = NonNullable<Awaited<ReturnType<typeof downloadMyPayslipHtml>>>
export type DownloadMyPayslipHtmlQueryError = ErrorType<unknown>


/**
 * @summary Download HTML payslip for a locked payroll entry (employee self-service)
 */

export function useDownloadMyPayslipHtml<TData = Awaited<ReturnType<typeof downloadMyPayslipHtml>>, TError = ErrorType<unknown>>(
 entryId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadMyPayslipHtml>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadMyPayslipHtmlQueryOptions(entryId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMyRegimeComparisonUrl = (params: GetMyRegimeComparisonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payroll/me/regime-comparison?${stringifiedParams}` : `/api/payroll/me/regime-comparison`
}

/**
 * @summary Compare projected annual tax under old vs new regime for the employee
 */
export const getMyRegimeComparison = async (params: GetMyRegimeComparisonParams, options?: RequestInit): Promise<GetMyRegimeComparison200> => {

  return customFetch<GetMyRegimeComparison200>(getGetMyRegimeComparisonUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyRegimeComparisonQueryKey = (params?: GetMyRegimeComparisonParams,) => {
    return [
    `/api/payroll/me/regime-comparison`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyRegimeComparisonQueryOptions = <TData = Awaited<ReturnType<typeof getMyRegimeComparison>>, TError = ErrorType<unknown>>(params: GetMyRegimeComparisonParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyRegimeComparison>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyRegimeComparisonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyRegimeComparison>>> = ({ signal }) => getMyRegimeComparison(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyRegimeComparison>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyRegimeComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof getMyRegimeComparison>>>
export type GetMyRegimeComparisonQueryError = ErrorType<unknown>


/**
 * @summary Compare projected annual tax under old vs new regime for the employee
 */

export function useGetMyRegimeComparison<TData = Awaited<ReturnType<typeof getMyRegimeComparison>>, TError = ErrorType<unknown>>(
 params: GetMyRegimeComparisonParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyRegimeComparison>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyRegimeComparisonQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMyTaxSummaryUrl = (params: GetMyTaxSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payroll/me/tax-summary?${stringifiedParams}` : `/api/payroll/me/tax-summary`
}

/**
 * @summary YTD tax summary and projection for the employee
 */
export const getMyTaxSummary = async (params: GetMyTaxSummaryParams, options?: RequestInit): Promise<GetMyTaxSummary200> => {

  return customFetch<GetMyTaxSummary200>(getGetMyTaxSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyTaxSummaryQueryKey = (params?: GetMyTaxSummaryParams,) => {
    return [
    `/api/payroll/me/tax-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyTaxSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMyTaxSummary>>, TError = ErrorType<unknown>>(params: GetMyTaxSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyTaxSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyTaxSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyTaxSummary>>> = ({ signal }) => getMyTaxSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyTaxSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyTaxSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMyTaxSummary>>>
export type GetMyTaxSummaryQueryError = ErrorType<unknown>


/**
 * @summary YTD tax summary and projection for the employee
 */

export function useGetMyTaxSummary<TData = Awaited<ReturnType<typeof getMyTaxSummary>>, TError = ErrorType<unknown>>(
 params: GetMyTaxSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyTaxSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyTaxSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadForm24QUrl = (params: DownloadForm24QParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payroll/reports/form-24q?${stringifiedParams}` : `/api/payroll/reports/form-24q`
}

/**
 * @summary Download Form 24Q TDS return data CSV for a financial year / quarter
 */
export const downloadForm24Q = async (params: DownloadForm24QParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadForm24QUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadForm24QQueryKey = (params?: DownloadForm24QParams,) => {
    return [
    `/api/payroll/reports/form-24q`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadForm24QQueryOptions = <TData = Awaited<ReturnType<typeof downloadForm24Q>>, TError = ErrorType<unknown>>(params: DownloadForm24QParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadForm24Q>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadForm24QQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadForm24Q>>> = ({ signal }) => downloadForm24Q(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadForm24Q>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadForm24QQueryResult = NonNullable<Awaited<ReturnType<typeof downloadForm24Q>>>
export type DownloadForm24QQueryError = ErrorType<unknown>


/**
 * @summary Download Form 24Q TDS return data CSV for a financial year / quarter
 */

export function useDownloadForm24Q<TData = Awaited<ReturnType<typeof downloadForm24Q>>, TError = ErrorType<unknown>>(
 params: DownloadForm24QParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadForm24Q>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadForm24QQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadForm16BulkUrl = (params: DownloadForm16BulkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payroll/reports/form-16?${stringifiedParams}` : `/api/payroll/reports/form-16`
}

/**
 * @summary Download bulk Form 16 data (all employees) for a financial year
 */
export const downloadForm16Bulk = async (params: DownloadForm16BulkParams, options?: RequestInit): Promise<DownloadForm16Bulk200Item[]> => {

  return customFetch<DownloadForm16Bulk200Item[]>(getDownloadForm16BulkUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadForm16BulkQueryKey = (params?: DownloadForm16BulkParams,) => {
    return [
    `/api/payroll/reports/form-16`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadForm16BulkQueryOptions = <TData = Awaited<ReturnType<typeof downloadForm16Bulk>>, TError = ErrorType<unknown>>(params: DownloadForm16BulkParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadForm16Bulk>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadForm16BulkQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadForm16Bulk>>> = ({ signal }) => downloadForm16Bulk(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadForm16Bulk>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadForm16BulkQueryResult = NonNullable<Awaited<ReturnType<typeof downloadForm16Bulk>>>
export type DownloadForm16BulkQueryError = ErrorType<unknown>


/**
 * @summary Download bulk Form 16 data (all employees) for a financial year
 */

export function useDownloadForm16Bulk<TData = Awaited<ReturnType<typeof downloadForm16Bulk>>, TError = ErrorType<unknown>>(
 params: DownloadForm16BulkParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadForm16Bulk>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadForm16BulkQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListEmployeeLoansUrl = () => {




  return `/api/payroll/loans`
}

/**
 * @summary List all employee salary advances / loans for the tenant
 */
export const listEmployeeLoans = async ( options?: RequestInit): Promise<EmployeeLoan[]> => {

  return customFetch<EmployeeLoan[]>(getListEmployeeLoansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmployeeLoansQueryKey = () => {
    return [
    `/api/payroll/loans`
    ] as const;
    }


export const getListEmployeeLoansQueryOptions = <TData = Awaited<ReturnType<typeof listEmployeeLoans>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployeeLoans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmployeeLoansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployeeLoans>>> = ({ signal }) => listEmployeeLoans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmployeeLoans>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEmployeeLoansQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployeeLoans>>>
export type ListEmployeeLoansQueryError = ErrorType<unknown>


/**
 * @summary List all employee salary advances / loans for the tenant
 */

export function useListEmployeeLoans<TData = Awaited<ReturnType<typeof listEmployeeLoans>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployeeLoans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEmployeeLoansQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateEmployeeLoanUrl = () => {




  return `/api/payroll/loans`
}

/**
 * @summary Create a new employee salary advance / loan
 */
export const createEmployeeLoan = async (employeeLoanInput: EmployeeLoanInput, options?: RequestInit): Promise<EmployeeLoan> => {

  return customFetch<EmployeeLoan>(getCreateEmployeeLoanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeLoanInput,)
  }
);}




export const getCreateEmployeeLoanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeLoan>>, TError,{data: BodyType<EmployeeLoanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployeeLoan>>, TError,{data: BodyType<EmployeeLoanInput>}, TContext> => {

const mutationKey = ['createEmployeeLoan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployeeLoan>>, {data: BodyType<EmployeeLoanInput>}> = (props) => {
          const {data} = props ?? {};

          return  createEmployeeLoan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeLoanMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployeeLoan>>>
    export type CreateEmployeeLoanMutationBody = BodyType<EmployeeLoanInput>
    export type CreateEmployeeLoanMutationError = ErrorType<unknown>

    /**
 * @summary Create a new employee salary advance / loan
 */
export const useCreateEmployeeLoan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeLoan>>, TError,{data: BodyType<EmployeeLoanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEmployeeLoan>>,
        TError,
        {data: BodyType<EmployeeLoanInput>},
        TContext
      > => {
      return useMutation(getCreateEmployeeLoanMutationOptions(options));
    }

export const getUpdateEmployeeLoanUrl = (id: number,) => {




  return `/api/payroll/loans/${id}`
}

/**
 * @summary Update an employee loan (e.g. mark fully repaid, adjust instalment)
 */
export const updateEmployeeLoan = async (id: number,
    employeeLoanUpdate: EmployeeLoanUpdate, options?: RequestInit): Promise<EmployeeLoan> => {

  return customFetch<EmployeeLoan>(getUpdateEmployeeLoanUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      employeeLoanUpdate,)
  }
);}




export const getUpdateEmployeeLoanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeLoan>>, TError,{id: number;data: BodyType<EmployeeLoanUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeLoan>>, TError,{id: number;data: BodyType<EmployeeLoanUpdate>}, TContext> => {

const mutationKey = ['updateEmployeeLoan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeLoan>>, {id: number;data: BodyType<EmployeeLoanUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployeeLoan(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeLoanMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeLoan>>>
    export type UpdateEmployeeLoanMutationBody = BodyType<EmployeeLoanUpdate>
    export type UpdateEmployeeLoanMutationError = ErrorType<unknown>

    /**
 * @summary Update an employee loan (e.g. mark fully repaid, adjust instalment)
 */
export const useUpdateEmployeeLoan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeLoan>>, TError,{id: number;data: BodyType<EmployeeLoanUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeLoan>>,
        TError,
        {id: number;data: BodyType<EmployeeLoanUpdate>},
        TContext
      > => {
      return useMutation(getUpdateEmployeeLoanMutationOptions(options));
    }

export const getDeleteEmployeeLoanUrl = (id: number,) => {




  return `/api/payroll/loans/${id}`
}

/**
 * @summary Delete an employee loan record
 */
export const deleteEmployeeLoan = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteEmployeeLoanUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEmployeeLoanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeLoan>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeLoan>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteEmployeeLoan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeLoan>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployeeLoan(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeLoanMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeLoan>>>

    export type DeleteEmployeeLoanMutationError = ErrorType<unknown>

    /**
 * @summary Delete an employee loan record
 */
export const useDeleteEmployeeLoan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeLoan>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployeeLoan>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteEmployeeLoanMutationOptions(options));
    }

export const getComputeFullFinalSettlementUrl = (employeeId: number,) => {




  return `/api/payroll/full-final/${employeeId}`
}

/**
 * @summary Compute full and final settlement for a separating employee
 */
export const computeFullFinalSettlement = async (employeeId: number,
    computeFullFinalSettlementBody: ComputeFullFinalSettlementBody, options?: RequestInit): Promise<ComputeFullFinalSettlement200> => {

  return customFetch<ComputeFullFinalSettlement200>(getComputeFullFinalSettlementUrl(employeeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      computeFullFinalSettlementBody,)
  }
);}




export const getComputeFullFinalSettlementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof computeFullFinalSettlement>>, TError,{employeeId: number;data: BodyType<ComputeFullFinalSettlementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof computeFullFinalSettlement>>, TError,{employeeId: number;data: BodyType<ComputeFullFinalSettlementBody>}, TContext> => {

const mutationKey = ['computeFullFinalSettlement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof computeFullFinalSettlement>>, {employeeId: number;data: BodyType<ComputeFullFinalSettlementBody>}> = (props) => {
          const {employeeId,data} = props ?? {};

          return  computeFullFinalSettlement(employeeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ComputeFullFinalSettlementMutationResult = NonNullable<Awaited<ReturnType<typeof computeFullFinalSettlement>>>
    export type ComputeFullFinalSettlementMutationBody = BodyType<ComputeFullFinalSettlementBody>
    export type ComputeFullFinalSettlementMutationError = ErrorType<unknown>

    /**
 * @summary Compute full and final settlement for a separating employee
 */
export const useComputeFullFinalSettlement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof computeFullFinalSettlement>>, TError,{employeeId: number;data: BodyType<ComputeFullFinalSettlementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof computeFullFinalSettlement>>,
        TError,
        {employeeId: number;data: BodyType<ComputeFullFinalSettlementBody>},
        TContext
      > => {
      return useMutation(getComputeFullFinalSettlementMutationOptions(options));
    }

export const getSeedPayrollConfigDefaultsUrl = () => {




  return `/api/payroll/config/seed-defaults`
}

/**
 * @summary Seed default payroll statutory configuration values for the tenant
 */
export const seedPayrollConfigDefaults = async ( options?: RequestInit): Promise<SeedPayrollConfigDefaults200> => {

  return customFetch<SeedPayrollConfigDefaults200>(getSeedPayrollConfigDefaultsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSeedPayrollConfigDefaultsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seedPayrollConfigDefaults>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof seedPayrollConfigDefaults>>, TError,void, TContext> => {

const mutationKey = ['seedPayrollConfigDefaults'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof seedPayrollConfigDefaults>>, void> = () => {


          return  seedPayrollConfigDefaults(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SeedPayrollConfigDefaultsMutationResult = NonNullable<Awaited<ReturnType<typeof seedPayrollConfigDefaults>>>

    export type SeedPayrollConfigDefaultsMutationError = ErrorType<unknown>

    /**
 * @summary Seed default payroll statutory configuration values for the tenant
 */
export const useSeedPayrollConfigDefaults = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seedPayrollConfigDefaults>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof seedPayrollConfigDefaults>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSeedPayrollConfigDefaultsMutationOptions(options));
    }

export const getGetTallyConfigUrl = () => {




  return `/api/tally/config`
}

/**
 * @summary Get Tally integration config for the current company
 */
export const getTallyConfig = async ( options?: RequestInit): Promise<TallyConfig> => {

  return customFetch<TallyConfig>(getGetTallyConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTallyConfigQueryKey = () => {
    return [
    `/api/tally/config`
    ] as const;
    }


export const getGetTallyConfigQueryOptions = <TData = Awaited<ReturnType<typeof getTallyConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTallyConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTallyConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTallyConfig>>> = ({ signal }) => getTallyConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTallyConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTallyConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getTallyConfig>>>
export type GetTallyConfigQueryError = ErrorType<unknown>


/**
 * @summary Get Tally integration config for the current company
 */

export function useGetTallyConfig<TData = Awaited<ReturnType<typeof getTallyConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTallyConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTallyConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateTallyConfigUrl = () => {




  return `/api/tally/config`
}

/**
 * @summary Create or update Tally integration config
 */
export const updateTallyConfig = async (tallyConfigInput: TallyConfigInput, options?: RequestInit): Promise<TallyConfig> => {

  return customFetch<TallyConfig>(getUpdateTallyConfigUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tallyConfigInput,)
  }
);}




export const getUpdateTallyConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTallyConfig>>, TError,{data: BodyType<TallyConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTallyConfig>>, TError,{data: BodyType<TallyConfigInput>}, TContext> => {

const mutationKey = ['updateTallyConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTallyConfig>>, {data: BodyType<TallyConfigInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateTallyConfig(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTallyConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateTallyConfig>>>
    export type UpdateTallyConfigMutationBody = BodyType<TallyConfigInput>
    export type UpdateTallyConfigMutationError = ErrorType<unknown>

    /**
 * @summary Create or update Tally integration config
 */
export const useUpdateTallyConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTallyConfig>>, TError,{data: BodyType<TallyConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTallyConfig>>,
        TError,
        {data: BodyType<TallyConfigInput>},
        TContext
      > => {
      return useMutation(getUpdateTallyConfigMutationOptions(options));
    }

export const getTestTallyConnectionUrl = () => {




  return `/api/tally/test-connection`
}

/**
 * @summary Ping the Tally HTTP gateway to verify connectivity
 */
export const testTallyConnection = async (testTallyConnectionBody?: TestTallyConnectionBody, options?: RequestInit): Promise<TestTallyConnection200> => {

  return customFetch<TestTallyConnection200>(getTestTallyConnectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testTallyConnectionBody,)
  }
);}




export const getTestTallyConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testTallyConnection>>, TError,{data?: BodyType<TestTallyConnectionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testTallyConnection>>, TError,{data?: BodyType<TestTallyConnectionBody>}, TContext> => {

const mutationKey = ['testTallyConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testTallyConnection>>, {data?: BodyType<TestTallyConnectionBody>}> = (props) => {
          const {data} = props ?? {};

          return  testTallyConnection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestTallyConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof testTallyConnection>>>
    export type TestTallyConnectionMutationBody = BodyType<TestTallyConnectionBody> | undefined
    export type TestTallyConnectionMutationError = ErrorType<unknown>

    /**
 * @summary Ping the Tally HTTP gateway to verify connectivity
 */
export const useTestTallyConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testTallyConnection>>, TError,{data?: BodyType<TestTallyConnectionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testTallyConnection>>,
        TError,
        {data?: BodyType<TestTallyConnectionBody>},
        TContext
      > => {
      return useMutation(getTestTallyConnectionMutationOptions(options));
    }

export const getListTallyLedgerMappingsUrl = () => {




  return `/api/tally/ledger-mappings`
}

/**
 * @summary List ERP account → Tally ledger name mappings
 */
export const listTallyLedgerMappings = async ( options?: RequestInit): Promise<TallyLedgerMapping[]> => {

  return customFetch<TallyLedgerMapping[]>(getListTallyLedgerMappingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTallyLedgerMappingsQueryKey = () => {
    return [
    `/api/tally/ledger-mappings`
    ] as const;
    }


export const getListTallyLedgerMappingsQueryOptions = <TData = Awaited<ReturnType<typeof listTallyLedgerMappings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallyLedgerMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTallyLedgerMappingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTallyLedgerMappings>>> = ({ signal }) => listTallyLedgerMappings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTallyLedgerMappings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTallyLedgerMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof listTallyLedgerMappings>>>
export type ListTallyLedgerMappingsQueryError = ErrorType<unknown>


/**
 * @summary List ERP account → Tally ledger name mappings
 */

export function useListTallyLedgerMappings<TData = Awaited<ReturnType<typeof listTallyLedgerMappings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallyLedgerMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTallyLedgerMappingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpsertTallyLedgerMappingUrl = () => {




  return `/api/tally/ledger-mappings`
}

/**
 * @summary Create or update a ledger mapping (upsert by erpAccountId)
 */
export const upsertTallyLedgerMapping = async (tallyLedgerMappingInput: TallyLedgerMappingInput, options?: RequestInit): Promise<TallyLedgerMapping> => {

  return customFetch<TallyLedgerMapping>(getUpsertTallyLedgerMappingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tallyLedgerMappingInput,)
  }
);}




export const getUpsertTallyLedgerMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertTallyLedgerMapping>>, TError,{data: BodyType<TallyLedgerMappingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertTallyLedgerMapping>>, TError,{data: BodyType<TallyLedgerMappingInput>}, TContext> => {

const mutationKey = ['upsertTallyLedgerMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertTallyLedgerMapping>>, {data: BodyType<TallyLedgerMappingInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertTallyLedgerMapping(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertTallyLedgerMappingMutationResult = NonNullable<Awaited<ReturnType<typeof upsertTallyLedgerMapping>>>
    export type UpsertTallyLedgerMappingMutationBody = BodyType<TallyLedgerMappingInput>
    export type UpsertTallyLedgerMappingMutationError = ErrorType<unknown>

    /**
 * @summary Create or update a ledger mapping (upsert by erpAccountId)
 */
export const useUpsertTallyLedgerMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertTallyLedgerMapping>>, TError,{data: BodyType<TallyLedgerMappingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertTallyLedgerMapping>>,
        TError,
        {data: BodyType<TallyLedgerMappingInput>},
        TContext
      > => {
      return useMutation(getUpsertTallyLedgerMappingMutationOptions(options));
    }

export const getDeleteTallyLedgerMappingUrl = (id: number,) => {




  return `/api/tally/ledger-mappings/${id}`
}

/**
 * @summary Delete a ledger mapping
 */
export const deleteTallyLedgerMapping = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTallyLedgerMappingUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTallyLedgerMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTallyLedgerMapping>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTallyLedgerMapping>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTallyLedgerMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTallyLedgerMapping>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTallyLedgerMapping(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTallyLedgerMappingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTallyLedgerMapping>>>

    export type DeleteTallyLedgerMappingMutationError = ErrorType<unknown>

    /**
 * @summary Delete a ledger mapping
 */
export const useDeleteTallyLedgerMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTallyLedgerMapping>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTallyLedgerMapping>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTallyLedgerMappingMutationOptions(options));
    }

export const getListTallyVoucherTypeMappingsUrl = () => {




  return `/api/tally/voucher-type-mappings`
}

/**
 * @summary List ERP voucher type → Tally voucher type mappings (with defaults)
 */
export const listTallyVoucherTypeMappings = async ( options?: RequestInit): Promise<TallyVoucherTypeMapping[]> => {

  return customFetch<TallyVoucherTypeMapping[]>(getListTallyVoucherTypeMappingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTallyVoucherTypeMappingsQueryKey = () => {
    return [
    `/api/tally/voucher-type-mappings`
    ] as const;
    }


export const getListTallyVoucherTypeMappingsQueryOptions = <TData = Awaited<ReturnType<typeof listTallyVoucherTypeMappings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallyVoucherTypeMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTallyVoucherTypeMappingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTallyVoucherTypeMappings>>> = ({ signal }) => listTallyVoucherTypeMappings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTallyVoucherTypeMappings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTallyVoucherTypeMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof listTallyVoucherTypeMappings>>>
export type ListTallyVoucherTypeMappingsQueryError = ErrorType<unknown>


/**
 * @summary List ERP voucher type → Tally voucher type mappings (with defaults)
 */

export function useListTallyVoucherTypeMappings<TData = Awaited<ReturnType<typeof listTallyVoucherTypeMappings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallyVoucherTypeMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTallyVoucherTypeMappingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSaveTallyVoucherTypeMappingsUrl = () => {




  return `/api/tally/voucher-type-mappings`
}

/**
 * @summary Bulk-replace all voucher type mappings for this company
 */
export const saveTallyVoucherTypeMappings = async (saveTallyVoucherTypeMappingsBodyItem: SaveTallyVoucherTypeMappingsBodyItem[], options?: RequestInit): Promise<SaveTallyVoucherTypeMappings200> => {

  return customFetch<SaveTallyVoucherTypeMappings200>(getSaveTallyVoucherTypeMappingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveTallyVoucherTypeMappingsBodyItem,)
  }
);}




export const getSaveTallyVoucherTypeMappingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTallyVoucherTypeMappings>>, TError,{data: BodyType<SaveTallyVoucherTypeMappingsBodyItem[]>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveTallyVoucherTypeMappings>>, TError,{data: BodyType<SaveTallyVoucherTypeMappingsBodyItem[]>}, TContext> => {

const mutationKey = ['saveTallyVoucherTypeMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveTallyVoucherTypeMappings>>, {data: BodyType<SaveTallyVoucherTypeMappingsBodyItem[]>}> = (props) => {
          const {data} = props ?? {};

          return  saveTallyVoucherTypeMappings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveTallyVoucherTypeMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof saveTallyVoucherTypeMappings>>>
    export type SaveTallyVoucherTypeMappingsMutationBody = BodyType<SaveTallyVoucherTypeMappingsBodyItem[]>
    export type SaveTallyVoucherTypeMappingsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk-replace all voucher type mappings for this company
 */
export const useSaveTallyVoucherTypeMappings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTallyVoucherTypeMappings>>, TError,{data: BodyType<SaveTallyVoucherTypeMappingsBodyItem[]>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveTallyVoucherTypeMappings>>,
        TError,
        {data: BodyType<SaveTallyVoucherTypeMappingsBodyItem[]>},
        TContext
      > => {
      return useMutation(getSaveTallyVoucherTypeMappingsMutationOptions(options));
    }

export const getListTallySyncQueueUrl = (params?: ListTallySyncQueueParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tally/sync-queue?${stringifiedParams}` : `/api/tally/sync-queue`
}

/**
 * @summary List outbound sync queue entries (most recent first, max 500)
 */
export const listTallySyncQueue = async (params?: ListTallySyncQueueParams, options?: RequestInit): Promise<TallySyncQueueItem[]> => {

  return customFetch<TallySyncQueueItem[]>(getListTallySyncQueueUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTallySyncQueueQueryKey = (params?: ListTallySyncQueueParams,) => {
    return [
    `/api/tally/sync-queue`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTallySyncQueueQueryOptions = <TData = Awaited<ReturnType<typeof listTallySyncQueue>>, TError = ErrorType<unknown>>(params?: ListTallySyncQueueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallySyncQueue>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTallySyncQueueQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTallySyncQueue>>> = ({ signal }) => listTallySyncQueue(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTallySyncQueue>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTallySyncQueueQueryResult = NonNullable<Awaited<ReturnType<typeof listTallySyncQueue>>>
export type ListTallySyncQueueQueryError = ErrorType<unknown>


/**
 * @summary List outbound sync queue entries (most recent first, max 500)
 */

export function useListTallySyncQueue<TData = Awaited<ReturnType<typeof listTallySyncQueue>>, TError = ErrorType<unknown>>(
 params?: ListTallySyncQueueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallySyncQueue>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTallySyncQueueQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getBulkQueueTallySyncUrl = () => {




  return `/api/tally/sync/bulk`
}

/**
 * @summary Queue all posted vouchers in a date range for Tally sync
 */
export const bulkQueueTallySync = async (bulkQueueTallySyncBody?: BulkQueueTallySyncBody, options?: RequestInit): Promise<BulkQueueTallySync200> => {

  return customFetch<BulkQueueTallySync200>(getBulkQueueTallySyncUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkQueueTallySyncBody,)
  }
);}




export const getBulkQueueTallySyncMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkQueueTallySync>>, TError,{data?: BodyType<BulkQueueTallySyncBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkQueueTallySync>>, TError,{data?: BodyType<BulkQueueTallySyncBody>}, TContext> => {

const mutationKey = ['bulkQueueTallySync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkQueueTallySync>>, {data?: BodyType<BulkQueueTallySyncBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkQueueTallySync(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkQueueTallySyncMutationResult = NonNullable<Awaited<ReturnType<typeof bulkQueueTallySync>>>
    export type BulkQueueTallySyncMutationBody = BodyType<BulkQueueTallySyncBody> | undefined
    export type BulkQueueTallySyncMutationError = ErrorType<unknown>

    /**
 * @summary Queue all posted vouchers in a date range for Tally sync
 */
export const useBulkQueueTallySync = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkQueueTallySync>>, TError,{data?: BodyType<BulkQueueTallySyncBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkQueueTallySync>>,
        TError,
        {data?: BodyType<BulkQueueTallySyncBody>},
        TContext
      > => {
      return useMutation(getBulkQueueTallySyncMutationOptions(options));
    }

export const getSyncVoucherToTallyUrl = (voucherId: number,) => {




  return `/api/tally/sync/${voucherId}`
}

/**
 * @summary Queue a single voucher and push it to Tally immediately (if enabled)
 */
export const syncVoucherToTally = async (voucherId: number, options?: RequestInit): Promise<TallySyncQueueItem> => {

  return customFetch<TallySyncQueueItem>(getSyncVoucherToTallyUrl(voucherId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSyncVoucherToTallyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncVoucherToTally>>, TError,{voucherId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncVoucherToTally>>, TError,{voucherId: number}, TContext> => {

const mutationKey = ['syncVoucherToTally'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncVoucherToTally>>, {voucherId: number}> = (props) => {
          const {voucherId} = props ?? {};

          return  syncVoucherToTally(voucherId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncVoucherToTallyMutationResult = NonNullable<Awaited<ReturnType<typeof syncVoucherToTally>>>

    export type SyncVoucherToTallyMutationError = ErrorType<unknown>

    /**
 * @summary Queue a single voucher and push it to Tally immediately (if enabled)
 */
export const useSyncVoucherToTally = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncVoucherToTally>>, TError,{voucherId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncVoucherToTally>>,
        TError,
        {voucherId: number},
        TContext
      > => {
      return useMutation(getSyncVoucherToTallyMutationOptions(options));
    }

export const getRetryTallySyncUrl = (syncId: number,) => {




  return `/api/tally/retry/${syncId}`
}

/**
 * @summary Retry a failed sync queue entry
 */
export const retryTallySync = async (syncId: number, options?: RequestInit): Promise<TallySyncQueueItem> => {

  return customFetch<TallySyncQueueItem>(getRetryTallySyncUrl(syncId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRetryTallySyncMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryTallySync>>, TError,{syncId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryTallySync>>, TError,{syncId: number}, TContext> => {

const mutationKey = ['retryTallySync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryTallySync>>, {syncId: number}> = (props) => {
          const {syncId} = props ?? {};

          return  retryTallySync(syncId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryTallySyncMutationResult = NonNullable<Awaited<ReturnType<typeof retryTallySync>>>

    export type RetryTallySyncMutationError = ErrorType<unknown>

    /**
 * @summary Retry a failed sync queue entry
 */
export const useRetryTallySync = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryTallySync>>, TError,{syncId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryTallySync>>,
        TError,
        {syncId: number},
        TContext
      > => {
      return useMutation(getRetryTallySyncMutationOptions(options));
    }

export const getDownloadVoucherTallyXmlUrl = (voucherId: number,) => {




  return `/api/tally/vouchers/${voucherId}/xml`
}

/**
 * @summary Download the Tally XML file for a voucher (air-gapped / manual import)
 */
export const downloadVoucherTallyXml = async (voucherId: number, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDownloadVoucherTallyXmlUrl(voucherId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadVoucherTallyXmlQueryKey = (voucherId: number,) => {
    return [
    `/api/tally/vouchers/${voucherId}/xml`
    ] as const;
    }


export const getDownloadVoucherTallyXmlQueryOptions = <TData = Awaited<ReturnType<typeof downloadVoucherTallyXml>>, TError = ErrorType<unknown>>(voucherId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadVoucherTallyXml>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadVoucherTallyXmlQueryKey(voucherId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadVoucherTallyXml>>> = ({ signal }) => downloadVoucherTallyXml(voucherId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(voucherId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadVoucherTallyXml>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadVoucherTallyXmlQueryResult = NonNullable<Awaited<ReturnType<typeof downloadVoucherTallyXml>>>
export type DownloadVoucherTallyXmlQueryError = ErrorType<unknown>


/**
 * @summary Download the Tally XML file for a voucher (air-gapped / manual import)
 */

export function useDownloadVoucherTallyXml<TData = Awaited<ReturnType<typeof downloadVoucherTallyXml>>, TError = ErrorType<unknown>>(
 voucherId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadVoucherTallyXml>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadVoucherTallyXmlQueryOptions(voucherId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPullTallyLedgersUrl = () => {




  return `/api/tally/pull-ledgers`
}

/**
 * @summary Pull ledger masters from Tally into tally_inbound_ledgers
 */
export const pullTallyLedgers = async ( options?: RequestInit): Promise<PullTallyLedgers200> => {

  return customFetch<PullTallyLedgers200>(getPullTallyLedgersUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPullTallyLedgersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullTallyLedgers>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullTallyLedgers>>, TError,void, TContext> => {

const mutationKey = ['pullTallyLedgers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullTallyLedgers>>, void> = () => {


          return  pullTallyLedgers(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullTallyLedgersMutationResult = NonNullable<Awaited<ReturnType<typeof pullTallyLedgers>>>

    export type PullTallyLedgersMutationError = ErrorType<unknown>

    /**
 * @summary Pull ledger masters from Tally into tally_inbound_ledgers
 */
export const usePullTallyLedgers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullTallyLedgers>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullTallyLedgers>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPullTallyLedgersMutationOptions(options));
    }

export const getListTallyInboundLedgersUrl = () => {




  return `/api/tally/inbound-ledgers`
}

/**
 * @summary List ledger masters pulled from Tally
 */
export const listTallyInboundLedgers = async ( options?: RequestInit): Promise<TallyInboundLedger[]> => {

  return customFetch<TallyInboundLedger[]>(getListTallyInboundLedgersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTallyInboundLedgersQueryKey = () => {
    return [
    `/api/tally/inbound-ledgers`
    ] as const;
    }


export const getListTallyInboundLedgersQueryOptions = <TData = Awaited<ReturnType<typeof listTallyInboundLedgers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallyInboundLedgers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTallyInboundLedgersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTallyInboundLedgers>>> = ({ signal }) => listTallyInboundLedgers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTallyInboundLedgers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTallyInboundLedgersQueryResult = NonNullable<Awaited<ReturnType<typeof listTallyInboundLedgers>>>
export type ListTallyInboundLedgersQueryError = ErrorType<unknown>


/**
 * @summary List ledger masters pulled from Tally
 */

export function useListTallyInboundLedgers<TData = Awaited<ReturnType<typeof listTallyInboundLedgers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallyInboundLedgers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTallyInboundLedgersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getMapTallyInboundLedgerUrl = (id: number,) => {




  return `/api/tally/inbound-ledgers/${id}/map`
}

/**
 * @summary Link a Tally ledger to an ERP chart-of-accounts account
 */
export const mapTallyInboundLedger = async (id: number,
    mapTallyInboundLedgerBody: MapTallyInboundLedgerBody, options?: RequestInit): Promise<TallyInboundLedger> => {

  return customFetch<TallyInboundLedger>(getMapTallyInboundLedgerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mapTallyInboundLedgerBody,)
  }
);}




export const getMapTallyInboundLedgerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapTallyInboundLedger>>, TError,{id: number;data: BodyType<MapTallyInboundLedgerBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mapTallyInboundLedger>>, TError,{id: number;data: BodyType<MapTallyInboundLedgerBody>}, TContext> => {

const mutationKey = ['mapTallyInboundLedger'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapTallyInboundLedger>>, {id: number;data: BodyType<MapTallyInboundLedgerBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  mapTallyInboundLedger(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MapTallyInboundLedgerMutationResult = NonNullable<Awaited<ReturnType<typeof mapTallyInboundLedger>>>
    export type MapTallyInboundLedgerMutationBody = BodyType<MapTallyInboundLedgerBody>
    export type MapTallyInboundLedgerMutationError = ErrorType<unknown>

    /**
 * @summary Link a Tally ledger to an ERP chart-of-accounts account
 */
export const useMapTallyInboundLedger = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapTallyInboundLedger>>, TError,{id: number;data: BodyType<MapTallyInboundLedgerBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof mapTallyInboundLedger>>,
        TError,
        {id: number;data: BodyType<MapTallyInboundLedgerBody>},
        TContext
      > => {
      return useMutation(getMapTallyInboundLedgerMutationOptions(options));
    }

export const getGetTallyReconciliationUrl = (params?: GetTallyReconciliationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tally/reconciliation?${stringifiedParams}` : `/api/tally/reconciliation`
}

/**
 * @summary Compare ERP closing balances against Tally closing balances for mapped accounts
 */
export const getTallyReconciliation = async (params?: GetTallyReconciliationParams, options?: RequestInit): Promise<TallyReconciliationReport> => {

  return customFetch<TallyReconciliationReport>(getGetTallyReconciliationUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTallyReconciliationQueryKey = (params?: GetTallyReconciliationParams,) => {
    return [
    `/api/tally/reconciliation`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTallyReconciliationQueryOptions = <TData = Awaited<ReturnType<typeof getTallyReconciliation>>, TError = ErrorType<unknown>>(params?: GetTallyReconciliationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTallyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTallyReconciliationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTallyReconciliation>>> = ({ signal }) => getTallyReconciliation(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTallyReconciliation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTallyReconciliationQueryResult = NonNullable<Awaited<ReturnType<typeof getTallyReconciliation>>>
export type GetTallyReconciliationQueryError = ErrorType<unknown>


/**
 * @summary Compare ERP closing balances against Tally closing balances for mapped accounts
 */

export function useGetTallyReconciliation<TData = Awaited<ReturnType<typeof getTallyReconciliation>>, TError = ErrorType<unknown>>(
 params?: GetTallyReconciliationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTallyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTallyReconciliationQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListTallyEnabledTenantsUrl = () => {




  return `/api/admin/tally-tenants`
}

/**
 * @summary Super-admin — list all tenants with Tally enabled
 */
export const listTallyEnabledTenants = async ( options?: RequestInit): Promise<TallyConfig[]> => {

  return customFetch<TallyConfig[]>(getListTallyEnabledTenantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTallyEnabledTenantsQueryKey = () => {
    return [
    `/api/admin/tally-tenants`
    ] as const;
    }


export const getListTallyEnabledTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listTallyEnabledTenants>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallyEnabledTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTallyEnabledTenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTallyEnabledTenants>>> = ({ signal }) => listTallyEnabledTenants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTallyEnabledTenants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTallyEnabledTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listTallyEnabledTenants>>>
export type ListTallyEnabledTenantsQueryError = ErrorType<unknown>


/**
 * @summary Super-admin — list all tenants with Tally enabled
 */

export function useListTallyEnabledTenants<TData = Awaited<ReturnType<typeof listTallyEnabledTenants>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTallyEnabledTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTallyEnabledTenantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetInventoryConfigUrl = () => {




  return `/api/inventory/config`
}

/**
 * @summary Get inventory module configuration for tenant
 */
export const getInventoryConfig = async ( options?: RequestInit): Promise<InventoryConfig> => {

  return customFetch<InventoryConfig>(getGetInventoryConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryConfigQueryKey = () => {
    return [
    `/api/inventory/config`
    ] as const;
    }


export const getGetInventoryConfigQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryConfig>>> = ({ signal }) => getInventoryConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryConfig>>>
export type GetInventoryConfigQueryError = ErrorType<unknown>


/**
 * @summary Get inventory module configuration for tenant
 */

export function useGetInventoryConfig<TData = Awaited<ReturnType<typeof getInventoryConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpsertInventoryConfigUrl = () => {




  return `/api/inventory/config`
}

/**
 * @summary Create or update inventory configuration
 */
export const upsertInventoryConfig = async (inventoryConfigInput: InventoryConfigInput, options?: RequestInit): Promise<InventoryConfig> => {

  return customFetch<InventoryConfig>(getUpsertInventoryConfigUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      inventoryConfigInput,)
  }
);}




export const getUpsertInventoryConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertInventoryConfig>>, TError,{data: BodyType<InventoryConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertInventoryConfig>>, TError,{data: BodyType<InventoryConfigInput>}, TContext> => {

const mutationKey = ['upsertInventoryConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertInventoryConfig>>, {data: BodyType<InventoryConfigInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertInventoryConfig(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertInventoryConfigMutationResult = NonNullable<Awaited<ReturnType<typeof upsertInventoryConfig>>>
    export type UpsertInventoryConfigMutationBody = BodyType<InventoryConfigInput>
    export type UpsertInventoryConfigMutationError = ErrorType<unknown>

    /**
 * @summary Create or update inventory configuration
 */
export const useUpsertInventoryConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertInventoryConfig>>, TError,{data: BodyType<InventoryConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertInventoryConfig>>,
        TError,
        {data: BodyType<InventoryConfigInput>},
        TContext
      > => {
      return useMutation(getUpsertInventoryConfigMutationOptions(options));
    }

export const getListWarehousesUrl = (params?: ListWarehousesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/warehouses?${stringifiedParams}` : `/api/inventory/warehouses`
}

/**
 * @summary List all warehouses for tenant
 */
export const listWarehouses = async (params?: ListWarehousesParams, options?: RequestInit): Promise<Warehouse[]> => {

  return customFetch<Warehouse[]>(getListWarehousesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWarehousesQueryKey = (params?: ListWarehousesParams,) => {
    return [
    `/api/inventory/warehouses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListWarehousesQueryOptions = <TData = Awaited<ReturnType<typeof listWarehouses>>, TError = ErrorType<unknown>>(params?: ListWarehousesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWarehouses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWarehousesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWarehouses>>> = ({ signal }) => listWarehouses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWarehouses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWarehousesQueryResult = NonNullable<Awaited<ReturnType<typeof listWarehouses>>>
export type ListWarehousesQueryError = ErrorType<unknown>


/**
 * @summary List all warehouses for tenant
 */

export function useListWarehouses<TData = Awaited<ReturnType<typeof listWarehouses>>, TError = ErrorType<unknown>>(
 params?: ListWarehousesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWarehouses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWarehousesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateWarehouseUrl = () => {




  return `/api/inventory/warehouses`
}

/**
 * @summary Create a new warehouse
 */
export const createWarehouse = async (warehouseInput: WarehouseInput, options?: RequestInit): Promise<Warehouse> => {

  return customFetch<Warehouse>(getCreateWarehouseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      warehouseInput,)
  }
);}




export const getCreateWarehouseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWarehouse>>, TError,{data: BodyType<WarehouseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWarehouse>>, TError,{data: BodyType<WarehouseInput>}, TContext> => {

const mutationKey = ['createWarehouse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWarehouse>>, {data: BodyType<WarehouseInput>}> = (props) => {
          const {data} = props ?? {};

          return  createWarehouse(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWarehouseMutationResult = NonNullable<Awaited<ReturnType<typeof createWarehouse>>>
    export type CreateWarehouseMutationBody = BodyType<WarehouseInput>
    export type CreateWarehouseMutationError = ErrorType<unknown>

    /**
 * @summary Create a new warehouse
 */
export const useCreateWarehouse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWarehouse>>, TError,{data: BodyType<WarehouseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWarehouse>>,
        TError,
        {data: BodyType<WarehouseInput>},
        TContext
      > => {
      return useMutation(getCreateWarehouseMutationOptions(options));
    }

export const getGetWarehouseUrl = (id: number,) => {




  return `/api/inventory/warehouses/${id}`
}

/**
 * @summary Get warehouse with bin locations
 */
export const getWarehouse = async (id: number, options?: RequestInit): Promise<WarehouseDetail> => {

  return customFetch<WarehouseDetail>(getGetWarehouseUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWarehouseQueryKey = (id: number,) => {
    return [
    `/api/inventory/warehouses/${id}`
    ] as const;
    }


export const getGetWarehouseQueryOptions = <TData = Awaited<ReturnType<typeof getWarehouse>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWarehouse>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWarehouseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWarehouse>>> = ({ signal }) => getWarehouse(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWarehouse>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWarehouseQueryResult = NonNullable<Awaited<ReturnType<typeof getWarehouse>>>
export type GetWarehouseQueryError = ErrorType<void>


/**
 * @summary Get warehouse with bin locations
 */

export function useGetWarehouse<TData = Awaited<ReturnType<typeof getWarehouse>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWarehouse>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWarehouseQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateWarehouseUrl = (id: number,) => {




  return `/api/inventory/warehouses/${id}`
}

/**
 * @summary Update warehouse
 */
export const updateWarehouse = async (id: number,
    warehouseInput: WarehouseInput, options?: RequestInit): Promise<Warehouse> => {

  return customFetch<Warehouse>(getUpdateWarehouseUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      warehouseInput,)
  }
);}




export const getUpdateWarehouseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWarehouse>>, TError,{id: number;data: BodyType<WarehouseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWarehouse>>, TError,{id: number;data: BodyType<WarehouseInput>}, TContext> => {

const mutationKey = ['updateWarehouse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWarehouse>>, {id: number;data: BodyType<WarehouseInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWarehouse(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWarehouseMutationResult = NonNullable<Awaited<ReturnType<typeof updateWarehouse>>>
    export type UpdateWarehouseMutationBody = BodyType<WarehouseInput>
    export type UpdateWarehouseMutationError = ErrorType<unknown>

    /**
 * @summary Update warehouse
 */
export const useUpdateWarehouse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWarehouse>>, TError,{id: number;data: BodyType<WarehouseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateWarehouse>>,
        TError,
        {id: number;data: BodyType<WarehouseInput>},
        TContext
      > => {
      return useMutation(getUpdateWarehouseMutationOptions(options));
    }

export const getDeleteWarehouseUrl = (id: number,) => {




  return `/api/inventory/warehouses/${id}`
}

/**
 * @summary Delete warehouse (only if no stock on hand)
 */
export const deleteWarehouse = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteWarehouseUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteWarehouseMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWarehouse>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWarehouse>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteWarehouse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWarehouse>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteWarehouse(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWarehouseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWarehouse>>>

    export type DeleteWarehouseMutationError = ErrorType<void>

    /**
 * @summary Delete warehouse (only if no stock on hand)
 */
export const useDeleteWarehouse = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWarehouse>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteWarehouse>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteWarehouseMutationOptions(options));
    }

export const getListBinsUrl = (id: number,) => {




  return `/api/inventory/warehouses/${id}/bins`
}

/**
 * @summary List bin locations for a warehouse
 */
export const listBins = async (id: number, options?: RequestInit): Promise<Bin[]> => {

  return customFetch<Bin[]>(getListBinsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBinsQueryKey = (id: number,) => {
    return [
    `/api/inventory/warehouses/${id}/bins`
    ] as const;
    }


export const getListBinsQueryOptions = <TData = Awaited<ReturnType<typeof listBins>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBins>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBinsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBins>>> = ({ signal }) => listBins(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBins>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBinsQueryResult = NonNullable<Awaited<ReturnType<typeof listBins>>>
export type ListBinsQueryError = ErrorType<unknown>


/**
 * @summary List bin locations for a warehouse
 */

export function useListBins<TData = Awaited<ReturnType<typeof listBins>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBins>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBinsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBinUrl = (id: number,) => {




  return `/api/inventory/warehouses/${id}/bins`
}

/**
 * @summary Create a bin location
 */
export const createBin = async (id: number,
    binInput: BinInput, options?: RequestInit): Promise<Bin> => {

  return customFetch<Bin>(getCreateBinUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      binInput,)
  }
);}




export const getCreateBinMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBin>>, TError,{id: number;data: BodyType<BinInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBin>>, TError,{id: number;data: BodyType<BinInput>}, TContext> => {

const mutationKey = ['createBin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBin>>, {id: number;data: BodyType<BinInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createBin(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBinMutationResult = NonNullable<Awaited<ReturnType<typeof createBin>>>
    export type CreateBinMutationBody = BodyType<BinInput>
    export type CreateBinMutationError = ErrorType<unknown>

    /**
 * @summary Create a bin location
 */
export const useCreateBin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBin>>, TError,{id: number;data: BodyType<BinInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBin>>,
        TError,
        {id: number;data: BodyType<BinInput>},
        TContext
      > => {
      return useMutation(getCreateBinMutationOptions(options));
    }

export const getUpdateBinUrl = (warehouseId: number,
    binId: number,) => {




  return `/api/inventory/warehouses/${warehouseId}/bins/${binId}`
}

/**
 * @summary Update a bin location
 */
export const updateBin = async (warehouseId: number,
    binId: number,
    binInput: BinInput, options?: RequestInit): Promise<Bin> => {

  return customFetch<Bin>(getUpdateBinUrl(warehouseId,binId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      binInput,)
  }
);}




export const getUpdateBinMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBin>>, TError,{warehouseId: number;binId: number;data: BodyType<BinInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBin>>, TError,{warehouseId: number;binId: number;data: BodyType<BinInput>}, TContext> => {

const mutationKey = ['updateBin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBin>>, {warehouseId: number;binId: number;data: BodyType<BinInput>}> = (props) => {
          const {warehouseId,binId,data} = props ?? {};

          return  updateBin(warehouseId,binId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBinMutationResult = NonNullable<Awaited<ReturnType<typeof updateBin>>>
    export type UpdateBinMutationBody = BodyType<BinInput>
    export type UpdateBinMutationError = ErrorType<unknown>

    /**
 * @summary Update a bin location
 */
export const useUpdateBin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBin>>, TError,{warehouseId: number;binId: number;data: BodyType<BinInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBin>>,
        TError,
        {warehouseId: number;binId: number;data: BodyType<BinInput>},
        TContext
      > => {
      return useMutation(getUpdateBinMutationOptions(options));
    }

export const getDeleteBinUrl = (warehouseId: number,
    binId: number,) => {




  return `/api/inventory/warehouses/${warehouseId}/bins/${binId}`
}

/**
 * @summary Delete a bin location
 */
export const deleteBin = async (warehouseId: number,
    binId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteBinUrl(warehouseId,binId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteBinMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBin>>, TError,{warehouseId: number;binId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBin>>, TError,{warehouseId: number;binId: number}, TContext> => {

const mutationKey = ['deleteBin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBin>>, {warehouseId: number;binId: number}> = (props) => {
          const {warehouseId,binId} = props ?? {};

          return  deleteBin(warehouseId,binId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBinMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBin>>>

    export type DeleteBinMutationError = ErrorType<unknown>

    /**
 * @summary Delete a bin location
 */
export const useDeleteBin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBin>>, TError,{warehouseId: number;binId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteBin>>,
        TError,
        {warehouseId: number;binId: number},
        TContext
      > => {
      return useMutation(getDeleteBinMutationOptions(options));
    }

export const getListBatchesUrl = (params?: ListBatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/batches?${stringifiedParams}` : `/api/inventory/batches`
}

/**
 * @summary List batches/lots for tenant
 */
export const listBatches = async (params?: ListBatchesParams, options?: RequestInit): Promise<Batch[]> => {

  return customFetch<Batch[]>(getListBatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBatchesQueryKey = (params?: ListBatchesParams,) => {
    return [
    `/api/inventory/batches`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBatchesQueryOptions = <TData = Awaited<ReturnType<typeof listBatches>>, TError = ErrorType<unknown>>(params?: ListBatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBatches>>> = ({ signal }) => listBatches(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBatches>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listBatches>>>
export type ListBatchesQueryError = ErrorType<unknown>


/**
 * @summary List batches/lots for tenant
 */

export function useListBatches<TData = Awaited<ReturnType<typeof listBatches>>, TError = ErrorType<unknown>>(
 params?: ListBatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBatchesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBatchUrl = () => {




  return `/api/inventory/batches`
}

/**
 * @summary Create a new batch/lot number record
 */
export const createBatch = async (batchInput: BatchInput, options?: RequestInit): Promise<Batch> => {

  return customFetch<Batch>(getCreateBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      batchInput,)
  }
);}




export const getCreateBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBatch>>, TError,{data: BodyType<BatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBatch>>, TError,{data: BodyType<BatchInput>}, TContext> => {

const mutationKey = ['createBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBatch>>, {data: BodyType<BatchInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createBatch>>>
    export type CreateBatchMutationBody = BodyType<BatchInput>
    export type CreateBatchMutationError = ErrorType<unknown>

    /**
 * @summary Create a new batch/lot number record
 */
export const useCreateBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBatch>>, TError,{data: BodyType<BatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBatch>>,
        TError,
        {data: BodyType<BatchInput>},
        TContext
      > => {
      return useMutation(getCreateBatchMutationOptions(options));
    }

export const getGetBatchUrl = (id: number,) => {




  return `/api/inventory/batches/${id}`
}

/**
 * @summary Get batch detail
 */
export const getBatch = async (id: number, options?: RequestInit): Promise<Batch> => {

  return customFetch<Batch>(getGetBatchUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBatchQueryKey = (id: number,) => {
    return [
    `/api/inventory/batches/${id}`
    ] as const;
    }


export const getGetBatchQueryOptions = <TData = Awaited<ReturnType<typeof getBatch>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBatchQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatch>>> = ({ signal }) => getBatch(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBatchQueryResult = NonNullable<Awaited<ReturnType<typeof getBatch>>>
export type GetBatchQueryError = ErrorType<void>


/**
 * @summary Get batch detail
 */

export function useGetBatch<TData = Awaited<ReturnType<typeof getBatch>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBatchQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateBatchUrl = (id: number,) => {




  return `/api/inventory/batches/${id}`
}

/**
 * @summary Update batch record
 */
export const updateBatch = async (id: number,
    batchInput: BatchInput, options?: RequestInit): Promise<Batch> => {

  return customFetch<Batch>(getUpdateBatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      batchInput,)
  }
);}




export const getUpdateBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBatch>>, TError,{id: number;data: BodyType<BatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBatch>>, TError,{id: number;data: BodyType<BatchInput>}, TContext> => {

const mutationKey = ['updateBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBatch>>, {id: number;data: BodyType<BatchInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateBatch>>>
    export type UpdateBatchMutationBody = BodyType<BatchInput>
    export type UpdateBatchMutationError = ErrorType<unknown>

    /**
 * @summary Update batch record
 */
export const useUpdateBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBatch>>, TError,{id: number;data: BodyType<BatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBatch>>,
        TError,
        {id: number;data: BodyType<BatchInput>},
        TContext
      > => {
      return useMutation(getUpdateBatchMutationOptions(options));
    }

export const getListStockLevelsUrl = (params?: ListStockLevelsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/stock-levels?${stringifiedParams}` : `/api/inventory/stock-levels`
}

/**
 * @summary Real-time stock positions per product per warehouse
 */
export const listStockLevels = async (params?: ListStockLevelsParams, options?: RequestInit): Promise<StockLevel[]> => {

  return customFetch<StockLevel[]>(getListStockLevelsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStockLevelsQueryKey = (params?: ListStockLevelsParams,) => {
    return [
    `/api/inventory/stock-levels`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStockLevelsQueryOptions = <TData = Awaited<ReturnType<typeof listStockLevels>>, TError = ErrorType<unknown>>(params?: ListStockLevelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStockLevels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStockLevelsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStockLevels>>> = ({ signal }) => listStockLevels(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStockLevels>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStockLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof listStockLevels>>>
export type ListStockLevelsQueryError = ErrorType<unknown>


/**
 * @summary Real-time stock positions per product per warehouse
 */

export function useListStockLevels<TData = Awaited<ReturnType<typeof listStockLevels>>, TError = ErrorType<unknown>>(
 params?: ListStockLevelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStockLevels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStockLevelsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListStockMovementsUrl = (params?: ListStockMovementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/movements?${stringifiedParams}` : `/api/inventory/movements`
}

/**
 * @summary List stock movements with optional filters
 */
export const listStockMovements = async (params?: ListStockMovementsParams, options?: RequestInit): Promise<StockMovement[]> => {

  return customFetch<StockMovement[]>(getListStockMovementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStockMovementsQueryKey = (params?: ListStockMovementsParams,) => {
    return [
    `/api/inventory/movements`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStockMovementsQueryOptions = <TData = Awaited<ReturnType<typeof listStockMovements>>, TError = ErrorType<unknown>>(params?: ListStockMovementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStockMovements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStockMovementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStockMovements>>> = ({ signal }) => listStockMovements(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStockMovements>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStockMovementsQueryResult = NonNullable<Awaited<ReturnType<typeof listStockMovements>>>
export type ListStockMovementsQueryError = ErrorType<unknown>


/**
 * @summary List stock movements with optional filters
 */

export function useListStockMovements<TData = Awaited<ReturnType<typeof listStockMovements>>, TError = ErrorType<unknown>>(
 params?: ListStockMovementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStockMovements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStockMovementsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateStockMovementUrl = () => {




  return `/api/inventory/movements`
}

/**
 * @summary Create a new stock movement (draft)
 */
export const createStockMovement = async (stockMovementInput: StockMovementInput, options?: RequestInit): Promise<StockMovement> => {

  return customFetch<StockMovement>(getCreateStockMovementUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockMovementInput,)
  }
);}




export const getCreateStockMovementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStockMovement>>, TError,{data: BodyType<StockMovementInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createStockMovement>>, TError,{data: BodyType<StockMovementInput>}, TContext> => {

const mutationKey = ['createStockMovement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStockMovement>>, {data: BodyType<StockMovementInput>}> = (props) => {
          const {data} = props ?? {};

          return  createStockMovement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStockMovementMutationResult = NonNullable<Awaited<ReturnType<typeof createStockMovement>>>
    export type CreateStockMovementMutationBody = BodyType<StockMovementInput>
    export type CreateStockMovementMutationError = ErrorType<unknown>

    /**
 * @summary Create a new stock movement (draft)
 */
export const useCreateStockMovement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStockMovement>>, TError,{data: BodyType<StockMovementInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStockMovement>>,
        TError,
        {data: BodyType<StockMovementInput>},
        TContext
      > => {
      return useMutation(getCreateStockMovementMutationOptions(options));
    }

export const getGetStockMovementUrl = (id: number,) => {




  return `/api/inventory/movements/${id}`
}

/**
 * @summary Get movement with line items
 */
export const getStockMovement = async (id: number, options?: RequestInit): Promise<StockMovementDetail> => {

  return customFetch<StockMovementDetail>(getGetStockMovementUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStockMovementQueryKey = (id: number,) => {
    return [
    `/api/inventory/movements/${id}`
    ] as const;
    }


export const getGetStockMovementQueryOptions = <TData = Awaited<ReturnType<typeof getStockMovement>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStockMovement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStockMovementQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockMovement>>> = ({ signal }) => getStockMovement(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStockMovement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStockMovementQueryResult = NonNullable<Awaited<ReturnType<typeof getStockMovement>>>
export type GetStockMovementQueryError = ErrorType<void>


/**
 * @summary Get movement with line items
 */

export function useGetStockMovement<TData = Awaited<ReturnType<typeof getStockMovement>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStockMovement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStockMovementQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateStockMovementUrl = (id: number,) => {




  return `/api/inventory/movements/${id}`
}

/**
 * @summary Update movement header (draft only)
 */
export const updateStockMovement = async (id: number,
    stockMovementInput: StockMovementInput, options?: RequestInit): Promise<StockMovement> => {

  return customFetch<StockMovement>(getUpdateStockMovementUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockMovementInput,)
  }
);}




export const getUpdateStockMovementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStockMovement>>, TError,{id: number;data: BodyType<StockMovementInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStockMovement>>, TError,{id: number;data: BodyType<StockMovementInput>}, TContext> => {

const mutationKey = ['updateStockMovement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStockMovement>>, {id: number;data: BodyType<StockMovementInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateStockMovement(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStockMovementMutationResult = NonNullable<Awaited<ReturnType<typeof updateStockMovement>>>
    export type UpdateStockMovementMutationBody = BodyType<StockMovementInput>
    export type UpdateStockMovementMutationError = ErrorType<unknown>

    /**
 * @summary Update movement header (draft only)
 */
export const useUpdateStockMovement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStockMovement>>, TError,{id: number;data: BodyType<StockMovementInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateStockMovement>>,
        TError,
        {id: number;data: BodyType<StockMovementInput>},
        TContext
      > => {
      return useMutation(getUpdateStockMovementMutationOptions(options));
    }

export const getApproveStockMovementUrl = (id: number,) => {




  return `/api/inventory/movements/${id}/approve`
}

/**
 * @summary Approve a draft movement (status → approved)
 */
export const approveStockMovement = async (id: number, options?: RequestInit): Promise<StockMovement> => {

  return customFetch<StockMovement>(getApproveStockMovementUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApproveStockMovementMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveStockMovement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveStockMovement>>, TError,{id: number}, TContext> => {

const mutationKey = ['approveStockMovement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveStockMovement>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  approveStockMovement(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveStockMovementMutationResult = NonNullable<Awaited<ReturnType<typeof approveStockMovement>>>

    export type ApproveStockMovementMutationError = ErrorType<void>

    /**
 * @summary Approve a draft movement (status → approved)
 */
export const useApproveStockMovement = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveStockMovement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveStockMovement>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApproveStockMovementMutationOptions(options));
    }

export const getPostStockMovementUrl = (id: number,) => {




  return `/api/inventory/movements/${id}/post`
}

/**
 * Movement **must be in `approved` status** before posting (draft → /approve → /post).
Atomically (within a single DB transaction):
- Computes FIFO/weighted-average cost for each line
- Updates stockLevels (qty, avgCost, totalValue)
- Flips movement status to `posted`
Finance posting requires `stockAdjustmentAccountId` to be configured for GRN and
return-to-vendor movements; if unset, finance posting is skipped with a warning.
GRN→vendor-bill creation and finance journal posting follow outside the transaction
and are non-fatal (errors are logged but do not roll back the stock posting).

 * @summary Post movement — updates stock levels, stamps costs, fires finance journal
 */
export const postStockMovement = async (id: number, options?: RequestInit): Promise<StockMovement> => {

  return customFetch<StockMovement>(getPostStockMovementUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostStockMovementMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStockMovement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postStockMovement>>, TError,{id: number}, TContext> => {

const mutationKey = ['postStockMovement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStockMovement>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postStockMovement(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostStockMovementMutationResult = NonNullable<Awaited<ReturnType<typeof postStockMovement>>>

    export type PostStockMovementMutationError = ErrorType<void>

    /**
 * @summary Post movement — updates stock levels, stamps costs, fires finance journal
 */
export const usePostStockMovement = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStockMovement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postStockMovement>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostStockMovementMutationOptions(options));
    }

export const getCancelStockMovementUrl = (id: number,) => {




  return `/api/inventory/movements/${id}/cancel`
}

/**
 * @summary Cancel a movement (cannot cancel posted movements)
 */
export const cancelStockMovement = async (id: number, options?: RequestInit): Promise<StockMovement> => {

  return customFetch<StockMovement>(getCancelStockMovementUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCancelStockMovementMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelStockMovement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelStockMovement>>, TError,{id: number}, TContext> => {

const mutationKey = ['cancelStockMovement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelStockMovement>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  cancelStockMovement(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelStockMovementMutationResult = NonNullable<Awaited<ReturnType<typeof cancelStockMovement>>>

    export type CancelStockMovementMutationError = ErrorType<void>

    /**
 * @summary Cancel a movement (cannot cancel posted movements)
 */
export const useCancelStockMovement = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelStockMovement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelStockMovement>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCancelStockMovementMutationOptions(options));
    }

export const getListPurchaseIndentsUrl = (params?: ListPurchaseIndentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/indents?${stringifiedParams}` : `/api/inventory/indents`
}

/**
 * @summary List purchase indents (material requisitions)
 */
export const listPurchaseIndents = async (params?: ListPurchaseIndentsParams, options?: RequestInit): Promise<PurchaseIndent[]> => {

  return customFetch<PurchaseIndent[]>(getListPurchaseIndentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseIndentsQueryKey = (params?: ListPurchaseIndentsParams,) => {
    return [
    `/api/inventory/indents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseIndentsQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseIndents>>, TError = ErrorType<unknown>>(params?: ListPurchaseIndentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseIndents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseIndentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseIndents>>> = ({ signal }) => listPurchaseIndents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseIndents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseIndentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseIndents>>>
export type ListPurchaseIndentsQueryError = ErrorType<unknown>


/**
 * @summary List purchase indents (material requisitions)
 */

export function useListPurchaseIndents<TData = Awaited<ReturnType<typeof listPurchaseIndents>>, TError = ErrorType<unknown>>(
 params?: ListPurchaseIndentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseIndents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseIndentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePurchaseIndentUrl = () => {




  return `/api/inventory/indents`
}

/**
 * @summary Create a purchase indent
 */
export const createPurchaseIndent = async (purchaseIndentInput: PurchaseIndentInput, options?: RequestInit): Promise<PurchaseIndent> => {

  return customFetch<PurchaseIndent>(getCreatePurchaseIndentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      purchaseIndentInput,)
  }
);}




export const getCreatePurchaseIndentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseIndent>>, TError,{data: BodyType<PurchaseIndentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPurchaseIndent>>, TError,{data: BodyType<PurchaseIndentInput>}, TContext> => {

const mutationKey = ['createPurchaseIndent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPurchaseIndent>>, {data: BodyType<PurchaseIndentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPurchaseIndent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePurchaseIndentMutationResult = NonNullable<Awaited<ReturnType<typeof createPurchaseIndent>>>
    export type CreatePurchaseIndentMutationBody = BodyType<PurchaseIndentInput>
    export type CreatePurchaseIndentMutationError = ErrorType<unknown>

    /**
 * @summary Create a purchase indent
 */
export const useCreatePurchaseIndent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseIndent>>, TError,{data: BodyType<PurchaseIndentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPurchaseIndent>>,
        TError,
        {data: BodyType<PurchaseIndentInput>},
        TContext
      > => {
      return useMutation(getCreatePurchaseIndentMutationOptions(options));
    }

export const getGetPurchaseIndentUrl = (id: number,) => {




  return `/api/inventory/indents/${id}`
}

/**
 * @summary Get indent with line items
 */
export const getPurchaseIndent = async (id: number, options?: RequestInit): Promise<PurchaseIndentDetail> => {

  return customFetch<PurchaseIndentDetail>(getGetPurchaseIndentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseIndentQueryKey = (id: number,) => {
    return [
    `/api/inventory/indents/${id}`
    ] as const;
    }


export const getGetPurchaseIndentQueryOptions = <TData = Awaited<ReturnType<typeof getPurchaseIndent>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseIndent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseIndentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchaseIndent>>> = ({ signal }) => getPurchaseIndent(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchaseIndent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseIndentQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchaseIndent>>>
export type GetPurchaseIndentQueryError = ErrorType<void>


/**
 * @summary Get indent with line items
 */

export function useGetPurchaseIndent<TData = Awaited<ReturnType<typeof getPurchaseIndent>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseIndent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseIndentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePurchaseIndentUrl = (id: number,) => {




  return `/api/inventory/indents/${id}`
}

/**
 * @summary Update indent (draft only)
 */
export const updatePurchaseIndent = async (id: number,
    purchaseIndentInput: PurchaseIndentInput, options?: RequestInit): Promise<PurchaseIndent> => {

  return customFetch<PurchaseIndent>(getUpdatePurchaseIndentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      purchaseIndentInput,)
  }
);}




export const getUpdatePurchaseIndentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseIndent>>, TError,{id: number;data: BodyType<PurchaseIndentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseIndent>>, TError,{id: number;data: BodyType<PurchaseIndentInput>}, TContext> => {

const mutationKey = ['updatePurchaseIndent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePurchaseIndent>>, {id: number;data: BodyType<PurchaseIndentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePurchaseIndent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePurchaseIndentMutationResult = NonNullable<Awaited<ReturnType<typeof updatePurchaseIndent>>>
    export type UpdatePurchaseIndentMutationBody = BodyType<PurchaseIndentInput>
    export type UpdatePurchaseIndentMutationError = ErrorType<unknown>

    /**
 * @summary Update indent (draft only)
 */
export const useUpdatePurchaseIndent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseIndent>>, TError,{id: number;data: BodyType<PurchaseIndentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePurchaseIndent>>,
        TError,
        {id: number;data: BodyType<PurchaseIndentInput>},
        TContext
      > => {
      return useMutation(getUpdatePurchaseIndentMutationOptions(options));
    }

export const getSubmitPurchaseIndentUrl = (id: number,) => {




  return `/api/inventory/indents/${id}/submit`
}

/**
 * @summary Submit indent for approval
 */
export const submitPurchaseIndent = async (id: number, options?: RequestInit): Promise<PurchaseIndent> => {

  return customFetch<PurchaseIndent>(getSubmitPurchaseIndentUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSubmitPurchaseIndentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPurchaseIndent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitPurchaseIndent>>, TError,{id: number}, TContext> => {

const mutationKey = ['submitPurchaseIndent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitPurchaseIndent>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  submitPurchaseIndent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitPurchaseIndentMutationResult = NonNullable<Awaited<ReturnType<typeof submitPurchaseIndent>>>

    export type SubmitPurchaseIndentMutationError = ErrorType<unknown>

    /**
 * @summary Submit indent for approval
 */
export const useSubmitPurchaseIndent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPurchaseIndent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitPurchaseIndent>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getSubmitPurchaseIndentMutationOptions(options));
    }

export const getApprovePurchaseIndentUrl = (id: number,) => {




  return `/api/inventory/indents/${id}/approve`
}

/**
 * @summary Approve indent (status → approved)
 */
export const approvePurchaseIndent = async (id: number, options?: RequestInit): Promise<PurchaseIndent> => {

  return customFetch<PurchaseIndent>(getApprovePurchaseIndentUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApprovePurchaseIndentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePurchaseIndent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePurchaseIndent>>, TError,{id: number}, TContext> => {

const mutationKey = ['approvePurchaseIndent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePurchaseIndent>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  approvePurchaseIndent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePurchaseIndentMutationResult = NonNullable<Awaited<ReturnType<typeof approvePurchaseIndent>>>

    export type ApprovePurchaseIndentMutationError = ErrorType<unknown>

    /**
 * @summary Approve indent (status → approved)
 */
export const useApprovePurchaseIndent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePurchaseIndent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approvePurchaseIndent>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApprovePurchaseIndentMutationOptions(options));
    }

export const getCancelPurchaseIndentUrl = (id: number,) => {




  return `/api/inventory/indents/${id}/cancel`
}

/**
 * @summary Cancel indent
 */
export const cancelPurchaseIndent = async (id: number, options?: RequestInit): Promise<PurchaseIndent> => {

  return customFetch<PurchaseIndent>(getCancelPurchaseIndentUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCancelPurchaseIndentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPurchaseIndent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelPurchaseIndent>>, TError,{id: number}, TContext> => {

const mutationKey = ['cancelPurchaseIndent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPurchaseIndent>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  cancelPurchaseIndent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPurchaseIndentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPurchaseIndent>>>

    export type CancelPurchaseIndentMutationError = ErrorType<unknown>

    /**
 * @summary Cancel indent
 */
export const useCancelPurchaseIndent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPurchaseIndent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelPurchaseIndent>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCancelPurchaseIndentMutationOptions(options));
    }

export const getListRfqsUrl = (params?: ListRfqsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/rfqs?${stringifiedParams}` : `/api/inventory/rfqs`
}

/**
 * @summary List Requests for Quotation
 */
export const listRfqs = async (params?: ListRfqsParams, options?: RequestInit): Promise<PurchaseRfq[]> => {

  return customFetch<PurchaseRfq[]>(getListRfqsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRfqsQueryKey = (params?: ListRfqsParams,) => {
    return [
    `/api/inventory/rfqs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRfqsQueryOptions = <TData = Awaited<ReturnType<typeof listRfqs>>, TError = ErrorType<unknown>>(params?: ListRfqsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRfqs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRfqsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRfqs>>> = ({ signal }) => listRfqs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRfqs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRfqsQueryResult = NonNullable<Awaited<ReturnType<typeof listRfqs>>>
export type ListRfqsQueryError = ErrorType<unknown>


/**
 * @summary List Requests for Quotation
 */

export function useListRfqs<TData = Awaited<ReturnType<typeof listRfqs>>, TError = ErrorType<unknown>>(
 params?: ListRfqsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRfqs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRfqsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateRfqUrl = () => {




  return `/api/inventory/rfqs`
}

/**
 * @summary Create an RFQ (optionally linked to an indent)
 */
export const createRfq = async (purchaseRfqInput: PurchaseRfqInput, options?: RequestInit): Promise<PurchaseRfq> => {

  return customFetch<PurchaseRfq>(getCreateRfqUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      purchaseRfqInput,)
  }
);}




export const getCreateRfqMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRfq>>, TError,{data: BodyType<PurchaseRfqInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRfq>>, TError,{data: BodyType<PurchaseRfqInput>}, TContext> => {

const mutationKey = ['createRfq'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRfq>>, {data: BodyType<PurchaseRfqInput>}> = (props) => {
          const {data} = props ?? {};

          return  createRfq(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRfqMutationResult = NonNullable<Awaited<ReturnType<typeof createRfq>>>
    export type CreateRfqMutationBody = BodyType<PurchaseRfqInput>
    export type CreateRfqMutationError = ErrorType<unknown>

    /**
 * @summary Create an RFQ (optionally linked to an indent)
 */
export const useCreateRfq = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRfq>>, TError,{data: BodyType<PurchaseRfqInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRfq>>,
        TError,
        {data: BodyType<PurchaseRfqInput>},
        TContext
      > => {
      return useMutation(getCreateRfqMutationOptions(options));
    }

export const getGetRfqUrl = (id: number,) => {




  return `/api/inventory/rfqs/${id}`
}

/**
 * @summary Get RFQ with vendor quote lines
 */
export const getRfq = async (id: number, options?: RequestInit): Promise<PurchaseRfqDetail> => {

  return customFetch<PurchaseRfqDetail>(getGetRfqUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRfqQueryKey = (id: number,) => {
    return [
    `/api/inventory/rfqs/${id}`
    ] as const;
    }


export const getGetRfqQueryOptions = <TData = Awaited<ReturnType<typeof getRfq>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRfq>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRfqQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRfq>>> = ({ signal }) => getRfq(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRfq>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRfqQueryResult = NonNullable<Awaited<ReturnType<typeof getRfq>>>
export type GetRfqQueryError = ErrorType<void>


/**
 * @summary Get RFQ with vendor quote lines
 */

export function useGetRfq<TData = Awaited<ReturnType<typeof getRfq>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRfq>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRfqQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateRfqUrl = (id: number,) => {




  return `/api/inventory/rfqs/${id}`
}

/**
 * @summary Update RFQ header and/or lines
 */
export const updateRfq = async (id: number,
    purchaseRfqInput: PurchaseRfqInput, options?: RequestInit): Promise<PurchaseRfq> => {

  return customFetch<PurchaseRfq>(getUpdateRfqUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      purchaseRfqInput,)
  }
);}




export const getUpdateRfqMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRfq>>, TError,{id: number;data: BodyType<PurchaseRfqInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRfq>>, TError,{id: number;data: BodyType<PurchaseRfqInput>}, TContext> => {

const mutationKey = ['updateRfq'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRfq>>, {id: number;data: BodyType<PurchaseRfqInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRfq(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRfqMutationResult = NonNullable<Awaited<ReturnType<typeof updateRfq>>>
    export type UpdateRfqMutationBody = BodyType<PurchaseRfqInput>
    export type UpdateRfqMutationError = ErrorType<unknown>

    /**
 * @summary Update RFQ header and/or lines
 */
export const useUpdateRfq = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRfq>>, TError,{id: number;data: BodyType<PurchaseRfqInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRfq>>,
        TError,
        {id: number;data: BodyType<PurchaseRfqInput>},
        TContext
      > => {
      return useMutation(getUpdateRfqMutationOptions(options));
    }

export const getSendRfqUrl = (id: number,) => {




  return `/api/inventory/rfqs/${id}/send`
}

/**
 * @summary Mark RFQ as sent to vendor (status → sent)
 */
export const sendRfq = async (id: number, options?: RequestInit): Promise<PurchaseRfq> => {

  return customFetch<PurchaseRfq>(getSendRfqUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSendRfqMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRfq>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendRfq>>, TError,{id: number}, TContext> => {

const mutationKey = ['sendRfq'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendRfq>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  sendRfq(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendRfqMutationResult = NonNullable<Awaited<ReturnType<typeof sendRfq>>>

    export type SendRfqMutationError = ErrorType<unknown>

    /**
 * @summary Mark RFQ as sent to vendor (status → sent)
 */
export const useSendRfq = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRfq>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendRfq>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getSendRfqMutationOptions(options));
    }

export const getAwardRfqUrl = (id: number,) => {




  return `/api/inventory/rfqs/${id}/award`
}

/**
 * @summary Award RFQ — creates a Purchase Order and links it
 */
export const awardRfq = async (id: number, options?: RequestInit): Promise<AwardRfq200> => {

  return customFetch<AwardRfq200>(getAwardRfqUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAwardRfqMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof awardRfq>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof awardRfq>>, TError,{id: number}, TContext> => {

const mutationKey = ['awardRfq'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof awardRfq>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  awardRfq(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AwardRfqMutationResult = NonNullable<Awaited<ReturnType<typeof awardRfq>>>

    export type AwardRfqMutationError = ErrorType<unknown>

    /**
 * @summary Award RFQ — creates a Purchase Order and links it
 */
export const useAwardRfq = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof awardRfq>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof awardRfq>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAwardRfqMutationOptions(options));
    }

export const getCancelRfqUrl = (id: number,) => {




  return `/api/inventory/rfqs/${id}/cancel`
}

/**
 * @summary Cancel RFQ
 */
export const cancelRfq = async (id: number, options?: RequestInit): Promise<PurchaseRfq> => {

  return customFetch<PurchaseRfq>(getCancelRfqUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCancelRfqMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRfq>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelRfq>>, TError,{id: number}, TContext> => {

const mutationKey = ['cancelRfq'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelRfq>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  cancelRfq(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelRfqMutationResult = NonNullable<Awaited<ReturnType<typeof cancelRfq>>>

    export type CancelRfqMutationError = ErrorType<unknown>

    /**
 * @summary Cancel RFQ
 */
export const useCancelRfq = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRfq>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelRfq>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCancelRfqMutationOptions(options));
    }

export const getListStockTakesUrl = (params?: ListStockTakesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/stock-takes?${stringifiedParams}` : `/api/inventory/stock-takes`
}

/**
 * @summary List physical stock count sessions
 */
export const listStockTakes = async (params?: ListStockTakesParams, options?: RequestInit): Promise<StockTake[]> => {

  return customFetch<StockTake[]>(getListStockTakesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStockTakesQueryKey = (params?: ListStockTakesParams,) => {
    return [
    `/api/inventory/stock-takes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStockTakesQueryOptions = <TData = Awaited<ReturnType<typeof listStockTakes>>, TError = ErrorType<unknown>>(params?: ListStockTakesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStockTakes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStockTakesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStockTakes>>> = ({ signal }) => listStockTakes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStockTakes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStockTakesQueryResult = NonNullable<Awaited<ReturnType<typeof listStockTakes>>>
export type ListStockTakesQueryError = ErrorType<unknown>


/**
 * @summary List physical stock count sessions
 */

export function useListStockTakes<TData = Awaited<ReturnType<typeof listStockTakes>>, TError = ErrorType<unknown>>(
 params?: ListStockTakesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStockTakes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStockTakesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateStockTakeUrl = () => {




  return `/api/inventory/stock-takes`
}

/**
 * @summary Create a stock take session
 */
export const createStockTake = async (stockTakeInput: StockTakeInput, options?: RequestInit): Promise<StockTake> => {

  return customFetch<StockTake>(getCreateStockTakeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockTakeInput,)
  }
);}




export const getCreateStockTakeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStockTake>>, TError,{data: BodyType<StockTakeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createStockTake>>, TError,{data: BodyType<StockTakeInput>}, TContext> => {

const mutationKey = ['createStockTake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStockTake>>, {data: BodyType<StockTakeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createStockTake(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStockTakeMutationResult = NonNullable<Awaited<ReturnType<typeof createStockTake>>>
    export type CreateStockTakeMutationBody = BodyType<StockTakeInput>
    export type CreateStockTakeMutationError = ErrorType<unknown>

    /**
 * @summary Create a stock take session
 */
export const useCreateStockTake = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStockTake>>, TError,{data: BodyType<StockTakeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStockTake>>,
        TError,
        {data: BodyType<StockTakeInput>},
        TContext
      > => {
      return useMutation(getCreateStockTakeMutationOptions(options));
    }

export const getGetStockTakeUrl = (id: number,) => {




  return `/api/inventory/stock-takes/${id}`
}

/**
 * @summary Get stock take with count lines
 */
export const getStockTake = async (id: number, options?: RequestInit): Promise<StockTakeDetail> => {

  return customFetch<StockTakeDetail>(getGetStockTakeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStockTakeQueryKey = (id: number,) => {
    return [
    `/api/inventory/stock-takes/${id}`
    ] as const;
    }


export const getGetStockTakeQueryOptions = <TData = Awaited<ReturnType<typeof getStockTake>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStockTake>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStockTakeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockTake>>> = ({ signal }) => getStockTake(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStockTake>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStockTakeQueryResult = NonNullable<Awaited<ReturnType<typeof getStockTake>>>
export type GetStockTakeQueryError = ErrorType<void>


/**
 * @summary Get stock take with count lines
 */

export function useGetStockTake<TData = Awaited<ReturnType<typeof getStockTake>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStockTake>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStockTakeQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateStockTakeUrl = (id: number,) => {




  return `/api/inventory/stock-takes/${id}`
}

/**
 * @summary Update stock take header or count lines
 */
export const updateStockTake = async (id: number,
    stockTakeInput: StockTakeInput, options?: RequestInit): Promise<StockTake> => {

  return customFetch<StockTake>(getUpdateStockTakeUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockTakeInput,)
  }
);}




export const getUpdateStockTakeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStockTake>>, TError,{id: number;data: BodyType<StockTakeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStockTake>>, TError,{id: number;data: BodyType<StockTakeInput>}, TContext> => {

const mutationKey = ['updateStockTake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStockTake>>, {id: number;data: BodyType<StockTakeInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateStockTake(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStockTakeMutationResult = NonNullable<Awaited<ReturnType<typeof updateStockTake>>>
    export type UpdateStockTakeMutationBody = BodyType<StockTakeInput>
    export type UpdateStockTakeMutationError = ErrorType<unknown>

    /**
 * @summary Update stock take header or count lines
 */
export const useUpdateStockTake = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStockTake>>, TError,{id: number;data: BodyType<StockTakeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateStockTake>>,
        TError,
        {id: number;data: BodyType<StockTakeInput>},
        TContext
      > => {
      return useMutation(getUpdateStockTakeMutationOptions(options));
    }

export const getCompleteStockTakeUrl = (id: number,) => {




  return `/api/inventory/stock-takes/${id}/complete`
}

/**
 * @summary Mark counting complete — computes variances
 */
export const completeStockTake = async (id: number, options?: RequestInit): Promise<StockTakeDetail> => {

  return customFetch<StockTakeDetail>(getCompleteStockTakeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCompleteStockTakeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeStockTake>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeStockTake>>, TError,{id: number}, TContext> => {

const mutationKey = ['completeStockTake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeStockTake>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  completeStockTake(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteStockTakeMutationResult = NonNullable<Awaited<ReturnType<typeof completeStockTake>>>

    export type CompleteStockTakeMutationError = ErrorType<unknown>

    /**
 * @summary Mark counting complete — computes variances
 */
export const useCompleteStockTake = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeStockTake>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeStockTake>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCompleteStockTakeMutationOptions(options));
    }

export const getPostStockTakeUrl = (id: number,) => {




  return `/api/inventory/stock-takes/${id}/post`
}

/**
 * @summary Post variances — creates stock_take_variance movements and adjusts stock levels
 */
export const postStockTake = async (id: number, options?: RequestInit): Promise<StockTake> => {

  return customFetch<StockTake>(getPostStockTakeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostStockTakeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStockTake>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postStockTake>>, TError,{id: number}, TContext> => {

const mutationKey = ['postStockTake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStockTake>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postStockTake(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostStockTakeMutationResult = NonNullable<Awaited<ReturnType<typeof postStockTake>>>

    export type PostStockTakeMutationError = ErrorType<unknown>

    /**
 * @summary Post variances — creates stock_take_variance movements and adjusts stock levels
 */
export const usePostStockTake = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStockTake>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postStockTake>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostStockTakeMutationOptions(options));
    }

export const getGetInventoryLowStockReportUrl = (params?: GetInventoryLowStockReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/low-stock?${stringifiedParams}` : `/api/inventory/reports/low-stock`
}

/**
 * @summary Products at or below reorder point
 */
export const getInventoryLowStockReport = async (params?: GetInventoryLowStockReportParams, options?: RequestInit): Promise<LowStockItem[]> => {

  return customFetch<LowStockItem[]>(getGetInventoryLowStockReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryLowStockReportQueryKey = (params?: GetInventoryLowStockReportParams,) => {
    return [
    `/api/inventory/reports/low-stock`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetInventoryLowStockReportQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryLowStockReport>>, TError = ErrorType<unknown>>(params?: GetInventoryLowStockReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryLowStockReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryLowStockReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryLowStockReport>>> = ({ signal }) => getInventoryLowStockReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryLowStockReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryLowStockReportQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryLowStockReport>>>
export type GetInventoryLowStockReportQueryError = ErrorType<unknown>


/**
 * @summary Products at or below reorder point
 */

export function useGetInventoryLowStockReport<TData = Awaited<ReturnType<typeof getInventoryLowStockReport>>, TError = ErrorType<unknown>>(
 params?: GetInventoryLowStockReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryLowStockReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryLowStockReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetInventoryValuationReportUrl = (params?: GetInventoryValuationReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/valuation?${stringifiedParams}` : `/api/inventory/reports/valuation`
}

/**
 * @summary Stock valuation summary — total value per warehouse and product
 */
export const getInventoryValuationReport = async (params?: GetInventoryValuationReportParams, options?: RequestInit): Promise<ValuationReport> => {

  return customFetch<ValuationReport>(getGetInventoryValuationReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryValuationReportQueryKey = (params?: GetInventoryValuationReportParams,) => {
    return [
    `/api/inventory/reports/valuation`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetInventoryValuationReportQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryValuationReport>>, TError = ErrorType<unknown>>(params?: GetInventoryValuationReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryValuationReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryValuationReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryValuationReport>>> = ({ signal }) => getInventoryValuationReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryValuationReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryValuationReportQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryValuationReport>>>
export type GetInventoryValuationReportQueryError = ErrorType<unknown>


/**
 * @summary Stock valuation summary — total value per warehouse and product
 */

export function useGetInventoryValuationReport<TData = Awaited<ReturnType<typeof getInventoryValuationReport>>, TError = ErrorType<unknown>>(
 params?: GetInventoryValuationReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryValuationReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryValuationReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAbcAnalysisUrl = (params?: GetAbcAnalysisParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/abc-analysis?${stringifiedParams}` : `/api/inventory/reports/abc-analysis`
}

/**
 * @summary ABC classification of products by consumption value
 */
export const getAbcAnalysis = async (params?: GetAbcAnalysisParams, options?: RequestInit): Promise<AbcAnalysisReport> => {

  return customFetch<AbcAnalysisReport>(getGetAbcAnalysisUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAbcAnalysisQueryKey = (params?: GetAbcAnalysisParams,) => {
    return [
    `/api/inventory/reports/abc-analysis`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAbcAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof getAbcAnalysis>>, TError = ErrorType<unknown>>(params?: GetAbcAnalysisParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAbcAnalysis>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAbcAnalysisQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAbcAnalysis>>> = ({ signal }) => getAbcAnalysis(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAbcAnalysis>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAbcAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof getAbcAnalysis>>>
export type GetAbcAnalysisQueryError = ErrorType<unknown>


/**
 * @summary ABC classification of products by consumption value
 */

export function useGetAbcAnalysis<TData = Awaited<ReturnType<typeof getAbcAnalysis>>, TError = ErrorType<unknown>>(
 params?: GetAbcAnalysisParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAbcAnalysis>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAbcAnalysisQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetStockLedgerUrl = (params: GetStockLedgerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/stock-ledger?${stringifiedParams}` : `/api/inventory/reports/stock-ledger`
}

/**
 * @summary Movement-by-movement stock ledger for a product
 */
export const getStockLedger = async (params: GetStockLedgerParams, options?: RequestInit): Promise<StockLedgerReport> => {

  return customFetch<StockLedgerReport>(getGetStockLedgerUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStockLedgerQueryKey = (params?: GetStockLedgerParams,) => {
    return [
    `/api/inventory/reports/stock-ledger`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStockLedgerQueryOptions = <TData = Awaited<ReturnType<typeof getStockLedger>>, TError = ErrorType<unknown>>(params: GetStockLedgerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStockLedger>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStockLedgerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockLedger>>> = ({ signal }) => getStockLedger(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStockLedger>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStockLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof getStockLedger>>>
export type GetStockLedgerQueryError = ErrorType<unknown>


/**
 * @summary Movement-by-movement stock ledger for a product
 */

export function useGetStockLedger<TData = Awaited<ReturnType<typeof getStockLedger>>, TError = ErrorType<unknown>>(
 params: GetStockLedgerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStockLedger>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStockLedgerQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCrmAccountsUrl = (params?: ListCrmAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/accounts?${stringifiedParams}` : `/api/crm/accounts`
}

/**
 * @summary List CRM accounts (prospects, customers, partners)
 */
export const listCrmAccounts = async (params?: ListCrmAccountsParams, options?: RequestInit): Promise<CrmAccount[]> => {

  return customFetch<CrmAccount[]>(getListCrmAccountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmAccountsQueryKey = (params?: ListCrmAccountsParams,) => {
    return [
    `/api/crm/accounts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listCrmAccounts>>, TError = ErrorType<unknown>>(params?: ListCrmAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmAccounts>>> = ({ signal }) => listCrmAccounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCrmAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmAccounts>>>
export type ListCrmAccountsQueryError = ErrorType<unknown>


/**
 * @summary List CRM accounts (prospects, customers, partners)
 */

export function useListCrmAccounts<TData = Awaited<ReturnType<typeof listCrmAccounts>>, TError = ErrorType<unknown>>(
 params?: ListCrmAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCrmAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCrmAccountUrl = () => {




  return `/api/crm/accounts`
}

/**
 * @summary Create a CRM account
 */
export const createCrmAccount = async (crmAccountInput: CrmAccountInput, options?: RequestInit): Promise<CrmAccount> => {

  return customFetch<CrmAccount>(getCreateCrmAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmAccountInput,)
  }
);}




export const getCreateCrmAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmAccount>>, TError,{data: BodyType<CrmAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrmAccount>>, TError,{data: BodyType<CrmAccountInput>}, TContext> => {

const mutationKey = ['createCrmAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrmAccount>>, {data: BodyType<CrmAccountInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCrmAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrmAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createCrmAccount>>>
    export type CreateCrmAccountMutationBody = BodyType<CrmAccountInput>
    export type CreateCrmAccountMutationError = ErrorType<unknown>

    /**
 * @summary Create a CRM account
 */
export const useCreateCrmAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmAccount>>, TError,{data: BodyType<CrmAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCrmAccount>>,
        TError,
        {data: BodyType<CrmAccountInput>},
        TContext
      > => {
      return useMutation(getCreateCrmAccountMutationOptions(options));
    }

export const getGetCrmAccountUrl = (id: number,) => {




  return `/api/crm/accounts/${id}`
}

/**
 * @summary Get CRM account with contacts and open opportunities
 */
export const getCrmAccount = async (id: number, options?: RequestInit): Promise<CrmAccountDetail> => {

  return customFetch<CrmAccountDetail>(getGetCrmAccountUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmAccountQueryKey = (id: number,) => {
    return [
    `/api/crm/accounts/${id}`
    ] as const;
    }


export const getGetCrmAccountQueryOptions = <TData = Awaited<ReturnType<typeof getCrmAccount>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmAccount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmAccountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmAccount>>> = ({ signal }) => getCrmAccount(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrmAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmAccount>>>
export type GetCrmAccountQueryError = ErrorType<unknown>


/**
 * @summary Get CRM account with contacts and open opportunities
 */

export function useGetCrmAccount<TData = Awaited<ReturnType<typeof getCrmAccount>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmAccount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrmAccountQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCrmAccountUrl = (id: number,) => {




  return `/api/crm/accounts/${id}`
}

/**
 * @summary Update CRM account
 */
export const updateCrmAccount = async (id: number,
    crmAccountInput: CrmAccountInput, options?: RequestInit): Promise<CrmAccount> => {

  return customFetch<CrmAccount>(getUpdateCrmAccountUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmAccountInput,)
  }
);}




export const getUpdateCrmAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmAccount>>, TError,{id: number;data: BodyType<CrmAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrmAccount>>, TError,{id: number;data: BodyType<CrmAccountInput>}, TContext> => {

const mutationKey = ['updateCrmAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrmAccount>>, {id: number;data: BodyType<CrmAccountInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCrmAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrmAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrmAccount>>>
    export type UpdateCrmAccountMutationBody = BodyType<CrmAccountInput>
    export type UpdateCrmAccountMutationError = ErrorType<unknown>

    /**
 * @summary Update CRM account
 */
export const useUpdateCrmAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmAccount>>, TError,{id: number;data: BodyType<CrmAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCrmAccount>>,
        TError,
        {id: number;data: BodyType<CrmAccountInput>},
        TContext
      > => {
      return useMutation(getUpdateCrmAccountMutationOptions(options));
    }

export const getDeleteCrmAccountUrl = (id: number,) => {




  return `/api/crm/accounts/${id}`
}

/**
 * @summary Delete CRM account
 */
export const deleteCrmAccount = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCrmAccountUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCrmAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCrmAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCrmAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCrmAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCrmAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCrmAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCrmAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCrmAccount>>>

    export type DeleteCrmAccountMutationError = ErrorType<unknown>

    /**
 * @summary Delete CRM account
 */
export const useDeleteCrmAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCrmAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCrmAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCrmAccountMutationOptions(options));
    }

export const getListCrmContactsUrl = (params?: ListCrmContactsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/contacts?${stringifiedParams}` : `/api/crm/contacts`
}

/**
 * @summary List contacts (optionally filter by accountId)
 */
export const listCrmContacts = async (params?: ListCrmContactsParams, options?: RequestInit): Promise<CrmContact[]> => {

  return customFetch<CrmContact[]>(getListCrmContactsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmContactsQueryKey = (params?: ListCrmContactsParams,) => {
    return [
    `/api/crm/contacts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmContactsQueryOptions = <TData = Awaited<ReturnType<typeof listCrmContacts>>, TError = ErrorType<unknown>>(params?: ListCrmContactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmContacts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmContactsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmContacts>>> = ({ signal }) => listCrmContacts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmContacts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCrmContactsQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmContacts>>>
export type ListCrmContactsQueryError = ErrorType<unknown>


/**
 * @summary List contacts (optionally filter by accountId)
 */

export function useListCrmContacts<TData = Awaited<ReturnType<typeof listCrmContacts>>, TError = ErrorType<unknown>>(
 params?: ListCrmContactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmContacts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCrmContactsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCrmContactUrl = () => {




  return `/api/crm/contacts`
}

/**
 * @summary Create a contact
 */
export const createCrmContact = async (crmContactInput: CrmContactInput, options?: RequestInit): Promise<CrmContact> => {

  return customFetch<CrmContact>(getCreateCrmContactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmContactInput,)
  }
);}




export const getCreateCrmContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmContact>>, TError,{data: BodyType<CrmContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrmContact>>, TError,{data: BodyType<CrmContactInput>}, TContext> => {

const mutationKey = ['createCrmContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrmContact>>, {data: BodyType<CrmContactInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCrmContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrmContactMutationResult = NonNullable<Awaited<ReturnType<typeof createCrmContact>>>
    export type CreateCrmContactMutationBody = BodyType<CrmContactInput>
    export type CreateCrmContactMutationError = ErrorType<unknown>

    /**
 * @summary Create a contact
 */
export const useCreateCrmContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmContact>>, TError,{data: BodyType<CrmContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCrmContact>>,
        TError,
        {data: BodyType<CrmContactInput>},
        TContext
      > => {
      return useMutation(getCreateCrmContactMutationOptions(options));
    }

export const getGetCrmContactUrl = (id: number,) => {




  return `/api/crm/contacts/${id}`
}

/**
 * @summary Get contact
 */
export const getCrmContact = async (id: number, options?: RequestInit): Promise<CrmContact> => {

  return customFetch<CrmContact>(getGetCrmContactUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmContactQueryKey = (id: number,) => {
    return [
    `/api/crm/contacts/${id}`
    ] as const;
    }


export const getGetCrmContactQueryOptions = <TData = Awaited<ReturnType<typeof getCrmContact>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmContact>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmContactQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmContact>>> = ({ signal }) => getCrmContact(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmContact>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrmContactQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmContact>>>
export type GetCrmContactQueryError = ErrorType<unknown>


/**
 * @summary Get contact
 */

export function useGetCrmContact<TData = Awaited<ReturnType<typeof getCrmContact>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmContact>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrmContactQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCrmContactUrl = (id: number,) => {




  return `/api/crm/contacts/${id}`
}

/**
 * @summary Update contact
 */
export const updateCrmContact = async (id: number,
    crmContactInput: CrmContactInput, options?: RequestInit): Promise<CrmContact> => {

  return customFetch<CrmContact>(getUpdateCrmContactUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmContactInput,)
  }
);}




export const getUpdateCrmContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmContact>>, TError,{id: number;data: BodyType<CrmContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrmContact>>, TError,{id: number;data: BodyType<CrmContactInput>}, TContext> => {

const mutationKey = ['updateCrmContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrmContact>>, {id: number;data: BodyType<CrmContactInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCrmContact(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrmContactMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrmContact>>>
    export type UpdateCrmContactMutationBody = BodyType<CrmContactInput>
    export type UpdateCrmContactMutationError = ErrorType<unknown>

    /**
 * @summary Update contact
 */
export const useUpdateCrmContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmContact>>, TError,{id: number;data: BodyType<CrmContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCrmContact>>,
        TError,
        {id: number;data: BodyType<CrmContactInput>},
        TContext
      > => {
      return useMutation(getUpdateCrmContactMutationOptions(options));
    }

export const getDeleteCrmContactUrl = (id: number,) => {




  return `/api/crm/contacts/${id}`
}

/**
 * @summary Delete contact
 */
export const deleteCrmContact = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCrmContactUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCrmContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCrmContact>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCrmContact>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCrmContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCrmContact>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCrmContact(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCrmContactMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCrmContact>>>

    export type DeleteCrmContactMutationError = ErrorType<unknown>

    /**
 * @summary Delete contact
 */
export const useDeleteCrmContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCrmContact>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCrmContact>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCrmContactMutationOptions(options));
    }

export const getListCrmLeadsUrl = (params?: ListCrmLeadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/leads?${stringifiedParams}` : `/api/crm/leads`
}

/**
 * @summary List leads with optional filters
 */
export const listCrmLeads = async (params?: ListCrmLeadsParams, options?: RequestInit): Promise<CrmLead[]> => {

  return customFetch<CrmLead[]>(getListCrmLeadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmLeadsQueryKey = (params?: ListCrmLeadsParams,) => {
    return [
    `/api/crm/leads`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmLeadsQueryOptions = <TData = Awaited<ReturnType<typeof listCrmLeads>>, TError = ErrorType<unknown>>(params?: ListCrmLeadsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmLeads>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmLeadsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmLeads>>> = ({ signal }) => listCrmLeads(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmLeads>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCrmLeadsQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmLeads>>>
export type ListCrmLeadsQueryError = ErrorType<unknown>


/**
 * @summary List leads with optional filters
 */

export function useListCrmLeads<TData = Awaited<ReturnType<typeof listCrmLeads>>, TError = ErrorType<unknown>>(
 params?: ListCrmLeadsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmLeads>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCrmLeadsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCrmLeadUrl = () => {




  return `/api/crm/leads`
}

/**
 * @summary Create a lead
 */
export const createCrmLead = async (crmLeadInput: CrmLeadInput, options?: RequestInit): Promise<CrmLead> => {

  return customFetch<CrmLead>(getCreateCrmLeadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmLeadInput,)
  }
);}




export const getCreateCrmLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmLead>>, TError,{data: BodyType<CrmLeadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrmLead>>, TError,{data: BodyType<CrmLeadInput>}, TContext> => {

const mutationKey = ['createCrmLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrmLead>>, {data: BodyType<CrmLeadInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCrmLead(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrmLeadMutationResult = NonNullable<Awaited<ReturnType<typeof createCrmLead>>>
    export type CreateCrmLeadMutationBody = BodyType<CrmLeadInput>
    export type CreateCrmLeadMutationError = ErrorType<unknown>

    /**
 * @summary Create a lead
 */
export const useCreateCrmLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmLead>>, TError,{data: BodyType<CrmLeadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCrmLead>>,
        TError,
        {data: BodyType<CrmLeadInput>},
        TContext
      > => {
      return useMutation(getCreateCrmLeadMutationOptions(options));
    }

export const getGetCrmLeadUrl = (id: number,) => {




  return `/api/crm/leads/${id}`
}

/**
 * @summary Get lead
 */
export const getCrmLead = async (id: number, options?: RequestInit): Promise<CrmLead> => {

  return customFetch<CrmLead>(getGetCrmLeadUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmLeadQueryKey = (id: number,) => {
    return [
    `/api/crm/leads/${id}`
    ] as const;
    }


export const getGetCrmLeadQueryOptions = <TData = Awaited<ReturnType<typeof getCrmLead>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmLead>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmLeadQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmLead>>> = ({ signal }) => getCrmLead(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmLead>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrmLeadQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmLead>>>
export type GetCrmLeadQueryError = ErrorType<unknown>


/**
 * @summary Get lead
 */

export function useGetCrmLead<TData = Awaited<ReturnType<typeof getCrmLead>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmLead>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrmLeadQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCrmLeadUrl = (id: number,) => {




  return `/api/crm/leads/${id}`
}

/**
 * @summary Update lead (status, rating, assignedTo, etc.)
 */
export const updateCrmLead = async (id: number,
    crmLeadInput: CrmLeadInput, options?: RequestInit): Promise<CrmLead> => {

  return customFetch<CrmLead>(getUpdateCrmLeadUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmLeadInput,)
  }
);}




export const getUpdateCrmLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmLead>>, TError,{id: number;data: BodyType<CrmLeadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrmLead>>, TError,{id: number;data: BodyType<CrmLeadInput>}, TContext> => {

const mutationKey = ['updateCrmLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrmLead>>, {id: number;data: BodyType<CrmLeadInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCrmLead(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrmLeadMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrmLead>>>
    export type UpdateCrmLeadMutationBody = BodyType<CrmLeadInput>
    export type UpdateCrmLeadMutationError = ErrorType<unknown>

    /**
 * @summary Update lead (status, rating, assignedTo, etc.)
 */
export const useUpdateCrmLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmLead>>, TError,{id: number;data: BodyType<CrmLeadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCrmLead>>,
        TError,
        {id: number;data: BodyType<CrmLeadInput>},
        TContext
      > => {
      return useMutation(getUpdateCrmLeadMutationOptions(options));
    }

export const getConvertCrmLeadUrl = (id: number,) => {




  return `/api/crm/leads/${id}/convert`
}

/**
 * @summary Convert lead → Account + Contact + Opportunity (atomic)
 */
export const convertCrmLead = async (id: number,
    convertCrmLeadBody?: ConvertCrmLeadBody, options?: RequestInit): Promise<ConvertCrmLead200> => {

  return customFetch<ConvertCrmLead200>(getConvertCrmLeadUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      convertCrmLeadBody,)
  }
);}




export const getConvertCrmLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertCrmLead>>, TError,{id: number;data?: BodyType<ConvertCrmLeadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof convertCrmLead>>, TError,{id: number;data?: BodyType<ConvertCrmLeadBody>}, TContext> => {

const mutationKey = ['convertCrmLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertCrmLead>>, {id: number;data?: BodyType<ConvertCrmLeadBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  convertCrmLead(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvertCrmLeadMutationResult = NonNullable<Awaited<ReturnType<typeof convertCrmLead>>>
    export type ConvertCrmLeadMutationBody = BodyType<ConvertCrmLeadBody> | undefined
    export type ConvertCrmLeadMutationError = ErrorType<unknown>

    /**
 * @summary Convert lead → Account + Contact + Opportunity (atomic)
 */
export const useConvertCrmLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertCrmLead>>, TError,{id: number;data?: BodyType<ConvertCrmLeadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof convertCrmLead>>,
        TError,
        {id: number;data?: BodyType<ConvertCrmLeadBody>},
        TContext
      > => {
      return useMutation(getConvertCrmLeadMutationOptions(options));
    }

export const getListCrmOpportunitiesUrl = (params?: ListCrmOpportunitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/opportunities?${stringifiedParams}` : `/api/crm/opportunities`
}

/**
 * @summary List opportunities (pipeline)
 */
export const listCrmOpportunities = async (params?: ListCrmOpportunitiesParams, options?: RequestInit): Promise<CrmOpportunity[]> => {

  return customFetch<CrmOpportunity[]>(getListCrmOpportunitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmOpportunitiesQueryKey = (params?: ListCrmOpportunitiesParams,) => {
    return [
    `/api/crm/opportunities`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmOpportunitiesQueryOptions = <TData = Awaited<ReturnType<typeof listCrmOpportunities>>, TError = ErrorType<unknown>>(params?: ListCrmOpportunitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmOpportunitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmOpportunities>>> = ({ signal }) => listCrmOpportunities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmOpportunities>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCrmOpportunitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmOpportunities>>>
export type ListCrmOpportunitiesQueryError = ErrorType<unknown>


/**
 * @summary List opportunities (pipeline)
 */

export function useListCrmOpportunities<TData = Awaited<ReturnType<typeof listCrmOpportunities>>, TError = ErrorType<unknown>>(
 params?: ListCrmOpportunitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCrmOpportunitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCrmOpportunityUrl = () => {




  return `/api/crm/opportunities`
}

/**
 * @summary Create opportunity
 */
export const createCrmOpportunity = async (crmOpportunityInput: CrmOpportunityInput, options?: RequestInit): Promise<CrmOpportunity> => {

  return customFetch<CrmOpportunity>(getCreateCrmOpportunityUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmOpportunityInput,)
  }
);}




export const getCreateCrmOpportunityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmOpportunity>>, TError,{data: BodyType<CrmOpportunityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrmOpportunity>>, TError,{data: BodyType<CrmOpportunityInput>}, TContext> => {

const mutationKey = ['createCrmOpportunity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrmOpportunity>>, {data: BodyType<CrmOpportunityInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCrmOpportunity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrmOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof createCrmOpportunity>>>
    export type CreateCrmOpportunityMutationBody = BodyType<CrmOpportunityInput>
    export type CreateCrmOpportunityMutationError = ErrorType<unknown>

    /**
 * @summary Create opportunity
 */
export const useCreateCrmOpportunity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmOpportunity>>, TError,{data: BodyType<CrmOpportunityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCrmOpportunity>>,
        TError,
        {data: BodyType<CrmOpportunityInput>},
        TContext
      > => {
      return useMutation(getCreateCrmOpportunityMutationOptions(options));
    }

export const getGetCrmOpportunityUrl = (id: number,) => {




  return `/api/crm/opportunities/${id}`
}

/**
 * @summary Get opportunity with activities and quotes
 */
export const getCrmOpportunity = async (id: number, options?: RequestInit): Promise<CrmOpportunityDetail> => {

  return customFetch<CrmOpportunityDetail>(getGetCrmOpportunityUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmOpportunityQueryKey = (id: number,) => {
    return [
    `/api/crm/opportunities/${id}`
    ] as const;
    }


export const getGetCrmOpportunityQueryOptions = <TData = Awaited<ReturnType<typeof getCrmOpportunity>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmOpportunity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmOpportunityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmOpportunity>>> = ({ signal }) => getCrmOpportunity(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmOpportunity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrmOpportunityQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmOpportunity>>>
export type GetCrmOpportunityQueryError = ErrorType<unknown>


/**
 * @summary Get opportunity with activities and quotes
 */

export function useGetCrmOpportunity<TData = Awaited<ReturnType<typeof getCrmOpportunity>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmOpportunity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrmOpportunityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCrmOpportunityUrl = (id: number,) => {




  return `/api/crm/opportunities/${id}`
}

/**
 * @summary Update opportunity (stage move, probability, value)
 */
export const updateCrmOpportunity = async (id: number,
    crmOpportunityInput: CrmOpportunityInput, options?: RequestInit): Promise<CrmOpportunity> => {

  return customFetch<CrmOpportunity>(getUpdateCrmOpportunityUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmOpportunityInput,)
  }
);}




export const getUpdateCrmOpportunityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmOpportunity>>, TError,{id: number;data: BodyType<CrmOpportunityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrmOpportunity>>, TError,{id: number;data: BodyType<CrmOpportunityInput>}, TContext> => {

const mutationKey = ['updateCrmOpportunity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrmOpportunity>>, {id: number;data: BodyType<CrmOpportunityInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCrmOpportunity(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrmOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrmOpportunity>>>
    export type UpdateCrmOpportunityMutationBody = BodyType<CrmOpportunityInput>
    export type UpdateCrmOpportunityMutationError = ErrorType<unknown>

    /**
 * @summary Update opportunity (stage move, probability, value)
 */
export const useUpdateCrmOpportunity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmOpportunity>>, TError,{id: number;data: BodyType<CrmOpportunityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCrmOpportunity>>,
        TError,
        {id: number;data: BodyType<CrmOpportunityInput>},
        TContext
      > => {
      return useMutation(getUpdateCrmOpportunityMutationOptions(options));
    }

export const getListCrmActivitiesUrl = (params?: ListCrmActivitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/activities?${stringifiedParams}` : `/api/crm/activities`
}

/**
 * @summary List CRM activities (calls, meetings, emails, tasks, notes)
 */
export const listCrmActivities = async (params?: ListCrmActivitiesParams, options?: RequestInit): Promise<CrmActivity[]> => {

  return customFetch<CrmActivity[]>(getListCrmActivitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmActivitiesQueryKey = (params?: ListCrmActivitiesParams,) => {
    return [
    `/api/crm/activities`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof listCrmActivities>>, TError = ErrorType<unknown>>(params?: ListCrmActivitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmActivities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmActivitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmActivities>>> = ({ signal }) => listCrmActivities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmActivities>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCrmActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmActivities>>>
export type ListCrmActivitiesQueryError = ErrorType<unknown>


/**
 * @summary List CRM activities (calls, meetings, emails, tasks, notes)
 */

export function useListCrmActivities<TData = Awaited<ReturnType<typeof listCrmActivities>>, TError = ErrorType<unknown>>(
 params?: ListCrmActivitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmActivities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCrmActivitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCrmActivityUrl = () => {




  return `/api/crm/activities`
}

/**
 * @summary Log an activity against a lead / opportunity / account / contact
 */
export const createCrmActivity = async (crmActivityInput: CrmActivityInput, options?: RequestInit): Promise<CrmActivity> => {

  return customFetch<CrmActivity>(getCreateCrmActivityUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmActivityInput,)
  }
);}




export const getCreateCrmActivityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmActivity>>, TError,{data: BodyType<CrmActivityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrmActivity>>, TError,{data: BodyType<CrmActivityInput>}, TContext> => {

const mutationKey = ['createCrmActivity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrmActivity>>, {data: BodyType<CrmActivityInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCrmActivity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrmActivityMutationResult = NonNullable<Awaited<ReturnType<typeof createCrmActivity>>>
    export type CreateCrmActivityMutationBody = BodyType<CrmActivityInput>
    export type CreateCrmActivityMutationError = ErrorType<unknown>

    /**
 * @summary Log an activity against a lead / opportunity / account / contact
 */
export const useCreateCrmActivity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmActivity>>, TError,{data: BodyType<CrmActivityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCrmActivity>>,
        TError,
        {data: BodyType<CrmActivityInput>},
        TContext
      > => {
      return useMutation(getCreateCrmActivityMutationOptions(options));
    }

export const getUpdateCrmActivityUrl = (id: number,) => {




  return `/api/crm/activities/${id}`
}

/**
 * @summary Update activity (mark complete, add outcome)
 */
export const updateCrmActivity = async (id: number,
    crmActivityInput: CrmActivityInput, options?: RequestInit): Promise<CrmActivity> => {

  return customFetch<CrmActivity>(getUpdateCrmActivityUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmActivityInput,)
  }
);}




export const getUpdateCrmActivityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmActivity>>, TError,{id: number;data: BodyType<CrmActivityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrmActivity>>, TError,{id: number;data: BodyType<CrmActivityInput>}, TContext> => {

const mutationKey = ['updateCrmActivity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrmActivity>>, {id: number;data: BodyType<CrmActivityInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCrmActivity(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrmActivityMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrmActivity>>>
    export type UpdateCrmActivityMutationBody = BodyType<CrmActivityInput>
    export type UpdateCrmActivityMutationError = ErrorType<unknown>

    /**
 * @summary Update activity (mark complete, add outcome)
 */
export const useUpdateCrmActivity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmActivity>>, TError,{id: number;data: BodyType<CrmActivityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCrmActivity>>,
        TError,
        {id: number;data: BodyType<CrmActivityInput>},
        TContext
      > => {
      return useMutation(getUpdateCrmActivityMutationOptions(options));
    }

export const getDeleteCrmActivityUrl = (id: number,) => {




  return `/api/crm/activities/${id}`
}

/**
 * @summary Delete activity
 */
export const deleteCrmActivity = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCrmActivityUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCrmActivityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCrmActivity>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCrmActivity>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCrmActivity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCrmActivity>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCrmActivity(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCrmActivityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCrmActivity>>>

    export type DeleteCrmActivityMutationError = ErrorType<unknown>

    /**
 * @summary Delete activity
 */
export const useDeleteCrmActivity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCrmActivity>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCrmActivity>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCrmActivityMutationOptions(options));
    }

export const getListCrmQuotesUrl = (params?: ListCrmQuotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/quotes?${stringifiedParams}` : `/api/crm/quotes`
}

/**
 * @summary List quotes
 */
export const listCrmQuotes = async (params?: ListCrmQuotesParams, options?: RequestInit): Promise<CrmQuote[]> => {

  return customFetch<CrmQuote[]>(getListCrmQuotesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmQuotesQueryKey = (params?: ListCrmQuotesParams,) => {
    return [
    `/api/crm/quotes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmQuotesQueryOptions = <TData = Awaited<ReturnType<typeof listCrmQuotes>>, TError = ErrorType<unknown>>(params?: ListCrmQuotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmQuotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmQuotesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmQuotes>>> = ({ signal }) => listCrmQuotes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmQuotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCrmQuotesQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmQuotes>>>
export type ListCrmQuotesQueryError = ErrorType<unknown>


/**
 * @summary List quotes
 */

export function useListCrmQuotes<TData = Awaited<ReturnType<typeof listCrmQuotes>>, TError = ErrorType<unknown>>(
 params?: ListCrmQuotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmQuotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCrmQuotesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCrmQuoteUrl = () => {




  return `/api/crm/quotes`
}

/**
 * @summary Create quote with line items (GST-aware tax computation)
 */
export const createCrmQuote = async (crmQuoteInput: CrmQuoteInput, options?: RequestInit): Promise<CrmQuoteDetail> => {

  return customFetch<CrmQuoteDetail>(getCreateCrmQuoteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmQuoteInput,)
  }
);}




export const getCreateCrmQuoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmQuote>>, TError,{data: BodyType<CrmQuoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrmQuote>>, TError,{data: BodyType<CrmQuoteInput>}, TContext> => {

const mutationKey = ['createCrmQuote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrmQuote>>, {data: BodyType<CrmQuoteInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCrmQuote(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrmQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof createCrmQuote>>>
    export type CreateCrmQuoteMutationBody = BodyType<CrmQuoteInput>
    export type CreateCrmQuoteMutationError = ErrorType<unknown>

    /**
 * @summary Create quote with line items (GST-aware tax computation)
 */
export const useCreateCrmQuote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmQuote>>, TError,{data: BodyType<CrmQuoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCrmQuote>>,
        TError,
        {data: BodyType<CrmQuoteInput>},
        TContext
      > => {
      return useMutation(getCreateCrmQuoteMutationOptions(options));
    }

export const getGetCrmQuoteUrl = (id: number,) => {




  return `/api/crm/quotes/${id}`
}

/**
 * @summary Get quote with line items
 */
export const getCrmQuote = async (id: number, options?: RequestInit): Promise<CrmQuoteDetail> => {

  return customFetch<CrmQuoteDetail>(getGetCrmQuoteUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmQuoteQueryKey = (id: number,) => {
    return [
    `/api/crm/quotes/${id}`
    ] as const;
    }


export const getGetCrmQuoteQueryOptions = <TData = Awaited<ReturnType<typeof getCrmQuote>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmQuote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmQuoteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmQuote>>> = ({ signal }) => getCrmQuote(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmQuote>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrmQuoteQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmQuote>>>
export type GetCrmQuoteQueryError = ErrorType<unknown>


/**
 * @summary Get quote with line items
 */

export function useGetCrmQuote<TData = Awaited<ReturnType<typeof getCrmQuote>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmQuote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrmQuoteQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCrmQuoteUrl = (id: number,) => {




  return `/api/crm/quotes/${id}`
}

/**
 * @summary Update quote header
 */
export const updateCrmQuote = async (id: number,
    crmQuoteInput: CrmQuoteInput, options?: RequestInit): Promise<CrmQuote> => {

  return customFetch<CrmQuote>(getUpdateCrmQuoteUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmQuoteInput,)
  }
);}




export const getUpdateCrmQuoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmQuote>>, TError,{id: number;data: BodyType<CrmQuoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrmQuote>>, TError,{id: number;data: BodyType<CrmQuoteInput>}, TContext> => {

const mutationKey = ['updateCrmQuote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrmQuote>>, {id: number;data: BodyType<CrmQuoteInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCrmQuote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrmQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrmQuote>>>
    export type UpdateCrmQuoteMutationBody = BodyType<CrmQuoteInput>
    export type UpdateCrmQuoteMutationError = ErrorType<unknown>

    /**
 * @summary Update quote header
 */
export const useUpdateCrmQuote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmQuote>>, TError,{id: number;data: BodyType<CrmQuoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCrmQuote>>,
        TError,
        {id: number;data: BodyType<CrmQuoteInput>},
        TContext
      > => {
      return useMutation(getUpdateCrmQuoteMutationOptions(options));
    }

export const getSendCrmQuoteUrl = (id: number,) => {




  return `/api/crm/quotes/${id}/send`
}

/**
 * @summary Email quote to customer + mark as sent (generates HMAC portal link)
 */
export const sendCrmQuote = async (id: number,
    sendCrmQuoteBody?: SendCrmQuoteBody, options?: RequestInit): Promise<SendCrmQuote200> => {

  return customFetch<SendCrmQuote200>(getSendCrmQuoteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendCrmQuoteBody,)
  }
);}




export const getSendCrmQuoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCrmQuote>>, TError,{id: number;data?: BodyType<SendCrmQuoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendCrmQuote>>, TError,{id: number;data?: BodyType<SendCrmQuoteBody>}, TContext> => {

const mutationKey = ['sendCrmQuote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCrmQuote>>, {id: number;data?: BodyType<SendCrmQuoteBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendCrmQuote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendCrmQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof sendCrmQuote>>>
    export type SendCrmQuoteMutationBody = BodyType<SendCrmQuoteBody> | undefined
    export type SendCrmQuoteMutationError = ErrorType<unknown>

    /**
 * @summary Email quote to customer + mark as sent (generates HMAC portal link)
 */
export const useSendCrmQuote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCrmQuote>>, TError,{id: number;data?: BodyType<SendCrmQuoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendCrmQuote>>,
        TError,
        {id: number;data?: BodyType<SendCrmQuoteBody>},
        TContext
      > => {
      return useMutation(getSendCrmQuoteMutationOptions(options));
    }

export const getAcceptCrmQuoteUrl = (id: number,) => {




  return `/api/crm/quotes/${id}/accept`
}

/**
 * @summary Mark quote as accepted (by customer or staff on behalf)
 */
export const acceptCrmQuote = async (id: number, options?: RequestInit): Promise<CrmQuote> => {

  return customFetch<CrmQuote>(getAcceptCrmQuoteUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAcceptCrmQuoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptCrmQuote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptCrmQuote>>, TError,{id: number}, TContext> => {

const mutationKey = ['acceptCrmQuote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptCrmQuote>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  acceptCrmQuote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptCrmQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptCrmQuote>>>

    export type AcceptCrmQuoteMutationError = ErrorType<unknown>

    /**
 * @summary Mark quote as accepted (by customer or staff on behalf)
 */
export const useAcceptCrmQuote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptCrmQuote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptCrmQuote>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAcceptCrmQuoteMutationOptions(options));
    }

export const getConvertCrmQuoteToOrderUrl = (id: number,) => {




  return `/api/crm/quotes/${id}/convert-to-order`
}

/**
 * @summary Convert accepted quote to sales order (with optional stock reservation)
 */
export const convertCrmQuoteToOrder = async (id: number, options?: RequestInit): Promise<CrmSalesOrder> => {

  return customFetch<CrmSalesOrder>(getConvertCrmQuoteToOrderUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getConvertCrmQuoteToOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertCrmQuoteToOrder>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof convertCrmQuoteToOrder>>, TError,{id: number}, TContext> => {

const mutationKey = ['convertCrmQuoteToOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertCrmQuoteToOrder>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  convertCrmQuoteToOrder(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvertCrmQuoteToOrderMutationResult = NonNullable<Awaited<ReturnType<typeof convertCrmQuoteToOrder>>>

    export type ConvertCrmQuoteToOrderMutationError = ErrorType<unknown>

    /**
 * @summary Convert accepted quote to sales order (with optional stock reservation)
 */
export const useConvertCrmQuoteToOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertCrmQuoteToOrder>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof convertCrmQuoteToOrder>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getConvertCrmQuoteToOrderMutationOptions(options));
    }

export const getListCrmSalesOrdersUrl = (params?: ListCrmSalesOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/sales-orders?${stringifiedParams}` : `/api/crm/sales-orders`
}

/**
 * @summary List sales orders
 */
export const listCrmSalesOrders = async (params?: ListCrmSalesOrdersParams, options?: RequestInit): Promise<CrmSalesOrder[]> => {

  return customFetch<CrmSalesOrder[]>(getListCrmSalesOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmSalesOrdersQueryKey = (params?: ListCrmSalesOrdersParams,) => {
    return [
    `/api/crm/sales-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmSalesOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listCrmSalesOrders>>, TError = ErrorType<unknown>>(params?: ListCrmSalesOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmSalesOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmSalesOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmSalesOrders>>> = ({ signal }) => listCrmSalesOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmSalesOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCrmSalesOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmSalesOrders>>>
export type ListCrmSalesOrdersQueryError = ErrorType<unknown>


/**
 * @summary List sales orders
 */

export function useListCrmSalesOrders<TData = Awaited<ReturnType<typeof listCrmSalesOrders>>, TError = ErrorType<unknown>>(
 params?: ListCrmSalesOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCrmSalesOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCrmSalesOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCrmSalesOrderUrl = () => {




  return `/api/crm/sales-orders`
}

/**
 * @summary Create sales order manually (without quote)
 */
export const createCrmSalesOrder = async (crmSalesOrderInput: CrmSalesOrderInput, options?: RequestInit): Promise<CrmSalesOrder> => {

  return customFetch<CrmSalesOrder>(getCreateCrmSalesOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmSalesOrderInput,)
  }
);}




export const getCreateCrmSalesOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmSalesOrder>>, TError,{data: BodyType<CrmSalesOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrmSalesOrder>>, TError,{data: BodyType<CrmSalesOrderInput>}, TContext> => {

const mutationKey = ['createCrmSalesOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrmSalesOrder>>, {data: BodyType<CrmSalesOrderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCrmSalesOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrmSalesOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createCrmSalesOrder>>>
    export type CreateCrmSalesOrderMutationBody = BodyType<CrmSalesOrderInput>
    export type CreateCrmSalesOrderMutationError = ErrorType<unknown>

    /**
 * @summary Create sales order manually (without quote)
 */
export const useCreateCrmSalesOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmSalesOrder>>, TError,{data: BodyType<CrmSalesOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCrmSalesOrder>>,
        TError,
        {data: BodyType<CrmSalesOrderInput>},
        TContext
      > => {
      return useMutation(getCreateCrmSalesOrderMutationOptions(options));
    }

export const getGetCrmSalesOrderUrl = (id: number,) => {




  return `/api/crm/sales-orders/${id}`
}

/**
 * @summary Get sales order with line items
 */
export const getCrmSalesOrder = async (id: number, options?: RequestInit): Promise<CrmSalesOrderDetail> => {

  return customFetch<CrmSalesOrderDetail>(getGetCrmSalesOrderUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmSalesOrderQueryKey = (id: number,) => {
    return [
    `/api/crm/sales-orders/${id}`
    ] as const;
    }


export const getGetCrmSalesOrderQueryOptions = <TData = Awaited<ReturnType<typeof getCrmSalesOrder>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmSalesOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmSalesOrderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmSalesOrder>>> = ({ signal }) => getCrmSalesOrder(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmSalesOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrmSalesOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmSalesOrder>>>
export type GetCrmSalesOrderQueryError = ErrorType<unknown>


/**
 * @summary Get sales order with line items
 */

export function useGetCrmSalesOrder<TData = Awaited<ReturnType<typeof getCrmSalesOrder>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmSalesOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrmSalesOrderQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCrmSalesOrderUrl = (id: number,) => {




  return `/api/crm/sales-orders/${id}`
}

/**
 * @summary Update sales order status / delivery dates
 */
export const updateCrmSalesOrder = async (id: number,
    crmSalesOrderInput: CrmSalesOrderInput, options?: RequestInit): Promise<CrmSalesOrder> => {

  return customFetch<CrmSalesOrder>(getUpdateCrmSalesOrderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crmSalesOrderInput,)
  }
);}




export const getUpdateCrmSalesOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmSalesOrder>>, TError,{id: number;data: BodyType<CrmSalesOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrmSalesOrder>>, TError,{id: number;data: BodyType<CrmSalesOrderInput>}, TContext> => {

const mutationKey = ['updateCrmSalesOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrmSalesOrder>>, {id: number;data: BodyType<CrmSalesOrderInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCrmSalesOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrmSalesOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrmSalesOrder>>>
    export type UpdateCrmSalesOrderMutationBody = BodyType<CrmSalesOrderInput>
    export type UpdateCrmSalesOrderMutationError = ErrorType<unknown>

    /**
 * @summary Update sales order status / delivery dates
 */
export const useUpdateCrmSalesOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmSalesOrder>>, TError,{id: number;data: BodyType<CrmSalesOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCrmSalesOrder>>,
        TError,
        {id: number;data: BodyType<CrmSalesOrderInput>},
        TContext
      > => {
      return useMutation(getUpdateCrmSalesOrderMutationOptions(options));
    }

export const getInvoiceCrmSalesOrderUrl = (id: number,) => {




  return `/api/crm/sales-orders/${id}/invoice`
}

/**
 * @summary Create Finance AR invoice from sales order (posts stock movement + double-entry)
 */
export const invoiceCrmSalesOrder = async (id: number,
    invoiceCrmSalesOrderBody?: InvoiceCrmSalesOrderBody, options?: RequestInit): Promise<SalesInvoice> => {

  return customFetch<SalesInvoice>(getInvoiceCrmSalesOrderUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      invoiceCrmSalesOrderBody,)
  }
);}




export const getInvoiceCrmSalesOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invoiceCrmSalesOrder>>, TError,{id: number;data?: BodyType<InvoiceCrmSalesOrderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof invoiceCrmSalesOrder>>, TError,{id: number;data?: BodyType<InvoiceCrmSalesOrderBody>}, TContext> => {

const mutationKey = ['invoiceCrmSalesOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invoiceCrmSalesOrder>>, {id: number;data?: BodyType<InvoiceCrmSalesOrderBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  invoiceCrmSalesOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InvoiceCrmSalesOrderMutationResult = NonNullable<Awaited<ReturnType<typeof invoiceCrmSalesOrder>>>
    export type InvoiceCrmSalesOrderMutationBody = BodyType<InvoiceCrmSalesOrderBody> | undefined
    export type InvoiceCrmSalesOrderMutationError = ErrorType<unknown>

    /**
 * @summary Create Finance AR invoice from sales order (posts stock movement + double-entry)
 */
export const useInvoiceCrmSalesOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invoiceCrmSalesOrder>>, TError,{id: number;data?: BodyType<InvoiceCrmSalesOrderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof invoiceCrmSalesOrder>>,
        TError,
        {id: number;data?: BodyType<InvoiceCrmSalesOrderBody>},
        TContext
      > => {
      return useMutation(getInvoiceCrmSalesOrderMutationOptions(options));
    }

export const getListSalesTargetsUrl = (params?: ListSalesTargetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/targets?${stringifiedParams}` : `/api/crm/targets`
}

/**
 * @summary List sales targets with achievement tracking
 */
export const listSalesTargets = async (params?: ListSalesTargetsParams, options?: RequestInit): Promise<SalesTarget[]> => {

  return customFetch<SalesTarget[]>(getListSalesTargetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalesTargetsQueryKey = (params?: ListSalesTargetsParams,) => {
    return [
    `/api/crm/targets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSalesTargetsQueryOptions = <TData = Awaited<ReturnType<typeof listSalesTargets>>, TError = ErrorType<unknown>>(params?: ListSalesTargetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalesTargets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalesTargetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalesTargets>>> = ({ signal }) => listSalesTargets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalesTargets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalesTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof listSalesTargets>>>
export type ListSalesTargetsQueryError = ErrorType<unknown>


/**
 * @summary List sales targets with achievement tracking
 */

export function useListSalesTargets<TData = Awaited<ReturnType<typeof listSalesTargets>>, TError = ErrorType<unknown>>(
 params?: ListSalesTargetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalesTargets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalesTargetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSalesTargetUrl = () => {




  return `/api/crm/targets`
}

/**
 * @summary Set a sales target for a salesperson
 */
export const createSalesTarget = async (salesTargetInput: SalesTargetInput, options?: RequestInit): Promise<SalesTarget> => {

  return customFetch<SalesTarget>(getCreateSalesTargetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salesTargetInput,)
  }
);}




export const getCreateSalesTargetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesTarget>>, TError,{data: BodyType<SalesTargetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSalesTarget>>, TError,{data: BodyType<SalesTargetInput>}, TContext> => {

const mutationKey = ['createSalesTarget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSalesTarget>>, {data: BodyType<SalesTargetInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSalesTarget(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSalesTargetMutationResult = NonNullable<Awaited<ReturnType<typeof createSalesTarget>>>
    export type CreateSalesTargetMutationBody = BodyType<SalesTargetInput>
    export type CreateSalesTargetMutationError = ErrorType<unknown>

    /**
 * @summary Set a sales target for a salesperson
 */
export const useCreateSalesTarget = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesTarget>>, TError,{data: BodyType<SalesTargetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSalesTarget>>,
        TError,
        {data: BodyType<SalesTargetInput>},
        TContext
      > => {
      return useMutation(getCreateSalesTargetMutationOptions(options));
    }

export const getUpdateSalesTargetUrl = (id: number,) => {




  return `/api/crm/targets/${id}`
}

/**
 * @summary Update target amount or record achievement
 */
export const updateSalesTarget = async (id: number,
    salesTargetInput: SalesTargetInput, options?: RequestInit): Promise<SalesTarget> => {

  return customFetch<SalesTarget>(getUpdateSalesTargetUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salesTargetInput,)
  }
);}




export const getUpdateSalesTargetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesTarget>>, TError,{id: number;data: BodyType<SalesTargetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSalesTarget>>, TError,{id: number;data: BodyType<SalesTargetInput>}, TContext> => {

const mutationKey = ['updateSalesTarget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSalesTarget>>, {id: number;data: BodyType<SalesTargetInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSalesTarget(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSalesTargetMutationResult = NonNullable<Awaited<ReturnType<typeof updateSalesTarget>>>
    export type UpdateSalesTargetMutationBody = BodyType<SalesTargetInput>
    export type UpdateSalesTargetMutationError = ErrorType<unknown>

    /**
 * @summary Update target amount or record achievement
 */
export const useUpdateSalesTarget = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesTarget>>, TError,{id: number;data: BodyType<SalesTargetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSalesTarget>>,
        TError,
        {id: number;data: BodyType<SalesTargetInput>},
        TContext
      > => {
      return useMutation(getUpdateSalesTargetMutationOptions(options));
    }

export const getListMarketingSegmentsUrl = () => {




  return `/api/crm/segments`
}

/**
 * @summary List audience segments (used in campaigns)
 */
export const listMarketingSegments = async ( options?: RequestInit): Promise<MarketingSegment[]> => {

  return customFetch<MarketingSegment[]>(getListMarketingSegmentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMarketingSegmentsQueryKey = () => {
    return [
    `/api/crm/segments`
    ] as const;
    }


export const getListMarketingSegmentsQueryOptions = <TData = Awaited<ReturnType<typeof listMarketingSegments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMarketingSegments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMarketingSegmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMarketingSegments>>> = ({ signal }) => listMarketingSegments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMarketingSegments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMarketingSegmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listMarketingSegments>>>
export type ListMarketingSegmentsQueryError = ErrorType<unknown>


/**
 * @summary List audience segments (used in campaigns)
 */

export function useListMarketingSegments<TData = Awaited<ReturnType<typeof listMarketingSegments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMarketingSegments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMarketingSegmentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateMarketingSegmentUrl = () => {




  return `/api/crm/segments`
}

/**
 * @summary Create an audience segment with filter criteria
 */
export const createMarketingSegment = async (marketingSegmentInput: MarketingSegmentInput, options?: RequestInit): Promise<MarketingSegment> => {

  return customFetch<MarketingSegment>(getCreateMarketingSegmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      marketingSegmentInput,)
  }
);}




export const getCreateMarketingSegmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMarketingSegment>>, TError,{data: BodyType<MarketingSegmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMarketingSegment>>, TError,{data: BodyType<MarketingSegmentInput>}, TContext> => {

const mutationKey = ['createMarketingSegment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMarketingSegment>>, {data: BodyType<MarketingSegmentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createMarketingSegment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMarketingSegmentMutationResult = NonNullable<Awaited<ReturnType<typeof createMarketingSegment>>>
    export type CreateMarketingSegmentMutationBody = BodyType<MarketingSegmentInput>
    export type CreateMarketingSegmentMutationError = ErrorType<unknown>

    /**
 * @summary Create an audience segment with filter criteria
 */
export const useCreateMarketingSegment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMarketingSegment>>, TError,{data: BodyType<MarketingSegmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMarketingSegment>>,
        TError,
        {data: BodyType<MarketingSegmentInput>},
        TContext
      > => {
      return useMutation(getCreateMarketingSegmentMutationOptions(options));
    }

export const getUpdateMarketingSegmentUrl = (id: number,) => {




  return `/api/crm/segments/${id}`
}

/**
 * @summary Update segment name / filter criteria
 */
export const updateMarketingSegment = async (id: number,
    marketingSegmentInput: MarketingSegmentInput, options?: RequestInit): Promise<MarketingSegment> => {

  return customFetch<MarketingSegment>(getUpdateMarketingSegmentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      marketingSegmentInput,)
  }
);}




export const getUpdateMarketingSegmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMarketingSegment>>, TError,{id: number;data: BodyType<MarketingSegmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMarketingSegment>>, TError,{id: number;data: BodyType<MarketingSegmentInput>}, TContext> => {

const mutationKey = ['updateMarketingSegment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMarketingSegment>>, {id: number;data: BodyType<MarketingSegmentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateMarketingSegment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMarketingSegmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateMarketingSegment>>>
    export type UpdateMarketingSegmentMutationBody = BodyType<MarketingSegmentInput>
    export type UpdateMarketingSegmentMutationError = ErrorType<unknown>

    /**
 * @summary Update segment name / filter criteria
 */
export const useUpdateMarketingSegment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMarketingSegment>>, TError,{id: number;data: BodyType<MarketingSegmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMarketingSegment>>,
        TError,
        {id: number;data: BodyType<MarketingSegmentInput>},
        TContext
      > => {
      return useMutation(getUpdateMarketingSegmentMutationOptions(options));
    }

export const getListEmailCampaignsUrl = (params?: ListEmailCampaignsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/campaigns?${stringifiedParams}` : `/api/crm/campaigns`
}

/**
 * @summary List marketing campaigns (email / SMS / event / social)
 */
export const listEmailCampaigns = async (params?: ListEmailCampaignsParams, options?: RequestInit): Promise<EmailCampaign[]> => {

  return customFetch<EmailCampaign[]>(getListEmailCampaignsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmailCampaignsQueryKey = (params?: ListEmailCampaignsParams,) => {
    return [
    `/api/crm/campaigns`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEmailCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listEmailCampaigns>>, TError = ErrorType<unknown>>(params?: ListEmailCampaignsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmailCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmailCampaignsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmailCampaigns>>> = ({ signal }) => listEmailCampaigns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmailCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEmailCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listEmailCampaigns>>>
export type ListEmailCampaignsQueryError = ErrorType<unknown>


/**
 * @summary List marketing campaigns (email / SMS / event / social)
 */

export function useListEmailCampaigns<TData = Awaited<ReturnType<typeof listEmailCampaigns>>, TError = ErrorType<unknown>>(
 params?: ListEmailCampaignsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmailCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEmailCampaignsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateEmailCampaignUrl = () => {




  return `/api/crm/campaigns`
}

/**
 * @summary Create a marketing campaign
 */
export const createEmailCampaign = async (emailCampaignInput: EmailCampaignInput, options?: RequestInit): Promise<EmailCampaign> => {

  return customFetch<EmailCampaign>(getCreateEmailCampaignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      emailCampaignInput,)
  }
);}




export const getCreateEmailCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailCampaign>>, TError,{data: BodyType<EmailCampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmailCampaign>>, TError,{data: BodyType<EmailCampaignInput>}, TContext> => {

const mutationKey = ['createEmailCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmailCampaign>>, {data: BodyType<EmailCampaignInput>}> = (props) => {
          const {data} = props ?? {};

          return  createEmailCampaign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmailCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createEmailCampaign>>>
    export type CreateEmailCampaignMutationBody = BodyType<EmailCampaignInput>
    export type CreateEmailCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Create a marketing campaign
 */
export const useCreateEmailCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailCampaign>>, TError,{data: BodyType<EmailCampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEmailCampaign>>,
        TError,
        {data: BodyType<EmailCampaignInput>},
        TContext
      > => {
      return useMutation(getCreateEmailCampaignMutationOptions(options));
    }

export const getGetEmailCampaignUrl = (id: number,) => {




  return `/api/crm/campaigns/${id}`
}

/**
 * @summary Get campaign with member list
 */
export const getEmailCampaign = async (id: number, options?: RequestInit): Promise<EmailCampaignDetail> => {

  return customFetch<EmailCampaignDetail>(getGetEmailCampaignUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmailCampaignQueryKey = (id: number,) => {
    return [
    `/api/crm/campaigns/${id}`
    ] as const;
    }


export const getGetEmailCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getEmailCampaign>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmailCampaign>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailCampaignQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailCampaign>>> = ({ signal }) => getEmailCampaign(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailCampaign>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmailCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailCampaign>>>
export type GetEmailCampaignQueryError = ErrorType<unknown>


/**
 * @summary Get campaign with member list
 */

export function useGetEmailCampaign<TData = Awaited<ReturnType<typeof getEmailCampaign>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmailCampaign>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmailCampaignQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateEmailCampaignUrl = (id: number,) => {




  return `/api/crm/campaigns/${id}`
}

/**
 * @summary Update campaign (draft only)
 */
export const updateEmailCampaign = async (id: number,
    emailCampaignInput: EmailCampaignInput, options?: RequestInit): Promise<EmailCampaign> => {

  return customFetch<EmailCampaign>(getUpdateEmailCampaignUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      emailCampaignInput,)
  }
);}




export const getUpdateEmailCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailCampaign>>, TError,{id: number;data: BodyType<EmailCampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailCampaign>>, TError,{id: number;data: BodyType<EmailCampaignInput>}, TContext> => {

const mutationKey = ['updateEmailCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailCampaign>>, {id: number;data: BodyType<EmailCampaignInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmailCampaign(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailCampaign>>>
    export type UpdateEmailCampaignMutationBody = BodyType<EmailCampaignInput>
    export type UpdateEmailCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Update campaign (draft only)
 */
export const useUpdateEmailCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailCampaign>>, TError,{id: number;data: BodyType<EmailCampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailCampaign>>,
        TError,
        {id: number;data: BodyType<EmailCampaignInput>},
        TContext
      > => {
      return useMutation(getUpdateEmailCampaignMutationOptions(options));
    }

export const getLaunchEmailCampaignUrl = (id: number,) => {




  return `/api/crm/campaigns/${id}/launch`
}

/**
 * @summary Launch campaign: populate members from segment, send emails, set status=running
 */
export const launchEmailCampaign = async (id: number, options?: RequestInit): Promise<LaunchEmailCampaign200> => {

  return customFetch<LaunchEmailCampaign200>(getLaunchEmailCampaignUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getLaunchEmailCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchEmailCampaign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof launchEmailCampaign>>, TError,{id: number}, TContext> => {

const mutationKey = ['launchEmailCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof launchEmailCampaign>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  launchEmailCampaign(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaunchEmailCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof launchEmailCampaign>>>

    export type LaunchEmailCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Launch campaign: populate members from segment, send emails, set status=running
 */
export const useLaunchEmailCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchEmailCampaign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof launchEmailCampaign>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getLaunchEmailCampaignMutationOptions(options));
    }

export const getCompleteEmailCampaignUrl = (id: number,) => {




  return `/api/crm/campaigns/${id}/complete`
}

/**
 * @summary Mark campaign as completed (stops tracking)
 */
export const completeEmailCampaign = async (id: number, options?: RequestInit): Promise<EmailCampaign> => {

  return customFetch<EmailCampaign>(getCompleteEmailCampaignUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCompleteEmailCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmailCampaign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeEmailCampaign>>, TError,{id: number}, TContext> => {

const mutationKey = ['completeEmailCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeEmailCampaign>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  completeEmailCampaign(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteEmailCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof completeEmailCampaign>>>

    export type CompleteEmailCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Mark campaign as completed (stops tracking)
 */
export const useCompleteEmailCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmailCampaign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeEmailCampaign>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCompleteEmailCampaignMutationOptions(options));
    }

export const getTrackCampaignEngagementUrl = (params: TrackCampaignEngagementParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/campaigns/track?${stringifiedParams}` : `/api/crm/campaigns/track`
}

/**
 * Public endpoint (no auth). HMAC-signed `tk` token validates the member + campaign pair and prevents metric spoofing. Click action accepts absolute https:// or relative / URLs.

 * @summary Pixel tracking endpoint: record open (image) or click (redirect) per member
 */
export const trackCampaignEngagement = async (params: TrackCampaignEngagementParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getTrackCampaignEngagementUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTrackCampaignEngagementQueryKey = (params?: TrackCampaignEngagementParams,) => {
    return [
    `/api/crm/campaigns/track`, ...(params ? [params] : [])
    ] as const;
    }


export const getTrackCampaignEngagementQueryOptions = <TData = Awaited<ReturnType<typeof trackCampaignEngagement>>, TError = ErrorType<void>>(params: TrackCampaignEngagementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof trackCampaignEngagement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTrackCampaignEngagementQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof trackCampaignEngagement>>> = ({ signal }) => trackCampaignEngagement(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof trackCampaignEngagement>>, TError, TData> & { queryKey: QueryKey }
}

export type TrackCampaignEngagementQueryResult = NonNullable<Awaited<ReturnType<typeof trackCampaignEngagement>>>
export type TrackCampaignEngagementQueryError = ErrorType<void>


/**
 * @summary Pixel tracking endpoint: record open (image) or click (redirect) per member
 */

export function useTrackCampaignEngagement<TData = Awaited<ReturnType<typeof trackCampaignEngagement>>, TError = ErrorType<void>>(
 params: TrackCampaignEngagementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof trackCampaignEngagement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTrackCampaignEngagementQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getViewCustomerPortalUrl = (params: ViewCustomerPortalParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/portal/customer?${stringifiedParams}` : `/api/crm/portal/customer`
}

/**
 * Public endpoint (no auth). HMAC-signed `ct` token identifies the customer. Returns orders, AR invoices, and payment history for that customer. Token is generated when a sales-order is created and can be emailed to the customer.

 * @summary Customer self-service portal: view orders, invoices, and payments via HMAC token
 */
export const viewCustomerPortal = async (params: ViewCustomerPortalParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getViewCustomerPortalUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getViewCustomerPortalQueryKey = (params?: ViewCustomerPortalParams,) => {
    return [
    `/api/crm/portal/customer`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewCustomerPortalQueryOptions = <TData = Awaited<ReturnType<typeof viewCustomerPortal>>, TError = ErrorType<void>>(params: ViewCustomerPortalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof viewCustomerPortal>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewCustomerPortalQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewCustomerPortal>>> = ({ signal }) => viewCustomerPortal(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewCustomerPortal>>, TError, TData> & { queryKey: QueryKey }
}

export type ViewCustomerPortalQueryResult = NonNullable<Awaited<ReturnType<typeof viewCustomerPortal>>>
export type ViewCustomerPortalQueryError = ErrorType<void>


/**
 * @summary Customer self-service portal: view orders, invoices, and payments via HMAC token
 */

export function useViewCustomerPortal<TData = Awaited<ReturnType<typeof viewCustomerPortal>>, TError = ErrorType<void>>(
 params: ViewCustomerPortalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof viewCustomerPortal>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getViewCustomerPortalQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getViewCustomerPortalQuoteUrl = (params: ViewCustomerPortalQuoteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/portal/quote?${stringifiedParams}` : `/api/crm/portal/quote`
}

/**
 * @summary Customer portal: view quote via time-limited HMAC token (no login required)
 */
export const viewCustomerPortalQuote = async (params: ViewCustomerPortalQuoteParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getViewCustomerPortalQuoteUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getViewCustomerPortalQuoteQueryKey = (params?: ViewCustomerPortalQuoteParams,) => {
    return [
    `/api/crm/portal/quote`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewCustomerPortalQuoteQueryOptions = <TData = Awaited<ReturnType<typeof viewCustomerPortalQuote>>, TError = ErrorType<void>>(params: ViewCustomerPortalQuoteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof viewCustomerPortalQuote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewCustomerPortalQuoteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewCustomerPortalQuote>>> = ({ signal }) => viewCustomerPortalQuote(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewCustomerPortalQuote>>, TError, TData> & { queryKey: QueryKey }
}

export type ViewCustomerPortalQuoteQueryResult = NonNullable<Awaited<ReturnType<typeof viewCustomerPortalQuote>>>
export type ViewCustomerPortalQuoteQueryError = ErrorType<void>


/**
 * @summary Customer portal: view quote via time-limited HMAC token (no login required)
 */

export function useViewCustomerPortalQuote<TData = Awaited<ReturnType<typeof viewCustomerPortalQuote>>, TError = ErrorType<void>>(
 params: ViewCustomerPortalQuoteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof viewCustomerPortalQuote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getViewCustomerPortalQuoteQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetCrmQuoteHtmlUrl = (id: number,) => {




  return `/api/crm/quotes/${id}/html`
}

/**
 * @summary Printable HTML view of a quote (internal staff; requires auth)
 */
export const getCrmQuoteHtml = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetCrmQuoteHtmlUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmQuoteHtmlQueryKey = (id: number,) => {
    return [
    `/api/crm/quotes/${id}/html`
    ] as const;
    }


export const getGetCrmQuoteHtmlQueryOptions = <TData = Awaited<ReturnType<typeof getCrmQuoteHtml>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmQuoteHtml>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmQuoteHtmlQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmQuoteHtml>>> = ({ signal }) => getCrmQuoteHtml(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmQuoteHtml>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrmQuoteHtmlQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmQuoteHtml>>>
export type GetCrmQuoteHtmlQueryError = ErrorType<unknown>


/**
 * @summary Printable HTML view of a quote (internal staff; requires auth)
 */

export function useGetCrmQuoteHtml<TData = Awaited<ReturnType<typeof getCrmQuoteHtml>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmQuoteHtml>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrmQuoteHtmlQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetCrmPipelineSummaryUrl = () => {




  return `/api/crm/reports/pipeline-summary`
}

/**
 * @summary Pipeline by stage + won revenue + active leads
 */
export const getCrmPipelineSummary = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetCrmPipelineSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmPipelineSummaryQueryKey = () => {
    return [
    `/api/crm/reports/pipeline-summary`
    ] as const;
    }


export const getGetCrmPipelineSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getCrmPipelineSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmPipelineSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmPipelineSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmPipelineSummary>>> = ({ signal }) => getCrmPipelineSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmPipelineSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrmPipelineSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmPipelineSummary>>>
export type GetCrmPipelineSummaryQueryError = ErrorType<unknown>


/**
 * @summary Pipeline by stage + won revenue + active leads
 */

export function useGetCrmPipelineSummary<TData = Awaited<ReturnType<typeof getCrmPipelineSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmPipelineSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrmPipelineSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetCrmActivityFeedUrl = () => {




  return `/api/crm/reports/activity-feed`
}

/**
 * @summary Recent activity feed (last 50 activities)
 */
export const getCrmActivityFeed = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetCrmActivityFeedUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmActivityFeedQueryKey = () => {
    return [
    `/api/crm/reports/activity-feed`
    ] as const;
    }


export const getGetCrmActivityFeedQueryOptions = <TData = Awaited<ReturnType<typeof getCrmActivityFeed>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmActivityFeed>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmActivityFeedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmActivityFeed>>> = ({ signal }) => getCrmActivityFeed({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmActivityFeed>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrmActivityFeedQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmActivityFeed>>>
export type GetCrmActivityFeedQueryError = ErrorType<unknown>


/**
 * @summary Recent activity feed (last 50 activities)
 */

export function useGetCrmActivityFeed<TData = Awaited<ReturnType<typeof getCrmActivityFeed>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrmActivityFeed>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrmActivityFeedQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListOpsProjectsUrl = (params?: ListOpsProjectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ops/projects?${stringifiedParams}` : `/api/ops/projects`
}

/**
 * @summary List projects
 */
export const listOpsProjects = async (params?: ListOpsProjectsParams, options?: RequestInit): Promise<OpsProject[]> => {

  return customFetch<OpsProject[]>(getListOpsProjectsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpsProjectsQueryKey = (params?: ListOpsProjectsParams,) => {
    return [
    `/api/ops/projects`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOpsProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listOpsProjects>>, TError = ErrorType<unknown>>(params?: ListOpsProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpsProjectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpsProjects>>> = ({ signal }) => listOpsProjects(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpsProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpsProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listOpsProjects>>>
export type ListOpsProjectsQueryError = ErrorType<unknown>


/**
 * @summary List projects
 */

export function useListOpsProjects<TData = Awaited<ReturnType<typeof listOpsProjects>>, TError = ErrorType<unknown>>(
 params?: ListOpsProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpsProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpsProjectUrl = () => {




  return `/api/ops/projects`
}

/**
 * @summary Create project
 */
export const createOpsProject = async (opsProjectInput: OpsProjectInput, options?: RequestInit): Promise<OpsProject> => {

  return customFetch<OpsProject>(getCreateOpsProjectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsProjectInput,)
  }
);}




export const getCreateOpsProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsProject>>, TError,{data: BodyType<OpsProjectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpsProject>>, TError,{data: BodyType<OpsProjectInput>}, TContext> => {

const mutationKey = ['createOpsProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpsProject>>, {data: BodyType<OpsProjectInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOpsProject(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpsProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createOpsProject>>>
    export type CreateOpsProjectMutationBody = BodyType<OpsProjectInput>
    export type CreateOpsProjectMutationError = ErrorType<unknown>

    /**
 * @summary Create project
 */
export const useCreateOpsProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsProject>>, TError,{data: BodyType<OpsProjectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpsProject>>,
        TError,
        {data: BodyType<OpsProjectInput>},
        TContext
      > => {
      return useMutation(getCreateOpsProjectMutationOptions(options));
    }

export const getGetOpsProjectUrl = (id: number,) => {




  return `/api/ops/projects/${id}`
}

/**
 * @summary Get project with milestones and tasks
 */
export const getOpsProject = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetOpsProjectUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpsProjectQueryKey = (id: number,) => {
    return [
    `/api/ops/projects/${id}`
    ] as const;
    }


export const getGetOpsProjectQueryOptions = <TData = Awaited<ReturnType<typeof getOpsProject>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpsProject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpsProjectQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpsProject>>> = ({ signal }) => getOpsProject(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpsProject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOpsProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getOpsProject>>>
export type GetOpsProjectQueryError = ErrorType<void>


/**
 * @summary Get project with milestones and tasks
 */

export function useGetOpsProject<TData = Awaited<ReturnType<typeof getOpsProject>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpsProject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOpsProjectQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateOpsProjectUrl = (id: number,) => {




  return `/api/ops/projects/${id}`
}

/**
 * @summary Update project
 */
export const updateOpsProject = async (id: number,
    opsProjectInput: OpsProjectInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOpsProjectUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsProjectInput,)
  }
);}




export const getUpdateOpsProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsProject>>, TError,{id: number;data: BodyType<OpsProjectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpsProject>>, TError,{id: number;data: BodyType<OpsProjectInput>}, TContext> => {

const mutationKey = ['updateOpsProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpsProject>>, {id: number;data: BodyType<OpsProjectInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpsProject(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpsProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpsProject>>>
    export type UpdateOpsProjectMutationBody = BodyType<OpsProjectInput>
    export type UpdateOpsProjectMutationError = ErrorType<unknown>

    /**
 * @summary Update project
 */
export const useUpdateOpsProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsProject>>, TError,{id: number;data: BodyType<OpsProjectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpsProject>>,
        TError,
        {id: number;data: BodyType<OpsProjectInput>},
        TContext
      > => {
      return useMutation(getUpdateOpsProjectMutationOptions(options));
    }

export const getDeleteOpsProjectUrl = (id: number,) => {




  return `/api/ops/projects/${id}`
}

/**
 * @summary Delete project
 */
export const deleteOpsProject = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteOpsProjectUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteOpsProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpsProject>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOpsProject>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteOpsProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOpsProject>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteOpsProject(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOpsProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOpsProject>>>

    export type DeleteOpsProjectMutationError = ErrorType<unknown>

    /**
 * @summary Delete project
 */
export const useDeleteOpsProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpsProject>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOpsProject>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteOpsProjectMutationOptions(options));
    }

export const getListOpsMilestonesUrl = (projectId: number,) => {




  return `/api/ops/projects/${projectId}/milestones`
}

/**
 * @summary List milestones for a project
 */
export const listOpsMilestones = async (projectId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListOpsMilestonesUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpsMilestonesQueryKey = (projectId: number,) => {
    return [
    `/api/ops/projects/${projectId}/milestones`
    ] as const;
    }


export const getListOpsMilestonesQueryOptions = <TData = Awaited<ReturnType<typeof listOpsMilestones>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsMilestones>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpsMilestonesQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpsMilestones>>> = ({ signal }) => listOpsMilestones(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpsMilestones>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpsMilestonesQueryResult = NonNullable<Awaited<ReturnType<typeof listOpsMilestones>>>
export type ListOpsMilestonesQueryError = ErrorType<unknown>


/**
 * @summary List milestones for a project
 */

export function useListOpsMilestones<TData = Awaited<ReturnType<typeof listOpsMilestones>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsMilestones>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpsMilestonesQueryOptions(projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpsMilestoneUrl = (projectId: number,) => {




  return `/api/ops/projects/${projectId}/milestones`
}

/**
 * @summary Create milestone
 */
export const createOpsMilestone = async (projectId: number,
    createOpsMilestoneBody: CreateOpsMilestoneBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateOpsMilestoneUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOpsMilestoneBody,)
  }
);}




export const getCreateOpsMilestoneMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsMilestone>>, TError,{projectId: number;data: BodyType<CreateOpsMilestoneBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpsMilestone>>, TError,{projectId: number;data: BodyType<CreateOpsMilestoneBody>}, TContext> => {

const mutationKey = ['createOpsMilestone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpsMilestone>>, {projectId: number;data: BodyType<CreateOpsMilestoneBody>}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createOpsMilestone(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpsMilestoneMutationResult = NonNullable<Awaited<ReturnType<typeof createOpsMilestone>>>
    export type CreateOpsMilestoneMutationBody = BodyType<CreateOpsMilestoneBody>
    export type CreateOpsMilestoneMutationError = ErrorType<unknown>

    /**
 * @summary Create milestone
 */
export const useCreateOpsMilestone = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsMilestone>>, TError,{projectId: number;data: BodyType<CreateOpsMilestoneBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpsMilestone>>,
        TError,
        {projectId: number;data: BodyType<CreateOpsMilestoneBody>},
        TContext
      > => {
      return useMutation(getCreateOpsMilestoneMutationOptions(options));
    }

export const getUpdateOpsMilestoneUrl = (id: number,) => {




  return `/api/ops/milestones/${id}`
}

/**
 * @summary Update milestone
 */
export const updateOpsMilestone = async (id: number,
    updateOpsMilestoneBody: UpdateOpsMilestoneBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOpsMilestoneUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOpsMilestoneBody,)
  }
);}




export const getUpdateOpsMilestoneMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsMilestone>>, TError,{id: number;data: BodyType<UpdateOpsMilestoneBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpsMilestone>>, TError,{id: number;data: BodyType<UpdateOpsMilestoneBody>}, TContext> => {

const mutationKey = ['updateOpsMilestone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpsMilestone>>, {id: number;data: BodyType<UpdateOpsMilestoneBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpsMilestone(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpsMilestoneMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpsMilestone>>>
    export type UpdateOpsMilestoneMutationBody = BodyType<UpdateOpsMilestoneBody>
    export type UpdateOpsMilestoneMutationError = ErrorType<unknown>

    /**
 * @summary Update milestone
 */
export const useUpdateOpsMilestone = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsMilestone>>, TError,{id: number;data: BodyType<UpdateOpsMilestoneBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpsMilestone>>,
        TError,
        {id: number;data: BodyType<UpdateOpsMilestoneBody>},
        TContext
      > => {
      return useMutation(getUpdateOpsMilestoneMutationOptions(options));
    }

export const getListOpsProjectTasksUrl = (projectId: number,
    params?: ListOpsProjectTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ops/projects/${projectId}/tasks?${stringifiedParams}` : `/api/ops/projects/${projectId}/tasks`
}

/**
 * @summary List tasks for a project
 */
export const listOpsProjectTasks = async (projectId: number,
    params?: ListOpsProjectTasksParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListOpsProjectTasksUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpsProjectTasksQueryKey = (projectId: number,
    params?: ListOpsProjectTasksParams,) => {
    return [
    `/api/ops/projects/${projectId}/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOpsProjectTasksQueryOptions = <TData = Awaited<ReturnType<typeof listOpsProjectTasks>>, TError = ErrorType<unknown>>(projectId: number,
    params?: ListOpsProjectTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsProjectTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpsProjectTasksQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpsProjectTasks>>> = ({ signal }) => listOpsProjectTasks(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpsProjectTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpsProjectTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listOpsProjectTasks>>>
export type ListOpsProjectTasksQueryError = ErrorType<unknown>


/**
 * @summary List tasks for a project
 */

export function useListOpsProjectTasks<TData = Awaited<ReturnType<typeof listOpsProjectTasks>>, TError = ErrorType<unknown>>(
 projectId: number,
    params?: ListOpsProjectTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsProjectTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpsProjectTasksQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpsProjectTaskUrl = (projectId: number,) => {




  return `/api/ops/projects/${projectId}/tasks`
}

/**
 * @summary Create task
 */
export const createOpsProjectTask = async (projectId: number,
    opsTaskInput: OpsTaskInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateOpsProjectTaskUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsTaskInput,)
  }
);}




export const getCreateOpsProjectTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsProjectTask>>, TError,{projectId: number;data: BodyType<OpsTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpsProjectTask>>, TError,{projectId: number;data: BodyType<OpsTaskInput>}, TContext> => {

const mutationKey = ['createOpsProjectTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpsProjectTask>>, {projectId: number;data: BodyType<OpsTaskInput>}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createOpsProjectTask(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpsProjectTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createOpsProjectTask>>>
    export type CreateOpsProjectTaskMutationBody = BodyType<OpsTaskInput>
    export type CreateOpsProjectTaskMutationError = ErrorType<unknown>

    /**
 * @summary Create task
 */
export const useCreateOpsProjectTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsProjectTask>>, TError,{projectId: number;data: BodyType<OpsTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpsProjectTask>>,
        TError,
        {projectId: number;data: BodyType<OpsTaskInput>},
        TContext
      > => {
      return useMutation(getCreateOpsProjectTaskMutationOptions(options));
    }

export const getUpdateOpsTaskUrl = (id: number,) => {




  return `/api/ops/tasks/${id}`
}

/**
 * @summary Update task status, assignee, priority etc.
 */
export const updateOpsTask = async (id: number,
    opsTaskInput: OpsTaskInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOpsTaskUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsTaskInput,)
  }
);}




export const getUpdateOpsTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsTask>>, TError,{id: number;data: BodyType<OpsTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpsTask>>, TError,{id: number;data: BodyType<OpsTaskInput>}, TContext> => {

const mutationKey = ['updateOpsTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpsTask>>, {id: number;data: BodyType<OpsTaskInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpsTask(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpsTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpsTask>>>
    export type UpdateOpsTaskMutationBody = BodyType<OpsTaskInput>
    export type UpdateOpsTaskMutationError = ErrorType<unknown>

    /**
 * @summary Update task status, assignee, priority etc.
 */
export const useUpdateOpsTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsTask>>, TError,{id: number;data: BodyType<OpsTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpsTask>>,
        TError,
        {id: number;data: BodyType<OpsTaskInput>},
        TContext
      > => {
      return useMutation(getUpdateOpsTaskMutationOptions(options));
    }

export const getDeleteOpsTaskUrl = (id: number,) => {




  return `/api/ops/tasks/${id}`
}

/**
 * @summary Delete task
 */
export const deleteOpsTask = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteOpsTaskUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteOpsTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpsTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOpsTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteOpsTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOpsTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteOpsTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOpsTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOpsTask>>>

    export type DeleteOpsTaskMutationError = ErrorType<unknown>

    /**
 * @summary Delete task
 */
export const useDeleteOpsTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpsTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOpsTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteOpsTaskMutationOptions(options));
    }

export const getListOpsTimeLogsUrl = (projectId: number,) => {




  return `/api/ops/projects/${projectId}/time-logs`
}

/**
 * @summary List time logs for a project
 */
export const listOpsTimeLogs = async (projectId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListOpsTimeLogsUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpsTimeLogsQueryKey = (projectId: number,) => {
    return [
    `/api/ops/projects/${projectId}/time-logs`
    ] as const;
    }


export const getListOpsTimeLogsQueryOptions = <TData = Awaited<ReturnType<typeof listOpsTimeLogs>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsTimeLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpsTimeLogsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpsTimeLogs>>> = ({ signal }) => listOpsTimeLogs(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpsTimeLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpsTimeLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listOpsTimeLogs>>>
export type ListOpsTimeLogsQueryError = ErrorType<unknown>


/**
 * @summary List time logs for a project
 */

export function useListOpsTimeLogs<TData = Awaited<ReturnType<typeof listOpsTimeLogs>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsTimeLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpsTimeLogsQueryOptions(projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpsTimeLogUrl = () => {




  return `/api/ops/time-logs`
}

/**
 * @summary Log time against a project/task
 */
export const createOpsTimeLog = async (createOpsTimeLogBody: CreateOpsTimeLogBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateOpsTimeLogUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOpsTimeLogBody,)
  }
);}




export const getCreateOpsTimeLogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsTimeLog>>, TError,{data: BodyType<CreateOpsTimeLogBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpsTimeLog>>, TError,{data: BodyType<CreateOpsTimeLogBody>}, TContext> => {

const mutationKey = ['createOpsTimeLog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpsTimeLog>>, {data: BodyType<CreateOpsTimeLogBody>}> = (props) => {
          const {data} = props ?? {};

          return  createOpsTimeLog(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpsTimeLogMutationResult = NonNullable<Awaited<ReturnType<typeof createOpsTimeLog>>>
    export type CreateOpsTimeLogMutationBody = BodyType<CreateOpsTimeLogBody>
    export type CreateOpsTimeLogMutationError = ErrorType<unknown>

    /**
 * @summary Log time against a project/task
 */
export const useCreateOpsTimeLog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsTimeLog>>, TError,{data: BodyType<CreateOpsTimeLogBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpsTimeLog>>,
        TError,
        {data: BodyType<CreateOpsTimeLogBody>},
        TContext
      > => {
      return useMutation(getCreateOpsTimeLogMutationOptions(options));
    }

export const getListOpsSlaPoliciesUrl = () => {




  return `/api/ops/sla-policies`
}

/**
 * @summary List SLA policies
 */
export const listOpsSlaPolicies = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListOpsSlaPoliciesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpsSlaPoliciesQueryKey = () => {
    return [
    `/api/ops/sla-policies`
    ] as const;
    }


export const getListOpsSlaPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof listOpsSlaPolicies>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsSlaPolicies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpsSlaPoliciesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpsSlaPolicies>>> = ({ signal }) => listOpsSlaPolicies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpsSlaPolicies>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpsSlaPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof listOpsSlaPolicies>>>
export type ListOpsSlaPoliciesQueryError = ErrorType<unknown>


/**
 * @summary List SLA policies
 */

export function useListOpsSlaPolicies<TData = Awaited<ReturnType<typeof listOpsSlaPolicies>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsSlaPolicies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpsSlaPoliciesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpsSlaPoliciesUrl = () => {




  return `/api/ops/sla-policies`
}

/**
 * @summary Create SLA policy
 */
export const createOpsSlaPolicies = async (opsSlaPolicyInput: OpsSlaPolicyInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateOpsSlaPoliciesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsSlaPolicyInput,)
  }
);}




export const getCreateOpsSlaPoliciesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsSlaPolicies>>, TError,{data: BodyType<OpsSlaPolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpsSlaPolicies>>, TError,{data: BodyType<OpsSlaPolicyInput>}, TContext> => {

const mutationKey = ['createOpsSlaPolicies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpsSlaPolicies>>, {data: BodyType<OpsSlaPolicyInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOpsSlaPolicies(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpsSlaPoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof createOpsSlaPolicies>>>
    export type CreateOpsSlaPoliciesMutationBody = BodyType<OpsSlaPolicyInput>
    export type CreateOpsSlaPoliciesMutationError = ErrorType<unknown>

    /**
 * @summary Create SLA policy
 */
export const useCreateOpsSlaPolicies = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsSlaPolicies>>, TError,{data: BodyType<OpsSlaPolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpsSlaPolicies>>,
        TError,
        {data: BodyType<OpsSlaPolicyInput>},
        TContext
      > => {
      return useMutation(getCreateOpsSlaPoliciesMutationOptions(options));
    }

export const getUpdateOpsSlaPolicyUrl = (id: number,) => {




  return `/api/ops/sla-policies/${id}`
}

/**
 * @summary Update SLA policy
 */
export const updateOpsSlaPolicy = async (id: number,
    opsSlaPolicyInput: OpsSlaPolicyInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOpsSlaPolicyUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsSlaPolicyInput,)
  }
);}




export const getUpdateOpsSlaPolicyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsSlaPolicy>>, TError,{id: number;data: BodyType<OpsSlaPolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpsSlaPolicy>>, TError,{id: number;data: BodyType<OpsSlaPolicyInput>}, TContext> => {

const mutationKey = ['updateOpsSlaPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpsSlaPolicy>>, {id: number;data: BodyType<OpsSlaPolicyInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpsSlaPolicy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpsSlaPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpsSlaPolicy>>>
    export type UpdateOpsSlaPolicyMutationBody = BodyType<OpsSlaPolicyInput>
    export type UpdateOpsSlaPolicyMutationError = ErrorType<unknown>

    /**
 * @summary Update SLA policy
 */
export const useUpdateOpsSlaPolicy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsSlaPolicy>>, TError,{id: number;data: BodyType<OpsSlaPolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpsSlaPolicy>>,
        TError,
        {id: number;data: BodyType<OpsSlaPolicyInput>},
        TContext
      > => {
      return useMutation(getUpdateOpsSlaPolicyMutationOptions(options));
    }

export const getListOpsTicketsUrl = (params?: ListOpsTicketsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ops/tickets?${stringifiedParams}` : `/api/ops/tickets`
}

/**
 * @summary List service tickets
 */
export const listOpsTickets = async (params?: ListOpsTicketsParams, options?: RequestInit): Promise<OpsTicket[]> => {

  return customFetch<OpsTicket[]>(getListOpsTicketsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpsTicketsQueryKey = (params?: ListOpsTicketsParams,) => {
    return [
    `/api/ops/tickets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOpsTicketsQueryOptions = <TData = Awaited<ReturnType<typeof listOpsTickets>>, TError = ErrorType<unknown>>(params?: ListOpsTicketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpsTicketsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpsTickets>>> = ({ signal }) => listOpsTickets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpsTickets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpsTicketsQueryResult = NonNullable<Awaited<ReturnType<typeof listOpsTickets>>>
export type ListOpsTicketsQueryError = ErrorType<unknown>


/**
 * @summary List service tickets
 */

export function useListOpsTickets<TData = Awaited<ReturnType<typeof listOpsTickets>>, TError = ErrorType<unknown>>(
 params?: ListOpsTicketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpsTicketsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpsTicketUrl = () => {




  return `/api/ops/tickets`
}

/**
 * @summary Create service ticket
 */
export const createOpsTicket = async (opsTicketInput: OpsTicketInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateOpsTicketUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsTicketInput,)
  }
);}




export const getCreateOpsTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsTicket>>, TError,{data: BodyType<OpsTicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpsTicket>>, TError,{data: BodyType<OpsTicketInput>}, TContext> => {

const mutationKey = ['createOpsTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpsTicket>>, {data: BodyType<OpsTicketInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOpsTicket(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpsTicketMutationResult = NonNullable<Awaited<ReturnType<typeof createOpsTicket>>>
    export type CreateOpsTicketMutationBody = BodyType<OpsTicketInput>
    export type CreateOpsTicketMutationError = ErrorType<unknown>

    /**
 * @summary Create service ticket
 */
export const useCreateOpsTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsTicket>>, TError,{data: BodyType<OpsTicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpsTicket>>,
        TError,
        {data: BodyType<OpsTicketInput>},
        TContext
      > => {
      return useMutation(getCreateOpsTicketMutationOptions(options));
    }

export const getGetOpsTicketUrl = (id: number,) => {




  return `/api/ops/tickets/${id}`
}

/**
 * @summary Get ticket with comments
 */
export const getOpsTicket = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetOpsTicketUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpsTicketQueryKey = (id: number,) => {
    return [
    `/api/ops/tickets/${id}`
    ] as const;
    }


export const getGetOpsTicketQueryOptions = <TData = Awaited<ReturnType<typeof getOpsTicket>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpsTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpsTicketQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpsTicket>>> = ({ signal }) => getOpsTicket(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpsTicket>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOpsTicketQueryResult = NonNullable<Awaited<ReturnType<typeof getOpsTicket>>>
export type GetOpsTicketQueryError = ErrorType<unknown>


/**
 * @summary Get ticket with comments
 */

export function useGetOpsTicket<TData = Awaited<ReturnType<typeof getOpsTicket>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpsTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOpsTicketQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateOpsTicketUrl = (id: number,) => {




  return `/api/ops/tickets/${id}`
}

/**
 * @summary Update ticket
 */
export const updateOpsTicket = async (id: number,
    opsTicketInput: OpsTicketInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOpsTicketUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsTicketInput,)
  }
);}




export const getUpdateOpsTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsTicket>>, TError,{id: number;data: BodyType<OpsTicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpsTicket>>, TError,{id: number;data: BodyType<OpsTicketInput>}, TContext> => {

const mutationKey = ['updateOpsTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpsTicket>>, {id: number;data: BodyType<OpsTicketInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpsTicket(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpsTicketMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpsTicket>>>
    export type UpdateOpsTicketMutationBody = BodyType<OpsTicketInput>
    export type UpdateOpsTicketMutationError = ErrorType<unknown>

    /**
 * @summary Update ticket
 */
export const useUpdateOpsTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsTicket>>, TError,{id: number;data: BodyType<OpsTicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpsTicket>>,
        TError,
        {id: number;data: BodyType<OpsTicketInput>},
        TContext
      > => {
      return useMutation(getUpdateOpsTicketMutationOptions(options));
    }

export const getAddOpsTicketCommentUrl = (id: number,) => {




  return `/api/ops/tickets/${id}/comments`
}

/**
 * @summary Add comment to ticket (sets firstResponseAt if public)
 */
export const addOpsTicketComment = async (id: number,
    addOpsTicketCommentBody: AddOpsTicketCommentBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getAddOpsTicketCommentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addOpsTicketCommentBody,)
  }
);}




export const getAddOpsTicketCommentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOpsTicketComment>>, TError,{id: number;data: BodyType<AddOpsTicketCommentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addOpsTicketComment>>, TError,{id: number;data: BodyType<AddOpsTicketCommentBody>}, TContext> => {

const mutationKey = ['addOpsTicketComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOpsTicketComment>>, {id: number;data: BodyType<AddOpsTicketCommentBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  addOpsTicketComment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOpsTicketCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addOpsTicketComment>>>
    export type AddOpsTicketCommentMutationBody = BodyType<AddOpsTicketCommentBody>
    export type AddOpsTicketCommentMutationError = ErrorType<unknown>

    /**
 * @summary Add comment to ticket (sets firstResponseAt if public)
 */
export const useAddOpsTicketComment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOpsTicketComment>>, TError,{id: number;data: BodyType<AddOpsTicketCommentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addOpsTicketComment>>,
        TError,
        {id: number;data: BodyType<AddOpsTicketCommentBody>},
        TContext
      > => {
      return useMutation(getAddOpsTicketCommentMutationOptions(options));
    }

export const getSubmitOpsTicketFeedbackUrl = (id: number,) => {




  return `/api/ops/tickets/${id}/feedback`
}

/**
 * @summary Submit CSAT feedback and close ticket
 */
export const submitOpsTicketFeedback = async (id: number,
    submitOpsTicketFeedbackBody: SubmitOpsTicketFeedbackBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getSubmitOpsTicketFeedbackUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      submitOpsTicketFeedbackBody,)
  }
);}




export const getSubmitOpsTicketFeedbackMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOpsTicketFeedback>>, TError,{id: number;data: BodyType<SubmitOpsTicketFeedbackBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitOpsTicketFeedback>>, TError,{id: number;data: BodyType<SubmitOpsTicketFeedbackBody>}, TContext> => {

const mutationKey = ['submitOpsTicketFeedback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitOpsTicketFeedback>>, {id: number;data: BodyType<SubmitOpsTicketFeedbackBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  submitOpsTicketFeedback(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitOpsTicketFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof submitOpsTicketFeedback>>>
    export type SubmitOpsTicketFeedbackMutationBody = BodyType<SubmitOpsTicketFeedbackBody>
    export type SubmitOpsTicketFeedbackMutationError = ErrorType<unknown>

    /**
 * @summary Submit CSAT feedback and close ticket
 */
export const useSubmitOpsTicketFeedback = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOpsTicketFeedback>>, TError,{id: number;data: BodyType<SubmitOpsTicketFeedbackBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitOpsTicketFeedback>>,
        TError,
        {id: number;data: BodyType<SubmitOpsTicketFeedbackBody>},
        TContext
      > => {
      return useMutation(getSubmitOpsTicketFeedbackMutationOptions(options));
    }

export const getListOpsDispatchUrl = (params?: ListOpsDispatchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ops/dispatch?${stringifiedParams}` : `/api/ops/dispatch`
}

/**
 * @summary List dispatch orders
 */
export const listOpsDispatch = async (params?: ListOpsDispatchParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListOpsDispatchUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpsDispatchQueryKey = (params?: ListOpsDispatchParams,) => {
    return [
    `/api/ops/dispatch`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOpsDispatchQueryOptions = <TData = Awaited<ReturnType<typeof listOpsDispatch>>, TError = ErrorType<unknown>>(params?: ListOpsDispatchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsDispatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpsDispatchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpsDispatch>>> = ({ signal }) => listOpsDispatch(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpsDispatch>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpsDispatchQueryResult = NonNullable<Awaited<ReturnType<typeof listOpsDispatch>>>
export type ListOpsDispatchQueryError = ErrorType<unknown>


/**
 * @summary List dispatch orders
 */

export function useListOpsDispatch<TData = Awaited<ReturnType<typeof listOpsDispatch>>, TError = ErrorType<unknown>>(
 params?: ListOpsDispatchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsDispatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpsDispatchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpsDispatchUrl = () => {




  return `/api/ops/dispatch`
}

/**
 * @summary Create dispatch order
 */
export const createOpsDispatch = async (opsDispatchInput: OpsDispatchInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateOpsDispatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsDispatchInput,)
  }
);}




export const getCreateOpsDispatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsDispatch>>, TError,{data: BodyType<OpsDispatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpsDispatch>>, TError,{data: BodyType<OpsDispatchInput>}, TContext> => {

const mutationKey = ['createOpsDispatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpsDispatch>>, {data: BodyType<OpsDispatchInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOpsDispatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpsDispatchMutationResult = NonNullable<Awaited<ReturnType<typeof createOpsDispatch>>>
    export type CreateOpsDispatchMutationBody = BodyType<OpsDispatchInput>
    export type CreateOpsDispatchMutationError = ErrorType<unknown>

    /**
 * @summary Create dispatch order
 */
export const useCreateOpsDispatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsDispatch>>, TError,{data: BodyType<OpsDispatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpsDispatch>>,
        TError,
        {data: BodyType<OpsDispatchInput>},
        TContext
      > => {
      return useMutation(getCreateOpsDispatchMutationOptions(options));
    }

export const getGetOpsDispatchUrl = (id: number,) => {




  return `/api/ops/dispatch/${id}`
}

/**
 * @summary Get dispatch order with lines
 */
export const getOpsDispatch = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetOpsDispatchUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpsDispatchQueryKey = (id: number,) => {
    return [
    `/api/ops/dispatch/${id}`
    ] as const;
    }


export const getGetOpsDispatchQueryOptions = <TData = Awaited<ReturnType<typeof getOpsDispatch>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpsDispatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpsDispatchQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpsDispatch>>> = ({ signal }) => getOpsDispatch(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpsDispatch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOpsDispatchQueryResult = NonNullable<Awaited<ReturnType<typeof getOpsDispatch>>>
export type GetOpsDispatchQueryError = ErrorType<unknown>


/**
 * @summary Get dispatch order with lines
 */

export function useGetOpsDispatch<TData = Awaited<ReturnType<typeof getOpsDispatch>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpsDispatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOpsDispatchQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateOpsDispatchUrl = (id: number,) => {




  return `/api/ops/dispatch/${id}`
}

/**
 * @summary Update dispatch order (status, carrier, dates)
 */
export const updateOpsDispatch = async (id: number,
    opsDispatchInput: OpsDispatchInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOpsDispatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsDispatchInput,)
  }
);}




export const getUpdateOpsDispatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsDispatch>>, TError,{id: number;data: BodyType<OpsDispatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpsDispatch>>, TError,{id: number;data: BodyType<OpsDispatchInput>}, TContext> => {

const mutationKey = ['updateOpsDispatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpsDispatch>>, {id: number;data: BodyType<OpsDispatchInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpsDispatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpsDispatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpsDispatch>>>
    export type UpdateOpsDispatchMutationBody = BodyType<OpsDispatchInput>
    export type UpdateOpsDispatchMutationError = ErrorType<unknown>

    /**
 * @summary Update dispatch order (status, carrier, dates)
 */
export const useUpdateOpsDispatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsDispatch>>, TError,{id: number;data: BodyType<OpsDispatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpsDispatch>>,
        TError,
        {id: number;data: BodyType<OpsDispatchInput>},
        TContext
      > => {
      return useMutation(getUpdateOpsDispatchMutationOptions(options));
    }

export const getConfirmOpsDeliveryUrl = (id: number,) => {




  return `/api/ops/dispatch/${id}/confirm-delivery`
}

/**
 * @summary Confirm delivery — creates stock issue movement and marks delivered
 */
export const confirmOpsDelivery = async (id: number,
    confirmOpsDeliveryBody?: ConfirmOpsDeliveryBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getConfirmOpsDeliveryUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      confirmOpsDeliveryBody,)
  }
);}




export const getConfirmOpsDeliveryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOpsDelivery>>, TError,{id: number;data?: BodyType<ConfirmOpsDeliveryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmOpsDelivery>>, TError,{id: number;data?: BodyType<ConfirmOpsDeliveryBody>}, TContext> => {

const mutationKey = ['confirmOpsDelivery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOpsDelivery>>, {id: number;data?: BodyType<ConfirmOpsDeliveryBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  confirmOpsDelivery(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOpsDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOpsDelivery>>>
    export type ConfirmOpsDeliveryMutationBody = BodyType<ConfirmOpsDeliveryBody> | undefined
    export type ConfirmOpsDeliveryMutationError = ErrorType<void>

    /**
 * @summary Confirm delivery — creates stock issue movement and marks delivered
 */
export const useConfirmOpsDelivery = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOpsDelivery>>, TError,{id: number;data?: BodyType<ConfirmOpsDeliveryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmOpsDelivery>>,
        TError,
        {id: number;data?: BodyType<ConfirmOpsDeliveryBody>},
        TContext
      > => {
      return useMutation(getConfirmOpsDeliveryMutationOptions(options));
    }

export const getCancelOpsDispatchUrl = (id: number,) => {




  return `/api/ops/dispatch/${id}/cancel`
}

/**
 * @summary Cancel dispatch order — sets status to cancelled with mandatory reason
 */
export const cancelOpsDispatch = async (id: number,
    cancelOpsDispatchBody: CancelOpsDispatchBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCancelOpsDispatchUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cancelOpsDispatchBody,)
  }
);}




export const getCancelOpsDispatchMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOpsDispatch>>, TError,{id: number;data: BodyType<CancelOpsDispatchBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelOpsDispatch>>, TError,{id: number;data: BodyType<CancelOpsDispatchBody>}, TContext> => {

const mutationKey = ['cancelOpsDispatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOpsDispatch>>, {id: number;data: BodyType<CancelOpsDispatchBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelOpsDispatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelOpsDispatchMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOpsDispatch>>>
    export type CancelOpsDispatchMutationBody = BodyType<CancelOpsDispatchBody>
    export type CancelOpsDispatchMutationError = ErrorType<void>

    /**
 * @summary Cancel dispatch order — sets status to cancelled with mandatory reason
 */
export const useCancelOpsDispatch = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOpsDispatch>>, TError,{id: number;data: BodyType<CancelOpsDispatchBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelOpsDispatch>>,
        TError,
        {id: number;data: BodyType<CancelOpsDispatchBody>},
        TContext
      > => {
      return useMutation(getCancelOpsDispatchMutationOptions(options));
    }

export const getListOpsWorkOrdersUrl = (params?: ListOpsWorkOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ops/work-orders?${stringifiedParams}` : `/api/ops/work-orders`
}

/**
 * @summary List work orders
 */
export const listOpsWorkOrders = async (params?: ListOpsWorkOrdersParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListOpsWorkOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpsWorkOrdersQueryKey = (params?: ListOpsWorkOrdersParams,) => {
    return [
    `/api/ops/work-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOpsWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listOpsWorkOrders>>, TError = ErrorType<unknown>>(params?: ListOpsWorkOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsWorkOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpsWorkOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpsWorkOrders>>> = ({ signal }) => listOpsWorkOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpsWorkOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpsWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listOpsWorkOrders>>>
export type ListOpsWorkOrdersQueryError = ErrorType<unknown>


/**
 * @summary List work orders
 */

export function useListOpsWorkOrders<TData = Awaited<ReturnType<typeof listOpsWorkOrders>>, TError = ErrorType<unknown>>(
 params?: ListOpsWorkOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsWorkOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpsWorkOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpsWorkOrderUrl = () => {




  return `/api/ops/work-orders`
}

/**
 * @summary Create work order
 */
export const createOpsWorkOrder = async (opsWorkOrderInput: OpsWorkOrderInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateOpsWorkOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsWorkOrderInput,)
  }
);}




export const getCreateOpsWorkOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsWorkOrder>>, TError,{data: BodyType<OpsWorkOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpsWorkOrder>>, TError,{data: BodyType<OpsWorkOrderInput>}, TContext> => {

const mutationKey = ['createOpsWorkOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpsWorkOrder>>, {data: BodyType<OpsWorkOrderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOpsWorkOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpsWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createOpsWorkOrder>>>
    export type CreateOpsWorkOrderMutationBody = BodyType<OpsWorkOrderInput>
    export type CreateOpsWorkOrderMutationError = ErrorType<unknown>

    /**
 * @summary Create work order
 */
export const useCreateOpsWorkOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsWorkOrder>>, TError,{data: BodyType<OpsWorkOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpsWorkOrder>>,
        TError,
        {data: BodyType<OpsWorkOrderInput>},
        TContext
      > => {
      return useMutation(getCreateOpsWorkOrderMutationOptions(options));
    }

export const getUpdateOpsWorkOrderUrl = (id: number,) => {




  return `/api/ops/work-orders/${id}`
}

/**
 * @summary Update work order
 */
export const updateOpsWorkOrder = async (id: number,
    opsWorkOrderInput: OpsWorkOrderInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOpsWorkOrderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsWorkOrderInput,)
  }
);}




export const getUpdateOpsWorkOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsWorkOrder>>, TError,{id: number;data: BodyType<OpsWorkOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpsWorkOrder>>, TError,{id: number;data: BodyType<OpsWorkOrderInput>}, TContext> => {

const mutationKey = ['updateOpsWorkOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpsWorkOrder>>, {id: number;data: BodyType<OpsWorkOrderInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpsWorkOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpsWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpsWorkOrder>>>
    export type UpdateOpsWorkOrderMutationBody = BodyType<OpsWorkOrderInput>
    export type UpdateOpsWorkOrderMutationError = ErrorType<unknown>

    /**
 * @summary Update work order
 */
export const useUpdateOpsWorkOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsWorkOrder>>, TError,{id: number;data: BodyType<OpsWorkOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpsWorkOrder>>,
        TError,
        {id: number;data: BodyType<OpsWorkOrderInput>},
        TContext
      > => {
      return useMutation(getUpdateOpsWorkOrderMutationOptions(options));
    }

export const getListOpsTimesheetsUrl = (params?: ListOpsTimesheetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ops/timesheets?${stringifiedParams}` : `/api/ops/timesheets`
}

/**
 * @summary List timesheet entries
 */
export const listOpsTimesheets = async (params?: ListOpsTimesheetsParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListOpsTimesheetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpsTimesheetsQueryKey = (params?: ListOpsTimesheetsParams,) => {
    return [
    `/api/ops/timesheets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOpsTimesheetsQueryOptions = <TData = Awaited<ReturnType<typeof listOpsTimesheets>>, TError = ErrorType<unknown>>(params?: ListOpsTimesheetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsTimesheets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpsTimesheetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpsTimesheets>>> = ({ signal }) => listOpsTimesheets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpsTimesheets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpsTimesheetsQueryResult = NonNullable<Awaited<ReturnType<typeof listOpsTimesheets>>>
export type ListOpsTimesheetsQueryError = ErrorType<unknown>


/**
 * @summary List timesheet entries
 */

export function useListOpsTimesheets<TData = Awaited<ReturnType<typeof listOpsTimesheets>>, TError = ErrorType<unknown>>(
 params?: ListOpsTimesheetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpsTimesheets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpsTimesheetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpsTimesheetUrl = () => {




  return `/api/ops/timesheets`
}

/**
 * @summary Log timesheet entry
 */
export const createOpsTimesheet = async (opsTimesheetInput: OpsTimesheetInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateOpsTimesheetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsTimesheetInput,)
  }
);}




export const getCreateOpsTimesheetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsTimesheet>>, TError,{data: BodyType<OpsTimesheetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpsTimesheet>>, TError,{data: BodyType<OpsTimesheetInput>}, TContext> => {

const mutationKey = ['createOpsTimesheet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpsTimesheet>>, {data: BodyType<OpsTimesheetInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOpsTimesheet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpsTimesheetMutationResult = NonNullable<Awaited<ReturnType<typeof createOpsTimesheet>>>
    export type CreateOpsTimesheetMutationBody = BodyType<OpsTimesheetInput>
    export type CreateOpsTimesheetMutationError = ErrorType<unknown>

    /**
 * @summary Log timesheet entry
 */
export const useCreateOpsTimesheet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpsTimesheet>>, TError,{data: BodyType<OpsTimesheetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpsTimesheet>>,
        TError,
        {data: BodyType<OpsTimesheetInput>},
        TContext
      > => {
      return useMutation(getCreateOpsTimesheetMutationOptions(options));
    }

export const getUpdateOpsTimesheetUrl = (id: number,) => {




  return `/api/ops/timesheets/${id}`
}

/**
 * @summary Update timesheet entry (draft only)
 */
export const updateOpsTimesheet = async (id: number,
    opsTimesheetInput: OpsTimesheetInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOpsTimesheetUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      opsTimesheetInput,)
  }
);}




export const getUpdateOpsTimesheetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsTimesheet>>, TError,{id: number;data: BodyType<OpsTimesheetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpsTimesheet>>, TError,{id: number;data: BodyType<OpsTimesheetInput>}, TContext> => {

const mutationKey = ['updateOpsTimesheet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpsTimesheet>>, {id: number;data: BodyType<OpsTimesheetInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpsTimesheet(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpsTimesheetMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpsTimesheet>>>
    export type UpdateOpsTimesheetMutationBody = BodyType<OpsTimesheetInput>
    export type UpdateOpsTimesheetMutationError = ErrorType<unknown>

    /**
 * @summary Update timesheet entry (draft only)
 */
export const useUpdateOpsTimesheet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpsTimesheet>>, TError,{id: number;data: BodyType<OpsTimesheetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpsTimesheet>>,
        TError,
        {id: number;data: BodyType<OpsTimesheetInput>},
        TContext
      > => {
      return useMutation(getUpdateOpsTimesheetMutationOptions(options));
    }

export const getSubmitOpsTimesheetUrl = (id: number,) => {




  return `/api/ops/timesheets/${id}/submit`
}

/**
 * @summary Submit timesheet entry for approval
 */
export const submitOpsTimesheet = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getSubmitOpsTimesheetUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSubmitOpsTimesheetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOpsTimesheet>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitOpsTimesheet>>, TError,{id: number}, TContext> => {

const mutationKey = ['submitOpsTimesheet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitOpsTimesheet>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  submitOpsTimesheet(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitOpsTimesheetMutationResult = NonNullable<Awaited<ReturnType<typeof submitOpsTimesheet>>>

    export type SubmitOpsTimesheetMutationError = ErrorType<unknown>

    /**
 * @summary Submit timesheet entry for approval
 */
export const useSubmitOpsTimesheet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOpsTimesheet>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitOpsTimesheet>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getSubmitOpsTimesheetMutationOptions(options));
    }

export const getApproveOpsTimesheetUrl = (id: number,) => {




  return `/api/ops/timesheets/${id}/approve`
}

/**
 * @summary Approve timesheet entry
 */
export const approveOpsTimesheet = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getApproveOpsTimesheetUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApproveOpsTimesheetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOpsTimesheet>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveOpsTimesheet>>, TError,{id: number}, TContext> => {

const mutationKey = ['approveOpsTimesheet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveOpsTimesheet>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  approveOpsTimesheet(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveOpsTimesheetMutationResult = NonNullable<Awaited<ReturnType<typeof approveOpsTimesheet>>>

    export type ApproveOpsTimesheetMutationError = ErrorType<unknown>

    /**
 * @summary Approve timesheet entry
 */
export const useApproveOpsTimesheet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOpsTimesheet>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveOpsTimesheet>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApproveOpsTimesheetMutationOptions(options));
    }

export const getRejectOpsTimesheetUrl = (id: number,) => {




  return `/api/ops/timesheets/${id}/reject`
}

/**
 * @summary Reject timesheet entry
 */
export const rejectOpsTimesheet = async (id: number,
    rejectOpsTimesheetBody?: RejectOpsTimesheetBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRejectOpsTimesheetUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rejectOpsTimesheetBody,)
  }
);}




export const getRejectOpsTimesheetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOpsTimesheet>>, TError,{id: number;data?: BodyType<RejectOpsTimesheetBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectOpsTimesheet>>, TError,{id: number;data?: BodyType<RejectOpsTimesheetBody>}, TContext> => {

const mutationKey = ['rejectOpsTimesheet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectOpsTimesheet>>, {id: number;data?: BodyType<RejectOpsTimesheetBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectOpsTimesheet(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectOpsTimesheetMutationResult = NonNullable<Awaited<ReturnType<typeof rejectOpsTimesheet>>>
    export type RejectOpsTimesheetMutationBody = BodyType<RejectOpsTimesheetBody> | undefined
    export type RejectOpsTimesheetMutationError = ErrorType<unknown>

    /**
 * @summary Reject timesheet entry
 */
export const useRejectOpsTimesheet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOpsTimesheet>>, TError,{id: number;data?: BodyType<RejectOpsTimesheetBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectOpsTimesheet>>,
        TError,
        {id: number;data?: BodyType<RejectOpsTimesheetBody>},
        TContext
      > => {
      return useMutation(getRejectOpsTimesheetMutationOptions(options));
    }

export const getExportOpsTimesheetsUrl = () => {




  return `/api/ops/timesheets/export`
}

/**
 * @summary Export approved billable timesheet hours for payroll
 */
export const exportOpsTimesheets = async ( options?: RequestInit): Promise<ExportOpsTimesheets200> => {

  return customFetch<ExportOpsTimesheets200>(getExportOpsTimesheetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportOpsTimesheetsQueryKey = () => {
    return [
    `/api/ops/timesheets/export`
    ] as const;
    }


export const getExportOpsTimesheetsQueryOptions = <TData = Awaited<ReturnType<typeof exportOpsTimesheets>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportOpsTimesheets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportOpsTimesheetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOpsTimesheets>>> = ({ signal }) => exportOpsTimesheets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportOpsTimesheets>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportOpsTimesheetsQueryResult = NonNullable<Awaited<ReturnType<typeof exportOpsTimesheets>>>
export type ExportOpsTimesheetsQueryError = ErrorType<unknown>


/**
 * @summary Export approved billable timesheet hours for payroll
 */

export function useExportOpsTimesheets<TData = Awaited<ReturnType<typeof exportOpsTimesheets>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportOpsTimesheets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportOpsTimesheetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetOpsDashboardUrl = () => {




  return `/api/ops/dashboard`
}

/**
 * @summary Operations KPI dashboard
 */
export const getOpsDashboard = async ( options?: RequestInit): Promise<OpsDashboard> => {

  return customFetch<OpsDashboard>(getGetOpsDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpsDashboardQueryKey = () => {
    return [
    `/api/ops/dashboard`
    ] as const;
    }


export const getGetOpsDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getOpsDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpsDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpsDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpsDashboard>>> = ({ signal }) => getOpsDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpsDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOpsDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getOpsDashboard>>>
export type GetOpsDashboardQueryError = ErrorType<unknown>


/**
 * @summary Operations KPI dashboard
 */

export function useGetOpsDashboard<TData = Awaited<ReturnType<typeof getOpsDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpsDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOpsDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminDashboardUrl = () => {




  return `/api/admin/dashboard`
}

/**
 * @summary Admin & IT KPI summary (assets, licenses, contracts, facility, visitors)
 */
export const getAdminDashboard = async ( options?: RequestInit): Promise<AdminDashboard> => {

  return customFetch<AdminDashboard>(getGetAdminDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminDashboardQueryKey = () => {
    return [
    `/api/admin/dashboard`
    ] as const;
    }


export const getGetAdminDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDashboard>>> = ({ signal }) => getAdminDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDashboard>>>
export type GetAdminDashboardQueryError = ErrorType<unknown>


/**
 * @summary Admin & IT KPI summary (assets, licenses, contracts, facility, visitors)
 */

export function useGetAdminDashboard<TData = Awaited<ReturnType<typeof getAdminDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAdminAssetsUrl = (params?: ListAdminAssetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/assets?${stringifiedParams}` : `/api/admin/assets`
}

/**
 * @summary List assets with optional type/status filter
 */
export const listAdminAssets = async (params?: ListAdminAssetsParams, options?: RequestInit): Promise<AdminAsset[]> => {

  return customFetch<AdminAsset[]>(getListAdminAssetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminAssetsQueryKey = (params?: ListAdminAssetsParams,) => {
    return [
    `/api/admin/assets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminAssetsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminAssets>>, TError = ErrorType<unknown>>(params?: ListAdminAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminAssets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminAssetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAssets>>> = ({ signal }) => listAdminAssets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminAssets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAssets>>>
export type ListAdminAssetsQueryError = ErrorType<unknown>


/**
 * @summary List assets with optional type/status filter
 */

export function useListAdminAssets<TData = Awaited<ReturnType<typeof listAdminAssets>>, TError = ErrorType<unknown>>(
 params?: ListAdminAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminAssets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminAssetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAdminAssetUrl = () => {




  return `/api/admin/assets`
}

/**
 * @summary Create a new asset (physical or IT)
 */
export const createAdminAsset = async (adminAssetInput: AdminAssetInput, options?: RequestInit): Promise<AdminAsset> => {

  return customFetch<AdminAsset>(getCreateAdminAssetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminAssetInput,)
  }
);}




export const getCreateAdminAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminAsset>>, TError,{data: BodyType<AdminAssetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminAsset>>, TError,{data: BodyType<AdminAssetInput>}, TContext> => {

const mutationKey = ['createAdminAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminAsset>>, {data: BodyType<AdminAssetInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAdminAsset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminAssetMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminAsset>>>
    export type CreateAdminAssetMutationBody = BodyType<AdminAssetInput>
    export type CreateAdminAssetMutationError = ErrorType<unknown>

    /**
 * @summary Create a new asset (physical or IT)
 */
export const useCreateAdminAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminAsset>>, TError,{data: BodyType<AdminAssetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminAsset>>,
        TError,
        {data: BodyType<AdminAssetInput>},
        TContext
      > => {
      return useMutation(getCreateAdminAssetMutationOptions(options));
    }

export const getGetAdminAssetUrl = (id: number,) => {




  return `/api/admin/assets/${id}`
}

/**
 * @summary Get asset with lifecycle history and depreciation schedule
 */
export const getAdminAsset = async (id: number, options?: RequestInit): Promise<AdminAssetDetail> => {

  return customFetch<AdminAssetDetail>(getGetAdminAssetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAssetQueryKey = (id: number,) => {
    return [
    `/api/admin/assets/${id}`
    ] as const;
    }


export const getGetAdminAssetQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAsset>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAssetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAsset>>> = ({ signal }) => getAdminAsset(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAsset>>>
export type GetAdminAssetQueryError = ErrorType<unknown>


/**
 * @summary Get asset with lifecycle history and depreciation schedule
 */

export function useGetAdminAsset<TData = Awaited<ReturnType<typeof getAdminAsset>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminAssetQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAdminAssetUrl = (id: number,) => {




  return `/api/admin/assets/${id}`
}

/**
 * @summary Update asset fields
 */
export const updateAdminAsset = async (id: number,
    adminAssetInput: AdminAssetInput, options?: RequestInit): Promise<AdminAsset> => {

  return customFetch<AdminAsset>(getUpdateAdminAssetUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminAssetInput,)
  }
);}




export const getUpdateAdminAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminAsset>>, TError,{id: number;data: BodyType<AdminAssetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminAsset>>, TError,{id: number;data: BodyType<AdminAssetInput>}, TContext> => {

const mutationKey = ['updateAdminAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminAsset>>, {id: number;data: BodyType<AdminAssetInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAdminAsset(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminAssetMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminAsset>>>
    export type UpdateAdminAssetMutationBody = BodyType<AdminAssetInput>
    export type UpdateAdminAssetMutationError = ErrorType<unknown>

    /**
 * @summary Update asset fields
 */
export const useUpdateAdminAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminAsset>>, TError,{id: number;data: BodyType<AdminAssetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminAsset>>,
        TError,
        {id: number;data: BodyType<AdminAssetInput>},
        TContext
      > => {
      return useMutation(getUpdateAdminAssetMutationOptions(options));
    }

export const getDeleteAdminAssetUrl = (id: number,) => {




  return `/api/admin/assets/${id}`
}

/**
 * @summary Delete an asset
 */
export const deleteAdminAsset = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAdminAssetUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAdminAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAsset>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAsset>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAdminAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminAsset>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminAsset(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminAsset>>>

    export type DeleteAdminAssetMutationError = ErrorType<unknown>

    /**
 * @summary Delete an asset
 */
export const useDeleteAdminAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAsset>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminAsset>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAdminAssetMutationOptions(options));
    }

export const getGetAdminAssetHistoryUrl = (id: number,) => {




  return `/api/admin/assets/${id}/history`
}

/**
 * @summary Get lifecycle event history for an asset
 */
export const getAdminAssetHistory = async (id: number, options?: RequestInit): Promise<AdminAssetHistory[]> => {

  return customFetch<AdminAssetHistory[]>(getGetAdminAssetHistoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAssetHistoryQueryKey = (id: number,) => {
    return [
    `/api/admin/assets/${id}/history`
    ] as const;
    }


export const getGetAdminAssetHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAssetHistory>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAssetHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAssetHistoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAssetHistory>>> = ({ signal }) => getAdminAssetHistory(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAssetHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAssetHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAssetHistory>>>
export type GetAdminAssetHistoryQueryError = ErrorType<unknown>


/**
 * @summary Get lifecycle event history for an asset
 */

export function useGetAdminAssetHistory<TData = Awaited<ReturnType<typeof getAdminAssetHistory>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAssetHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminAssetHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRecordAssetLifecycleEventUrl = (id: number,) => {




  return `/api/admin/assets/${id}/lifecycle`
}

/**
 * @summary Record an assign/return/repair/retire/relocate/scrap event
 */
export const recordAssetLifecycleEvent = async (id: number,
    adminAssetLifecycleInput: AdminAssetLifecycleInput, options?: RequestInit): Promise<RecordAssetLifecycleEvent201> => {

  return customFetch<RecordAssetLifecycleEvent201>(getRecordAssetLifecycleEventUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminAssetLifecycleInput,)
  }
);}




export const getRecordAssetLifecycleEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAssetLifecycleEvent>>, TError,{id: number;data: BodyType<AdminAssetLifecycleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordAssetLifecycleEvent>>, TError,{id: number;data: BodyType<AdminAssetLifecycleInput>}, TContext> => {

const mutationKey = ['recordAssetLifecycleEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordAssetLifecycleEvent>>, {id: number;data: BodyType<AdminAssetLifecycleInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  recordAssetLifecycleEvent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordAssetLifecycleEventMutationResult = NonNullable<Awaited<ReturnType<typeof recordAssetLifecycleEvent>>>
    export type RecordAssetLifecycleEventMutationBody = BodyType<AdminAssetLifecycleInput>
    export type RecordAssetLifecycleEventMutationError = ErrorType<unknown>

    /**
 * @summary Record an assign/return/repair/retire/relocate/scrap event
 */
export const useRecordAssetLifecycleEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAssetLifecycleEvent>>, TError,{id: number;data: BodyType<AdminAssetLifecycleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordAssetLifecycleEvent>>,
        TError,
        {id: number;data: BodyType<AdminAssetLifecycleInput>},
        TContext
      > => {
      return useMutation(getRecordAssetLifecycleEventMutationOptions(options));
    }

export const getGetAssetDepreciationScheduleUrl = (id: number,) => {




  return `/api/admin/assets/${id}/depreciation`
}

/**
 * @summary Get depreciation schedule for an asset
 */
export const getAssetDepreciationSchedule = async (id: number, options?: RequestInit): Promise<AdminDepreciationSchedule[]> => {

  return customFetch<AdminDepreciationSchedule[]>(getGetAssetDepreciationScheduleUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetDepreciationScheduleQueryKey = (id: number,) => {
    return [
    `/api/admin/assets/${id}/depreciation`
    ] as const;
    }


export const getGetAssetDepreciationScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getAssetDepreciationSchedule>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetDepreciationSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetDepreciationScheduleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetDepreciationSchedule>>> = ({ signal }) => getAssetDepreciationSchedule(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetDepreciationSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssetDepreciationScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetDepreciationSchedule>>>
export type GetAssetDepreciationScheduleQueryError = ErrorType<unknown>


/**
 * @summary Get depreciation schedule for an asset
 */

export function useGetAssetDepreciationSchedule<TData = Awaited<ReturnType<typeof getAssetDepreciationSchedule>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetDepreciationSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAssetDepreciationScheduleQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGenerateDepreciationScheduleUrl = (id: number,) => {




  return `/api/admin/assets/${id}/depreciation/generate`
}

/**
 * @summary (Re-)generate the full depreciation schedule for an asset
 */
export const generateDepreciationSchedule = async (id: number, options?: RequestInit): Promise<AdminDepreciationSchedule[]> => {

  return customFetch<AdminDepreciationSchedule[]>(getGenerateDepreciationScheduleUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGenerateDepreciationScheduleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDepreciationSchedule>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateDepreciationSchedule>>, TError,{id: number}, TContext> => {

const mutationKey = ['generateDepreciationSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateDepreciationSchedule>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  generateDepreciationSchedule(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateDepreciationScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof generateDepreciationSchedule>>>

    export type GenerateDepreciationScheduleMutationError = ErrorType<unknown>

    /**
 * @summary (Re-)generate the full depreciation schedule for an asset
 */
export const useGenerateDepreciationSchedule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDepreciationSchedule>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateDepreciationSchedule>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getGenerateDepreciationScheduleMutationOptions(options));
    }

export const getPostDepreciationToFinanceUrl = (scheduleId: number,) => {




  return `/api/admin/depreciation/${scheduleId}/post`
}

/**
 * @summary Post a depreciation schedule row as a double-entry journal voucher in Finance
 */
export const postDepreciationToFinance = async (scheduleId: number,
    postDepreciationToFinanceBody?: PostDepreciationToFinanceBody, options?: RequestInit): Promise<PostDepreciationToFinance200> => {

  return customFetch<PostDepreciationToFinance200>(getPostDepreciationToFinanceUrl(scheduleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postDepreciationToFinanceBody,)
  }
);}




export const getPostDepreciationToFinanceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDepreciationToFinance>>, TError,{scheduleId: number;data?: BodyType<PostDepreciationToFinanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postDepreciationToFinance>>, TError,{scheduleId: number;data?: BodyType<PostDepreciationToFinanceBody>}, TContext> => {

const mutationKey = ['postDepreciationToFinance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDepreciationToFinance>>, {scheduleId: number;data?: BodyType<PostDepreciationToFinanceBody>}> = (props) => {
          const {scheduleId,data} = props ?? {};

          return  postDepreciationToFinance(scheduleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostDepreciationToFinanceMutationResult = NonNullable<Awaited<ReturnType<typeof postDepreciationToFinance>>>
    export type PostDepreciationToFinanceMutationBody = BodyType<PostDepreciationToFinanceBody> | undefined
    export type PostDepreciationToFinanceMutationError = ErrorType<void>

    /**
 * @summary Post a depreciation schedule row as a double-entry journal voucher in Finance
 */
export const usePostDepreciationToFinance = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDepreciationToFinance>>, TError,{scheduleId: number;data?: BodyType<PostDepreciationToFinanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postDepreciationToFinance>>,
        TError,
        {scheduleId: number;data?: BodyType<PostDepreciationToFinanceBody>},
        TContext
      > => {
      return useMutation(getPostDepreciationToFinanceMutationOptions(options));
    }

export const getListSoftwareLicensesUrl = (params?: ListSoftwareLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/licenses?${stringifiedParams}` : `/api/admin/licenses`
}

/**
 * @summary List software/SaaS licenses
 */
export const listSoftwareLicenses = async (params?: ListSoftwareLicensesParams, options?: RequestInit): Promise<AdminSoftwareLicense[]> => {

  return customFetch<AdminSoftwareLicense[]>(getListSoftwareLicensesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSoftwareLicensesQueryKey = (params?: ListSoftwareLicensesParams,) => {
    return [
    `/api/admin/licenses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSoftwareLicensesQueryOptions = <TData = Awaited<ReturnType<typeof listSoftwareLicenses>>, TError = ErrorType<unknown>>(params?: ListSoftwareLicensesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSoftwareLicenses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSoftwareLicensesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSoftwareLicenses>>> = ({ signal }) => listSoftwareLicenses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSoftwareLicenses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSoftwareLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof listSoftwareLicenses>>>
export type ListSoftwareLicensesQueryError = ErrorType<unknown>


/**
 * @summary List software/SaaS licenses
 */

export function useListSoftwareLicenses<TData = Awaited<ReturnType<typeof listSoftwareLicenses>>, TError = ErrorType<unknown>>(
 params?: ListSoftwareLicensesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSoftwareLicenses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSoftwareLicensesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSoftwareLicenseUrl = () => {




  return `/api/admin/licenses`
}

/**
 * @summary Add a software license
 */
export const createSoftwareLicense = async (adminSoftwareLicenseInput: AdminSoftwareLicenseInput, options?: RequestInit): Promise<AdminSoftwareLicense> => {

  return customFetch<AdminSoftwareLicense>(getCreateSoftwareLicenseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminSoftwareLicenseInput,)
  }
);}




export const getCreateSoftwareLicenseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSoftwareLicense>>, TError,{data: BodyType<AdminSoftwareLicenseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSoftwareLicense>>, TError,{data: BodyType<AdminSoftwareLicenseInput>}, TContext> => {

const mutationKey = ['createSoftwareLicense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSoftwareLicense>>, {data: BodyType<AdminSoftwareLicenseInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSoftwareLicense(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSoftwareLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof createSoftwareLicense>>>
    export type CreateSoftwareLicenseMutationBody = BodyType<AdminSoftwareLicenseInput>
    export type CreateSoftwareLicenseMutationError = ErrorType<unknown>

    /**
 * @summary Add a software license
 */
export const useCreateSoftwareLicense = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSoftwareLicense>>, TError,{data: BodyType<AdminSoftwareLicenseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSoftwareLicense>>,
        TError,
        {data: BodyType<AdminSoftwareLicenseInput>},
        TContext
      > => {
      return useMutation(getCreateSoftwareLicenseMutationOptions(options));
    }

export const getGetSoftwareLicenseUrl = (id: number,) => {




  return `/api/admin/licenses/${id}`
}

/**
 * @summary Get license with allocations
 */
export const getSoftwareLicense = async (id: number, options?: RequestInit): Promise<AdminSoftwareLicenseDetail> => {

  return customFetch<AdminSoftwareLicenseDetail>(getGetSoftwareLicenseUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSoftwareLicenseQueryKey = (id: number,) => {
    return [
    `/api/admin/licenses/${id}`
    ] as const;
    }


export const getGetSoftwareLicenseQueryOptions = <TData = Awaited<ReturnType<typeof getSoftwareLicense>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSoftwareLicense>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSoftwareLicenseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSoftwareLicense>>> = ({ signal }) => getSoftwareLicense(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSoftwareLicense>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSoftwareLicenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSoftwareLicense>>>
export type GetSoftwareLicenseQueryError = ErrorType<unknown>


/**
 * @summary Get license with allocations
 */

export function useGetSoftwareLicense<TData = Awaited<ReturnType<typeof getSoftwareLicense>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSoftwareLicense>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSoftwareLicenseQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSoftwareLicenseUrl = (id: number,) => {




  return `/api/admin/licenses/${id}`
}

/**
 * @summary Update a license
 */
export const updateSoftwareLicense = async (id: number,
    adminSoftwareLicenseInput: AdminSoftwareLicenseInput, options?: RequestInit): Promise<AdminSoftwareLicense> => {

  return customFetch<AdminSoftwareLicense>(getUpdateSoftwareLicenseUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminSoftwareLicenseInput,)
  }
);}




export const getUpdateSoftwareLicenseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSoftwareLicense>>, TError,{id: number;data: BodyType<AdminSoftwareLicenseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSoftwareLicense>>, TError,{id: number;data: BodyType<AdminSoftwareLicenseInput>}, TContext> => {

const mutationKey = ['updateSoftwareLicense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSoftwareLicense>>, {id: number;data: BodyType<AdminSoftwareLicenseInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSoftwareLicense(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSoftwareLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof updateSoftwareLicense>>>
    export type UpdateSoftwareLicenseMutationBody = BodyType<AdminSoftwareLicenseInput>
    export type UpdateSoftwareLicenseMutationError = ErrorType<unknown>

    /**
 * @summary Update a license
 */
export const useUpdateSoftwareLicense = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSoftwareLicense>>, TError,{id: number;data: BodyType<AdminSoftwareLicenseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSoftwareLicense>>,
        TError,
        {id: number;data: BodyType<AdminSoftwareLicenseInput>},
        TContext
      > => {
      return useMutation(getUpdateSoftwareLicenseMutationOptions(options));
    }

export const getAllocateLicenseSeatUrl = (id: number,) => {




  return `/api/admin/licenses/${id}/allocate`
}

/**
 * @summary Allocate a seat to an employee or asset (validates tenant ownership)
 */
export const allocateLicenseSeat = async (id: number,
    allocateLicenseSeatBody: AllocateLicenseSeatBody, options?: RequestInit): Promise<AdminLicenseAllocation> => {

  return customFetch<AdminLicenseAllocation>(getAllocateLicenseSeatUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      allocateLicenseSeatBody,)
  }
);}




export const getAllocateLicenseSeatMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocateLicenseSeat>>, TError,{id: number;data: BodyType<AllocateLicenseSeatBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allocateLicenseSeat>>, TError,{id: number;data: BodyType<AllocateLicenseSeatBody>}, TContext> => {

const mutationKey = ['allocateLicenseSeat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocateLicenseSeat>>, {id: number;data: BodyType<AllocateLicenseSeatBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  allocateLicenseSeat(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllocateLicenseSeatMutationResult = NonNullable<Awaited<ReturnType<typeof allocateLicenseSeat>>>
    export type AllocateLicenseSeatMutationBody = BodyType<AllocateLicenseSeatBody>
    export type AllocateLicenseSeatMutationError = ErrorType<void>

    /**
 * @summary Allocate a seat to an employee or asset (validates tenant ownership)
 */
export const useAllocateLicenseSeat = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocateLicenseSeat>>, TError,{id: number;data: BodyType<AllocateLicenseSeatBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof allocateLicenseSeat>>,
        TError,
        {id: number;data: BodyType<AllocateLicenseSeatBody>},
        TContext
      > => {
      return useMutation(getAllocateLicenseSeatMutationOptions(options));
    }

export const getReturnLicenseSeatUrl = (allocId: number,) => {




  return `/api/admin/licenses/allocations/${allocId}/return`
}

/**
 * @summary Mark a license allocation as returned (seat freed)
 */
export const returnLicenseSeat = async (allocId: number, options?: RequestInit): Promise<AdminLicenseAllocation> => {

  return customFetch<AdminLicenseAllocation>(getReturnLicenseSeatUrl(allocId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getReturnLicenseSeatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnLicenseSeat>>, TError,{allocId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof returnLicenseSeat>>, TError,{allocId: number}, TContext> => {

const mutationKey = ['returnLicenseSeat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof returnLicenseSeat>>, {allocId: number}> = (props) => {
          const {allocId} = props ?? {};

          return  returnLicenseSeat(allocId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReturnLicenseSeatMutationResult = NonNullable<Awaited<ReturnType<typeof returnLicenseSeat>>>

    export type ReturnLicenseSeatMutationError = ErrorType<unknown>

    /**
 * @summary Mark a license allocation as returned (seat freed)
 */
export const useReturnLicenseSeat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnLicenseSeat>>, TError,{allocId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof returnLicenseSeat>>,
        TError,
        {allocId: number},
        TContext
      > => {
      return useMutation(getReturnLicenseSeatMutationOptions(options));
    }

export const getListVendorContractsUrl = (params?: ListVendorContractsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/contracts?${stringifiedParams}` : `/api/admin/contracts`
}

/**
 * @summary List vendor contracts
 */
export const listVendorContracts = async (params?: ListVendorContractsParams, options?: RequestInit): Promise<AdminVendorContract[]> => {

  return customFetch<AdminVendorContract[]>(getListVendorContractsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorContractsQueryKey = (params?: ListVendorContractsParams,) => {
    return [
    `/api/admin/contracts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVendorContractsQueryOptions = <TData = Awaited<ReturnType<typeof listVendorContracts>>, TError = ErrorType<unknown>>(params?: ListVendorContractsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorContracts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorContractsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorContracts>>> = ({ signal }) => listVendorContracts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorContracts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorContractsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorContracts>>>
export type ListVendorContractsQueryError = ErrorType<unknown>


/**
 * @summary List vendor contracts
 */

export function useListVendorContracts<TData = Awaited<ReturnType<typeof listVendorContracts>>, TError = ErrorType<unknown>>(
 params?: ListVendorContractsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorContracts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorContractsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateVendorContractUrl = () => {




  return `/api/admin/contracts`
}

/**
 * @summary Create a vendor contract
 */
export const createVendorContract = async (adminVendorContractInput: AdminVendorContractInput, options?: RequestInit): Promise<AdminVendorContract> => {

  return customFetch<AdminVendorContract>(getCreateVendorContractUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminVendorContractInput,)
  }
);}




export const getCreateVendorContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorContract>>, TError,{data: BodyType<AdminVendorContractInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVendorContract>>, TError,{data: BodyType<AdminVendorContractInput>}, TContext> => {

const mutationKey = ['createVendorContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVendorContract>>, {data: BodyType<AdminVendorContractInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVendorContract(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVendorContractMutationResult = NonNullable<Awaited<ReturnType<typeof createVendorContract>>>
    export type CreateVendorContractMutationBody = BodyType<AdminVendorContractInput>
    export type CreateVendorContractMutationError = ErrorType<unknown>

    /**
 * @summary Create a vendor contract
 */
export const useCreateVendorContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorContract>>, TError,{data: BodyType<AdminVendorContractInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVendorContract>>,
        TError,
        {data: BodyType<AdminVendorContractInput>},
        TContext
      > => {
      return useMutation(getCreateVendorContractMutationOptions(options));
    }

export const getGetVendorContractUrl = (id: number,) => {




  return `/api/admin/contracts/${id}`
}

/**
 * @summary Get a vendor contract
 */
export const getVendorContract = async (id: number, options?: RequestInit): Promise<AdminVendorContract> => {

  return customFetch<AdminVendorContract>(getGetVendorContractUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorContractQueryKey = (id: number,) => {
    return [
    `/api/admin/contracts/${id}`
    ] as const;
    }


export const getGetVendorContractQueryOptions = <TData = Awaited<ReturnType<typeof getVendorContract>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorContract>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorContractQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendorContract>>> = ({ signal }) => getVendorContract(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendorContract>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVendorContractQueryResult = NonNullable<Awaited<ReturnType<typeof getVendorContract>>>
export type GetVendorContractQueryError = ErrorType<unknown>


/**
 * @summary Get a vendor contract
 */

export function useGetVendorContract<TData = Awaited<ReturnType<typeof getVendorContract>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorContract>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVendorContractQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateVendorContractUrl = (id: number,) => {




  return `/api/admin/contracts/${id}`
}

/**
 * @summary Update a vendor contract
 */
export const updateVendorContract = async (id: number,
    adminVendorContractInput: AdminVendorContractInput, options?: RequestInit): Promise<AdminVendorContract> => {

  return customFetch<AdminVendorContract>(getUpdateVendorContractUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminVendorContractInput,)
  }
);}




export const getUpdateVendorContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendorContract>>, TError,{id: number;data: BodyType<AdminVendorContractInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVendorContract>>, TError,{id: number;data: BodyType<AdminVendorContractInput>}, TContext> => {

const mutationKey = ['updateVendorContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVendorContract>>, {id: number;data: BodyType<AdminVendorContractInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVendorContract(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVendorContractMutationResult = NonNullable<Awaited<ReturnType<typeof updateVendorContract>>>
    export type UpdateVendorContractMutationBody = BodyType<AdminVendorContractInput>
    export type UpdateVendorContractMutationError = ErrorType<unknown>

    /**
 * @summary Update a vendor contract
 */
export const useUpdateVendorContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendorContract>>, TError,{id: number;data: BodyType<AdminVendorContractInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVendorContract>>,
        TError,
        {id: number;data: BodyType<AdminVendorContractInput>},
        TContext
      > => {
      return useMutation(getUpdateVendorContractMutationOptions(options));
    }

export const getDeleteVendorContractUrl = (id: number,) => {




  return `/api/admin/contracts/${id}`
}

/**
 * @summary Delete a vendor contract
 */
export const deleteVendorContract = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteVendorContractUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteVendorContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVendorContract>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVendorContract>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteVendorContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVendorContract>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteVendorContract(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVendorContractMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVendorContract>>>

    export type DeleteVendorContractMutationError = ErrorType<unknown>

    /**
 * @summary Delete a vendor contract
 */
export const useDeleteVendorContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVendorContract>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVendorContract>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteVendorContractMutationOptions(options));
    }

export const getListAdminRoomsUrl = () => {




  return `/api/admin/rooms`
}

/**
 * @summary List meeting rooms
 */
export const listAdminRooms = async ( options?: RequestInit): Promise<AdminRoom[]> => {

  return customFetch<AdminRoom[]>(getListAdminRoomsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRoomsQueryKey = () => {
    return [
    `/api/admin/rooms`
    ] as const;
    }


export const getListAdminRoomsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRooms>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminRooms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRoomsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRooms>>> = ({ signal }) => listAdminRooms({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRooms>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminRoomsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRooms>>>
export type ListAdminRoomsQueryError = ErrorType<unknown>


/**
 * @summary List meeting rooms
 */

export function useListAdminRooms<TData = Awaited<ReturnType<typeof listAdminRooms>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminRooms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminRoomsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAdminRoomUrl = () => {




  return `/api/admin/rooms`
}

/**
 * @summary Create a meeting room
 */
export const createAdminRoom = async (adminRoomInput: AdminRoomInput, options?: RequestInit): Promise<AdminRoom> => {

  return customFetch<AdminRoom>(getCreateAdminRoomUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminRoomInput,)
  }
);}




export const getCreateAdminRoomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRoom>>, TError,{data: BodyType<AdminRoomInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminRoom>>, TError,{data: BodyType<AdminRoomInput>}, TContext> => {

const mutationKey = ['createAdminRoom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminRoom>>, {data: BodyType<AdminRoomInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAdminRoom(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminRoomMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminRoom>>>
    export type CreateAdminRoomMutationBody = BodyType<AdminRoomInput>
    export type CreateAdminRoomMutationError = ErrorType<unknown>

    /**
 * @summary Create a meeting room
 */
export const useCreateAdminRoom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRoom>>, TError,{data: BodyType<AdminRoomInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminRoom>>,
        TError,
        {data: BodyType<AdminRoomInput>},
        TContext
      > => {
      return useMutation(getCreateAdminRoomMutationOptions(options));
    }

export const getUpdateAdminRoomUrl = (id: number,) => {




  return `/api/admin/rooms/${id}`
}

/**
 * @summary Update a meeting room
 */
export const updateAdminRoom = async (id: number,
    adminRoomInput: AdminRoomInput, options?: RequestInit): Promise<AdminRoom> => {

  return customFetch<AdminRoom>(getUpdateAdminRoomUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminRoomInput,)
  }
);}




export const getUpdateAdminRoomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminRoom>>, TError,{id: number;data: BodyType<AdminRoomInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminRoom>>, TError,{id: number;data: BodyType<AdminRoomInput>}, TContext> => {

const mutationKey = ['updateAdminRoom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminRoom>>, {id: number;data: BodyType<AdminRoomInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAdminRoom(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminRoomMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminRoom>>>
    export type UpdateAdminRoomMutationBody = BodyType<AdminRoomInput>
    export type UpdateAdminRoomMutationError = ErrorType<unknown>

    /**
 * @summary Update a meeting room
 */
export const useUpdateAdminRoom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminRoom>>, TError,{id: number;data: BodyType<AdminRoomInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminRoom>>,
        TError,
        {id: number;data: BodyType<AdminRoomInput>},
        TContext
      > => {
      return useMutation(getUpdateAdminRoomMutationOptions(options));
    }

export const getDeleteAdminRoomUrl = (id: number,) => {




  return `/api/admin/rooms/${id}`
}

/**
 * @summary Delete a meeting room
 */
export const deleteAdminRoom = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAdminRoomUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAdminRoomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminRoom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminRoom>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAdminRoom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminRoom>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminRoom(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminRoomMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminRoom>>>

    export type DeleteAdminRoomMutationError = ErrorType<unknown>

    /**
 * @summary Delete a meeting room
 */
export const useDeleteAdminRoom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminRoom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminRoom>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAdminRoomMutationOptions(options));
    }

export const getListRoomBookingsUrl = (roomId: number,
    params?: ListRoomBookingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/rooms/${roomId}/bookings?${stringifiedParams}` : `/api/admin/rooms/${roomId}/bookings`
}

/**
 * @summary List bookings for a specific room
 */
export const listRoomBookings = async (roomId: number,
    params?: ListRoomBookingsParams, options?: RequestInit): Promise<AdminRoomBooking[]> => {

  return customFetch<AdminRoomBooking[]>(getListRoomBookingsUrl(roomId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRoomBookingsQueryKey = (roomId: number,
    params?: ListRoomBookingsParams,) => {
    return [
    `/api/admin/rooms/${roomId}/bookings`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRoomBookingsQueryOptions = <TData = Awaited<ReturnType<typeof listRoomBookings>>, TError = ErrorType<unknown>>(roomId: number,
    params?: ListRoomBookingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoomBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRoomBookingsQueryKey(roomId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoomBookings>>> = ({ signal }) => listRoomBookings(roomId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roomId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRoomBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRoomBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof listRoomBookings>>>
export type ListRoomBookingsQueryError = ErrorType<unknown>


/**
 * @summary List bookings for a specific room
 */

export function useListRoomBookings<TData = Awaited<ReturnType<typeof listRoomBookings>>, TError = ErrorType<unknown>>(
 roomId: number,
    params?: ListRoomBookingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoomBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRoomBookingsQueryOptions(roomId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAllRoomBookingsUrl = (params?: ListAllRoomBookingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/room-bookings?${stringifiedParams}` : `/api/admin/room-bookings`
}

/**
 * @summary List all room bookings (optionally filter by date or bookedBy)
 */
export const listAllRoomBookings = async (params?: ListAllRoomBookingsParams, options?: RequestInit): Promise<AdminRoomBooking[]> => {

  return customFetch<AdminRoomBooking[]>(getListAllRoomBookingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllRoomBookingsQueryKey = (params?: ListAllRoomBookingsParams,) => {
    return [
    `/api/admin/room-bookings`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAllRoomBookingsQueryOptions = <TData = Awaited<ReturnType<typeof listAllRoomBookings>>, TError = ErrorType<unknown>>(params?: ListAllRoomBookingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAllRoomBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllRoomBookingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllRoomBookings>>> = ({ signal }) => listAllRoomBookings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllRoomBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAllRoomBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllRoomBookings>>>
export type ListAllRoomBookingsQueryError = ErrorType<unknown>


/**
 * @summary List all room bookings (optionally filter by date or bookedBy)
 */

export function useListAllRoomBookings<TData = Awaited<ReturnType<typeof listAllRoomBookings>>, TError = ErrorType<unknown>>(
 params?: ListAllRoomBookingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAllRoomBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAllRoomBookingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateRoomBookingUrl = () => {




  return `/api/admin/room-bookings`
}

/**
 * @summary Book a meeting room (validates roomId belongs to tenant)
 */
export const createRoomBooking = async (adminRoomBookingInput: AdminRoomBookingInput, options?: RequestInit): Promise<AdminRoomBooking> => {

  return customFetch<AdminRoomBooking>(getCreateRoomBookingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminRoomBookingInput,)
  }
);}




export const getCreateRoomBookingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoomBooking>>, TError,{data: BodyType<AdminRoomBookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRoomBooking>>, TError,{data: BodyType<AdminRoomBookingInput>}, TContext> => {

const mutationKey = ['createRoomBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRoomBooking>>, {data: BodyType<AdminRoomBookingInput>}> = (props) => {
          const {data} = props ?? {};

          return  createRoomBooking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRoomBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createRoomBooking>>>
    export type CreateRoomBookingMutationBody = BodyType<AdminRoomBookingInput>
    export type CreateRoomBookingMutationError = ErrorType<void>

    /**
 * @summary Book a meeting room (validates roomId belongs to tenant)
 */
export const useCreateRoomBooking = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoomBooking>>, TError,{data: BodyType<AdminRoomBookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRoomBooking>>,
        TError,
        {data: BodyType<AdminRoomBookingInput>},
        TContext
      > => {
      return useMutation(getCreateRoomBookingMutationOptions(options));
    }

export const getUpdateRoomBookingUrl = (id: number,) => {




  return `/api/admin/room-bookings/${id}`
}

/**
 * @summary Update or cancel a room booking
 */
export const updateRoomBooking = async (id: number,
    adminRoomBookingInput: AdminRoomBookingInput, options?: RequestInit): Promise<AdminRoomBooking> => {

  return customFetch<AdminRoomBooking>(getUpdateRoomBookingUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminRoomBookingInput,)
  }
);}




export const getUpdateRoomBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoomBooking>>, TError,{id: number;data: BodyType<AdminRoomBookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRoomBooking>>, TError,{id: number;data: BodyType<AdminRoomBookingInput>}, TContext> => {

const mutationKey = ['updateRoomBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRoomBooking>>, {id: number;data: BodyType<AdminRoomBookingInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRoomBooking(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoomBookingMutationResult = NonNullable<Awaited<ReturnType<typeof updateRoomBooking>>>
    export type UpdateRoomBookingMutationBody = BodyType<AdminRoomBookingInput>
    export type UpdateRoomBookingMutationError = ErrorType<unknown>

    /**
 * @summary Update or cancel a room booking
 */
export const useUpdateRoomBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoomBooking>>, TError,{id: number;data: BodyType<AdminRoomBookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRoomBooking>>,
        TError,
        {id: number;data: BodyType<AdminRoomBookingInput>},
        TContext
      > => {
      return useMutation(getUpdateRoomBookingMutationOptions(options));
    }

export const getListFacilityRequestsUrl = (params?: ListFacilityRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/facility-requests?${stringifiedParams}` : `/api/admin/facility-requests`
}

/**
 * @summary List facility requests
 */
export const listFacilityRequests = async (params?: ListFacilityRequestsParams, options?: RequestInit): Promise<AdminFacilityRequest[]> => {

  return customFetch<AdminFacilityRequest[]>(getListFacilityRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFacilityRequestsQueryKey = (params?: ListFacilityRequestsParams,) => {
    return [
    `/api/admin/facility-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFacilityRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listFacilityRequests>>, TError = ErrorType<unknown>>(params?: ListFacilityRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFacilityRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFacilityRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFacilityRequests>>> = ({ signal }) => listFacilityRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFacilityRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFacilityRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listFacilityRequests>>>
export type ListFacilityRequestsQueryError = ErrorType<unknown>


/**
 * @summary List facility requests
 */

export function useListFacilityRequests<TData = Awaited<ReturnType<typeof listFacilityRequests>>, TError = ErrorType<unknown>>(
 params?: ListFacilityRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFacilityRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFacilityRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateFacilityRequestUrl = () => {




  return `/api/admin/facility-requests`
}

/**
 * @summary Submit a new facility request
 */
export const createFacilityRequest = async (adminFacilityRequestInput: AdminFacilityRequestInput, options?: RequestInit): Promise<AdminFacilityRequest> => {

  return customFetch<AdminFacilityRequest>(getCreateFacilityRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminFacilityRequestInput,)
  }
);}




export const getCreateFacilityRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFacilityRequest>>, TError,{data: BodyType<AdminFacilityRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFacilityRequest>>, TError,{data: BodyType<AdminFacilityRequestInput>}, TContext> => {

const mutationKey = ['createFacilityRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFacilityRequest>>, {data: BodyType<AdminFacilityRequestInput>}> = (props) => {
          const {data} = props ?? {};

          return  createFacilityRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFacilityRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createFacilityRequest>>>
    export type CreateFacilityRequestMutationBody = BodyType<AdminFacilityRequestInput>
    export type CreateFacilityRequestMutationError = ErrorType<unknown>

    /**
 * @summary Submit a new facility request
 */
export const useCreateFacilityRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFacilityRequest>>, TError,{data: BodyType<AdminFacilityRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFacilityRequest>>,
        TError,
        {data: BodyType<AdminFacilityRequestInput>},
        TContext
      > => {
      return useMutation(getCreateFacilityRequestMutationOptions(options));
    }

export const getUpdateFacilityRequestUrl = (id: number,) => {




  return `/api/admin/facility-requests/${id}`
}

/**
 * @summary Update status or assignment of a facility request
 */
export const updateFacilityRequest = async (id: number,
    adminFacilityRequestInput: AdminFacilityRequestInput, options?: RequestInit): Promise<AdminFacilityRequest> => {

  return customFetch<AdminFacilityRequest>(getUpdateFacilityRequestUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminFacilityRequestInput,)
  }
);}




export const getUpdateFacilityRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFacilityRequest>>, TError,{id: number;data: BodyType<AdminFacilityRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFacilityRequest>>, TError,{id: number;data: BodyType<AdminFacilityRequestInput>}, TContext> => {

const mutationKey = ['updateFacilityRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFacilityRequest>>, {id: number;data: BodyType<AdminFacilityRequestInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFacilityRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFacilityRequestMutationResult = NonNullable<Awaited<ReturnType<typeof updateFacilityRequest>>>
    export type UpdateFacilityRequestMutationBody = BodyType<AdminFacilityRequestInput>
    export type UpdateFacilityRequestMutationError = ErrorType<unknown>

    /**
 * @summary Update status or assignment of a facility request
 */
export const useUpdateFacilityRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFacilityRequest>>, TError,{id: number;data: BodyType<AdminFacilityRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateFacilityRequest>>,
        TError,
        {id: number;data: BodyType<AdminFacilityRequestInput>},
        TContext
      > => {
      return useMutation(getUpdateFacilityRequestMutationOptions(options));
    }

export const getListVisitorsUrl = (params?: ListVisitorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/visitors?${stringifiedParams}` : `/api/admin/visitors`
}

/**
 * @summary List visitors
 */
export const listVisitors = async (params?: ListVisitorsParams, options?: RequestInit): Promise<AdminVisitor[]> => {

  return customFetch<AdminVisitor[]>(getListVisitorsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVisitorsQueryKey = (params?: ListVisitorsParams,) => {
    return [
    `/api/admin/visitors`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVisitorsQueryOptions = <TData = Awaited<ReturnType<typeof listVisitors>>, TError = ErrorType<unknown>>(params?: ListVisitorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVisitors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVisitorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVisitors>>> = ({ signal }) => listVisitors(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVisitors>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVisitorsQueryResult = NonNullable<Awaited<ReturnType<typeof listVisitors>>>
export type ListVisitorsQueryError = ErrorType<unknown>


/**
 * @summary List visitors
 */

export function useListVisitors<TData = Awaited<ReturnType<typeof listVisitors>>, TError = ErrorType<unknown>>(
 params?: ListVisitorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVisitors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVisitorsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPreRegisterVisitorUrl = () => {




  return `/api/admin/visitors`
}

/**
 * @summary Pre-register a visitor
 */
export const preRegisterVisitor = async (adminVisitorInput: AdminVisitorInput, options?: RequestInit): Promise<AdminVisitor> => {

  return customFetch<AdminVisitor>(getPreRegisterVisitorUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminVisitorInput,)
  }
);}




export const getPreRegisterVisitorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preRegisterVisitor>>, TError,{data: BodyType<AdminVisitorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof preRegisterVisitor>>, TError,{data: BodyType<AdminVisitorInput>}, TContext> => {

const mutationKey = ['preRegisterVisitor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof preRegisterVisitor>>, {data: BodyType<AdminVisitorInput>}> = (props) => {
          const {data} = props ?? {};

          return  preRegisterVisitor(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreRegisterVisitorMutationResult = NonNullable<Awaited<ReturnType<typeof preRegisterVisitor>>>
    export type PreRegisterVisitorMutationBody = BodyType<AdminVisitorInput>
    export type PreRegisterVisitorMutationError = ErrorType<unknown>

    /**
 * @summary Pre-register a visitor
 */
export const usePreRegisterVisitor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preRegisterVisitor>>, TError,{data: BodyType<AdminVisitorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof preRegisterVisitor>>,
        TError,
        {data: BodyType<AdminVisitorInput>},
        TContext
      > => {
      return useMutation(getPreRegisterVisitorMutationOptions(options));
    }

export const getUpdateVisitorUrl = (id: number,) => {




  return `/api/admin/visitors/${id}`
}

/**
 * @summary Update visitor — use status=checked_in or checked_out for gate actions
 */
export const updateVisitor = async (id: number,
    adminVisitorInput: AdminVisitorInput, options?: RequestInit): Promise<AdminVisitor> => {

  return customFetch<AdminVisitor>(getUpdateVisitorUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminVisitorInput,)
  }
);}




export const getUpdateVisitorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVisitor>>, TError,{id: number;data: BodyType<AdminVisitorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVisitor>>, TError,{id: number;data: BodyType<AdminVisitorInput>}, TContext> => {

const mutationKey = ['updateVisitor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVisitor>>, {id: number;data: BodyType<AdminVisitorInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVisitor(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVisitorMutationResult = NonNullable<Awaited<ReturnType<typeof updateVisitor>>>
    export type UpdateVisitorMutationBody = BodyType<AdminVisitorInput>
    export type UpdateVisitorMutationError = ErrorType<unknown>

    /**
 * @summary Update visitor — use status=checked_in or checked_out for gate actions
 */
export const useUpdateVisitor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVisitor>>, TError,{id: number;data: BodyType<AdminVisitorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVisitor>>,
        TError,
        {id: number;data: BodyType<AdminVisitorInput>},
        TContext
      > => {
      return useMutation(getUpdateVisitorMutationOptions(options));
    }

export const getListItHelpdeskTicketsUrl = (params?: ListItHelpdeskTicketsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/helpdesk?${stringifiedParams}` : `/api/admin/helpdesk`
}

/**
 * @summary List IT helpdesk tickets (type=it_request ops tickets)
 */
export const listItHelpdeskTickets = async (params?: ListItHelpdeskTicketsParams, options?: RequestInit): Promise<AdminHelpdeskTicket[]> => {

  return customFetch<AdminHelpdeskTicket[]>(getListItHelpdeskTicketsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListItHelpdeskTicketsQueryKey = (params?: ListItHelpdeskTicketsParams,) => {
    return [
    `/api/admin/helpdesk`, ...(params ? [params] : [])
    ] as const;
    }


export const getListItHelpdeskTicketsQueryOptions = <TData = Awaited<ReturnType<typeof listItHelpdeskTickets>>, TError = ErrorType<unknown>>(params?: ListItHelpdeskTicketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listItHelpdeskTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListItHelpdeskTicketsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listItHelpdeskTickets>>> = ({ signal }) => listItHelpdeskTickets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listItHelpdeskTickets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListItHelpdeskTicketsQueryResult = NonNullable<Awaited<ReturnType<typeof listItHelpdeskTickets>>>
export type ListItHelpdeskTicketsQueryError = ErrorType<unknown>


/**
 * @summary List IT helpdesk tickets (type=it_request ops tickets)
 */

export function useListItHelpdeskTickets<TData = Awaited<ReturnType<typeof listItHelpdeskTickets>>, TError = ErrorType<unknown>>(
 params?: ListItHelpdeskTicketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listItHelpdeskTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListItHelpdeskTicketsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateItHelpdeskTicketUrl = () => {




  return `/api/admin/helpdesk`
}

/**
 * @summary Raise an IT helpdesk ticket (linked to optional asset)
 */
export const createItHelpdeskTicket = async (adminHelpdeskTicketInput: AdminHelpdeskTicketInput, options?: RequestInit): Promise<AdminHelpdeskTicket> => {

  return customFetch<AdminHelpdeskTicket>(getCreateItHelpdeskTicketUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminHelpdeskTicketInput,)
  }
);}




export const getCreateItHelpdeskTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItHelpdeskTicket>>, TError,{data: BodyType<AdminHelpdeskTicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createItHelpdeskTicket>>, TError,{data: BodyType<AdminHelpdeskTicketInput>}, TContext> => {

const mutationKey = ['createItHelpdeskTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createItHelpdeskTicket>>, {data: BodyType<AdminHelpdeskTicketInput>}> = (props) => {
          const {data} = props ?? {};

          return  createItHelpdeskTicket(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateItHelpdeskTicketMutationResult = NonNullable<Awaited<ReturnType<typeof createItHelpdeskTicket>>>
    export type CreateItHelpdeskTicketMutationBody = BodyType<AdminHelpdeskTicketInput>
    export type CreateItHelpdeskTicketMutationError = ErrorType<unknown>

    /**
 * @summary Raise an IT helpdesk ticket (linked to optional asset)
 */
export const useCreateItHelpdeskTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItHelpdeskTicket>>, TError,{data: BodyType<AdminHelpdeskTicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createItHelpdeskTicket>>,
        TError,
        {data: BodyType<AdminHelpdeskTicketInput>},
        TContext
      > => {
      return useMutation(getCreateItHelpdeskTicketMutationOptions(options));
    }

export const getGetItHelpdeskTicketUrl = (id: number,) => {




  return `/api/admin/helpdesk/${id}`
}

/**
 * @summary Get an IT helpdesk ticket
 */
export const getItHelpdeskTicket = async (id: number, options?: RequestInit): Promise<AdminHelpdeskTicket> => {

  return customFetch<AdminHelpdeskTicket>(getGetItHelpdeskTicketUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetItHelpdeskTicketQueryKey = (id: number,) => {
    return [
    `/api/admin/helpdesk/${id}`
    ] as const;
    }


export const getGetItHelpdeskTicketQueryOptions = <TData = Awaited<ReturnType<typeof getItHelpdeskTicket>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItHelpdeskTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetItHelpdeskTicketQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItHelpdeskTicket>>> = ({ signal }) => getItHelpdeskTicket(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItHelpdeskTicket>>, TError, TData> & { queryKey: QueryKey }
}

export type GetItHelpdeskTicketQueryResult = NonNullable<Awaited<ReturnType<typeof getItHelpdeskTicket>>>
export type GetItHelpdeskTicketQueryError = ErrorType<unknown>


/**
 * @summary Get an IT helpdesk ticket
 */

export function useGetItHelpdeskTicket<TData = Awaited<ReturnType<typeof getItHelpdeskTicket>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItHelpdeskTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetItHelpdeskTicketQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateItHelpdeskTicketUrl = (id: number,) => {




  return `/api/admin/helpdesk/${id}`
}

/**
 * @summary Update IT helpdesk ticket status, assignment, or resolution
 */
export const updateItHelpdeskTicket = async (id: number,
    adminHelpdeskTicketInput: AdminHelpdeskTicketInput, options?: RequestInit): Promise<AdminHelpdeskTicket> => {

  return customFetch<AdminHelpdeskTicket>(getUpdateItHelpdeskTicketUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminHelpdeskTicketInput,)
  }
);}




export const getUpdateItHelpdeskTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItHelpdeskTicket>>, TError,{id: number;data: BodyType<AdminHelpdeskTicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateItHelpdeskTicket>>, TError,{id: number;data: BodyType<AdminHelpdeskTicketInput>}, TContext> => {

const mutationKey = ['updateItHelpdeskTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateItHelpdeskTicket>>, {id: number;data: BodyType<AdminHelpdeskTicketInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateItHelpdeskTicket(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateItHelpdeskTicketMutationResult = NonNullable<Awaited<ReturnType<typeof updateItHelpdeskTicket>>>
    export type UpdateItHelpdeskTicketMutationBody = BodyType<AdminHelpdeskTicketInput>
    export type UpdateItHelpdeskTicketMutationError = ErrorType<unknown>

    /**
 * @summary Update IT helpdesk ticket status, assignment, or resolution
 */
export const useUpdateItHelpdeskTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItHelpdeskTicket>>, TError,{id: number;data: BodyType<AdminHelpdeskTicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateItHelpdeskTicket>>,
        TError,
        {id: number;data: BodyType<AdminHelpdeskTicketInput>},
        TContext
      > => {
      return useMutation(getUpdateItHelpdeskTicketMutationOptions(options));
    }

export const getGetMisExecutiveDashboardUrl = () => {




  return `/api/reports/executive`
}

/**
 * @summary Cross-module executive dashboard KPIs
 */
export const getMisExecutiveDashboard = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisExecutiveDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisExecutiveDashboardQueryKey = () => {
    return [
    `/api/reports/executive`
    ] as const;
    }


export const getGetMisExecutiveDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getMisExecutiveDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisExecutiveDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisExecutiveDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisExecutiveDashboard>>> = ({ signal }) => getMisExecutiveDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisExecutiveDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisExecutiveDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getMisExecutiveDashboard>>>
export type GetMisExecutiveDashboardQueryError = ErrorType<unknown>


/**
 * @summary Cross-module executive dashboard KPIs
 */

export function useGetMisExecutiveDashboard<TData = Awaited<ReturnType<typeof getMisExecutiveDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisExecutiveDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisExecutiveDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisHrHeadcountUrl = (params?: GetMisHrHeadcountParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/hr/headcount?${stringifiedParams}` : `/api/reports/hr/headcount`
}

/**
 * @summary Headcount by department
 */
export const getMisHrHeadcount = async (params?: GetMisHrHeadcountParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisHrHeadcountUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisHrHeadcountQueryKey = (params?: GetMisHrHeadcountParams,) => {
    return [
    `/api/reports/hr/headcount`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMisHrHeadcountQueryOptions = <TData = Awaited<ReturnType<typeof getMisHrHeadcount>>, TError = ErrorType<unknown>>(params?: GetMisHrHeadcountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisHrHeadcount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisHrHeadcountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisHrHeadcount>>> = ({ signal }) => getMisHrHeadcount(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisHrHeadcount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisHrHeadcountQueryResult = NonNullable<Awaited<ReturnType<typeof getMisHrHeadcount>>>
export type GetMisHrHeadcountQueryError = ErrorType<unknown>


/**
 * @summary Headcount by department
 */

export function useGetMisHrHeadcount<TData = Awaited<ReturnType<typeof getMisHrHeadcount>>, TError = ErrorType<unknown>>(
 params?: GetMisHrHeadcountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisHrHeadcount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisHrHeadcountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisHrAttritionUrl = () => {




  return `/api/reports/hr/attrition`
}

/**
 * @summary Joiner/leaver trend (90 days)
 */
export const getMisHrAttrition = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisHrAttritionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisHrAttritionQueryKey = () => {
    return [
    `/api/reports/hr/attrition`
    ] as const;
    }


export const getGetMisHrAttritionQueryOptions = <TData = Awaited<ReturnType<typeof getMisHrAttrition>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisHrAttrition>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisHrAttritionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisHrAttrition>>> = ({ signal }) => getMisHrAttrition({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisHrAttrition>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisHrAttritionQueryResult = NonNullable<Awaited<ReturnType<typeof getMisHrAttrition>>>
export type GetMisHrAttritionQueryError = ErrorType<unknown>


/**
 * @summary Joiner/leaver trend (90 days)
 */

export function useGetMisHrAttrition<TData = Awaited<ReturnType<typeof getMisHrAttrition>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisHrAttrition>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisHrAttritionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisHrLeaveBalanceUrl = () => {




  return `/api/reports/hr/leave-balance`
}

/**
 * @summary Leave balance by employee and type
 */
export const getMisHrLeaveBalance = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisHrLeaveBalanceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisHrLeaveBalanceQueryKey = () => {
    return [
    `/api/reports/hr/leave-balance`
    ] as const;
    }


export const getGetMisHrLeaveBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getMisHrLeaveBalance>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisHrLeaveBalance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisHrLeaveBalanceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisHrLeaveBalance>>> = ({ signal }) => getMisHrLeaveBalance({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisHrLeaveBalance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisHrLeaveBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getMisHrLeaveBalance>>>
export type GetMisHrLeaveBalanceQueryError = ErrorType<unknown>


/**
 * @summary Leave balance by employee and type
 */

export function useGetMisHrLeaveBalance<TData = Awaited<ReturnType<typeof getMisHrLeaveBalance>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisHrLeaveBalance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisHrLeaveBalanceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisHrAttendanceUrl = (params?: GetMisHrAttendanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/hr/attendance?${stringifiedParams}` : `/api/reports/hr/attendance`
}

/**
 * @summary Monthly attendance summary
 */
export const getMisHrAttendance = async (params?: GetMisHrAttendanceParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisHrAttendanceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisHrAttendanceQueryKey = (params?: GetMisHrAttendanceParams,) => {
    return [
    `/api/reports/hr/attendance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMisHrAttendanceQueryOptions = <TData = Awaited<ReturnType<typeof getMisHrAttendance>>, TError = ErrorType<unknown>>(params?: GetMisHrAttendanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisHrAttendance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisHrAttendanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisHrAttendance>>> = ({ signal }) => getMisHrAttendance(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisHrAttendance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisHrAttendanceQueryResult = NonNullable<Awaited<ReturnType<typeof getMisHrAttendance>>>
export type GetMisHrAttendanceQueryError = ErrorType<unknown>


/**
 * @summary Monthly attendance summary
 */

export function useGetMisHrAttendance<TData = Awaited<ReturnType<typeof getMisHrAttendance>>, TError = ErrorType<unknown>>(
 params?: GetMisHrAttendanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisHrAttendance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisHrAttendanceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisPayrollSalaryRegisterUrl = (params?: GetMisPayrollSalaryRegisterParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/payroll/salary-register?${stringifiedParams}` : `/api/reports/payroll/salary-register`
}

/**
 * @summary Salary register for a payroll run
 */
export const getMisPayrollSalaryRegister = async (params?: GetMisPayrollSalaryRegisterParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisPayrollSalaryRegisterUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisPayrollSalaryRegisterQueryKey = (params?: GetMisPayrollSalaryRegisterParams,) => {
    return [
    `/api/reports/payroll/salary-register`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMisPayrollSalaryRegisterQueryOptions = <TData = Awaited<ReturnType<typeof getMisPayrollSalaryRegister>>, TError = ErrorType<unknown>>(params?: GetMisPayrollSalaryRegisterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisPayrollSalaryRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisPayrollSalaryRegisterQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisPayrollSalaryRegister>>> = ({ signal }) => getMisPayrollSalaryRegister(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisPayrollSalaryRegister>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisPayrollSalaryRegisterQueryResult = NonNullable<Awaited<ReturnType<typeof getMisPayrollSalaryRegister>>>
export type GetMisPayrollSalaryRegisterQueryError = ErrorType<unknown>


/**
 * @summary Salary register for a payroll run
 */

export function useGetMisPayrollSalaryRegister<TData = Awaited<ReturnType<typeof getMisPayrollSalaryRegister>>, TError = ErrorType<unknown>>(
 params?: GetMisPayrollSalaryRegisterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisPayrollSalaryRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisPayrollSalaryRegisterQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisPayrollStatutoryUrl = () => {




  return `/api/reports/payroll/statutory`
}

/**
 * @summary Statutory summary (PF/ESI/TDS) for locked runs
 */
export const getMisPayrollStatutory = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisPayrollStatutoryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisPayrollStatutoryQueryKey = () => {
    return [
    `/api/reports/payroll/statutory`
    ] as const;
    }


export const getGetMisPayrollStatutoryQueryOptions = <TData = Awaited<ReturnType<typeof getMisPayrollStatutory>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisPayrollStatutory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisPayrollStatutoryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisPayrollStatutory>>> = ({ signal }) => getMisPayrollStatutory({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisPayrollStatutory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisPayrollStatutoryQueryResult = NonNullable<Awaited<ReturnType<typeof getMisPayrollStatutory>>>
export type GetMisPayrollStatutoryQueryError = ErrorType<unknown>


/**
 * @summary Statutory summary (PF/ESI/TDS) for locked runs
 */

export function useGetMisPayrollStatutory<TData = Awaited<ReturnType<typeof getMisPayrollStatutory>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisPayrollStatutory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisPayrollStatutoryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisFinanceArAgingUrl = () => {




  return `/api/reports/finance/ar-aging`
}

/**
 * @summary AR aging with 0-30/31-60/61-90/90+ buckets
 */
export const getMisFinanceArAging = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisFinanceArAgingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisFinanceArAgingQueryKey = () => {
    return [
    `/api/reports/finance/ar-aging`
    ] as const;
    }


export const getGetMisFinanceArAgingQueryOptions = <TData = Awaited<ReturnType<typeof getMisFinanceArAging>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisFinanceArAging>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisFinanceArAgingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisFinanceArAging>>> = ({ signal }) => getMisFinanceArAging({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisFinanceArAging>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisFinanceArAgingQueryResult = NonNullable<Awaited<ReturnType<typeof getMisFinanceArAging>>>
export type GetMisFinanceArAgingQueryError = ErrorType<unknown>


/**
 * @summary AR aging with 0-30/31-60/61-90/90+ buckets
 */

export function useGetMisFinanceArAging<TData = Awaited<ReturnType<typeof getMisFinanceArAging>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisFinanceArAging>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisFinanceArAgingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisFinanceApAgingUrl = () => {




  return `/api/reports/finance/ap-aging`
}

/**
 * @summary AP aging with 0-30/31-60/61-90/90+ buckets
 */
export const getMisFinanceApAging = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisFinanceApAgingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisFinanceApAgingQueryKey = () => {
    return [
    `/api/reports/finance/ap-aging`
    ] as const;
    }


export const getGetMisFinanceApAgingQueryOptions = <TData = Awaited<ReturnType<typeof getMisFinanceApAging>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisFinanceApAging>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisFinanceApAgingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisFinanceApAging>>> = ({ signal }) => getMisFinanceApAging({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisFinanceApAging>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisFinanceApAgingQueryResult = NonNullable<Awaited<ReturnType<typeof getMisFinanceApAging>>>
export type GetMisFinanceApAgingQueryError = ErrorType<unknown>


/**
 * @summary AP aging with 0-30/31-60/61-90/90+ buckets
 */

export function useGetMisFinanceApAging<TData = Awaited<ReturnType<typeof getMisFinanceApAging>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisFinanceApAging>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisFinanceApAgingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisFinanceGstSummaryUrl = () => {




  return `/api/reports/finance/gst-summary`
}

/**
 * @summary GST summary grouped by month
 */
export const getMisFinanceGstSummary = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisFinanceGstSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisFinanceGstSummaryQueryKey = () => {
    return [
    `/api/reports/finance/gst-summary`
    ] as const;
    }


export const getGetMisFinanceGstSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMisFinanceGstSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisFinanceGstSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisFinanceGstSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisFinanceGstSummary>>> = ({ signal }) => getMisFinanceGstSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisFinanceGstSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisFinanceGstSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMisFinanceGstSummary>>>
export type GetMisFinanceGstSummaryQueryError = ErrorType<unknown>


/**
 * @summary GST summary grouped by month
 */

export function useGetMisFinanceGstSummary<TData = Awaited<ReturnType<typeof getMisFinanceGstSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisFinanceGstSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisFinanceGstSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisStockSummaryUrl = () => {




  return `/api/reports/stock/summary`
}

/**
 * @summary Stock on-hand summary per product per warehouse
 */
export const getMisStockSummary = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisStockSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisStockSummaryQueryKey = () => {
    return [
    `/api/reports/stock/summary`
    ] as const;
    }


export const getGetMisStockSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMisStockSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisStockSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisStockSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisStockSummary>>> = ({ signal }) => getMisStockSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisStockSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisStockSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMisStockSummary>>>
export type GetMisStockSummaryQueryError = ErrorType<unknown>


/**
 * @summary Stock on-hand summary per product per warehouse
 */

export function useGetMisStockSummary<TData = Awaited<ReturnType<typeof getMisStockSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisStockSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisStockSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisStockValuationUrl = () => {




  return `/api/reports/stock/valuation`
}

/**
 * @summary Stock valuation by warehouse with grand total
 */
export const getMisStockValuation = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisStockValuationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisStockValuationQueryKey = () => {
    return [
    `/api/reports/stock/valuation`
    ] as const;
    }


export const getGetMisStockValuationQueryOptions = <TData = Awaited<ReturnType<typeof getMisStockValuation>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisStockValuation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisStockValuationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisStockValuation>>> = ({ signal }) => getMisStockValuation({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisStockValuation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisStockValuationQueryResult = NonNullable<Awaited<ReturnType<typeof getMisStockValuation>>>
export type GetMisStockValuationQueryError = ErrorType<unknown>


/**
 * @summary Stock valuation by warehouse with grand total
 */

export function useGetMisStockValuation<TData = Awaited<ReturnType<typeof getMisStockValuation>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisStockValuation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisStockValuationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisStockSlowMovingUrl = () => {




  return `/api/reports/stock/slow-moving`
}

/**
 * @summary Items with no movement in 90+ days
 */
export const getMisStockSlowMoving = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisStockSlowMovingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisStockSlowMovingQueryKey = () => {
    return [
    `/api/reports/stock/slow-moving`
    ] as const;
    }


export const getGetMisStockSlowMovingQueryOptions = <TData = Awaited<ReturnType<typeof getMisStockSlowMoving>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisStockSlowMoving>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisStockSlowMovingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisStockSlowMoving>>> = ({ signal }) => getMisStockSlowMoving({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisStockSlowMoving>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisStockSlowMovingQueryResult = NonNullable<Awaited<ReturnType<typeof getMisStockSlowMoving>>>
export type GetMisStockSlowMovingQueryError = ErrorType<unknown>


/**
 * @summary Items with no movement in 90+ days
 */

export function useGetMisStockSlowMoving<TData = Awaited<ReturnType<typeof getMisStockSlowMoving>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisStockSlowMoving>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisStockSlowMovingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisCrmPipelineUrl = () => {




  return `/api/reports/crm/pipeline`
}

/**
 * @summary Pipeline value by opportunity stage
 */
export const getMisCrmPipeline = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisCrmPipelineUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisCrmPipelineQueryKey = () => {
    return [
    `/api/reports/crm/pipeline`
    ] as const;
    }


export const getGetMisCrmPipelineQueryOptions = <TData = Awaited<ReturnType<typeof getMisCrmPipeline>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisCrmPipeline>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisCrmPipelineQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisCrmPipeline>>> = ({ signal }) => getMisCrmPipeline({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisCrmPipeline>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisCrmPipelineQueryResult = NonNullable<Awaited<ReturnType<typeof getMisCrmPipeline>>>
export type GetMisCrmPipelineQueryError = ErrorType<unknown>


/**
 * @summary Pipeline value by opportunity stage
 */

export function useGetMisCrmPipeline<TData = Awaited<ReturnType<typeof getMisCrmPipeline>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisCrmPipeline>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisCrmPipelineQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisCrmSalesRepUrl = () => {




  return `/api/reports/crm/sales-rep`
}

/**
 * @summary Won vs total deals and revenue by sales rep
 */
export const getMisCrmSalesRep = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisCrmSalesRepUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisCrmSalesRepQueryKey = () => {
    return [
    `/api/reports/crm/sales-rep`
    ] as const;
    }


export const getGetMisCrmSalesRepQueryOptions = <TData = Awaited<ReturnType<typeof getMisCrmSalesRep>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisCrmSalesRep>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisCrmSalesRepQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisCrmSalesRep>>> = ({ signal }) => getMisCrmSalesRep({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisCrmSalesRep>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisCrmSalesRepQueryResult = NonNullable<Awaited<ReturnType<typeof getMisCrmSalesRep>>>
export type GetMisCrmSalesRepQueryError = ErrorType<unknown>


/**
 * @summary Won vs total deals and revenue by sales rep
 */

export function useGetMisCrmSalesRep<TData = Awaited<ReturnType<typeof getMisCrmSalesRep>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisCrmSalesRep>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisCrmSalesRepQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisCrmCampaignsUrl = () => {




  return `/api/reports/crm/campaigns`
}

/**
 * @summary Email campaign performance and ROI
 */
export const getMisCrmCampaigns = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisCrmCampaignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisCrmCampaignsQueryKey = () => {
    return [
    `/api/reports/crm/campaigns`
    ] as const;
    }


export const getGetMisCrmCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof getMisCrmCampaigns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisCrmCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisCrmCampaignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisCrmCampaigns>>> = ({ signal }) => getMisCrmCampaigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisCrmCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisCrmCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof getMisCrmCampaigns>>>
export type GetMisCrmCampaignsQueryError = ErrorType<unknown>


/**
 * @summary Email campaign performance and ROI
 */

export function useGetMisCrmCampaigns<TData = Awaited<ReturnType<typeof getMisCrmCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisCrmCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisCrmCampaignsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisCrmFunnelUrl = () => {




  return `/api/reports/crm/funnel`
}

/**
 * @summary Conversion funnel — leads to orders
 */
export const getMisCrmFunnel = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisCrmFunnelUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisCrmFunnelQueryKey = () => {
    return [
    `/api/reports/crm/funnel`
    ] as const;
    }


export const getGetMisCrmFunnelQueryOptions = <TData = Awaited<ReturnType<typeof getMisCrmFunnel>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisCrmFunnel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisCrmFunnelQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisCrmFunnel>>> = ({ signal }) => getMisCrmFunnel({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisCrmFunnel>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisCrmFunnelQueryResult = NonNullable<Awaited<ReturnType<typeof getMisCrmFunnel>>>
export type GetMisCrmFunnelQueryError = ErrorType<unknown>


/**
 * @summary Conversion funnel — leads to orders
 */

export function useGetMisCrmFunnel<TData = Awaited<ReturnType<typeof getMisCrmFunnel>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisCrmFunnel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisCrmFunnelQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisOpsTicketSlaUrl = () => {




  return `/api/reports/ops/ticket-sla`
}

/**
 * @summary Ticket SLA compliance by priority
 */
export const getMisOpsTicketSla = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisOpsTicketSlaUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisOpsTicketSlaQueryKey = () => {
    return [
    `/api/reports/ops/ticket-sla`
    ] as const;
    }


export const getGetMisOpsTicketSlaQueryOptions = <TData = Awaited<ReturnType<typeof getMisOpsTicketSla>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisOpsTicketSla>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisOpsTicketSlaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisOpsTicketSla>>> = ({ signal }) => getMisOpsTicketSla({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisOpsTicketSla>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisOpsTicketSlaQueryResult = NonNullable<Awaited<ReturnType<typeof getMisOpsTicketSla>>>
export type GetMisOpsTicketSlaQueryError = ErrorType<unknown>


/**
 * @summary Ticket SLA compliance by priority
 */

export function useGetMisOpsTicketSla<TData = Awaited<ReturnType<typeof getMisOpsTicketSla>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisOpsTicketSla>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisOpsTicketSlaQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisAdminAssetRegisterUrl = () => {




  return `/api/reports/admin/asset-register`
}

/**
 * @summary Full IT and physical asset register
 */
export const getMisAdminAssetRegister = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisAdminAssetRegisterUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisAdminAssetRegisterQueryKey = () => {
    return [
    `/api/reports/admin/asset-register`
    ] as const;
    }


export const getGetMisAdminAssetRegisterQueryOptions = <TData = Awaited<ReturnType<typeof getMisAdminAssetRegister>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisAdminAssetRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisAdminAssetRegisterQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisAdminAssetRegister>>> = ({ signal }) => getMisAdminAssetRegister({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisAdminAssetRegister>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisAdminAssetRegisterQueryResult = NonNullable<Awaited<ReturnType<typeof getMisAdminAssetRegister>>>
export type GetMisAdminAssetRegisterQueryError = ErrorType<unknown>


/**
 * @summary Full IT and physical asset register
 */

export function useGetMisAdminAssetRegister<TData = Awaited<ReturnType<typeof getMisAdminAssetRegister>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisAdminAssetRegister>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisAdminAssetRegisterQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisAdminLicenseUtilizationUrl = () => {




  return `/api/reports/admin/license-utilization`
}

/**
 * @summary Software license seat utilization
 */
export const getMisAdminLicenseUtilization = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisAdminLicenseUtilizationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisAdminLicenseUtilizationQueryKey = () => {
    return [
    `/api/reports/admin/license-utilization`
    ] as const;
    }


export const getGetMisAdminLicenseUtilizationQueryOptions = <TData = Awaited<ReturnType<typeof getMisAdminLicenseUtilization>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisAdminLicenseUtilization>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisAdminLicenseUtilizationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisAdminLicenseUtilization>>> = ({ signal }) => getMisAdminLicenseUtilization({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisAdminLicenseUtilization>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisAdminLicenseUtilizationQueryResult = NonNullable<Awaited<ReturnType<typeof getMisAdminLicenseUtilization>>>
export type GetMisAdminLicenseUtilizationQueryError = ErrorType<unknown>


/**
 * @summary Software license seat utilization
 */

export function useGetMisAdminLicenseUtilization<TData = Awaited<ReturnType<typeof getMisAdminLicenseUtilization>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisAdminLicenseUtilization>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisAdminLicenseUtilizationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMisAdhocSourcesUrl = () => {




  return `/api/reports/adhoc/sources`
}

/**
 * @summary List allowed data sources and columns for ad-hoc builder
 */
export const getMisAdhocSources = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMisAdhocSourcesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMisAdhocSourcesQueryKey = () => {
    return [
    `/api/reports/adhoc/sources`
    ] as const;
    }


export const getGetMisAdhocSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getMisAdhocSources>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisAdhocSources>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMisAdhocSourcesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMisAdhocSources>>> = ({ signal }) => getMisAdhocSources({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMisAdhocSources>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMisAdhocSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getMisAdhocSources>>>
export type GetMisAdhocSourcesQueryError = ErrorType<unknown>


/**
 * @summary List allowed data sources and columns for ad-hoc builder
 */

export function useGetMisAdhocSources<TData = Awaited<ReturnType<typeof getMisAdhocSources>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMisAdhocSources>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMisAdhocSourcesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRunMisAdhocReportUrl = () => {




  return `/api/reports/adhoc/run`
}

/**
 * @summary Execute an ad-hoc query — returns JSON or CSV
 */
export const runMisAdhocReport = async (runMisAdhocReportBody: RunMisAdhocReportBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRunMisAdhocReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runMisAdhocReportBody,)
  }
);}




export const getRunMisAdhocReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runMisAdhocReport>>, TError,{data: BodyType<RunMisAdhocReportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runMisAdhocReport>>, TError,{data: BodyType<RunMisAdhocReportBody>}, TContext> => {

const mutationKey = ['runMisAdhocReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runMisAdhocReport>>, {data: BodyType<RunMisAdhocReportBody>}> = (props) => {
          const {data} = props ?? {};

          return  runMisAdhocReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunMisAdhocReportMutationResult = NonNullable<Awaited<ReturnType<typeof runMisAdhocReport>>>
    export type RunMisAdhocReportMutationBody = BodyType<RunMisAdhocReportBody>
    export type RunMisAdhocReportMutationError = ErrorType<unknown>

    /**
 * @summary Execute an ad-hoc query — returns JSON or CSV
 */
export const useRunMisAdhocReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runMisAdhocReport>>, TError,{data: BodyType<RunMisAdhocReportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runMisAdhocReport>>,
        TError,
        {data: BodyType<RunMisAdhocReportBody>},
        TContext
      > => {
      return useMutation(getRunMisAdhocReportMutationOptions(options));
    }

export const getListMisSavedReportsUrl = () => {




  return `/api/reports/saved`
}

/**
 * @summary List personal and shared saved reports
 */
export const listMisSavedReports = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListMisSavedReportsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMisSavedReportsQueryKey = () => {
    return [
    `/api/reports/saved`
    ] as const;
    }


export const getListMisSavedReportsQueryOptions = <TData = Awaited<ReturnType<typeof listMisSavedReports>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMisSavedReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMisSavedReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMisSavedReports>>> = ({ signal }) => listMisSavedReports({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMisSavedReports>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMisSavedReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listMisSavedReports>>>
export type ListMisSavedReportsQueryError = ErrorType<unknown>


/**
 * @summary List personal and shared saved reports
 */

export function useListMisSavedReports<TData = Awaited<ReturnType<typeof listMisSavedReports>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMisSavedReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMisSavedReportsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateMisSavedReportUrl = () => {




  return `/api/reports/saved`
}

/**
 * @summary Save a report definition
 */
export const createMisSavedReport = async (createMisSavedReportBody: CreateMisSavedReportBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateMisSavedReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createMisSavedReportBody,)
  }
);}




export const getCreateMisSavedReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMisSavedReport>>, TError,{data: BodyType<CreateMisSavedReportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMisSavedReport>>, TError,{data: BodyType<CreateMisSavedReportBody>}, TContext> => {

const mutationKey = ['createMisSavedReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMisSavedReport>>, {data: BodyType<CreateMisSavedReportBody>}> = (props) => {
          const {data} = props ?? {};

          return  createMisSavedReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMisSavedReportMutationResult = NonNullable<Awaited<ReturnType<typeof createMisSavedReport>>>
    export type CreateMisSavedReportMutationBody = BodyType<CreateMisSavedReportBody>
    export type CreateMisSavedReportMutationError = ErrorType<unknown>

    /**
 * @summary Save a report definition
 */
export const useCreateMisSavedReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMisSavedReport>>, TError,{data: BodyType<CreateMisSavedReportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMisSavedReport>>,
        TError,
        {data: BodyType<CreateMisSavedReportBody>},
        TContext
      > => {
      return useMutation(getCreateMisSavedReportMutationOptions(options));
    }

export const getDeleteMisSavedReportUrl = (id: number,) => {




  return `/api/reports/saved/${id}`
}

/**
 * @summary Delete a saved report
 */
export const deleteMisSavedReport = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteMisSavedReportUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMisSavedReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMisSavedReport>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMisSavedReport>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteMisSavedReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMisSavedReport>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteMisSavedReport(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMisSavedReportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMisSavedReport>>>

    export type DeleteMisSavedReportMutationError = ErrorType<unknown>

    /**
 * @summary Delete a saved report
 */
export const useDeleteMisSavedReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMisSavedReport>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMisSavedReport>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteMisSavedReportMutationOptions(options));
    }

export const getListMisScheduledReportsUrl = () => {




  return `/api/reports/scheduled`
}

/**
 * @summary List scheduled report deliveries
 */
export const listMisScheduledReports = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListMisScheduledReportsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMisScheduledReportsQueryKey = () => {
    return [
    `/api/reports/scheduled`
    ] as const;
    }


export const getListMisScheduledReportsQueryOptions = <TData = Awaited<ReturnType<typeof listMisScheduledReports>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMisScheduledReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMisScheduledReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMisScheduledReports>>> = ({ signal }) => listMisScheduledReports({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMisScheduledReports>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMisScheduledReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listMisScheduledReports>>>
export type ListMisScheduledReportsQueryError = ErrorType<unknown>


/**
 * @summary List scheduled report deliveries
 */

export function useListMisScheduledReports<TData = Awaited<ReturnType<typeof listMisScheduledReports>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMisScheduledReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMisScheduledReportsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateMisScheduledReportUrl = () => {




  return `/api/reports/scheduled`
}

/**
 * @summary Create a scheduled report delivery
 */
export const createMisScheduledReport = async (createMisScheduledReportBody: CreateMisScheduledReportBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateMisScheduledReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createMisScheduledReportBody,)
  }
);}




export const getCreateMisScheduledReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMisScheduledReport>>, TError,{data: BodyType<CreateMisScheduledReportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMisScheduledReport>>, TError,{data: BodyType<CreateMisScheduledReportBody>}, TContext> => {

const mutationKey = ['createMisScheduledReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMisScheduledReport>>, {data: BodyType<CreateMisScheduledReportBody>}> = (props) => {
          const {data} = props ?? {};

          return  createMisScheduledReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMisScheduledReportMutationResult = NonNullable<Awaited<ReturnType<typeof createMisScheduledReport>>>
    export type CreateMisScheduledReportMutationBody = BodyType<CreateMisScheduledReportBody>
    export type CreateMisScheduledReportMutationError = ErrorType<unknown>

    /**
 * @summary Create a scheduled report delivery
 */
export const useCreateMisScheduledReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMisScheduledReport>>, TError,{data: BodyType<CreateMisScheduledReportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMisScheduledReport>>,
        TError,
        {data: BodyType<CreateMisScheduledReportBody>},
        TContext
      > => {
      return useMutation(getCreateMisScheduledReportMutationOptions(options));
    }

export const getUpdateMisScheduledReportUrl = (id: number,) => {




  return `/api/reports/scheduled/${id}`
}

/**
 * @summary Update a scheduled report delivery
 */
export const updateMisScheduledReport = async (id: number,
    updateMisScheduledReportBody: UpdateMisScheduledReportBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateMisScheduledReportUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateMisScheduledReportBody,)
  }
);}




export const getUpdateMisScheduledReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMisScheduledReport>>, TError,{id: number;data: BodyType<UpdateMisScheduledReportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMisScheduledReport>>, TError,{id: number;data: BodyType<UpdateMisScheduledReportBody>}, TContext> => {

const mutationKey = ['updateMisScheduledReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMisScheduledReport>>, {id: number;data: BodyType<UpdateMisScheduledReportBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateMisScheduledReport(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMisScheduledReportMutationResult = NonNullable<Awaited<ReturnType<typeof updateMisScheduledReport>>>
    export type UpdateMisScheduledReportMutationBody = BodyType<UpdateMisScheduledReportBody>
    export type UpdateMisScheduledReportMutationError = ErrorType<unknown>

    /**
 * @summary Update a scheduled report delivery
 */
export const useUpdateMisScheduledReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMisScheduledReport>>, TError,{id: number;data: BodyType<UpdateMisScheduledReportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMisScheduledReport>>,
        TError,
        {id: number;data: BodyType<UpdateMisScheduledReportBody>},
        TContext
      > => {
      return useMutation(getUpdateMisScheduledReportMutationOptions(options));
    }

export const getDeleteMisScheduledReportUrl = (id: number,) => {




  return `/api/reports/scheduled/${id}`
}

/**
 * @summary Delete a scheduled report delivery
 */
export const deleteMisScheduledReport = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteMisScheduledReportUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMisScheduledReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMisScheduledReport>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMisScheduledReport>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteMisScheduledReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMisScheduledReport>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteMisScheduledReport(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMisScheduledReportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMisScheduledReport>>>

    export type DeleteMisScheduledReportMutationError = ErrorType<unknown>

    /**
 * @summary Delete a scheduled report delivery
 */
export const useDeleteMisScheduledReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMisScheduledReport>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMisScheduledReport>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteMisScheduledReportMutationOptions(options));
    }

export const getListPerfCyclesUrl = () => {




  return `/api/hr/performance/cycles`
}

/**
 * @summary List appraisal cycles
 */
export const listPerfCycles = async ( options?: RequestInit): Promise<PerfCycle[]> => {

  return customFetch<PerfCycle[]>(getListPerfCyclesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPerfCyclesQueryKey = () => {
    return [
    `/api/hr/performance/cycles`
    ] as const;
    }


export const getListPerfCyclesQueryOptions = <TData = Awaited<ReturnType<typeof listPerfCycles>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfCycles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPerfCyclesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPerfCycles>>> = ({ signal }) => listPerfCycles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPerfCycles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPerfCyclesQueryResult = NonNullable<Awaited<ReturnType<typeof listPerfCycles>>>
export type ListPerfCyclesQueryError = ErrorType<unknown>


/**
 * @summary List appraisal cycles
 */

export function useListPerfCycles<TData = Awaited<ReturnType<typeof listPerfCycles>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfCycles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPerfCyclesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePerfCycleUrl = () => {




  return `/api/hr/performance/cycles`
}

/**
 * @summary Create an appraisal cycle
 */
export const createPerfCycle = async (perfCycleInput: PerfCycleInput, options?: RequestInit): Promise<PerfCycle> => {

  return customFetch<PerfCycle>(getCreatePerfCycleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perfCycleInput,)
  }
);}




export const getCreatePerfCycleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerfCycle>>, TError,{data: BodyType<PerfCycleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPerfCycle>>, TError,{data: BodyType<PerfCycleInput>}, TContext> => {

const mutationKey = ['createPerfCycle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerfCycle>>, {data: BodyType<PerfCycleInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPerfCycle(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePerfCycleMutationResult = NonNullable<Awaited<ReturnType<typeof createPerfCycle>>>
    export type CreatePerfCycleMutationBody = BodyType<PerfCycleInput>
    export type CreatePerfCycleMutationError = ErrorType<unknown>

    /**
 * @summary Create an appraisal cycle
 */
export const useCreatePerfCycle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerfCycle>>, TError,{data: BodyType<PerfCycleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPerfCycle>>,
        TError,
        {data: BodyType<PerfCycleInput>},
        TContext
      > => {
      return useMutation(getCreatePerfCycleMutationOptions(options));
    }

export const getGetPerfCycleUrl = (id: number,) => {




  return `/api/hr/performance/cycles/${id}`
}

/**
 * @summary Get a single appraisal cycle
 */
export const getPerfCycle = async (id: number, options?: RequestInit): Promise<PerfCycle> => {

  return customFetch<PerfCycle>(getGetPerfCycleUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerfCycleQueryKey = (id: number,) => {
    return [
    `/api/hr/performance/cycles/${id}`
    ] as const;
    }


export const getGetPerfCycleQueryOptions = <TData = Awaited<ReturnType<typeof getPerfCycle>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPerfCycle>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerfCycleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerfCycle>>> = ({ signal }) => getPerfCycle(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerfCycle>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPerfCycleQueryResult = NonNullable<Awaited<ReturnType<typeof getPerfCycle>>>
export type GetPerfCycleQueryError = ErrorType<unknown>


/**
 * @summary Get a single appraisal cycle
 */

export function useGetPerfCycle<TData = Awaited<ReturnType<typeof getPerfCycle>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPerfCycle>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPerfCycleQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePerfCycleUrl = (id: number,) => {




  return `/api/hr/performance/cycles/${id}`
}

/**
 * @summary Update an appraisal cycle
 */
export const updatePerfCycle = async (id: number,
    perfCycleInput: PerfCycleInput, options?: RequestInit): Promise<PerfCycle> => {

  return customFetch<PerfCycle>(getUpdatePerfCycleUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perfCycleInput,)
  }
);}




export const getUpdatePerfCycleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerfCycle>>, TError,{id: number;data: BodyType<PerfCycleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePerfCycle>>, TError,{id: number;data: BodyType<PerfCycleInput>}, TContext> => {

const mutationKey = ['updatePerfCycle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePerfCycle>>, {id: number;data: BodyType<PerfCycleInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePerfCycle(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePerfCycleMutationResult = NonNullable<Awaited<ReturnType<typeof updatePerfCycle>>>
    export type UpdatePerfCycleMutationBody = BodyType<PerfCycleInput>
    export type UpdatePerfCycleMutationError = ErrorType<unknown>

    /**
 * @summary Update an appraisal cycle
 */
export const useUpdatePerfCycle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerfCycle>>, TError,{id: number;data: BodyType<PerfCycleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePerfCycle>>,
        TError,
        {id: number;data: BodyType<PerfCycleInput>},
        TContext
      > => {
      return useMutation(getUpdatePerfCycleMutationOptions(options));
    }

export const getDeletePerfCycleUrl = (id: number,) => {




  return `/api/hr/performance/cycles/${id}`
}

/**
 * @summary Delete an appraisal cycle
 */
export const deletePerfCycle = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePerfCycleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePerfCycleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerfCycle>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerfCycle>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePerfCycle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerfCycle>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePerfCycle(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePerfCycleMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerfCycle>>>

    export type DeletePerfCycleMutationError = ErrorType<unknown>

    /**
 * @summary Delete an appraisal cycle
 */
export const useDeletePerfCycle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerfCycle>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePerfCycle>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePerfCycleMutationOptions(options));
    }

export const getListPerfKrasUrl = (cycleId: number,
    params?: ListPerfKrasParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/performance/cycles/${cycleId}/kras?${stringifiedParams}` : `/api/hr/performance/cycles/${cycleId}/kras`
}

/**
 * @summary List KRAs for a cycle
 */
export const listPerfKras = async (cycleId: number,
    params?: ListPerfKrasParams, options?: RequestInit): Promise<PerfKra[]> => {

  return customFetch<PerfKra[]>(getListPerfKrasUrl(cycleId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPerfKrasQueryKey = (cycleId: number,
    params?: ListPerfKrasParams,) => {
    return [
    `/api/hr/performance/cycles/${cycleId}/kras`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPerfKrasQueryOptions = <TData = Awaited<ReturnType<typeof listPerfKras>>, TError = ErrorType<unknown>>(cycleId: number,
    params?: ListPerfKrasParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfKras>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPerfKrasQueryKey(cycleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPerfKras>>> = ({ signal }) => listPerfKras(cycleId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPerfKras>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPerfKrasQueryResult = NonNullable<Awaited<ReturnType<typeof listPerfKras>>>
export type ListPerfKrasQueryError = ErrorType<unknown>


/**
 * @summary List KRAs for a cycle
 */

export function useListPerfKras<TData = Awaited<ReturnType<typeof listPerfKras>>, TError = ErrorType<unknown>>(
 cycleId: number,
    params?: ListPerfKrasParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfKras>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPerfKrasQueryOptions(cycleId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePerfKraUrl = (cycleId: number,) => {




  return `/api/hr/performance/cycles/${cycleId}/kras`
}

/**
 * @summary Create a KRA for an employee in a cycle
 */
export const createPerfKra = async (cycleId: number,
    perfKraInput: PerfKraInput, options?: RequestInit): Promise<PerfKra> => {

  return customFetch<PerfKra>(getCreatePerfKraUrl(cycleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perfKraInput,)
  }
);}




export const getCreatePerfKraMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerfKra>>, TError,{cycleId: number;data: BodyType<PerfKraInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPerfKra>>, TError,{cycleId: number;data: BodyType<PerfKraInput>}, TContext> => {

const mutationKey = ['createPerfKra'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerfKra>>, {cycleId: number;data: BodyType<PerfKraInput>}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  createPerfKra(cycleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePerfKraMutationResult = NonNullable<Awaited<ReturnType<typeof createPerfKra>>>
    export type CreatePerfKraMutationBody = BodyType<PerfKraInput>
    export type CreatePerfKraMutationError = ErrorType<unknown>

    /**
 * @summary Create a KRA for an employee in a cycle
 */
export const useCreatePerfKra = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerfKra>>, TError,{cycleId: number;data: BodyType<PerfKraInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPerfKra>>,
        TError,
        {cycleId: number;data: BodyType<PerfKraInput>},
        TContext
      > => {
      return useMutation(getCreatePerfKraMutationOptions(options));
    }

export const getUpdatePerfKraUrl = (id: number,) => {




  return `/api/hr/performance/kras/${id}`
}

/**
 * @summary Update a KRA
 */
export const updatePerfKra = async (id: number,
    perfKraInput: PerfKraInput, options?: RequestInit): Promise<PerfKra> => {

  return customFetch<PerfKra>(getUpdatePerfKraUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perfKraInput,)
  }
);}




export const getUpdatePerfKraMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerfKra>>, TError,{id: number;data: BodyType<PerfKraInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePerfKra>>, TError,{id: number;data: BodyType<PerfKraInput>}, TContext> => {

const mutationKey = ['updatePerfKra'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePerfKra>>, {id: number;data: BodyType<PerfKraInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePerfKra(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePerfKraMutationResult = NonNullable<Awaited<ReturnType<typeof updatePerfKra>>>
    export type UpdatePerfKraMutationBody = BodyType<PerfKraInput>
    export type UpdatePerfKraMutationError = ErrorType<unknown>

    /**
 * @summary Update a KRA
 */
export const useUpdatePerfKra = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerfKra>>, TError,{id: number;data: BodyType<PerfKraInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePerfKra>>,
        TError,
        {id: number;data: BodyType<PerfKraInput>},
        TContext
      > => {
      return useMutation(getUpdatePerfKraMutationOptions(options));
    }

export const getDeletePerfKraUrl = (id: number,) => {




  return `/api/hr/performance/kras/${id}`
}

/**
 * @summary Delete a KRA
 */
export const deletePerfKra = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePerfKraUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePerfKraMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerfKra>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerfKra>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePerfKra'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerfKra>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePerfKra(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePerfKraMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerfKra>>>

    export type DeletePerfKraMutationError = ErrorType<unknown>

    /**
 * @summary Delete a KRA
 */
export const useDeletePerfKra = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerfKra>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePerfKra>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePerfKraMutationOptions(options));
    }

export const getSubmitPerfKraUrl = (id: number,) => {




  return `/api/hr/performance/kras/${id}/submit`
}

/**
 * @summary Employee submits KRA for manager approval
 */
export const submitPerfKra = async (id: number, options?: RequestInit): Promise<PerfKra> => {

  return customFetch<PerfKra>(getSubmitPerfKraUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSubmitPerfKraMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPerfKra>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitPerfKra>>, TError,{id: number}, TContext> => {

const mutationKey = ['submitPerfKra'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitPerfKra>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  submitPerfKra(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitPerfKraMutationResult = NonNullable<Awaited<ReturnType<typeof submitPerfKra>>>

    export type SubmitPerfKraMutationError = ErrorType<unknown>

    /**
 * @summary Employee submits KRA for manager approval
 */
export const useSubmitPerfKra = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPerfKra>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitPerfKra>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getSubmitPerfKraMutationOptions(options));
    }

export const getApprovePerfKraUrl = (id: number,) => {




  return `/api/hr/performance/kras/${id}/approve`
}

/**
 * @summary Manager approves a KRA
 */
export const approvePerfKra = async (id: number,
    approvePerfKraBody?: ApprovePerfKraBody, options?: RequestInit): Promise<PerfKra> => {

  return customFetch<PerfKra>(getApprovePerfKraUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approvePerfKraBody,)
  }
);}




export const getApprovePerfKraMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePerfKra>>, TError,{id: number;data?: BodyType<ApprovePerfKraBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePerfKra>>, TError,{id: number;data?: BodyType<ApprovePerfKraBody>}, TContext> => {

const mutationKey = ['approvePerfKra'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePerfKra>>, {id: number;data?: BodyType<ApprovePerfKraBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  approvePerfKra(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePerfKraMutationResult = NonNullable<Awaited<ReturnType<typeof approvePerfKra>>>
    export type ApprovePerfKraMutationBody = BodyType<ApprovePerfKraBody> | undefined
    export type ApprovePerfKraMutationError = ErrorType<unknown>

    /**
 * @summary Manager approves a KRA
 */
export const useApprovePerfKra = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePerfKra>>, TError,{id: number;data?: BodyType<ApprovePerfKraBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approvePerfKra>>,
        TError,
        {id: number;data?: BodyType<ApprovePerfKraBody>},
        TContext
      > => {
      return useMutation(getApprovePerfKraMutationOptions(options));
    }

export const getRejectPerfKraUrl = (id: number,) => {




  return `/api/hr/performance/kras/${id}/reject`
}

/**
 * @summary Manager rejects a KRA
 */
export const rejectPerfKra = async (id: number,
    rejectPerfKraBody?: RejectPerfKraBody, options?: RequestInit): Promise<PerfKra> => {

  return customFetch<PerfKra>(getRejectPerfKraUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rejectPerfKraBody,)
  }
);}




export const getRejectPerfKraMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectPerfKra>>, TError,{id: number;data?: BodyType<RejectPerfKraBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectPerfKra>>, TError,{id: number;data?: BodyType<RejectPerfKraBody>}, TContext> => {

const mutationKey = ['rejectPerfKra'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectPerfKra>>, {id: number;data?: BodyType<RejectPerfKraBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectPerfKra(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectPerfKraMutationResult = NonNullable<Awaited<ReturnType<typeof rejectPerfKra>>>
    export type RejectPerfKraMutationBody = BodyType<RejectPerfKraBody> | undefined
    export type RejectPerfKraMutationError = ErrorType<unknown>

    /**
 * @summary Manager rejects a KRA
 */
export const useRejectPerfKra = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectPerfKra>>, TError,{id: number;data?: BodyType<RejectPerfKraBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectPerfKra>>,
        TError,
        {id: number;data?: BodyType<RejectPerfKraBody>},
        TContext
      > => {
      return useMutation(getRejectPerfKraMutationOptions(options));
    }

export const getListPerfAssessmentsUrl = (cycleId: number,
    params?: ListPerfAssessmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/performance/cycles/${cycleId}/assessments?${stringifiedParams}` : `/api/hr/performance/cycles/${cycleId}/assessments`
}

/**
 * @summary List assessments for a cycle
 */
export const listPerfAssessments = async (cycleId: number,
    params?: ListPerfAssessmentsParams, options?: RequestInit): Promise<PerfAssessment[]> => {

  return customFetch<PerfAssessment[]>(getListPerfAssessmentsUrl(cycleId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPerfAssessmentsQueryKey = (cycleId: number,
    params?: ListPerfAssessmentsParams,) => {
    return [
    `/api/hr/performance/cycles/${cycleId}/assessments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPerfAssessmentsQueryOptions = <TData = Awaited<ReturnType<typeof listPerfAssessments>>, TError = ErrorType<unknown>>(cycleId: number,
    params?: ListPerfAssessmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfAssessments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPerfAssessmentsQueryKey(cycleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPerfAssessments>>> = ({ signal }) => listPerfAssessments(cycleId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPerfAssessments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPerfAssessmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPerfAssessments>>>
export type ListPerfAssessmentsQueryError = ErrorType<unknown>


/**
 * @summary List assessments for a cycle
 */

export function useListPerfAssessments<TData = Awaited<ReturnType<typeof listPerfAssessments>>, TError = ErrorType<unknown>>(
 cycleId: number,
    params?: ListPerfAssessmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfAssessments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPerfAssessmentsQueryOptions(cycleId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpsertPerfAssessmentUrl = (cycleId: number,) => {




  return `/api/hr/performance/cycles/${cycleId}/assessments`
}

/**
 * @summary Create or update a self/manager assessment
 */
export const upsertPerfAssessment = async (cycleId: number,
    perfAssessmentInput: PerfAssessmentInput, options?: RequestInit): Promise<PerfAssessment> => {

  return customFetch<PerfAssessment>(getUpsertPerfAssessmentUrl(cycleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perfAssessmentInput,)
  }
);}




export const getUpsertPerfAssessmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPerfAssessment>>, TError,{cycleId: number;data: BodyType<PerfAssessmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertPerfAssessment>>, TError,{cycleId: number;data: BodyType<PerfAssessmentInput>}, TContext> => {

const mutationKey = ['upsertPerfAssessment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertPerfAssessment>>, {cycleId: number;data: BodyType<PerfAssessmentInput>}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  upsertPerfAssessment(cycleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertPerfAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof upsertPerfAssessment>>>
    export type UpsertPerfAssessmentMutationBody = BodyType<PerfAssessmentInput>
    export type UpsertPerfAssessmentMutationError = ErrorType<unknown>

    /**
 * @summary Create or update a self/manager assessment
 */
export const useUpsertPerfAssessment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPerfAssessment>>, TError,{cycleId: number;data: BodyType<PerfAssessmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertPerfAssessment>>,
        TError,
        {cycleId: number;data: BodyType<PerfAssessmentInput>},
        TContext
      > => {
      return useMutation(getUpsertPerfAssessmentMutationOptions(options));
    }

export const getListPerfFeedbackRequestsUrl = (cycleId: number,
    params?: ListPerfFeedbackRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/performance/cycles/${cycleId}/feedback-requests?${stringifiedParams}` : `/api/hr/performance/cycles/${cycleId}/feedback-requests`
}

/**
 * @summary List 360 feedback requests for a cycle
 */
export const listPerfFeedbackRequests = async (cycleId: number,
    params?: ListPerfFeedbackRequestsParams, options?: RequestInit): Promise<PerfFeedbackRequest[]> => {

  return customFetch<PerfFeedbackRequest[]>(getListPerfFeedbackRequestsUrl(cycleId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPerfFeedbackRequestsQueryKey = (cycleId: number,
    params?: ListPerfFeedbackRequestsParams,) => {
    return [
    `/api/hr/performance/cycles/${cycleId}/feedback-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPerfFeedbackRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listPerfFeedbackRequests>>, TError = ErrorType<unknown>>(cycleId: number,
    params?: ListPerfFeedbackRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfFeedbackRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPerfFeedbackRequestsQueryKey(cycleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPerfFeedbackRequests>>> = ({ signal }) => listPerfFeedbackRequests(cycleId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPerfFeedbackRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPerfFeedbackRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listPerfFeedbackRequests>>>
export type ListPerfFeedbackRequestsQueryError = ErrorType<unknown>


/**
 * @summary List 360 feedback requests for a cycle
 */

export function useListPerfFeedbackRequests<TData = Awaited<ReturnType<typeof listPerfFeedbackRequests>>, TError = ErrorType<unknown>>(
 cycleId: number,
    params?: ListPerfFeedbackRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfFeedbackRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPerfFeedbackRequestsQueryOptions(cycleId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePerfFeedbackRequestsUrl = (cycleId: number,) => {




  return `/api/hr/performance/cycles/${cycleId}/feedback-requests`
}

/**
 * @summary Create one or more 360 feedback requests
 */
export const createPerfFeedbackRequests = async (cycleId: number,
    perfFeedbackRequestsInput: PerfFeedbackRequestsInput, options?: RequestInit): Promise<PerfFeedbackRequest[]> => {

  return customFetch<PerfFeedbackRequest[]>(getCreatePerfFeedbackRequestsUrl(cycleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perfFeedbackRequestsInput,)
  }
);}




export const getCreatePerfFeedbackRequestsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerfFeedbackRequests>>, TError,{cycleId: number;data: BodyType<PerfFeedbackRequestsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPerfFeedbackRequests>>, TError,{cycleId: number;data: BodyType<PerfFeedbackRequestsInput>}, TContext> => {

const mutationKey = ['createPerfFeedbackRequests'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerfFeedbackRequests>>, {cycleId: number;data: BodyType<PerfFeedbackRequestsInput>}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  createPerfFeedbackRequests(cycleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePerfFeedbackRequestsMutationResult = NonNullable<Awaited<ReturnType<typeof createPerfFeedbackRequests>>>
    export type CreatePerfFeedbackRequestsMutationBody = BodyType<PerfFeedbackRequestsInput>
    export type CreatePerfFeedbackRequestsMutationError = ErrorType<unknown>

    /**
 * @summary Create one or more 360 feedback requests
 */
export const useCreatePerfFeedbackRequests = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerfFeedbackRequests>>, TError,{cycleId: number;data: BodyType<PerfFeedbackRequestsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPerfFeedbackRequests>>,
        TError,
        {cycleId: number;data: BodyType<PerfFeedbackRequestsInput>},
        TContext
      > => {
      return useMutation(getCreatePerfFeedbackRequestsMutationOptions(options));
    }

export const getDeletePerfFeedbackRequestUrl = (id: number,) => {




  return `/api/hr/performance/feedback-requests/${id}`
}

/**
 * @summary Delete a feedback request
 */
export const deletePerfFeedbackRequest = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePerfFeedbackRequestUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePerfFeedbackRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerfFeedbackRequest>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerfFeedbackRequest>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePerfFeedbackRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerfFeedbackRequest>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePerfFeedbackRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePerfFeedbackRequestMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerfFeedbackRequest>>>

    export type DeletePerfFeedbackRequestMutationError = ErrorType<unknown>

    /**
 * @summary Delete a feedback request
 */
export const useDeletePerfFeedbackRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerfFeedbackRequest>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePerfFeedbackRequest>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePerfFeedbackRequestMutationOptions(options));
    }

export const getRespondPerfFeedbackUrl = (id: number,) => {




  return `/api/hr/performance/feedback-requests/${id}/respond`
}

/**
 * @summary Submit a 360 feedback response
 */
export const respondPerfFeedback = async (id: number,
    perfFeedbackResponseInput: PerfFeedbackResponseInput, options?: RequestInit): Promise<PerfFeedbackResponse> => {

  return customFetch<PerfFeedbackResponse>(getRespondPerfFeedbackUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perfFeedbackResponseInput,)
  }
);}




export const getRespondPerfFeedbackMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondPerfFeedback>>, TError,{id: number;data: BodyType<PerfFeedbackResponseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof respondPerfFeedback>>, TError,{id: number;data: BodyType<PerfFeedbackResponseInput>}, TContext> => {

const mutationKey = ['respondPerfFeedback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof respondPerfFeedback>>, {id: number;data: BodyType<PerfFeedbackResponseInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  respondPerfFeedback(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RespondPerfFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof respondPerfFeedback>>>
    export type RespondPerfFeedbackMutationBody = BodyType<PerfFeedbackResponseInput>
    export type RespondPerfFeedbackMutationError = ErrorType<unknown>

    /**
 * @summary Submit a 360 feedback response
 */
export const useRespondPerfFeedback = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondPerfFeedback>>, TError,{id: number;data: BodyType<PerfFeedbackResponseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof respondPerfFeedback>>,
        TError,
        {id: number;data: BodyType<PerfFeedbackResponseInput>},
        TContext
      > => {
      return useMutation(getRespondPerfFeedbackMutationOptions(options));
    }

export const getListPerfRatingsUrl = (cycleId: number,) => {




  return `/api/hr/performance/cycles/${cycleId}/ratings`
}

/**
 * @summary List final ratings for a cycle
 */
export const listPerfRatings = async (cycleId: number, options?: RequestInit): Promise<PerfRating[]> => {

  return customFetch<PerfRating[]>(getListPerfRatingsUrl(cycleId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPerfRatingsQueryKey = (cycleId: number,) => {
    return [
    `/api/hr/performance/cycles/${cycleId}/ratings`
    ] as const;
    }


export const getListPerfRatingsQueryOptions = <TData = Awaited<ReturnType<typeof listPerfRatings>>, TError = ErrorType<unknown>>(cycleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfRatings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPerfRatingsQueryKey(cycleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPerfRatings>>> = ({ signal }) => listPerfRatings(cycleId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPerfRatings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPerfRatingsQueryResult = NonNullable<Awaited<ReturnType<typeof listPerfRatings>>>
export type ListPerfRatingsQueryError = ErrorType<unknown>


/**
 * @summary List final ratings for a cycle
 */

export function useListPerfRatings<TData = Awaited<ReturnType<typeof listPerfRatings>>, TError = ErrorType<unknown>>(
 cycleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerfRatings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPerfRatingsQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getComputePerfRatingsUrl = (cycleId: number,) => {




  return `/api/hr/performance/cycles/${cycleId}/ratings/compute`
}

/**
 * @summary Compute weighted ratings for all assessed employees in a cycle
 */
export const computePerfRatings = async (cycleId: number, options?: RequestInit): Promise<ComputePerfRatings200> => {

  return customFetch<ComputePerfRatings200>(getComputePerfRatingsUrl(cycleId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getComputePerfRatingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof computePerfRatings>>, TError,{cycleId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof computePerfRatings>>, TError,{cycleId: number}, TContext> => {

const mutationKey = ['computePerfRatings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof computePerfRatings>>, {cycleId: number}> = (props) => {
          const {cycleId} = props ?? {};

          return  computePerfRatings(cycleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ComputePerfRatingsMutationResult = NonNullable<Awaited<ReturnType<typeof computePerfRatings>>>

    export type ComputePerfRatingsMutationError = ErrorType<unknown>

    /**
 * @summary Compute weighted ratings for all assessed employees in a cycle
 */
export const useComputePerfRatings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof computePerfRatings>>, TError,{cycleId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof computePerfRatings>>,
        TError,
        {cycleId: number},
        TContext
      > => {
      return useMutation(getComputePerfRatingsMutationOptions(options));
    }

export const getUpdatePerfRatingUrl = (id: number,) => {




  return `/api/hr/performance/ratings/${id}`
}

/**
 * @summary HR calibration override, increment and promotion update
 */
export const updatePerfRating = async (id: number,
    perfRatingUpdate: PerfRatingUpdate, options?: RequestInit): Promise<PerfRating> => {

  return customFetch<PerfRating>(getUpdatePerfRatingUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perfRatingUpdate,)
  }
);}




export const getUpdatePerfRatingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerfRating>>, TError,{id: number;data: BodyType<PerfRatingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePerfRating>>, TError,{id: number;data: BodyType<PerfRatingUpdate>}, TContext> => {

const mutationKey = ['updatePerfRating'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePerfRating>>, {id: number;data: BodyType<PerfRatingUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePerfRating(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePerfRatingMutationResult = NonNullable<Awaited<ReturnType<typeof updatePerfRating>>>
    export type UpdatePerfRatingMutationBody = BodyType<PerfRatingUpdate>
    export type UpdatePerfRatingMutationError = ErrorType<unknown>

    /**
 * @summary HR calibration override, increment and promotion update
 */
export const useUpdatePerfRating = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerfRating>>, TError,{id: number;data: BodyType<PerfRatingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePerfRating>>,
        TError,
        {id: number;data: BodyType<PerfRatingUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePerfRatingMutationOptions(options));
    }

export const getGetPerfBellCurveUrl = (cycleId: number,) => {




  return `/api/hr/performance/cycles/${cycleId}/bell-curve`
}

/**
 * @summary Bell-curve distribution of ratings for a cycle
 */
export const getPerfBellCurve = async (cycleId: number, options?: RequestInit): Promise<GetPerfBellCurve200Item[]> => {

  return customFetch<GetPerfBellCurve200Item[]>(getGetPerfBellCurveUrl(cycleId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerfBellCurveQueryKey = (cycleId: number,) => {
    return [
    `/api/hr/performance/cycles/${cycleId}/bell-curve`
    ] as const;
    }


export const getGetPerfBellCurveQueryOptions = <TData = Awaited<ReturnType<typeof getPerfBellCurve>>, TError = ErrorType<unknown>>(cycleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPerfBellCurve>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerfBellCurveQueryKey(cycleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerfBellCurve>>> = ({ signal }) => getPerfBellCurve(cycleId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerfBellCurve>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPerfBellCurveQueryResult = NonNullable<Awaited<ReturnType<typeof getPerfBellCurve>>>
export type GetPerfBellCurveQueryError = ErrorType<unknown>


/**
 * @summary Bell-curve distribution of ratings for a cycle
 */

export function useGetPerfBellCurve<TData = Awaited<ReturnType<typeof getPerfBellCurve>>, TError = ErrorType<unknown>>(
 cycleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPerfBellCurve>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPerfBellCurveQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetPerfPayrollHandoffUrl = (cycleId: number,) => {




  return `/api/hr/performance/cycles/${cycleId}/payroll-handoff`
}

/**
 * @summary Payroll handoff data — finalized increment and promotion recommendations for a cycle
 */
export const getPerfPayrollHandoff = async (cycleId: number, options?: RequestInit): Promise<GetPerfPayrollHandoff200Item[]> => {

  return customFetch<GetPerfPayrollHandoff200Item[]>(getGetPerfPayrollHandoffUrl(cycleId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerfPayrollHandoffQueryKey = (cycleId: number,) => {
    return [
    `/api/hr/performance/cycles/${cycleId}/payroll-handoff`
    ] as const;
    }


export const getGetPerfPayrollHandoffQueryOptions = <TData = Awaited<ReturnType<typeof getPerfPayrollHandoff>>, TError = ErrorType<unknown>>(cycleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPerfPayrollHandoff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerfPayrollHandoffQueryKey(cycleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerfPayrollHandoff>>> = ({ signal }) => getPerfPayrollHandoff(cycleId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerfPayrollHandoff>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPerfPayrollHandoffQueryResult = NonNullable<Awaited<ReturnType<typeof getPerfPayrollHandoff>>>
export type GetPerfPayrollHandoffQueryError = ErrorType<unknown>


/**
 * @summary Payroll handoff data — finalized increment and promotion recommendations for a cycle
 */

export function useGetPerfPayrollHandoff<TData = Awaited<ReturnType<typeof getPerfPayrollHandoff>>, TError = ErrorType<unknown>>(
 cycleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPerfPayrollHandoff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPerfPayrollHandoffQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetEmployeePerformanceHistoryUrl = (empId: number,) => {




  return `/api/hr/employees/${empId}/performance-history`
}

/**
 * @summary All appraisal ratings for an employee across cycles
 */
export const getEmployeePerformanceHistory = async (empId: number, options?: RequestInit): Promise<GetEmployeePerformanceHistory200Item[]> => {

  return customFetch<GetEmployeePerformanceHistory200Item[]>(getGetEmployeePerformanceHistoryUrl(empId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmployeePerformanceHistoryQueryKey = (empId: number,) => {
    return [
    `/api/hr/employees/${empId}/performance-history`
    ] as const;
    }


export const getGetEmployeePerformanceHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeePerformanceHistory>>, TError = ErrorType<unknown>>(empId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployeePerformanceHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeePerformanceHistoryQueryKey(empId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeePerformanceHistory>>> = ({ signal }) => getEmployeePerformanceHistory(empId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(empId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeePerformanceHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeePerformanceHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeePerformanceHistory>>>
export type GetEmployeePerformanceHistoryQueryError = ErrorType<unknown>


/**
 * @summary All appraisal ratings for an employee across cycles
 */

export function useGetEmployeePerformanceHistory<TData = Awaited<ReturnType<typeof getEmployeePerformanceHistory>>, TError = ErrorType<unknown>>(
 empId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployeePerformanceHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployeePerformanceHistoryQueryOptions(empId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListTrainingProgrammesUrl = () => {




  return `/api/hr/ld/programmes`
}

/**
 * @summary List all training programmes
 */
export const listTrainingProgrammes = async ( options?: RequestInit): Promise<TrainingProgramme[]> => {

  return customFetch<TrainingProgramme[]>(getListTrainingProgrammesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTrainingProgrammesQueryKey = () => {
    return [
    `/api/hr/ld/programmes`
    ] as const;
    }


export const getListTrainingProgrammesQueryOptions = <TData = Awaited<ReturnType<typeof listTrainingProgrammes>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingProgrammes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTrainingProgrammesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTrainingProgrammes>>> = ({ signal }) => listTrainingProgrammes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTrainingProgrammes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTrainingProgrammesQueryResult = NonNullable<Awaited<ReturnType<typeof listTrainingProgrammes>>>
export type ListTrainingProgrammesQueryError = ErrorType<unknown>


/**
 * @summary List all training programmes
 */

export function useListTrainingProgrammes<TData = Awaited<ReturnType<typeof listTrainingProgrammes>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingProgrammes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTrainingProgrammesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTrainingProgrammeUrl = () => {




  return `/api/hr/ld/programmes`
}

/**
 * @summary Create a training programme
 */
export const createTrainingProgramme = async (trainingProgrammeInput: TrainingProgrammeInput, options?: RequestInit): Promise<TrainingProgramme> => {

  return customFetch<TrainingProgramme>(getCreateTrainingProgrammeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      trainingProgrammeInput,)
  }
);}




export const getCreateTrainingProgrammeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingProgramme>>, TError,{data: BodyType<TrainingProgrammeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTrainingProgramme>>, TError,{data: BodyType<TrainingProgrammeInput>}, TContext> => {

const mutationKey = ['createTrainingProgramme'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrainingProgramme>>, {data: BodyType<TrainingProgrammeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTrainingProgramme(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTrainingProgrammeMutationResult = NonNullable<Awaited<ReturnType<typeof createTrainingProgramme>>>
    export type CreateTrainingProgrammeMutationBody = BodyType<TrainingProgrammeInput>
    export type CreateTrainingProgrammeMutationError = ErrorType<unknown>

    /**
 * @summary Create a training programme
 */
export const useCreateTrainingProgramme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingProgramme>>, TError,{data: BodyType<TrainingProgrammeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTrainingProgramme>>,
        TError,
        {data: BodyType<TrainingProgrammeInput>},
        TContext
      > => {
      return useMutation(getCreateTrainingProgrammeMutationOptions(options));
    }

export const getGetTrainingProgrammeUrl = (id: number,) => {




  return `/api/hr/ld/programmes/${id}`
}

/**
 * @summary Get a training programme
 */
export const getTrainingProgramme = async (id: number, options?: RequestInit): Promise<TrainingProgramme> => {

  return customFetch<TrainingProgramme>(getGetTrainingProgrammeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrainingProgrammeQueryKey = (id: number,) => {
    return [
    `/api/hr/ld/programmes/${id}`
    ] as const;
    }


export const getGetTrainingProgrammeQueryOptions = <TData = Awaited<ReturnType<typeof getTrainingProgramme>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrainingProgramme>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrainingProgrammeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrainingProgramme>>> = ({ signal }) => getTrainingProgramme(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrainingProgramme>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTrainingProgrammeQueryResult = NonNullable<Awaited<ReturnType<typeof getTrainingProgramme>>>
export type GetTrainingProgrammeQueryError = ErrorType<unknown>


/**
 * @summary Get a training programme
 */

export function useGetTrainingProgramme<TData = Awaited<ReturnType<typeof getTrainingProgramme>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrainingProgramme>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTrainingProgrammeQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateTrainingProgrammeUrl = (id: number,) => {




  return `/api/hr/ld/programmes/${id}`
}

/**
 * @summary Update a training programme
 */
export const updateTrainingProgramme = async (id: number,
    trainingProgrammeInput: TrainingProgrammeInput, options?: RequestInit): Promise<TrainingProgramme> => {

  return customFetch<TrainingProgramme>(getUpdateTrainingProgrammeUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      trainingProgrammeInput,)
  }
);}




export const getUpdateTrainingProgrammeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrainingProgramme>>, TError,{id: number;data: BodyType<TrainingProgrammeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTrainingProgramme>>, TError,{id: number;data: BodyType<TrainingProgrammeInput>}, TContext> => {

const mutationKey = ['updateTrainingProgramme'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTrainingProgramme>>, {id: number;data: BodyType<TrainingProgrammeInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTrainingProgramme(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTrainingProgrammeMutationResult = NonNullable<Awaited<ReturnType<typeof updateTrainingProgramme>>>
    export type UpdateTrainingProgrammeMutationBody = BodyType<TrainingProgrammeInput>
    export type UpdateTrainingProgrammeMutationError = ErrorType<unknown>

    /**
 * @summary Update a training programme
 */
export const useUpdateTrainingProgramme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrainingProgramme>>, TError,{id: number;data: BodyType<TrainingProgrammeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTrainingProgramme>>,
        TError,
        {id: number;data: BodyType<TrainingProgrammeInput>},
        TContext
      > => {
      return useMutation(getUpdateTrainingProgrammeMutationOptions(options));
    }

export const getDeleteTrainingProgrammeUrl = (id: number,) => {




  return `/api/hr/ld/programmes/${id}`
}

/**
 * @summary Delete a training programme
 */
export const deleteTrainingProgramme = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTrainingProgrammeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTrainingProgrammeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingProgramme>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingProgramme>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTrainingProgramme'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTrainingProgramme>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTrainingProgramme(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTrainingProgrammeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTrainingProgramme>>>

    export type DeleteTrainingProgrammeMutationError = ErrorType<unknown>

    /**
 * @summary Delete a training programme
 */
export const useDeleteTrainingProgramme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingProgramme>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTrainingProgramme>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTrainingProgrammeMutationOptions(options));
    }

export const getListTrainingNominationsUrl = (programmeId: number,) => {




  return `/api/hr/ld/programmes/${programmeId}/nominations`
}

/**
 * @summary List nominations for a training programme
 */
export const listTrainingNominations = async (programmeId: number, options?: RequestInit): Promise<TrainingNominationRow[]> => {

  return customFetch<TrainingNominationRow[]>(getListTrainingNominationsUrl(programmeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTrainingNominationsQueryKey = (programmeId: number,) => {
    return [
    `/api/hr/ld/programmes/${programmeId}/nominations`
    ] as const;
    }


export const getListTrainingNominationsQueryOptions = <TData = Awaited<ReturnType<typeof listTrainingNominations>>, TError = ErrorType<unknown>>(programmeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingNominations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTrainingNominationsQueryKey(programmeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTrainingNominations>>> = ({ signal }) => listTrainingNominations(programmeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(programmeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTrainingNominations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTrainingNominationsQueryResult = NonNullable<Awaited<ReturnType<typeof listTrainingNominations>>>
export type ListTrainingNominationsQueryError = ErrorType<unknown>


/**
 * @summary List nominations for a training programme
 */

export function useListTrainingNominations<TData = Awaited<ReturnType<typeof listTrainingNominations>>, TError = ErrorType<unknown>>(
 programmeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingNominations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTrainingNominationsQueryOptions(programmeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTrainingNominationUrl = (programmeId: number,) => {




  return `/api/hr/ld/programmes/${programmeId}/nominations`
}

/**
 * @summary Nominate or enrol an employee in a training programme
 */
export const createTrainingNomination = async (programmeId: number,
    trainingNominationInput: TrainingNominationInput, options?: RequestInit): Promise<TrainingNomination> => {

  return customFetch<TrainingNomination>(getCreateTrainingNominationUrl(programmeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      trainingNominationInput,)
  }
);}




export const getCreateTrainingNominationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingNomination>>, TError,{programmeId: number;data: BodyType<TrainingNominationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTrainingNomination>>, TError,{programmeId: number;data: BodyType<TrainingNominationInput>}, TContext> => {

const mutationKey = ['createTrainingNomination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrainingNomination>>, {programmeId: number;data: BodyType<TrainingNominationInput>}> = (props) => {
          const {programmeId,data} = props ?? {};

          return  createTrainingNomination(programmeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTrainingNominationMutationResult = NonNullable<Awaited<ReturnType<typeof createTrainingNomination>>>
    export type CreateTrainingNominationMutationBody = BodyType<TrainingNominationInput>
    export type CreateTrainingNominationMutationError = ErrorType<unknown>

    /**
 * @summary Nominate or enrol an employee in a training programme
 */
export const useCreateTrainingNomination = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingNomination>>, TError,{programmeId: number;data: BodyType<TrainingNominationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTrainingNomination>>,
        TError,
        {programmeId: number;data: BodyType<TrainingNominationInput>},
        TContext
      > => {
      return useMutation(getCreateTrainingNominationMutationOptions(options));
    }

export const getUpdateTrainingNominationUrl = (id: number,) => {




  return `/api/hr/ld/nominations/${id}`
}

/**
 * @summary Update nomination status, attendance, feedback, or score
 */
export const updateTrainingNomination = async (id: number,
    trainingNominationUpdate: TrainingNominationUpdate, options?: RequestInit): Promise<TrainingNomination> => {

  return customFetch<TrainingNomination>(getUpdateTrainingNominationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      trainingNominationUpdate,)
  }
);}




export const getUpdateTrainingNominationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrainingNomination>>, TError,{id: number;data: BodyType<TrainingNominationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTrainingNomination>>, TError,{id: number;data: BodyType<TrainingNominationUpdate>}, TContext> => {

const mutationKey = ['updateTrainingNomination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTrainingNomination>>, {id: number;data: BodyType<TrainingNominationUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTrainingNomination(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTrainingNominationMutationResult = NonNullable<Awaited<ReturnType<typeof updateTrainingNomination>>>
    export type UpdateTrainingNominationMutationBody = BodyType<TrainingNominationUpdate>
    export type UpdateTrainingNominationMutationError = ErrorType<unknown>

    /**
 * @summary Update nomination status, attendance, feedback, or score
 */
export const useUpdateTrainingNomination = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrainingNomination>>, TError,{id: number;data: BodyType<TrainingNominationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTrainingNomination>>,
        TError,
        {id: number;data: BodyType<TrainingNominationUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTrainingNominationMutationOptions(options));
    }

export const getDeleteTrainingNominationUrl = (id: number,) => {




  return `/api/hr/ld/nominations/${id}`
}

/**
 * @summary Remove a nomination
 */
export const deleteTrainingNomination = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTrainingNominationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTrainingNominationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingNomination>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingNomination>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTrainingNomination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTrainingNomination>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTrainingNomination(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTrainingNominationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTrainingNomination>>>

    export type DeleteTrainingNominationMutationError = ErrorType<unknown>

    /**
 * @summary Remove a nomination
 */
export const useDeleteTrainingNomination = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingNomination>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTrainingNomination>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTrainingNominationMutationOptions(options));
    }

export const getListLdSkillsUrl = () => {




  return `/api/hr/ld/skills`
}

/**
 * @summary List skill catalogue
 */
export const listLdSkills = async ( options?: RequestInit): Promise<LdSkill[]> => {

  return customFetch<LdSkill[]>(getListLdSkillsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLdSkillsQueryKey = () => {
    return [
    `/api/hr/ld/skills`
    ] as const;
    }


export const getListLdSkillsQueryOptions = <TData = Awaited<ReturnType<typeof listLdSkills>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLdSkills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLdSkillsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLdSkills>>> = ({ signal }) => listLdSkills({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLdSkills>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLdSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof listLdSkills>>>
export type ListLdSkillsQueryError = ErrorType<unknown>


/**
 * @summary List skill catalogue
 */

export function useListLdSkills<TData = Awaited<ReturnType<typeof listLdSkills>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLdSkills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLdSkillsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateLdSkillUrl = () => {




  return `/api/hr/ld/skills`
}

/**
 * @summary Create a skill
 */
export const createLdSkill = async (ldSkillInput: LdSkillInput, options?: RequestInit): Promise<LdSkill> => {

  return customFetch<LdSkill>(getCreateLdSkillUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ldSkillInput,)
  }
);}




export const getCreateLdSkillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLdSkill>>, TError,{data: BodyType<LdSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLdSkill>>, TError,{data: BodyType<LdSkillInput>}, TContext> => {

const mutationKey = ['createLdSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLdSkill>>, {data: BodyType<LdSkillInput>}> = (props) => {
          const {data} = props ?? {};

          return  createLdSkill(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLdSkillMutationResult = NonNullable<Awaited<ReturnType<typeof createLdSkill>>>
    export type CreateLdSkillMutationBody = BodyType<LdSkillInput>
    export type CreateLdSkillMutationError = ErrorType<unknown>

    /**
 * @summary Create a skill
 */
export const useCreateLdSkill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLdSkill>>, TError,{data: BodyType<LdSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLdSkill>>,
        TError,
        {data: BodyType<LdSkillInput>},
        TContext
      > => {
      return useMutation(getCreateLdSkillMutationOptions(options));
    }

export const getUpdateLdSkillUrl = (id: number,) => {




  return `/api/hr/ld/skills/${id}`
}

/**
 * @summary Update a skill
 */
export const updateLdSkill = async (id: number,
    ldSkillInput: LdSkillInput, options?: RequestInit): Promise<LdSkill> => {

  return customFetch<LdSkill>(getUpdateLdSkillUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ldSkillInput,)
  }
);}




export const getUpdateLdSkillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLdSkill>>, TError,{id: number;data: BodyType<LdSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLdSkill>>, TError,{id: number;data: BodyType<LdSkillInput>}, TContext> => {

const mutationKey = ['updateLdSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLdSkill>>, {id: number;data: BodyType<LdSkillInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLdSkill(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLdSkillMutationResult = NonNullable<Awaited<ReturnType<typeof updateLdSkill>>>
    export type UpdateLdSkillMutationBody = BodyType<LdSkillInput>
    export type UpdateLdSkillMutationError = ErrorType<unknown>

    /**
 * @summary Update a skill
 */
export const useUpdateLdSkill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLdSkill>>, TError,{id: number;data: BodyType<LdSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLdSkill>>,
        TError,
        {id: number;data: BodyType<LdSkillInput>},
        TContext
      > => {
      return useMutation(getUpdateLdSkillMutationOptions(options));
    }

export const getDeleteLdSkillUrl = (id: number,) => {




  return `/api/hr/ld/skills/${id}`
}

/**
 * @summary Delete a skill
 */
export const deleteLdSkill = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLdSkillUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLdSkillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLdSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLdSkill>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteLdSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLdSkill>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteLdSkill(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLdSkillMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLdSkill>>>

    export type DeleteLdSkillMutationError = ErrorType<unknown>

    /**
 * @summary Delete a skill
 */
export const useDeleteLdSkill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLdSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLdSkill>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteLdSkillMutationOptions(options));
    }

export const getListLdRoleSkillsUrl = () => {




  return `/api/hr/ld/role-skills`
}

/**
 * @summary List role skill mappings
 */
export const listLdRoleSkills = async ( options?: RequestInit): Promise<LdRoleSkillRow[]> => {

  return customFetch<LdRoleSkillRow[]>(getListLdRoleSkillsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLdRoleSkillsQueryKey = () => {
    return [
    `/api/hr/ld/role-skills`
    ] as const;
    }


export const getListLdRoleSkillsQueryOptions = <TData = Awaited<ReturnType<typeof listLdRoleSkills>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLdRoleSkills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLdRoleSkillsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLdRoleSkills>>> = ({ signal }) => listLdRoleSkills({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLdRoleSkills>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLdRoleSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof listLdRoleSkills>>>
export type ListLdRoleSkillsQueryError = ErrorType<unknown>


/**
 * @summary List role skill mappings
 */

export function useListLdRoleSkills<TData = Awaited<ReturnType<typeof listLdRoleSkills>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLdRoleSkills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLdRoleSkillsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateLdRoleSkillUrl = () => {




  return `/api/hr/ld/role-skills`
}

/**
 * @summary Map a skill to a designation
 */
export const createLdRoleSkill = async (ldRoleSkillInput: LdRoleSkillInput, options?: RequestInit): Promise<LdRoleSkill> => {

  return customFetch<LdRoleSkill>(getCreateLdRoleSkillUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ldRoleSkillInput,)
  }
);}




export const getCreateLdRoleSkillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLdRoleSkill>>, TError,{data: BodyType<LdRoleSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLdRoleSkill>>, TError,{data: BodyType<LdRoleSkillInput>}, TContext> => {

const mutationKey = ['createLdRoleSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLdRoleSkill>>, {data: BodyType<LdRoleSkillInput>}> = (props) => {
          const {data} = props ?? {};

          return  createLdRoleSkill(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLdRoleSkillMutationResult = NonNullable<Awaited<ReturnType<typeof createLdRoleSkill>>>
    export type CreateLdRoleSkillMutationBody = BodyType<LdRoleSkillInput>
    export type CreateLdRoleSkillMutationError = ErrorType<unknown>

    /**
 * @summary Map a skill to a designation
 */
export const useCreateLdRoleSkill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLdRoleSkill>>, TError,{data: BodyType<LdRoleSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLdRoleSkill>>,
        TError,
        {data: BodyType<LdRoleSkillInput>},
        TContext
      > => {
      return useMutation(getCreateLdRoleSkillMutationOptions(options));
    }

export const getDeleteLdRoleSkillUrl = (id: number,) => {




  return `/api/hr/ld/role-skills/${id}`
}

/**
 * @summary Remove a role skill mapping
 */
export const deleteLdRoleSkill = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLdRoleSkillUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLdRoleSkillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLdRoleSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLdRoleSkill>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteLdRoleSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLdRoleSkill>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteLdRoleSkill(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLdRoleSkillMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLdRoleSkill>>>

    export type DeleteLdRoleSkillMutationError = ErrorType<unknown>

    /**
 * @summary Remove a role skill mapping
 */
export const useDeleteLdRoleSkill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLdRoleSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLdRoleSkill>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteLdRoleSkillMutationOptions(options));
    }

export const getListLdEmployeeSkillsUrl = (params?: ListLdEmployeeSkillsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/ld/employee-skills?${stringifiedParams}` : `/api/hr/ld/employee-skills`
}

/**
 * @summary List employee skill ratings
 */
export const listLdEmployeeSkills = async (params?: ListLdEmployeeSkillsParams, options?: RequestInit): Promise<LdEmployeeSkillRow[]> => {

  return customFetch<LdEmployeeSkillRow[]>(getListLdEmployeeSkillsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLdEmployeeSkillsQueryKey = (params?: ListLdEmployeeSkillsParams,) => {
    return [
    `/api/hr/ld/employee-skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLdEmployeeSkillsQueryOptions = <TData = Awaited<ReturnType<typeof listLdEmployeeSkills>>, TError = ErrorType<unknown>>(params?: ListLdEmployeeSkillsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLdEmployeeSkills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLdEmployeeSkillsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLdEmployeeSkills>>> = ({ signal }) => listLdEmployeeSkills(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLdEmployeeSkills>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLdEmployeeSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof listLdEmployeeSkills>>>
export type ListLdEmployeeSkillsQueryError = ErrorType<unknown>


/**
 * @summary List employee skill ratings
 */

export function useListLdEmployeeSkills<TData = Awaited<ReturnType<typeof listLdEmployeeSkills>>, TError = ErrorType<unknown>>(
 params?: ListLdEmployeeSkillsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLdEmployeeSkills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLdEmployeeSkillsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpsertLdEmployeeSkillUrl = () => {




  return `/api/hr/ld/employee-skills`
}

/**
 * @summary Set or update an employee skill rating
 */
export const upsertLdEmployeeSkill = async (ldEmployeeSkillInput: LdEmployeeSkillInput, options?: RequestInit): Promise<LdEmployeeSkill> => {

  return customFetch<LdEmployeeSkill>(getUpsertLdEmployeeSkillUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ldEmployeeSkillInput,)
  }
);}




export const getUpsertLdEmployeeSkillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertLdEmployeeSkill>>, TError,{data: BodyType<LdEmployeeSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertLdEmployeeSkill>>, TError,{data: BodyType<LdEmployeeSkillInput>}, TContext> => {

const mutationKey = ['upsertLdEmployeeSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertLdEmployeeSkill>>, {data: BodyType<LdEmployeeSkillInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertLdEmployeeSkill(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertLdEmployeeSkillMutationResult = NonNullable<Awaited<ReturnType<typeof upsertLdEmployeeSkill>>>
    export type UpsertLdEmployeeSkillMutationBody = BodyType<LdEmployeeSkillInput>
    export type UpsertLdEmployeeSkillMutationError = ErrorType<unknown>

    /**
 * @summary Set or update an employee skill rating
 */
export const useUpsertLdEmployeeSkill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertLdEmployeeSkill>>, TError,{data: BodyType<LdEmployeeSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertLdEmployeeSkill>>,
        TError,
        {data: BodyType<LdEmployeeSkillInput>},
        TContext
      > => {
      return useMutation(getUpsertLdEmployeeSkillMutationOptions(options));
    }

export const getUpdateLdEmployeeSkillUrl = (id: number,) => {




  return `/api/hr/ld/employee-skills/${id}`
}

/**
 * @summary Update an employee skill rating
 */
export const updateLdEmployeeSkill = async (id: number,
    ldEmployeeSkillInput: LdEmployeeSkillInput, options?: RequestInit): Promise<LdEmployeeSkill> => {

  return customFetch<LdEmployeeSkill>(getUpdateLdEmployeeSkillUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ldEmployeeSkillInput,)
  }
);}




export const getUpdateLdEmployeeSkillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLdEmployeeSkill>>, TError,{id: number;data: BodyType<LdEmployeeSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLdEmployeeSkill>>, TError,{id: number;data: BodyType<LdEmployeeSkillInput>}, TContext> => {

const mutationKey = ['updateLdEmployeeSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLdEmployeeSkill>>, {id: number;data: BodyType<LdEmployeeSkillInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLdEmployeeSkill(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLdEmployeeSkillMutationResult = NonNullable<Awaited<ReturnType<typeof updateLdEmployeeSkill>>>
    export type UpdateLdEmployeeSkillMutationBody = BodyType<LdEmployeeSkillInput>
    export type UpdateLdEmployeeSkillMutationError = ErrorType<unknown>

    /**
 * @summary Update an employee skill rating
 */
export const useUpdateLdEmployeeSkill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLdEmployeeSkill>>, TError,{id: number;data: BodyType<LdEmployeeSkillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLdEmployeeSkill>>,
        TError,
        {id: number;data: BodyType<LdEmployeeSkillInput>},
        TContext
      > => {
      return useMutation(getUpdateLdEmployeeSkillMutationOptions(options));
    }

export const getDeleteLdEmployeeSkillUrl = (id: number,) => {




  return `/api/hr/ld/employee-skills/${id}`
}

/**
 * @summary Remove an employee skill rating
 */
export const deleteLdEmployeeSkill = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLdEmployeeSkillUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLdEmployeeSkillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLdEmployeeSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLdEmployeeSkill>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteLdEmployeeSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLdEmployeeSkill>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteLdEmployeeSkill(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLdEmployeeSkillMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLdEmployeeSkill>>>

    export type DeleteLdEmployeeSkillMutationError = ErrorType<unknown>

    /**
 * @summary Remove an employee skill rating
 */
export const useDeleteLdEmployeeSkill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLdEmployeeSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLdEmployeeSkill>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteLdEmployeeSkillMutationOptions(options));
    }

export const getListLdCertificationsUrl = (params?: ListLdCertificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/ld/certifications?${stringifiedParams}` : `/api/hr/ld/certifications`
}

/**
 * @summary List certifications
 */
export const listLdCertifications = async (params?: ListLdCertificationsParams, options?: RequestInit): Promise<LdCertificationRow[]> => {

  return customFetch<LdCertificationRow[]>(getListLdCertificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLdCertificationsQueryKey = (params?: ListLdCertificationsParams,) => {
    return [
    `/api/hr/ld/certifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLdCertificationsQueryOptions = <TData = Awaited<ReturnType<typeof listLdCertifications>>, TError = ErrorType<unknown>>(params?: ListLdCertificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLdCertifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLdCertificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLdCertifications>>> = ({ signal }) => listLdCertifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLdCertifications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLdCertificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listLdCertifications>>>
export type ListLdCertificationsQueryError = ErrorType<unknown>


/**
 * @summary List certifications
 */

export function useListLdCertifications<TData = Awaited<ReturnType<typeof listLdCertifications>>, TError = ErrorType<unknown>>(
 params?: ListLdCertificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLdCertifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLdCertificationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateLdCertificationUrl = () => {




  return `/api/hr/ld/certifications`
}

/**
 * @summary Record a certification for an employee
 */
export const createLdCertification = async (ldCertificationInput: LdCertificationInput, options?: RequestInit): Promise<LdCertification> => {

  return customFetch<LdCertification>(getCreateLdCertificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ldCertificationInput,)
  }
);}




export const getCreateLdCertificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLdCertification>>, TError,{data: BodyType<LdCertificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLdCertification>>, TError,{data: BodyType<LdCertificationInput>}, TContext> => {

const mutationKey = ['createLdCertification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLdCertification>>, {data: BodyType<LdCertificationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createLdCertification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLdCertificationMutationResult = NonNullable<Awaited<ReturnType<typeof createLdCertification>>>
    export type CreateLdCertificationMutationBody = BodyType<LdCertificationInput>
    export type CreateLdCertificationMutationError = ErrorType<unknown>

    /**
 * @summary Record a certification for an employee
 */
export const useCreateLdCertification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLdCertification>>, TError,{data: BodyType<LdCertificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLdCertification>>,
        TError,
        {data: BodyType<LdCertificationInput>},
        TContext
      > => {
      return useMutation(getCreateLdCertificationMutationOptions(options));
    }

export const getUpdateLdCertificationUrl = (id: number,) => {




  return `/api/hr/ld/certifications/${id}`
}

/**
 * @summary Update a certification
 */
export const updateLdCertification = async (id: number,
    ldCertificationInput: LdCertificationInput, options?: RequestInit): Promise<LdCertification> => {

  return customFetch<LdCertification>(getUpdateLdCertificationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ldCertificationInput,)
  }
);}




export const getUpdateLdCertificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLdCertification>>, TError,{id: number;data: BodyType<LdCertificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLdCertification>>, TError,{id: number;data: BodyType<LdCertificationInput>}, TContext> => {

const mutationKey = ['updateLdCertification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLdCertification>>, {id: number;data: BodyType<LdCertificationInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLdCertification(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLdCertificationMutationResult = NonNullable<Awaited<ReturnType<typeof updateLdCertification>>>
    export type UpdateLdCertificationMutationBody = BodyType<LdCertificationInput>
    export type UpdateLdCertificationMutationError = ErrorType<unknown>

    /**
 * @summary Update a certification
 */
export const useUpdateLdCertification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLdCertification>>, TError,{id: number;data: BodyType<LdCertificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLdCertification>>,
        TError,
        {id: number;data: BodyType<LdCertificationInput>},
        TContext
      > => {
      return useMutation(getUpdateLdCertificationMutationOptions(options));
    }

export const getDeleteLdCertificationUrl = (id: number,) => {




  return `/api/hr/ld/certifications/${id}`
}

/**
 * @summary Delete a certification
 */
export const deleteLdCertification = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLdCertificationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLdCertificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLdCertification>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLdCertification>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteLdCertification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLdCertification>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteLdCertification(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLdCertificationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLdCertification>>>

    export type DeleteLdCertificationMutationError = ErrorType<unknown>

    /**
 * @summary Delete a certification
 */
export const useDeleteLdCertification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLdCertification>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLdCertification>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteLdCertificationMutationOptions(options));
    }

export const getGetLdReportSummaryUrl = () => {




  return `/api/hr/ld/reports/summary`
}

/**
 * @summary Get L&D summary KPIs
 */
export const getLdReportSummary = async ( options?: RequestInit): Promise<LdReportSummary> => {

  return customFetch<LdReportSummary>(getGetLdReportSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLdReportSummaryQueryKey = () => {
    return [
    `/api/hr/ld/reports/summary`
    ] as const;
    }


export const getGetLdReportSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getLdReportSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLdReportSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLdReportSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLdReportSummary>>> = ({ signal }) => getLdReportSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLdReportSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLdReportSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getLdReportSummary>>>
export type GetLdReportSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get L&D summary KPIs
 */

export function useGetLdReportSummary<TData = Awaited<ReturnType<typeof getLdReportSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLdReportSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLdReportSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetLdTrainingCostReportUrl = () => {




  return `/api/hr/ld/reports/training-cost`
}

/**
 * @summary Training cost per department
 */
export const getLdTrainingCostReport = async ( options?: RequestInit): Promise<LdTrainingCostRow[]> => {

  return customFetch<LdTrainingCostRow[]>(getGetLdTrainingCostReportUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLdTrainingCostReportQueryKey = () => {
    return [
    `/api/hr/ld/reports/training-cost`
    ] as const;
    }


export const getGetLdTrainingCostReportQueryOptions = <TData = Awaited<ReturnType<typeof getLdTrainingCostReport>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLdTrainingCostReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLdTrainingCostReportQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLdTrainingCostReport>>> = ({ signal }) => getLdTrainingCostReport({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLdTrainingCostReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLdTrainingCostReportQueryResult = NonNullable<Awaited<ReturnType<typeof getLdTrainingCostReport>>>
export type GetLdTrainingCostReportQueryError = ErrorType<unknown>


/**
 * @summary Training cost per department
 */

export function useGetLdTrainingCostReport<TData = Awaited<ReturnType<typeof getLdTrainingCostReport>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLdTrainingCostReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLdTrainingCostReportQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetLdTrainingHoursReportUrl = () => {




  return `/api/hr/ld/reports/training-hours`
}

/**
 * @summary Training hours per employee
 */
export const getLdTrainingHoursReport = async ( options?: RequestInit): Promise<LdTrainingHoursRow[]> => {

  return customFetch<LdTrainingHoursRow[]>(getGetLdTrainingHoursReportUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLdTrainingHoursReportQueryKey = () => {
    return [
    `/api/hr/ld/reports/training-hours`
    ] as const;
    }


export const getGetLdTrainingHoursReportQueryOptions = <TData = Awaited<ReturnType<typeof getLdTrainingHoursReport>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLdTrainingHoursReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLdTrainingHoursReportQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLdTrainingHoursReport>>> = ({ signal }) => getLdTrainingHoursReport({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLdTrainingHoursReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLdTrainingHoursReportQueryResult = NonNullable<Awaited<ReturnType<typeof getLdTrainingHoursReport>>>
export type GetLdTrainingHoursReportQueryError = ErrorType<unknown>


/**
 * @summary Training hours per employee
 */

export function useGetLdTrainingHoursReport<TData = Awaited<ReturnType<typeof getLdTrainingHoursReport>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLdTrainingHoursReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLdTrainingHoursReportQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListPerDiemPoliciesUrl = () => {




  return `/api/travel/per-diem-policies`
}

/**
 * @summary List per-diem policies
 */
export const listPerDiemPolicies = async ( options?: RequestInit): Promise<PerDiemPolicy[]> => {

  return customFetch<PerDiemPolicy[]>(getListPerDiemPoliciesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPerDiemPoliciesQueryKey = () => {
    return [
    `/api/travel/per-diem-policies`
    ] as const;
    }


export const getListPerDiemPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof listPerDiemPolicies>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerDiemPolicies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPerDiemPoliciesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPerDiemPolicies>>> = ({ signal }) => listPerDiemPolicies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPerDiemPolicies>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPerDiemPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof listPerDiemPolicies>>>
export type ListPerDiemPoliciesQueryError = ErrorType<unknown>


/**
 * @summary List per-diem policies
 */

export function useListPerDiemPolicies<TData = Awaited<ReturnType<typeof listPerDiemPolicies>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPerDiemPolicies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPerDiemPoliciesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePerDiemPolicyUrl = () => {




  return `/api/travel/per-diem-policies`
}

/**
 * @summary Create a per-diem policy
 */
export const createPerDiemPolicy = async (perDiemPolicyInput: PerDiemPolicyInput, options?: RequestInit): Promise<PerDiemPolicy> => {

  return customFetch<PerDiemPolicy>(getCreatePerDiemPolicyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perDiemPolicyInput,)
  }
);}




export const getCreatePerDiemPolicyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerDiemPolicy>>, TError,{data: BodyType<PerDiemPolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPerDiemPolicy>>, TError,{data: BodyType<PerDiemPolicyInput>}, TContext> => {

const mutationKey = ['createPerDiemPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerDiemPolicy>>, {data: BodyType<PerDiemPolicyInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPerDiemPolicy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePerDiemPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof createPerDiemPolicy>>>
    export type CreatePerDiemPolicyMutationBody = BodyType<PerDiemPolicyInput>
    export type CreatePerDiemPolicyMutationError = ErrorType<unknown>

    /**
 * @summary Create a per-diem policy
 */
export const useCreatePerDiemPolicy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerDiemPolicy>>, TError,{data: BodyType<PerDiemPolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPerDiemPolicy>>,
        TError,
        {data: BodyType<PerDiemPolicyInput>},
        TContext
      > => {
      return useMutation(getCreatePerDiemPolicyMutationOptions(options));
    }

export const getUpdatePerDiemPolicyUrl = (id: number,) => {




  return `/api/travel/per-diem-policies/${id}`
}

/**
 * @summary Update a per-diem policy
 */
export const updatePerDiemPolicy = async (id: number,
    perDiemPolicyInput: PerDiemPolicyInput, options?: RequestInit): Promise<PerDiemPolicy> => {

  return customFetch<PerDiemPolicy>(getUpdatePerDiemPolicyUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      perDiemPolicyInput,)
  }
);}




export const getUpdatePerDiemPolicyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerDiemPolicy>>, TError,{id: number;data: BodyType<PerDiemPolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePerDiemPolicy>>, TError,{id: number;data: BodyType<PerDiemPolicyInput>}, TContext> => {

const mutationKey = ['updatePerDiemPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePerDiemPolicy>>, {id: number;data: BodyType<PerDiemPolicyInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePerDiemPolicy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePerDiemPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof updatePerDiemPolicy>>>
    export type UpdatePerDiemPolicyMutationBody = BodyType<PerDiemPolicyInput>
    export type UpdatePerDiemPolicyMutationError = ErrorType<unknown>

    /**
 * @summary Update a per-diem policy
 */
export const useUpdatePerDiemPolicy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerDiemPolicy>>, TError,{id: number;data: BodyType<PerDiemPolicyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePerDiemPolicy>>,
        TError,
        {id: number;data: BodyType<PerDiemPolicyInput>},
        TContext
      > => {
      return useMutation(getUpdatePerDiemPolicyMutationOptions(options));
    }

export const getDeletePerDiemPolicyUrl = (id: number,) => {




  return `/api/travel/per-diem-policies/${id}`
}

/**
 * @summary Delete a per-diem policy
 */
export const deletePerDiemPolicy = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePerDiemPolicyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePerDiemPolicyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerDiemPolicy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerDiemPolicy>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePerDiemPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerDiemPolicy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePerDiemPolicy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePerDiemPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerDiemPolicy>>>

    export type DeletePerDiemPolicyMutationError = ErrorType<unknown>

    /**
 * @summary Delete a per-diem policy
 */
export const useDeletePerDiemPolicy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerDiemPolicy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePerDiemPolicy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePerDiemPolicyMutationOptions(options));
    }

export const getListTravelRequestsUrl = (params?: ListTravelRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/travel/requests?${stringifiedParams}` : `/api/travel/requests`
}

/**
 * @summary List travel requests
 */
export const listTravelRequests = async (params?: ListTravelRequestsParams, options?: RequestInit): Promise<TravelRequest[]> => {

  return customFetch<TravelRequest[]>(getListTravelRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTravelRequestsQueryKey = (params?: ListTravelRequestsParams,) => {
    return [
    `/api/travel/requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTravelRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listTravelRequests>>, TError = ErrorType<unknown>>(params?: ListTravelRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTravelRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTravelRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTravelRequests>>> = ({ signal }) => listTravelRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTravelRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTravelRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listTravelRequests>>>
export type ListTravelRequestsQueryError = ErrorType<unknown>


/**
 * @summary List travel requests
 */

export function useListTravelRequests<TData = Awaited<ReturnType<typeof listTravelRequests>>, TError = ErrorType<unknown>>(
 params?: ListTravelRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTravelRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTravelRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTravelRequestUrl = () => {




  return `/api/travel/requests`
}

/**
 * @summary Create a travel request
 */
export const createTravelRequest = async (travelRequestInput: TravelRequestInput, options?: RequestInit): Promise<TravelRequest> => {

  return customFetch<TravelRequest>(getCreateTravelRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      travelRequestInput,)
  }
);}




export const getCreateTravelRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTravelRequest>>, TError,{data: BodyType<TravelRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTravelRequest>>, TError,{data: BodyType<TravelRequestInput>}, TContext> => {

const mutationKey = ['createTravelRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTravelRequest>>, {data: BodyType<TravelRequestInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTravelRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTravelRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createTravelRequest>>>
    export type CreateTravelRequestMutationBody = BodyType<TravelRequestInput>
    export type CreateTravelRequestMutationError = ErrorType<unknown>

    /**
 * @summary Create a travel request
 */
export const useCreateTravelRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTravelRequest>>, TError,{data: BodyType<TravelRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTravelRequest>>,
        TError,
        {data: BodyType<TravelRequestInput>},
        TContext
      > => {
      return useMutation(getCreateTravelRequestMutationOptions(options));
    }

export const getGetTravelRequestUrl = (id: number,) => {




  return `/api/travel/requests/${id}`
}

/**
 * @summary Get a travel request
 */
export const getTravelRequest = async (id: number, options?: RequestInit): Promise<TravelRequest> => {

  return customFetch<TravelRequest>(getGetTravelRequestUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTravelRequestQueryKey = (id: number,) => {
    return [
    `/api/travel/requests/${id}`
    ] as const;
    }


export const getGetTravelRequestQueryOptions = <TData = Awaited<ReturnType<typeof getTravelRequest>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTravelRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTravelRequestQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTravelRequest>>> = ({ signal }) => getTravelRequest(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTravelRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTravelRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getTravelRequest>>>
export type GetTravelRequestQueryError = ErrorType<unknown>


/**
 * @summary Get a travel request
 */

export function useGetTravelRequest<TData = Awaited<ReturnType<typeof getTravelRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTravelRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTravelRequestQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateTravelRequestUrl = (id: number,) => {




  return `/api/travel/requests/${id}`
}

/**
 * @summary Update a travel request
 */
export const updateTravelRequest = async (id: number,
    travelRequestInput: TravelRequestInput, options?: RequestInit): Promise<TravelRequest> => {

  return customFetch<TravelRequest>(getUpdateTravelRequestUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      travelRequestInput,)
  }
);}




export const getUpdateTravelRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTravelRequest>>, TError,{id: number;data: BodyType<TravelRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTravelRequest>>, TError,{id: number;data: BodyType<TravelRequestInput>}, TContext> => {

const mutationKey = ['updateTravelRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTravelRequest>>, {id: number;data: BodyType<TravelRequestInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTravelRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTravelRequestMutationResult = NonNullable<Awaited<ReturnType<typeof updateTravelRequest>>>
    export type UpdateTravelRequestMutationBody = BodyType<TravelRequestInput>
    export type UpdateTravelRequestMutationError = ErrorType<unknown>

    /**
 * @summary Update a travel request
 */
export const useUpdateTravelRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTravelRequest>>, TError,{id: number;data: BodyType<TravelRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTravelRequest>>,
        TError,
        {id: number;data: BodyType<TravelRequestInput>},
        TContext
      > => {
      return useMutation(getUpdateTravelRequestMutationOptions(options));
    }

export const getApproveTravelRequestUrl = (id: number,) => {




  return `/api/travel/requests/${id}/approve`
}

/**
 * @summary Approve a travel request
 */
export const approveTravelRequest = async (id: number,
    approveTravelRequestBody?: ApproveTravelRequestBody, options?: RequestInit): Promise<TravelRequest> => {

  return customFetch<TravelRequest>(getApproveTravelRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approveTravelRequestBody,)
  }
);}




export const getApproveTravelRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTravelRequest>>, TError,{id: number;data?: BodyType<ApproveTravelRequestBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveTravelRequest>>, TError,{id: number;data?: BodyType<ApproveTravelRequestBody>}, TContext> => {

const mutationKey = ['approveTravelRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveTravelRequest>>, {id: number;data?: BodyType<ApproveTravelRequestBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveTravelRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveTravelRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveTravelRequest>>>
    export type ApproveTravelRequestMutationBody = BodyType<ApproveTravelRequestBody> | undefined
    export type ApproveTravelRequestMutationError = ErrorType<unknown>

    /**
 * @summary Approve a travel request
 */
export const useApproveTravelRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTravelRequest>>, TError,{id: number;data?: BodyType<ApproveTravelRequestBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveTravelRequest>>,
        TError,
        {id: number;data?: BodyType<ApproveTravelRequestBody>},
        TContext
      > => {
      return useMutation(getApproveTravelRequestMutationOptions(options));
    }

export const getRejectTravelRequestUrl = (id: number,) => {




  return `/api/travel/requests/${id}/reject`
}

/**
 * @summary Reject a travel request
 */
export const rejectTravelRequest = async (id: number,
    rejectTravelRequestBody: RejectTravelRequestBody, options?: RequestInit): Promise<TravelRequest> => {

  return customFetch<TravelRequest>(getRejectTravelRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rejectTravelRequestBody,)
  }
);}




export const getRejectTravelRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectTravelRequest>>, TError,{id: number;data: BodyType<RejectTravelRequestBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectTravelRequest>>, TError,{id: number;data: BodyType<RejectTravelRequestBody>}, TContext> => {

const mutationKey = ['rejectTravelRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectTravelRequest>>, {id: number;data: BodyType<RejectTravelRequestBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectTravelRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectTravelRequestMutationResult = NonNullable<Awaited<ReturnType<typeof rejectTravelRequest>>>
    export type RejectTravelRequestMutationBody = BodyType<RejectTravelRequestBody>
    export type RejectTravelRequestMutationError = ErrorType<unknown>

    /**
 * @summary Reject a travel request
 */
export const useRejectTravelRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectTravelRequest>>, TError,{id: number;data: BodyType<RejectTravelRequestBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectTravelRequest>>,
        TError,
        {id: number;data: BodyType<RejectTravelRequestBody>},
        TContext
      > => {
      return useMutation(getRejectTravelRequestMutationOptions(options));
    }

export const getCancelTravelRequestUrl = (id: number,) => {




  return `/api/travel/requests/${id}/cancel`
}

/**
 * @summary Cancel a travel request
 */
export const cancelTravelRequest = async (id: number,
    cancelTravelRequestBody?: CancelTravelRequestBody, options?: RequestInit): Promise<TravelRequest> => {

  return customFetch<TravelRequest>(getCancelTravelRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cancelTravelRequestBody,)
  }
);}




export const getCancelTravelRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTravelRequest>>, TError,{id: number;data?: BodyType<CancelTravelRequestBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelTravelRequest>>, TError,{id: number;data?: BodyType<CancelTravelRequestBody>}, TContext> => {

const mutationKey = ['cancelTravelRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelTravelRequest>>, {id: number;data?: BodyType<CancelTravelRequestBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelTravelRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelTravelRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cancelTravelRequest>>>
    export type CancelTravelRequestMutationBody = BodyType<CancelTravelRequestBody> | undefined
    export type CancelTravelRequestMutationError = ErrorType<unknown>

    /**
 * @summary Cancel a travel request
 */
export const useCancelTravelRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTravelRequest>>, TError,{id: number;data?: BodyType<CancelTravelRequestBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelTravelRequest>>,
        TError,
        {id: number;data?: BodyType<CancelTravelRequestBody>},
        TContext
      > => {
      return useMutation(getCancelTravelRequestMutationOptions(options));
    }

export const getListTravelBookingsUrl = (params?: ListTravelBookingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/travel/bookings?${stringifiedParams}` : `/api/travel/bookings`
}

/**
 * @summary List travel bookings
 */
export const listTravelBookings = async (params?: ListTravelBookingsParams, options?: RequestInit): Promise<TravelBooking[]> => {

  return customFetch<TravelBooking[]>(getListTravelBookingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTravelBookingsQueryKey = (params?: ListTravelBookingsParams,) => {
    return [
    `/api/travel/bookings`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTravelBookingsQueryOptions = <TData = Awaited<ReturnType<typeof listTravelBookings>>, TError = ErrorType<unknown>>(params?: ListTravelBookingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTravelBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTravelBookingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTravelBookings>>> = ({ signal }) => listTravelBookings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTravelBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTravelBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof listTravelBookings>>>
export type ListTravelBookingsQueryError = ErrorType<unknown>


/**
 * @summary List travel bookings
 */

export function useListTravelBookings<TData = Awaited<ReturnType<typeof listTravelBookings>>, TError = ErrorType<unknown>>(
 params?: ListTravelBookingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTravelBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTravelBookingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTravelBookingUrl = () => {




  return `/api/travel/bookings`
}

/**
 * @summary Create a travel booking
 */
export const createTravelBooking = async (travelBookingInput: TravelBookingInput, options?: RequestInit): Promise<TravelBooking> => {

  return customFetch<TravelBooking>(getCreateTravelBookingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      travelBookingInput,)
  }
);}




export const getCreateTravelBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTravelBooking>>, TError,{data: BodyType<TravelBookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTravelBooking>>, TError,{data: BodyType<TravelBookingInput>}, TContext> => {

const mutationKey = ['createTravelBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTravelBooking>>, {data: BodyType<TravelBookingInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTravelBooking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTravelBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createTravelBooking>>>
    export type CreateTravelBookingMutationBody = BodyType<TravelBookingInput>
    export type CreateTravelBookingMutationError = ErrorType<unknown>

    /**
 * @summary Create a travel booking
 */
export const useCreateTravelBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTravelBooking>>, TError,{data: BodyType<TravelBookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTravelBooking>>,
        TError,
        {data: BodyType<TravelBookingInput>},
        TContext
      > => {
      return useMutation(getCreateTravelBookingMutationOptions(options));
    }

export const getUpdateTravelBookingUrl = (id: number,) => {




  return `/api/travel/bookings/${id}`
}

/**
 * @summary Update a travel booking
 */
export const updateTravelBooking = async (id: number,
    travelBookingInput: TravelBookingInput, options?: RequestInit): Promise<TravelBooking> => {

  return customFetch<TravelBooking>(getUpdateTravelBookingUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      travelBookingInput,)
  }
);}




export const getUpdateTravelBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTravelBooking>>, TError,{id: number;data: BodyType<TravelBookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTravelBooking>>, TError,{id: number;data: BodyType<TravelBookingInput>}, TContext> => {

const mutationKey = ['updateTravelBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTravelBooking>>, {id: number;data: BodyType<TravelBookingInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTravelBooking(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTravelBookingMutationResult = NonNullable<Awaited<ReturnType<typeof updateTravelBooking>>>
    export type UpdateTravelBookingMutationBody = BodyType<TravelBookingInput>
    export type UpdateTravelBookingMutationError = ErrorType<unknown>

    /**
 * @summary Update a travel booking
 */
export const useUpdateTravelBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTravelBooking>>, TError,{id: number;data: BodyType<TravelBookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTravelBooking>>,
        TError,
        {id: number;data: BodyType<TravelBookingInput>},
        TContext
      > => {
      return useMutation(getUpdateTravelBookingMutationOptions(options));
    }

export const getDeleteTravelBookingUrl = (id: number,) => {




  return `/api/travel/bookings/${id}`
}

/**
 * @summary Delete a travel booking
 */
export const deleteTravelBooking = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTravelBookingUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTravelBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTravelBooking>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTravelBooking>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTravelBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTravelBooking>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTravelBooking(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTravelBookingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTravelBooking>>>

    export type DeleteTravelBookingMutationError = ErrorType<unknown>

    /**
 * @summary Delete a travel booking
 */
export const useDeleteTravelBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTravelBooking>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTravelBooking>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTravelBookingMutationOptions(options));
    }

export const getListTravelAdvancesUrl = (params?: ListTravelAdvancesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/travel/advances?${stringifiedParams}` : `/api/travel/advances`
}

/**
 * @summary List travel advances
 */
export const listTravelAdvances = async (params?: ListTravelAdvancesParams, options?: RequestInit): Promise<TravelAdvance[]> => {

  return customFetch<TravelAdvance[]>(getListTravelAdvancesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTravelAdvancesQueryKey = (params?: ListTravelAdvancesParams,) => {
    return [
    `/api/travel/advances`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTravelAdvancesQueryOptions = <TData = Awaited<ReturnType<typeof listTravelAdvances>>, TError = ErrorType<unknown>>(params?: ListTravelAdvancesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTravelAdvances>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTravelAdvancesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTravelAdvances>>> = ({ signal }) => listTravelAdvances(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTravelAdvances>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTravelAdvancesQueryResult = NonNullable<Awaited<ReturnType<typeof listTravelAdvances>>>
export type ListTravelAdvancesQueryError = ErrorType<unknown>


/**
 * @summary List travel advances
 */

export function useListTravelAdvances<TData = Awaited<ReturnType<typeof listTravelAdvances>>, TError = ErrorType<unknown>>(
 params?: ListTravelAdvancesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTravelAdvances>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTravelAdvancesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTravelAdvanceUrl = () => {




  return `/api/travel/advances`
}

/**
 * @summary Request a travel advance
 */
export const createTravelAdvance = async (travelAdvanceInput: TravelAdvanceInput, options?: RequestInit): Promise<TravelAdvance> => {

  return customFetch<TravelAdvance>(getCreateTravelAdvanceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      travelAdvanceInput,)
  }
);}




export const getCreateTravelAdvanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTravelAdvance>>, TError,{data: BodyType<TravelAdvanceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTravelAdvance>>, TError,{data: BodyType<TravelAdvanceInput>}, TContext> => {

const mutationKey = ['createTravelAdvance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTravelAdvance>>, {data: BodyType<TravelAdvanceInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTravelAdvance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTravelAdvanceMutationResult = NonNullable<Awaited<ReturnType<typeof createTravelAdvance>>>
    export type CreateTravelAdvanceMutationBody = BodyType<TravelAdvanceInput>
    export type CreateTravelAdvanceMutationError = ErrorType<unknown>

    /**
 * @summary Request a travel advance
 */
export const useCreateTravelAdvance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTravelAdvance>>, TError,{data: BodyType<TravelAdvanceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTravelAdvance>>,
        TError,
        {data: BodyType<TravelAdvanceInput>},
        TContext
      > => {
      return useMutation(getCreateTravelAdvanceMutationOptions(options));
    }

export const getApproveTravelAdvanceUrl = (id: number,) => {




  return `/api/travel/advances/${id}/approve`
}

/**
 * @summary Approve a travel advance
 */
export const approveTravelAdvance = async (id: number,
    approveTravelAdvanceBody?: ApproveTravelAdvanceBody, options?: RequestInit): Promise<TravelAdvance> => {

  return customFetch<TravelAdvance>(getApproveTravelAdvanceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approveTravelAdvanceBody,)
  }
);}




export const getApproveTravelAdvanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTravelAdvance>>, TError,{id: number;data?: BodyType<ApproveTravelAdvanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveTravelAdvance>>, TError,{id: number;data?: BodyType<ApproveTravelAdvanceBody>}, TContext> => {

const mutationKey = ['approveTravelAdvance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveTravelAdvance>>, {id: number;data?: BodyType<ApproveTravelAdvanceBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveTravelAdvance(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveTravelAdvanceMutationResult = NonNullable<Awaited<ReturnType<typeof approveTravelAdvance>>>
    export type ApproveTravelAdvanceMutationBody = BodyType<ApproveTravelAdvanceBody> | undefined
    export type ApproveTravelAdvanceMutationError = ErrorType<unknown>

    /**
 * @summary Approve a travel advance
 */
export const useApproveTravelAdvance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTravelAdvance>>, TError,{id: number;data?: BodyType<ApproveTravelAdvanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveTravelAdvance>>,
        TError,
        {id: number;data?: BodyType<ApproveTravelAdvanceBody>},
        TContext
      > => {
      return useMutation(getApproveTravelAdvanceMutationOptions(options));
    }

export const getDisburseTravelAdvanceUrl = (id: number,) => {




  return `/api/travel/advances/${id}/disburse`
}

/**
 * @summary Mark advance as disbursed and post finance voucher
 */
export const disburseTravelAdvance = async (id: number,
    disburseTravelAdvanceBody?: DisburseTravelAdvanceBody, options?: RequestInit): Promise<TravelAdvance> => {

  return customFetch<TravelAdvance>(getDisburseTravelAdvanceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      disburseTravelAdvanceBody,)
  }
);}




export const getDisburseTravelAdvanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disburseTravelAdvance>>, TError,{id: number;data?: BodyType<DisburseTravelAdvanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disburseTravelAdvance>>, TError,{id: number;data?: BodyType<DisburseTravelAdvanceBody>}, TContext> => {

const mutationKey = ['disburseTravelAdvance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disburseTravelAdvance>>, {id: number;data?: BodyType<DisburseTravelAdvanceBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  disburseTravelAdvance(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisburseTravelAdvanceMutationResult = NonNullable<Awaited<ReturnType<typeof disburseTravelAdvance>>>
    export type DisburseTravelAdvanceMutationBody = BodyType<DisburseTravelAdvanceBody> | undefined
    export type DisburseTravelAdvanceMutationError = ErrorType<unknown>

    /**
 * @summary Mark advance as disbursed and post finance voucher
 */
export const useDisburseTravelAdvance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disburseTravelAdvance>>, TError,{id: number;data?: BodyType<DisburseTravelAdvanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disburseTravelAdvance>>,
        TError,
        {id: number;data?: BodyType<DisburseTravelAdvanceBody>},
        TContext
      > => {
      return useMutation(getDisburseTravelAdvanceMutationOptions(options));
    }

export const getReconcileTravelAdvanceUrl = (id: number,) => {




  return `/api/travel/advances/${id}/reconcile`
}

/**
 * @summary Reconcile advance against actual spend
 */
export const reconcileTravelAdvance = async (id: number,
    reconcileTravelAdvanceBody: ReconcileTravelAdvanceBody, options?: RequestInit): Promise<TravelAdvance> => {

  return customFetch<TravelAdvance>(getReconcileTravelAdvanceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reconcileTravelAdvanceBody,)
  }
);}




export const getReconcileTravelAdvanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileTravelAdvance>>, TError,{id: number;data: BodyType<ReconcileTravelAdvanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reconcileTravelAdvance>>, TError,{id: number;data: BodyType<ReconcileTravelAdvanceBody>}, TContext> => {

const mutationKey = ['reconcileTravelAdvance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconcileTravelAdvance>>, {id: number;data: BodyType<ReconcileTravelAdvanceBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  reconcileTravelAdvance(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReconcileTravelAdvanceMutationResult = NonNullable<Awaited<ReturnType<typeof reconcileTravelAdvance>>>
    export type ReconcileTravelAdvanceMutationBody = BodyType<ReconcileTravelAdvanceBody>
    export type ReconcileTravelAdvanceMutationError = ErrorType<unknown>

    /**
 * @summary Reconcile advance against actual spend
 */
export const useReconcileTravelAdvance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileTravelAdvance>>, TError,{id: number;data: BodyType<ReconcileTravelAdvanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reconcileTravelAdvance>>,
        TError,
        {id: number;data: BodyType<ReconcileTravelAdvanceBody>},
        TContext
      > => {
      return useMutation(getReconcileTravelAdvanceMutationOptions(options));
    }

export const getListExpenseClaimsUrl = (params?: ListExpenseClaimsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/travel/claims?${stringifiedParams}` : `/api/travel/claims`
}

/**
 * @summary List expense claims
 */
export const listExpenseClaims = async (params?: ListExpenseClaimsParams, options?: RequestInit): Promise<ExpenseClaim[]> => {

  return customFetch<ExpenseClaim[]>(getListExpenseClaimsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExpenseClaimsQueryKey = (params?: ListExpenseClaimsParams,) => {
    return [
    `/api/travel/claims`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExpenseClaimsQueryOptions = <TData = Awaited<ReturnType<typeof listExpenseClaims>>, TError = ErrorType<unknown>>(params?: ListExpenseClaimsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExpenseClaims>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExpenseClaimsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExpenseClaims>>> = ({ signal }) => listExpenseClaims(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExpenseClaims>>, TError, TData> & { queryKey: QueryKey }
}

export type ListExpenseClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof listExpenseClaims>>>
export type ListExpenseClaimsQueryError = ErrorType<unknown>


/**
 * @summary List expense claims
 */

export function useListExpenseClaims<TData = Awaited<ReturnType<typeof listExpenseClaims>>, TError = ErrorType<unknown>>(
 params?: ListExpenseClaimsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExpenseClaims>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListExpenseClaimsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateExpenseClaimUrl = () => {




  return `/api/travel/claims`
}

/**
 * @summary Submit an expense claim
 */
export const createExpenseClaim = async (expenseClaimInput: ExpenseClaimInput, options?: RequestInit): Promise<ExpenseClaim> => {

  return customFetch<ExpenseClaim>(getCreateExpenseClaimUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      expenseClaimInput,)
  }
);}




export const getCreateExpenseClaimMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExpenseClaim>>, TError,{data: BodyType<ExpenseClaimInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExpenseClaim>>, TError,{data: BodyType<ExpenseClaimInput>}, TContext> => {

const mutationKey = ['createExpenseClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExpenseClaim>>, {data: BodyType<ExpenseClaimInput>}> = (props) => {
          const {data} = props ?? {};

          return  createExpenseClaim(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExpenseClaimMutationResult = NonNullable<Awaited<ReturnType<typeof createExpenseClaim>>>
    export type CreateExpenseClaimMutationBody = BodyType<ExpenseClaimInput>
    export type CreateExpenseClaimMutationError = ErrorType<unknown>

    /**
 * @summary Submit an expense claim
 */
export const useCreateExpenseClaim = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExpenseClaim>>, TError,{data: BodyType<ExpenseClaimInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createExpenseClaim>>,
        TError,
        {data: BodyType<ExpenseClaimInput>},
        TContext
      > => {
      return useMutation(getCreateExpenseClaimMutationOptions(options));
    }

export const getGetExpenseClaimUrl = (id: number,) => {




  return `/api/travel/claims/${id}`
}

/**
 * @summary Get expense claim with items
 */
export const getExpenseClaim = async (id: number, options?: RequestInit): Promise<ExpenseClaimDetail> => {

  return customFetch<ExpenseClaimDetail>(getGetExpenseClaimUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExpenseClaimQueryKey = (id: number,) => {
    return [
    `/api/travel/claims/${id}`
    ] as const;
    }


export const getGetExpenseClaimQueryOptions = <TData = Awaited<ReturnType<typeof getExpenseClaim>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenseClaim>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExpenseClaimQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpenseClaim>>> = ({ signal }) => getExpenseClaim(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExpenseClaim>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExpenseClaimQueryResult = NonNullable<Awaited<ReturnType<typeof getExpenseClaim>>>
export type GetExpenseClaimQueryError = ErrorType<unknown>


/**
 * @summary Get expense claim with items
 */

export function useGetExpenseClaim<TData = Awaited<ReturnType<typeof getExpenseClaim>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenseClaim>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExpenseClaimQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getManagerApproveExpenseClaimUrl = (id: number,) => {




  return `/api/travel/claims/${id}/manager-approve`
}

/**
 * @summary Manager approves expense claim
 */
export const managerApproveExpenseClaim = async (id: number,
    managerApproveExpenseClaimBody?: ManagerApproveExpenseClaimBody, options?: RequestInit): Promise<ExpenseClaim> => {

  return customFetch<ExpenseClaim>(getManagerApproveExpenseClaimUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      managerApproveExpenseClaimBody,)
  }
);}




export const getManagerApproveExpenseClaimMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managerApproveExpenseClaim>>, TError,{id: number;data?: BodyType<ManagerApproveExpenseClaimBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof managerApproveExpenseClaim>>, TError,{id: number;data?: BodyType<ManagerApproveExpenseClaimBody>}, TContext> => {

const mutationKey = ['managerApproveExpenseClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof managerApproveExpenseClaim>>, {id: number;data?: BodyType<ManagerApproveExpenseClaimBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  managerApproveExpenseClaim(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ManagerApproveExpenseClaimMutationResult = NonNullable<Awaited<ReturnType<typeof managerApproveExpenseClaim>>>
    export type ManagerApproveExpenseClaimMutationBody = BodyType<ManagerApproveExpenseClaimBody> | undefined
    export type ManagerApproveExpenseClaimMutationError = ErrorType<unknown>

    /**
 * @summary Manager approves expense claim
 */
export const useManagerApproveExpenseClaim = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managerApproveExpenseClaim>>, TError,{id: number;data?: BodyType<ManagerApproveExpenseClaimBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof managerApproveExpenseClaim>>,
        TError,
        {id: number;data?: BodyType<ManagerApproveExpenseClaimBody>},
        TContext
      > => {
      return useMutation(getManagerApproveExpenseClaimMutationOptions(options));
    }

export const getFinanceApproveExpenseClaimUrl = (id: number,) => {




  return `/api/travel/claims/${id}/finance-approve`
}

/**
 * @summary Finance approves claim and posts journal entry
 */
export const financeApproveExpenseClaim = async (id: number,
    financeApproveExpenseClaimBody?: FinanceApproveExpenseClaimBody, options?: RequestInit): Promise<ExpenseClaim> => {

  return customFetch<ExpenseClaim>(getFinanceApproveExpenseClaimUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      financeApproveExpenseClaimBody,)
  }
);}




export const getFinanceApproveExpenseClaimMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof financeApproveExpenseClaim>>, TError,{id: number;data?: BodyType<FinanceApproveExpenseClaimBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof financeApproveExpenseClaim>>, TError,{id: number;data?: BodyType<FinanceApproveExpenseClaimBody>}, TContext> => {

const mutationKey = ['financeApproveExpenseClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof financeApproveExpenseClaim>>, {id: number;data?: BodyType<FinanceApproveExpenseClaimBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  financeApproveExpenseClaim(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinanceApproveExpenseClaimMutationResult = NonNullable<Awaited<ReturnType<typeof financeApproveExpenseClaim>>>
    export type FinanceApproveExpenseClaimMutationBody = BodyType<FinanceApproveExpenseClaimBody> | undefined
    export type FinanceApproveExpenseClaimMutationError = ErrorType<unknown>

    /**
 * @summary Finance approves claim and posts journal entry
 */
export const useFinanceApproveExpenseClaim = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof financeApproveExpenseClaim>>, TError,{id: number;data?: BodyType<FinanceApproveExpenseClaimBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof financeApproveExpenseClaim>>,
        TError,
        {id: number;data?: BodyType<FinanceApproveExpenseClaimBody>},
        TContext
      > => {
      return useMutation(getFinanceApproveExpenseClaimMutationOptions(options));
    }

export const getRejectExpenseClaimUrl = (id: number,) => {




  return `/api/travel/claims/${id}/reject`
}

/**
 * @summary Reject an expense claim
 */
export const rejectExpenseClaim = async (id: number,
    rejectExpenseClaimBody: RejectExpenseClaimBody, options?: RequestInit): Promise<ExpenseClaim> => {

  return customFetch<ExpenseClaim>(getRejectExpenseClaimUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rejectExpenseClaimBody,)
  }
);}




export const getRejectExpenseClaimMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectExpenseClaim>>, TError,{id: number;data: BodyType<RejectExpenseClaimBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectExpenseClaim>>, TError,{id: number;data: BodyType<RejectExpenseClaimBody>}, TContext> => {

const mutationKey = ['rejectExpenseClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectExpenseClaim>>, {id: number;data: BodyType<RejectExpenseClaimBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectExpenseClaim(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectExpenseClaimMutationResult = NonNullable<Awaited<ReturnType<typeof rejectExpenseClaim>>>
    export type RejectExpenseClaimMutationBody = BodyType<RejectExpenseClaimBody>
    export type RejectExpenseClaimMutationError = ErrorType<unknown>

    /**
 * @summary Reject an expense claim
 */
export const useRejectExpenseClaim = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectExpenseClaim>>, TError,{id: number;data: BodyType<RejectExpenseClaimBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectExpenseClaim>>,
        TError,
        {id: number;data: BodyType<RejectExpenseClaimBody>},
        TContext
      > => {
      return useMutation(getRejectExpenseClaimMutationOptions(options));
    }

export const getListExpenseClaimItemsUrl = (id: number,) => {




  return `/api/travel/claims/${id}/items`
}

/**
 * @summary List items for an expense claim
 */
export const listExpenseClaimItems = async (id: number, options?: RequestInit): Promise<ExpenseClaimItem[]> => {

  return customFetch<ExpenseClaimItem[]>(getListExpenseClaimItemsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExpenseClaimItemsQueryKey = (id: number,) => {
    return [
    `/api/travel/claims/${id}/items`
    ] as const;
    }


export const getListExpenseClaimItemsQueryOptions = <TData = Awaited<ReturnType<typeof listExpenseClaimItems>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExpenseClaimItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExpenseClaimItemsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExpenseClaimItems>>> = ({ signal }) => listExpenseClaimItems(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExpenseClaimItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListExpenseClaimItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listExpenseClaimItems>>>
export type ListExpenseClaimItemsQueryError = ErrorType<unknown>


/**
 * @summary List items for an expense claim
 */

export function useListExpenseClaimItems<TData = Awaited<ReturnType<typeof listExpenseClaimItems>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExpenseClaimItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListExpenseClaimItemsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAddExpenseClaimItemUrl = (id: number,) => {




  return `/api/travel/claims/${id}/items`
}

/**
 * @summary Add item to expense claim
 */
export const addExpenseClaimItem = async (id: number,
    expenseClaimItemInput: ExpenseClaimItemInput, options?: RequestInit): Promise<ExpenseClaimItem> => {

  return customFetch<ExpenseClaimItem>(getAddExpenseClaimItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      expenseClaimItemInput,)
  }
);}




export const getAddExpenseClaimItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addExpenseClaimItem>>, TError,{id: number;data: BodyType<ExpenseClaimItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addExpenseClaimItem>>, TError,{id: number;data: BodyType<ExpenseClaimItemInput>}, TContext> => {

const mutationKey = ['addExpenseClaimItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addExpenseClaimItem>>, {id: number;data: BodyType<ExpenseClaimItemInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addExpenseClaimItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddExpenseClaimItemMutationResult = NonNullable<Awaited<ReturnType<typeof addExpenseClaimItem>>>
    export type AddExpenseClaimItemMutationBody = BodyType<ExpenseClaimItemInput>
    export type AddExpenseClaimItemMutationError = ErrorType<unknown>

    /**
 * @summary Add item to expense claim
 */
export const useAddExpenseClaimItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addExpenseClaimItem>>, TError,{id: number;data: BodyType<ExpenseClaimItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addExpenseClaimItem>>,
        TError,
        {id: number;data: BodyType<ExpenseClaimItemInput>},
        TContext
      > => {
      return useMutation(getAddExpenseClaimItemMutationOptions(options));
    }

export const getDeleteExpenseClaimItemUrl = (claimId: number,
    itemId: number,) => {




  return `/api/travel/claims/${claimId}/items/${itemId}`
}

/**
 * @summary Remove item from expense claim
 */
export const deleteExpenseClaimItem = async (claimId: number,
    itemId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteExpenseClaimItemUrl(claimId,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteExpenseClaimItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExpenseClaimItem>>, TError,{claimId: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExpenseClaimItem>>, TError,{claimId: number;itemId: number}, TContext> => {

const mutationKey = ['deleteExpenseClaimItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExpenseClaimItem>>, {claimId: number;itemId: number}> = (props) => {
          const {claimId,itemId} = props ?? {};

          return  deleteExpenseClaimItem(claimId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExpenseClaimItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExpenseClaimItem>>>

    export type DeleteExpenseClaimItemMutationError = ErrorType<unknown>

    /**
 * @summary Remove item from expense claim
 */
export const useDeleteExpenseClaimItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExpenseClaimItem>>, TError,{claimId: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteExpenseClaimItem>>,
        TError,
        {claimId: number;itemId: number},
        TContext
      > => {
      return useMutation(getDeleteExpenseClaimItemMutationOptions(options));
    }

export const getGetTravelSpendSummaryUrl = (params?: GetTravelSpendSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/travel/reports/spend-summary?${stringifiedParams}` : `/api/travel/reports/spend-summary`
}

/**
 * @summary Travel spend by employee, outstanding advances, policy violations
 */
export const getTravelSpendSummary = async (params?: GetTravelSpendSummaryParams, options?: RequestInit): Promise<TravelSpendSummary> => {

  return customFetch<TravelSpendSummary>(getGetTravelSpendSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTravelSpendSummaryQueryKey = (params?: GetTravelSpendSummaryParams,) => {
    return [
    `/api/travel/reports/spend-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTravelSpendSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getTravelSpendSummary>>, TError = ErrorType<unknown>>(params?: GetTravelSpendSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTravelSpendSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTravelSpendSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTravelSpendSummary>>> = ({ signal }) => getTravelSpendSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTravelSpendSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTravelSpendSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getTravelSpendSummary>>>
export type GetTravelSpendSummaryQueryError = ErrorType<unknown>


/**
 * @summary Travel spend by employee, outstanding advances, policy violations
 */

export function useGetTravelSpendSummary<TData = Awaited<ReturnType<typeof getTravelSpendSummary>>, TError = ErrorType<unknown>>(
 params?: GetTravelSpendSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTravelSpendSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTravelSpendSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







